import { defineComponent as ke, openBlock as c, createElementBlock as k, mergeProps as Ee, inject as Ds, provide as Hs, resolveComponent as Ae, normalizeClass as ue, createElementVNode as O, createVNode as He, withDirectives as At, vModelCheckbox as Ts, reactive as Lr, ref as ee, useSlots as Qt, toRef as Zr, onMounted as ot, nextTick as Nt, computed as Q, onUnmounted as Da, watch as Ft, isRef as e1, unref as g, createSlots as it, renderList as Pe, withCtx as ve, renderSlot as X, normalizeProps as Ue, guardReactiveProps as rt, Teleport as $s, Transition as dr, createCommentVNode as S, h as Ss, render as t1, withKeys as be, createBlock as ce, withModifiers as xe, normalizeStyle as dt, Fragment as he, toDisplayString as me, resolveDynamicComponent as Xt, createTextVNode as Je, getCurrentScope as _s, onScopeDispose as Os, onBeforeUpdate as Ps, vShow as Pr, toHandlers as Bs, getCurrentInstance as T1, vModelSelect as Zs, vModelText as $1 } from "vue";
const As = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke-width="1.5" class="stroke-primary"/></svg>', Rs = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke-width="1.5" stroke-linejoin="bevel" d="M2.75 2.75H6.25V14.25H2.75z" class="stroke-primary"/><path stroke-width="1.5" stroke-linejoin="bevel" d="M10.25 7.75H13.75V17.25H10.25z" class="stroke-primary"/><path d="M2 21.25H22" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.75 10L17 10.75V20.5H18.5V11.5H20.5V20.5H22V10.75L21.25 10H17.75Z" class="fill-primary"/></svg>', Is = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="2.25" stroke-width="1.5" class="stroke-primary"/><path d="M7.43902 8.4997C5.85508 10.5582 5.85583 13.4411 7.43971 15.4996L4.24392 18.6954C0.922931 14.8564 0.922209 9.14288 4.24323 5.30391L7.43902 8.4997ZM19.7568 5.30391C23.0778 9.1429 23.0778 14.8571 19.7568 18.6961L16.561 15.5003C18.1449 13.4418 18.1449 10.5583 16.561 8.4997L19.7568 5.30391Z" stroke-width="1.5" class="stroke-primary"/></svg>', Ys = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#RtmK)" stroke-width="1.5" class="stroke-primary"><path d="M23.0001 20.2471H2.53125L18.5 2.1875"/><path d="M14.2913 20.1079C14.2913 16.6359 12.884 13.4926 10.6086 11.2173"/></g><defs><clipPath id="RtmK"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath></defs></svg>', Ns = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6.65151 6.206C7.08675 5.14456 7.72727 4.17951 8.53635 3.36621L20.9427 15.6579C19.3108 17.3001 17.0942 18.2282 14.779 18.2386C12.4638 18.2491 10.2389 17.3411 8.59217 15.7137C7.77577 14.9077 7.12655 13.9485 6.68173 12.891C6.23692 11.8336 6.00528 10.6987 6.00009 9.55154C5.9949 8.40435 6.21628 7.26743 6.65151 6.206Z" stroke-width="1.5" class="stroke-primary"/><path d="M18.5 8.25C18.5 6.7312 17.2688 5.49997 15.75 5.49997" stroke-width="1.5" class="stroke-primary"/><path d="M21.75 8.25C21.75 4.93629 19.0637 2.25 15.75 2.25" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.32204 16.4539L3.37757 20.8315L2.59155 22.0001H3.99989H10.2499H10.9999V21.2501V19.8106C10.4831 19.6332 9.98134 19.4137 9.49989 19.1541V20.5001H5.40823L7.35767 17.6018C7.30981 17.5563 7.26236 17.5103 7.21531 17.4638C6.8944 17.147 6.59606 16.8095 6.32204 16.4539Z" class="fill-primary"/></svg>', Fs = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.77422 6.70104C4.29142 5.4397 5.05259 4.2929 6.01404 3.32642L20.757 17.933C18.8177 19.8846 16.1837 20.9875 13.4324 20.9999C10.6812 21.0123 8.03727 19.9333 6.08038 17.9994C5.11022 17.0416 4.33872 15.9018 3.81013 14.6451C3.28154 13.3885 3.00627 12.0399 3.00011 10.6767C2.99394 9.31343 3.25701 7.96238 3.77422 6.70104Z" stroke-width="1.5" class="stroke-primary"/><path d="M17.8543 9.13009C17.8543 7.32524 16.3912 5.86212 14.5863 5.86212" stroke-width="1.5" class="stroke-primary"/><path d="M21.7163 9.13003C21.7163 5.19222 18.5241 2 14.5863 2" stroke-width="1.5" class="stroke-primary"/></svg>', Es = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.63575 11.5782L3.42279 20.8319L2.63855 22H4.04546H15.7642H16.5142V21.25V16.7184C16.0041 16.4912 15.5036 16.242 15.0142 15.9712V20.5H5.45238L10.6824 12.7103C10.3181 12.3464 9.96896 11.9687 9.63575 11.5782Z" class="fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.0004 16.2145C18.2918 15.739 14.8169 14.0599 12.1281 11.4027C10.5272 9.82224 9.25412 7.94126 8.38187 5.86765C7.85867 4.62386 7.48586 3.32546 7.26906 1.99998H8.79095C8.99324 3.12511 9.31915 4.22727 9.76452 5.28604C10.5603 7.17775 11.7217 8.89372 13.1822 10.3355L13.1824 10.3358C15.5899 12.715 18.6879 14.2348 22.0004 14.701V16.2145Z" class="fill-primary"/></svg>', zs = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M16.5 10.75H7.5" stroke-width="1.5" class="stroke-primary"/><path d="M15.5 6.75H8.5" stroke-width="1.5" class="stroke-primary"/><path d="M2 14.75L7 14.75L8 16.75H16L17 14.75L22 14.75" stroke-width="1.5" class="stroke-primary"/><path d="M19 2.75H5L2 14V21.25H22V14L19 2.75Z" stroke-width="1.5" class="stroke-primary"/></svg>', qs = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.3917 17.3917L6.60835 6.60828" stroke-width="1.5" class="stroke-primary"/></svg>', Us = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.75 20.5002H21.9999V5.5" stroke-width="1.5" class="stroke-primary"/><path d="M18.75 3.25H2V17.25H18.75V3.25Z" stroke-width="1.5" class="stroke-primary"/><path d="M13.125 10.25C13.125 11.7688 11.8938 13 10.375 13C8.85622 13 7.625 11.7688 7.625 10.25C7.625 8.73124 8.85622 7.5 10.375 7.5C11.8938 7.5 13.125 8.73124 13.125 10.25Z" stroke-width="1.5" class="stroke-primary"/></svg>', Ks = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="11.928" cy="20" r="2" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.9429 3.59447C10.9429 3.59447 10.8186 1.59425 12 1.60281C13.1814 1.61137 13.0571 3.59447 13.0571 3.59447V3.81401C14.6426 3.9635 15.7292 4.43055 16.4829 5.02709C17.4113 5.76183 17.7551 6.63232 17.9234 7.08709C17.9866 7.25782 18.0411 7.50494 18.0887 7.74735C18.1399 8.00867 18.195 8.32922 18.252 8.68279C18.3472 9.27293 18.4512 9.97552 18.5556 10.681L18.6175 11.0995C18.7432 11.9465 18.8671 12.7656 18.9776 13.3916C19.0331 13.706 19.0829 13.9583 19.1256 14.1357C19.1359 14.1787 19.145 14.2138 19.1527 14.242C19.3769 14.4327 19.9117 14.7719 21.0259 14.9677V16.4078H2.97351V14.9736C4.08766 14.7778 4.62243 14.4327 4.84665 14.242C4.85442 14.2138 4.86351 14.1787 4.87382 14.1357C4.91646 13.9583 4.96629 13.706 5.02181 13.3916C5.13232 12.7656 5.25614 11.9465 5.38183 11.0995L5.44376 10.6813C5.54814 9.9758 5.65213 9.27293 5.74733 8.68279C5.80437 8.32922 5.85943 8.00867 5.9107 7.74735C5.95827 7.50494 6.01279 7.25782 6.07598 7.08709C6.24428 6.63232 6.58808 5.76183 7.51645 5.02709C8.27029 4.43048 9.35703 3.96338 10.9429 3.81396V3.59447ZM17.8921 14.9394H6.09292C6.12196 14.7939 6.30121 13.8462 6.33081 13.6785C6.44587 13.0268 6.57285 12.1857 6.69805 11.342L6.7606 10.9197C6.86502 10.2139 6.96704 9.52437 7.06038 8.94579C7.11632 8.59904 7.16797 8.2995 7.21401 8.06488C7.23703 7.94755 7.25768 7.85146 7.27575 7.77662C7.28474 7.73941 7.29246 7.71008 7.29883 7.68778C7.30198 7.67678 7.30453 7.66839 7.30648 7.66232L7.30932 7.65381C7.44248 7.29399 7.66543 6.73255 8.28897 6.23906C8.86841 5.78048 9.85941 5.33086 11.5843 5.25976H12.4151C14.14 5.33086 15.131 5.78048 15.7104 6.23906C16.334 6.73255 16.5569 7.29399 16.6901 7.65381L16.6929 7.66232C16.6948 7.66839 16.6974 7.67678 16.7005 7.68778C16.7069 7.71008 16.7146 7.73941 16.7236 7.77662C16.7417 7.85146 16.7623 7.94755 16.7854 8.06488C16.8314 8.2995 16.8831 8.59904 16.939 8.94579C17.0323 9.52437 17.1344 10.2139 17.2388 10.9197L17.3013 11.342C17.4265 12.1857 17.5535 13.0268 17.6686 13.6785C17.6982 13.8462 17.8631 14.7939 17.8921 14.9394Z" class="fill-primary"/></svg>', Ws = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M4 4.75H20" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M4 12H20" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M4 19.25H20" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/></svg>', js = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M2.75 4H21.25V21.25H2.75V4Z" stroke-width="1.5" class="stroke-primary"/><path d="M6 8.75H18" stroke-width="1.5" class="stroke-primary"/><path d="M17.25 4V1" stroke-width="1.5" class="stroke-primary"/><path d="M6.75 4V1" stroke-width="1.5" class="stroke-primary"/></svg>', Qs = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6 17C13.4286 16 17.1429 13 19 6.99997" stroke-width="1.5" class="stroke-primary"/><path d="M21.0004 21.25L2.75037 21.25L2.75037 3" stroke-width="1.5" class="stroke-primary"/></svg>', Xs = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M16 5H20V21H4V5H8" stroke-width="1.5" stroke-linecap="round" class="stroke-primary"/><path d="M7.25 15.6699H16.75" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M7.25 11.6699H16.75" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M16 3H8V7H16V3Z" stroke-width="1.5" class="stroke-primary"/></svg>', Gs = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M4.75012 13.75L9.00012 18L19.7501 7.24997" stroke-width="1.5" class="stroke-primary"/></svg>', Js = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M15.4314 14.9429L11.6614 12.6939V6.84692" stroke-width="1.5" class="stroke-primary"/><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>', en = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M16.7393 19.5579L21.8328 11.9992L16.7393 4.44067" stroke-width="1.5" class="stroke-primary"/><path d="M7.26074 19.5579L2.16723 11.9992L7.26074 4.44067" stroke-width="1.5" class="stroke-primary"/><path transform="rotate(10 13.389 1.963)" stroke-width=".75" d="M13.389 1.963H14.139V22.213H13.389z" class="stroke-primary"/></svg>', tn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M14.2411 2.71875H9.75891L9.28535 5.61998C8.75181 5.84433 8.25235 6.13266 7.79662 6.47515L5.0563 5.43304L2.81458 9.31581L5.06997 11.1599C5.03407 11.4457 5.01561 11.7365 5.01561 12.0312C5.01561 12.326 5.03407 12.6168 5.06997 12.9025L2.81458 14.7467L5.05565 18.6283L7.79983 17.5898C8.2547 17.9312 8.75306 18.2187 9.28535 18.4425L9.75891 21.3438H14.2411L14.7147 18.4425C15.2482 18.2182 15.7476 17.9299 16.2034 17.5874L18.9437 18.6294L21.1855 14.7467L18.9301 12.9026C18.9659 12.6168 18.9844 12.326 18.9844 12.0312C18.9844 11.7365 18.9659 11.4457 18.9301 11.16L21.1855 9.31586L18.9443 5.43419L16.2002 6.47274C15.7453 6.1313 15.247 5.84381 14.7147 5.61998L14.2411 2.71875Z" stroke-width="1.5" class="stroke-primary"/><path d="M9.75 12C9.75 10.7573 10.7573 9.75 12 9.75C13.2427 9.75 14.25 10.7573 14.25 12C14.25 13.2427 13.2427 14.25 12 14.25C10.7573 14.25 9.75 13.2427 9.75 12Z" stroke-width="1.5" class="stroke-primary"/></svg>', rn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M11.0352 17.4642H7.46204V6.65181H16.6443V10.817" stroke-width="1.5" class="stroke-primary"/><path d="M6.98202 13.0631H3.40881V2.25075H12.5911V6.41591" stroke-width="1.5" class="stroke-primary"/><path transform="matrix(1 0 0 -1 11.339 21.75)" stroke-width="1.5" d="M0 0H9.252V10.812H0z" class="stroke-primary"/></svg>', an = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M1 8H4.5" stroke-width="1.5" class="stroke-primary"/><path d="M19.5 8H23" stroke-width="1.5" class="stroke-primary"/><path d="M8 4.5L8 1" stroke-width="1.5" class="stroke-primary"/><path d="M8 23L8 19.5" stroke-width="1.5" class="stroke-primary"/><path d="M1 12H4.5" stroke-width="1.5" class="stroke-primary"/><path d="M19.5 12H23" stroke-width="1.5" class="stroke-primary"/><path d="M12 4.5L12 1" stroke-width="1.5" class="stroke-primary"/><path d="M12 23L12 19.5" stroke-width="1.5" class="stroke-primary"/><path d="M1 16H4.5" stroke-width="1.5" class="stroke-primary"/><path d="M19.5 16H23" stroke-width="1.5" class="stroke-primary"/><path d="M16 4.5L16 1" stroke-width="1.5" class="stroke-primary"/><path d="M16 23L16 19.5" stroke-width="1.5" class="stroke-primary"/><path stroke-width="1.5" d="M6.75 6.75H17.25V17.25H6.75z" class="stroke-primary"/></svg>', sn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M8.37785 8H4V21.2472H15.25V16.1441" stroke-width="1.5" class="stroke-primary"/><path stroke-width="1.5" d="M8.75 2.75H20.085V15.997H8.75z" class="stroke-primary"/></svg>', nn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.25 6.48322L6.46662 17.2666" stroke-width="1.5" class="stroke-primary"/><path d="M17.2499 17.2666L6.4665 6.48322" stroke-width="1.5" class="stroke-primary"/></svg>', ln = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M18 2.99951H19C19.5523 2.99951 20 3.44723 20 3.99951V9.49951C20 10.9995 21 11.9995 22.5 11.9995H23" stroke-width="1.5" class="stroke-primary"/><path d="M18 20.9995H19C19.5523 20.9995 20 20.5518 20 19.9995V14.4995C20 12.9995 21 11.9995 22.5 11.9995H23" stroke-width="1.5" class="stroke-primary"/><path d="M6 20.9995H5C4.44772 20.9995 4 20.5518 4 19.9995V14.4995C4 12.9995 3 11.9995 1.5 11.9995H1" stroke-width="1.5" class="stroke-primary"/><path d="M6 2.99951H5C4.44772 2.99951 4 3.44723 4 3.99951V9.49951C4 10.9995 3 11.9995 1.5 11.9995H1" stroke-width="1.5" class="stroke-primary"/></svg>', on = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.25 12L22.7479 12" stroke-width="1.5" class="stroke-primary"/><path d="M1.25 12H6.75" stroke-width="1.5" class="stroke-primary"/><path d="M14.6245 7.45264L17.3735 2.69129" stroke-width="1.5" class="stroke-primary"/><path d="M6.62451 21.3088L9.37451 16.5457" stroke-width="1.5" class="stroke-primary"/><path d="M14.6245 16.5474L17.3735 21.3087" stroke-width="1.5" class="stroke-primary"/><path d="M6.62451 2.69116L9.37451 7.4543" stroke-width="1.5" class="stroke-primary"/></svg>', un = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path clip-rule="evenodd" d="M8.65918 15.341L10.2519 10.2517L15.3411 8.65906L13.7484 13.7483L8.65918 15.341Z" stroke-width="1.5" class="stroke-primary"/><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>', dn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.2499 21.25V2.75H9.74988L4.74988 7.75V21.25H19.2499Z" stroke-width="1.5" class="stroke-primary"/></svg>', cn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 3.6001L12 13.8001" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.6499 18.4254C10.6499 17.6799 11.2513 17.0754 11.9932 17.0754H12.0066C12.7485 17.0754 13.3499 17.6799 13.3499 18.4254C13.3499 19.171 12.7485 19.7754 12.0066 19.7754H11.9932C11.2513 19.7754 10.6499 19.171 10.6499 18.4254Z" class="fill-primary"/></svg>', pn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M15.25 12C15.25 12.6428 15.0594 13.2711 14.7023 13.8056C14.3452 14.3401 13.8376 14.7566 13.2437 15.0026C12.6499 15.2486 11.9964 15.313 11.366 15.1876C10.7355 15.0621 10.1564 14.7526 9.7019 14.2981C9.24738 13.8436 8.93785 13.2645 8.81245 12.634C8.68705 12.0036 8.75141 11.3501 8.99739 10.7563C9.24338 10.1624 9.65994 9.65484 10.1944 9.29772C10.7289 8.94061 11.3572 8.75 12 8.75C12.862 8.75 13.6886 9.09241 14.2981 9.7019C14.9076 10.3114 15.25 11.138 15.25 12Z" stroke-width="1.5" class="stroke-primary"/><path d="M23.0933 12C20.9803 15.3959 17.2514 19.9237 12 19.9237C6.74859 19.9237 3.01974 15.3959 0.906738 12C3.01974 8.60409 6.74859 4.07623 12 4.07623C17.2514 4.07623 20.9803 8.60409 23.0933 12Z" stroke-width="1.5" class="stroke-primary"/></svg>', hn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.06726 12L14.5135 20.0547V3.94434L3.06726 12Z" stroke-width="1.5" class="stroke-primary"/><path d="M15.0743 7.53906V9.37305L20.7365 5.38867V18.6104L15.0743 14.625V16.46L22.2365 21.5V2.5L15.0743 7.53906Z" class="fill-primary"/></svg>', mn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20.9327 12L9.48645 20.0547V3.94434L20.9327 12Z" stroke-width="1.5" class="stroke-primary"/><path d="M8.92566 7.53906V9.37305L3.26355 5.38867V18.6104L8.92566 14.625V16.46L1.76355 21.5V2.5L8.92566 7.53906Z" class="fill-primary"/></svg>', vn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M9.99903 20.5952V14.5L3.68933 7.25V2.75H20.3117V7.25L13.9999 14.5V18.2984L9.99903 20.5952Z" stroke-width="1.5" class="stroke-primary"/></svg>', fn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M4.75 22V2.75" stroke-width="1.5" class="stroke-primary"/><path d="M4 2.75H20.25L15.75 8.5L20.25 14.2956H4" stroke-width="1.5" class="stroke-primary"/></svg>', wn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.3999 19.9698L2.56039 19.8978C1.72491 18.369 1.25 16.615 1.25 14.75C1.25 8.81294 6.06294 4 12 4C17.9371 4 22.75 8.81294 22.75 14.75C22.75 16.6443 22.26 18.4242 21.3999 19.9698ZM6.011 7.70034C7.41109 6.50973 9.17037 5.7288 11.1035 5.54289V7.7819C11.3499 7.75565 11.6001 7.74219 11.8535 7.74219C12.1069 7.74219 12.3571 7.75565 12.6035 7.7819V5.51937C14.6517 5.65128 16.5184 6.44982 17.9889 7.70027L16.3916 9.2976C16.777 9.60783 17.1331 9.96229 17.4517 10.3588L19.0496 8.76092C20.2687 10.1944 21.0582 12.0045 21.2194 13.9922H18.8138C18.8401 14.2386 18.8535 14.4888 18.8535 14.7422C18.8535 14.9956 18.8401 15.2458 18.8138 15.4922H21.2207C21.1448 16.4471 20.924 17.3612 20.5802 18.2125C20.5802 18.2125 15.1713 18.2084 12.2913 18.1438L14.7058 12.7932L13.3264 12.2039L10.6861 18.1438C7.81289 18.1884 3.39244 18.1438 3.39244 18.1438C3.06425 17.3122 2.85312 16.4215 2.77934 15.4922H4.89323C4.86698 15.2458 4.85352 14.9956 4.85352 14.7422C4.85352 14.4888 4.86698 14.2386 4.89323 13.9922H2.7806C2.94177 12.0045 3.73132 10.1945 4.95034 8.761L6.54784 10.3585C6.70351 10.1657 6.87093 9.97925 7.05009 9.80009C7.22925 9.62093 7.4157 9.45351 7.6085 9.29784L6.011 7.70034Z" class="fill-primary"/></svg>', gn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path clip-rule="evenodd" d="M22 12C22 17.5232 17.5232 22 12 22C6.47676 22 2 17.5232 2 12C2 6.47676 6.47676 2 12 2C17.5232 2 22 6.47676 22 12Z" stroke-width="1.5" class="stroke-primary"/><path d="M11.5203 2.00049C8.77868 5.15355 4.94041 13.5677 11.5203 21.9999" stroke-width="1.5" class="stroke-primary"/><path d="M12.2163 2C14.9579 5.15306 18.7962 13.5672 12.2163 21.9994" stroke-width="1.5" class="stroke-primary"/><path d="M2 12L22 12" stroke-width="1.5" class="stroke-primary"/></svg>', yn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.2501 21.25H14.2501V14.75H9.75012V21.25H2.75012V11.2217L11.0135 2.75H12.9578L21.2501 11.2122V21.25Z" stroke-width="1.5" class="stroke-primary"/></svg>', kn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0581 11.3768C7.0825 11.7683 4.3856 13.047 2.24341 14.9377L3.23601 16.0623C4.95639 14.5439 7.07308 13.4656 9.41157 13.0026L10.0581 11.3768ZM14.7331 13.0321C17.0143 13.5103 19.0793 14.5752 20.7642 16.0623L21.7568 14.9377C19.9442 13.3379 17.7345 12.1763 15.2948 11.6195L14.7331 13.0321Z" class="fill-primary"/><path d="M15.8562 3.55835L9.11951 20.4" stroke-width="1.5" class="stroke-primary"/></svg>', Cn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M8.5 17.75L15.5 17.75" stroke-width="1.5" class="stroke-primary"/><path d="M5.75 2.75H18.2456V8L14.2456 12L18.2456 16V21.25H5.75V16L9.75 12L5.75 8V2.75Z" stroke-width="1.5" class="stroke-primary"/></svg>', bn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M15.4063 2.4375L13.5 21.5H15.0075L16.9137 2.4375H15.4063Z" class="fill-primary"/><path d="M8.90625 2.4375L7 21.5H8.50748L10.4137 2.4375H8.90625Z" class="fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.3506 15.5L2.5006 14H20.9931L20.8431 15.5L2.3506 15.5Z" class="fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.00072 9L3.15072 7.5H21.6432L21.4932 9L3.00072 9Z" class="fill-primary"/></svg>', Ln = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M2.75 2.75H21.25V21.25H2.75V2.75Z" stroke-width="1.5" stroke-linecap="round" class="stroke-primary"/><path clip-rule="evenodd" d="M11.5 8.6875C11.5 9.79259 10.6051 10.6875 9.5 10.6875C8.39599 10.6875 7.5 9.79259 7.5 8.6875C7.5 7.58241 8.39599 6.6875 9.5 6.6875C10.604 6.68858 11.4989 7.58349 11.5 8.6875Z" stroke-width="1.5" stroke-linecap="round" class="stroke-primary"/><path d="M20.797 15.7969L17.5001 12.5L14.5001 16.5L12.5001 14.5L7.40637 20.8438" stroke-width="1.5" stroke-linecap="square" class="stroke-primary"/></svg>', Mn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#umDx)"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.25 11.5C22.25 14.1234 20.1234 16.25 17.5 16.25C15.8418 16.25 14.3821 15.4003 13.5324 14.1126C13.337 14.6385 13.0842 15.1365 12.7818 15.599C13.9277 16.9169 15.6165 17.75 17.5 17.75C20.9518 17.75 23.75 14.9518 23.75 11.5H22.25ZM0.25 11.5H1.75C1.75 8.87665 3.87665 6.75 6.5 6.75C8.15819 6.75 9.61793 7.59968 10.4676 8.88739C10.663 8.36153 10.9158 7.86352 11.2182 7.40096C10.0723 6.08313 8.38347 5.25 6.5 5.25C3.04822 5.25 0.25 8.04822 0.25 11.5Z" class="fill-primary"/><path d="M1 11.5C1 14.5376 3.46243 17 6.5 17C9.53757 17 12 14.5376 12 11.5C12 8.46243 14.4624 6 17.5 6C20.5376 6 23 8.46243 23 11.5" stroke-width="1.5" class="stroke-primary"/></g><defs><clipPath id="umDx"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath></defs></svg>', Vn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M14.2528 13.8159C14.5124 13.8893 14.609 13.919 14.8827 13.9537C15.1117 13.9828 15.2631 14 15.5 14C18.5376 14 21.0001 11.5376 21.0001 8.5C21.0001 5.46243 18.5376 3 15.5 3C12.4625 3 10 5.46243 10 8.5C10 8.93684 10.051 9.36179 10.1472 9.76923C10.2021 10.0018 9.60458 10.5642 9.37744 10.7912" stroke-width="1.5" class="stroke-primary"/><path d="M9.73265 10.436L4 16.1667V20.5H8.2363V17.25H11.009V14.5417L12.5 14.9999C13.2583 14.3786 14.1216 13.7831 14.2856 13.8224" stroke-width="1.5" class="stroke-primary"/><circle cx="17" cy="7" r="1" class="fill-primary"/></svg>', xn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M4.29065 12.2501L15.317 2.50006L13.7209 11.7501H19.5817L8.68305 21.5001L9.99999 12.2501H4.29065Z" stroke-width="1.5" class="stroke-primary"/></svg>', Dn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.24988 8.75H20.7499V21.25H3.24988V8.75Z" stroke-width="1.5" class="stroke-primary"/><path d="M7.25 8.5V6.25C7.25 3.62665 9.37665 1.5 12 1.5C14.6234 1.5 16.75 3.62665 16.75 6.25V8.5" stroke-width="1.5" class="stroke-primary"/></svg>', Hn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#wpfd)" stroke-width="1.5" stroke-miterlimit="10" class="stroke-primary"><path d="M7.69531 3V8.45508M4.96875 5.72852H10.4238"/><path d="M18.3105 3.00049V8.6875M15.4688 5.84326H21.1558"/><path d="M18.3123 13.8125V19.8125M15.3123 16.8125H21.3123"/><path d="M13.0912 13.4251L5.38987 21.1264L3.03125 18.7678L10.7326 11.0664" stroke-linecap="round"/><path d="M13.1105 8.6875L10.7325 11.0654L13.0912 13.424L15.4691 11.0461L13.1105 8.6875Z" stroke-linecap="round"/></g><defs><clipPath id="wpfd"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath></defs></svg>', Tn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><ellipse cx="10.25" cy="10.25" rx="7.5" ry="7.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><path d="M15.4762 15.9928L20.0002 20.5076" stroke-width="1.5" class="stroke-primary"/></svg>', $n = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.4029 10.1526C19.4029 15.2448 12 21.1406 12 21.1406C10.5916 19.8451 4.59705 15.243 4.59705 10.1526C4.59705 8.18924 5.37699 6.30628 6.76531 4.91796C8.15363 3.52964 10.0366 2.74969 12 2.74969C13.9633 2.74969 15.8463 3.52964 17.2346 4.91796C18.6229 6.30628 19.4029 8.18924 19.4029 10.1526Z" stroke-width="1.5" class="stroke-primary"/><path d="M12 8.32812C12.3631 8.32812 12.7181 8.4358 13.02 8.63754C13.3219 8.83927 13.5572 9.126 13.6962 9.46148C13.8351 9.79695 13.8715 10.1661 13.8007 10.5222C13.7298 10.8784 13.555 11.2055 13.2982 11.4623C13.0414 11.719 12.7143 11.8939 12.3582 11.9647C12.002 12.0356 11.6329 11.9992 11.2974 11.8602C10.9619 11.7213 10.6752 11.486 10.4735 11.184C10.2717 10.8821 10.1641 10.5272 10.1641 10.1641C10.1641 9.67714 10.3575 9.21016 10.7018 8.86586C11.0461 8.52155 11.5131 8.32813 12 8.32812Z" stroke-width="1.5" class="stroke-primary"/></svg>', Sn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><ellipse cx="4.5" cy="12" rx="2" ry="2" class="fill-primary"/><circle cx="12" cy="12" r="2" class="fill-primary"/><circle cx="19.5" cy="12" r="2" class="fill-primary"/></svg>', _n = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M18.8921 7.85114L11.9893 13.5001L5.10791 7.85114" stroke-width="1.5" class="stroke-primary"/><path d="M2 3.5H22V20.5H2V3.5Z" stroke-width="1.5" stroke-linecap="round" class="stroke-primary"/></svg>', On = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.084 2.05859C22.0503 2.05859 22.8338 2.84229 22.834 3.80859V16.8379C22.834 17.8044 22.0505 18.5879 21.084 18.5879H14.5V20.7158H20.3672V22.2158H3.86719V20.7158H9.5V18.5879H3.15039C2.18389 18.5879 1.40039 17.8044 1.40039 16.8379V3.80859C1.40062 2.84229 2.18403 2.05859 3.15039 2.05859H21.084ZM3.15039 3.55859C3.01246 3.55859 2.90062 3.67072 2.90039 3.80859V14.1318C2.90039 14.2699 3.01232 14.3818 3.15039 14.3818H21.084C21.2221 14.3818 21.334 14.2699 21.334 14.1318V3.80859C21.3338 3.68813 21.2483 3.58791 21.1348 3.56445L21.084 3.55859H3.15039Z" class="fill-primary"/></svg>', Pn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3.875" stroke-width=".25" class="stroke-primary"/><rect x="2.25" y="2.25" width="19.5" height="19.5" rx="2.75" stroke-width=".5" class="stroke-primary"/></svg>', Bn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M2.75 2.75H13.25V21.25H2.75V2.75Z" stroke-width="1.5" class="stroke-primary"/><path d="M13.25 12.75H21.25V21.25H13.25V12.75Z" stroke-width="1.5" class="stroke-primary"/><path d="M6 6.75H10.0001" stroke-width="1.5" class="stroke-primary"/></svg>', Zn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M9.5085 20.7453C14.3589 22.0449 19.3445 19.1665 20.6442 14.3161C21.9439 9.46565 19.0654 4.48003 14.215 3.18036C10.1227 2.08384 5.93421 3.96139 3.94429 7.48809" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><circle cx="7.75" cy="20" r="1.75" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><circle cx="12" cy="12" r="2.5" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/></svg>', An = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7.00305 2.5H8.50305V21.5H7.00305V2.5Z" class="fill-primary"/><path d="M15.492 2.5H16.992V21.5H15.492z" class="fill-primary"/></svg>', Rn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M16.2224 3.75513L19.9741 7.50682L8.72557 18.8071L3.70051 20.168L4.97388 15.0554L16.2224 3.75513Z" stroke-width="1.5" class="stroke-primary"/><path d="M17.2226 10.8755L13.3142 6.9668" stroke-width="1.5" class="stroke-primary"/></svg>', In = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="17.75" cy="17.75" r="3" stroke-width="1.5" class="stroke-primary"/><circle cx="6.25" cy="6.25" r="3" stroke-width="1.5" class="stroke-primary"/><path d="M5 21L19 3" stroke-width="1.5" class="stroke-primary"/></svg>', Yn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.4463 12L6 20.0547V3.94434L17.4463 12Z" stroke-width="1.5" class="stroke-primary"/></svg>', Nn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 5.25V18.75" stroke-width="1.5" class="stroke-primary"/><path d="M18.75 12L5.25 12" stroke-width="1.5" class="stroke-primary"/></svg>', Fn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1V13V1Z" class="fill-primary"/><path d="M12 1V13" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M8.15622 4.26526C7.70664 4.49608 7.27984 4.76524 6.88082 5.06995L6.87594 5.06018C5.86519 5.83203 5.03237 6.82538 4.44625 7.97327L4.28903 8.29846C3.53486 9.94193 3.31519 11.7816 3.65719 13.5543L3.73239 13.9078C4.14933 15.6703 5.10674 17.2493 6.45993 18.4244L6.73532 18.6539C8.23413 19.8487 10.0866 20.498 11.9931 20.4996C13.8995 20.5012 15.7522 19.8548 17.2529 18.6627L17.5293 18.4342C17.9968 18.0296 18.4158 17.5756 18.7832 17.0836C18.8029 17.0574 18.8224 17.031 18.8418 17.0045C18.8875 16.9418 18.9316 16.878 18.9756 16.8141C19.938 15.4242 20.5048 13.7348 20.5048 11.9108C20.5048 9.8231 19.7643 7.91055 18.5351 6.42346C18.4918 6.37087 18.4469 6.31969 18.4023 6.26819C18.3526 6.21084 18.3031 6.15328 18.2519 6.09729C18.2008 6.04131 18.1482 5.98684 18.0957 5.93225C18.0429 5.87756 17.9897 5.8234 17.9355 5.77014C17.8861 5.7215 17.8366 5.67304 17.7861 5.62561C17.7306 5.57362 17.674 5.52279 17.6172 5.47229C17.5578 5.41952 17.4982 5.36716 17.4375 5.31604C17.3963 5.28153 17.3542 5.24822 17.3125 5.21448C17.2528 5.16618 17.1947 5.11568 17.1338 5.06897L17.1318 5.0719C16.7331 4.76722 16.3066 4.4981 15.8574 4.26721L16.5381 2.92151C18.5403 3.95031 20.1414 5.62938 21.082 7.68811L21.25 8.07678C21.9947 9.90539 22.1901 11.9152 21.8125 13.8551L21.7226 14.2692C21.2301 16.3356 20.1043 18.1889 18.5107 19.568L18.1865 19.8375C16.5314 21.1523 14.5098 21.9036 12.4121 21.9908L11.9912 21.9996C9.88461 21.9978 7.83625 21.3248 6.13571 20.0826L5.80075 19.8268C4.14793 18.5092 2.95163 16.7013 2.37887 14.6637L2.2734 14.2526C1.75193 12.0476 1.98175 9.72956 2.92575 7.67249C3.86978 5.61556 5.47272 3.93905 7.47653 2.9137L8.15622 4.26526Z" class="fill-primary"/></svg>', En = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20.488 21C19.2525 17.5044 15.9187 15 12.0001 15C8.08143 15 4.74772 17.5044 3.51221 21" stroke-width="1.5" class="stroke-primary"/><circle cx="12" cy="7" r="4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>', zn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7.1161 12.7528V13.5028H7.65083L7.82513 12.9973L7.1161 12.7528ZM10.8236 2L11.569 1.9171L10.1146 1.75553L10.8236 2ZM13.0481 22L12.3027 22.0829L13.7279 22.3168L13.0481 22ZM17.3569 12.7528V12.0028H16.879L16.6771 12.4361L17.3569 12.7528ZM1.25 13.5028H7.1161V12.0028H1.25V13.5028ZM7.82513 12.9973L11.5327 2.24447L10.1146 1.75553L6.40706 12.5084L7.82513 12.9973ZM10.0782 2.0829L12.3027 22.0829L13.7935 21.9171L11.569 1.9171L10.0782 2.0829ZM13.7279 22.3168L18.0367 13.0696L16.6771 12.4361L12.3682 21.6832L13.7279 22.3168ZM17.3569 13.5028H22.75V12.0028H17.3569V13.5028Z" class="fill-primary"/></svg>', qn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M11.8499 14.618C11.4107 14.3806 10.9193 14.2564 10.4201 14.2565C9.92084 14.2564 9.42944 14.3806 8.99022 14.618C8.551 14.8553 8.17778 15.1983 7.90424 15.6159C7.63071 16.0335 7.46546 16.5127 7.42341 17.0102C7.38137 17.5077 7.46384 18.0078 7.66339 18.4654V19.5179H2.15002V4.48315H7.47416V5.38468C7.38474 5.82165 7.39364 6.27303 7.50023 6.70613C7.60682 7.13922 7.80841 7.54319 8.09042 7.88874C8.37242 8.2343 8.72776 8.51279 9.13069 8.70404C9.53363 8.89529 9.97406 8.99452 10.4201 8.99452C10.8661 8.99452 11.3065 8.8953 11.7095 8.70404C12.1124 8.51279 12.4677 8.2343 12.7497 7.88874C13.0317 7.54319 13.2333 7.13922 13.3399 6.70613C13.4465 6.27303 13.4554 5.82165 13.366 5.38468V4.48315H18.7412V9.16729H19.1877C19.51 9.05476 19.8488 8.9969 20.1902 8.99612C20.6281 8.99611 21.0608 9.09176 21.4579 9.27637C21.855 9.46099 22.207 9.73012 22.4893 10.065C22.7716 10.3998 22.9773 10.7922 23.0921 11.2148C23.2069 11.6375 23.228 12.0801 23.1539 12.5117C23.0799 12.9433 22.9124 13.3536 22.6633 13.7137C22.4141 14.0739 22.0893 14.3753 21.7116 14.5968C21.3338 14.8184 20.9122 14.9548 20.4763 14.9964C20.0403 15.0381 19.6006 14.984 19.1877 14.838H18.7412V19.5179H13.1768V18.4654C13.3763 18.0078 13.4588 17.5076 13.4167 17.0102C13.3747 16.5127 13.2095 16.0335 12.9359 15.6159C12.6624 15.1983 12.2892 14.8553 11.8499 14.618Z" stroke-width="1.5" class="stroke-primary"/></svg>', Un = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7.00033 7.71708C6.93972 2.63001 15.1271 0.678775 17.1393 5.58083C19.2371 11.2535 11.7882 10.483 11.7882 15.3785V16.25" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5732 20.7587C10.5732 20.0131 11.1747 19.4087 11.9165 19.4087H11.93C12.6718 19.4087 13.2732 20.0131 13.2732 20.7587C13.2732 21.5043 12.6718 22.1087 11.93 22.1087H11.9165C11.1747 22.1087 10.5732 21.5043 10.5732 20.7587Z" class="fill-primary"/></svg>', Kn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M2 12C4 -8.58307e-06 10 1.43051e-05 12 12C14 24 20 24 22 12" stroke-width="1.5" class="stroke-primary"/></svg>', Wn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7.5 18.4902V22.7812H16.5V18.4902" stroke-width="1.5" class="stroke-primary"/><path d="M17.25 20H6.75" stroke-width="1.5" class="stroke-primary"/><path clip-rule="evenodd" d="M21.25 10.7499C21.25 15.8589 17.109 19.9999 12 19.9999C6.891 19.9999 2.75 15.8589 2.75 10.7499C2.75 5.64094 6.891 1.49994 12 1.49994C17.109 1.49994 21.25 5.64094 21.25 10.7499Z" stroke-width="1.5" class="stroke-primary"/><path d="M2.75 10.7499L21.25 10.7499" stroke-width="1.5" class="stroke-primary"/><path d="M11.51 1.5L12.9593 2.90869C17.0783 6.91239 17.0783 14.5876 12.9593 18.5913L11.51 20" stroke-width="1.5" class="stroke-primary"/><path d="M12.5385 1.5L11.0893 2.90869C6.97025 6.91239 6.97024 14.5876 11.0893 18.5913L12.5385 20" stroke-width="1.5" class="stroke-primary"/></svg>', jn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path clip-rule="evenodd" d="M3.75 2.5V21.625L6.5 19.4688L9.25 21.625L12 19.4688L14.75 21.625L17.5 19.4688L20.25 21.625V2.5H3.75Z" stroke-width="1.5" class="stroke-primary"/><path d="M7.6875 7.25H16.3125" stroke-width="1.5" class="stroke-primary"/><path d="M7.6875 11.25H16.3125" stroke-width="1.5" class="stroke-primary"/></svg>', Qn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.4384 20.8532C7.18954 21.2976 8.70856 18.9677 8.66132 17.8484L6.18723 15.3525C5.14143 15.438 2.55878 17.9025 3.4384 20.8532Z" stroke-width="1.5" class="stroke-primary"/><path d="M10.6479 6.99384L6.38598 7.55567L2.45317 11.4885L8.60914 12.0261" stroke-width="1.5" class="stroke-primary"/><path d="M12.0284 15.4457L12.5661 21.6016L16.4989 17.6688L17.0607 13.4069" stroke-width="1.5" class="stroke-primary"/><path d="M20.9935 3.06114C20.9935 3.06114 16.1893 1.23688 12.2975 5.02641C11.3801 5.92029 10.698 7.02709 10.2041 8.20974L8.60911 12.0262L12.0284 15.4455L15.8455 13.8511C17.027 13.3572 18.1349 12.6752 19.0282 11.7571C22.8178 7.86534 20.9935 3.06114 20.9935 3.06114Z" stroke-width="1.5" class="stroke-primary"/></svg>', Xn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M8.3434 18.3139C6.89115 18.3139 5.71387 17.1366 5.71387 15.6843" stroke-width="1.5" class="stroke-primary"/><path d="M8.34377 21.26C5.28004 21.26 2.79639 18.7764 2.79639 15.7126" stroke-width="1.5" class="stroke-primary"/><path d="M11.5 9.75L18.25 3L21.75 6.49997L15 13.2501" stroke-width="1.5" class="stroke-primary"/><path d="M6.60349 11.3191L13.0763 17.7919C14.714 16.0607 14.8854 13.1909 14.8854 13.1909L11.1891 9.49443C11.1891 9.49443 8.4908 9.44759 6.60349 11.3191Z" stroke-width="1.5" class="stroke-primary"/><path d="M21.9796 11.2855L19.5 8.80591L17.0204 11.2855L19.5 13.7652L21.9796 11.2855Z" stroke-width="1.5" class="stroke-primary"/><path d="M15.8715 5.34053L13.0483 2.51733L10.4818 5.08387L13.305 7.90707L15.8715 5.34053Z" stroke-width="1.5" class="stroke-primary"/></svg>', Gn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.34058C13.0257 2.25533 14.6503 3.10265 16.3623 3.78394C18.0744 4.46524 19.874 4.98022 21.25 5.23022V8.84058C21.25 14.6529 17.731 19.9962 12.5107 22.5974L12 22.8406L11.4893 22.5974C6.26905 19.9962 2.75 14.6529 2.75 8.84058V5.23022C4.12602 4.98022 5.92565 4.46525 7.6377 3.78394C9.34967 3.10265 10.9743 2.25533 12 1.34058Z" stroke-width="1.5" class="stroke-primary"/></svg>', Jn = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M15 4.23529L9 20.2353" stroke-width="1.5" class="stroke-primary"/></svg>', el = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12.5 16.75H4" stroke-width="1.5" class="stroke-primary"/><path d="M11.5 7.25H20" stroke-width="1.5" class="stroke-primary"/><path clip-rule="evenodd" d="M8.75 7.125C8.75 5.81347 7.68653 4.75 6.375 4.75C5.06347 4.75 4 5.81347 4 7.125C4 8.43653 5.06347 9.5 6.375 9.5C7.68653 9.5 8.75 8.43653 8.75 7.125Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><path clip-rule="evenodd" d="M20.25 16.625C20.25 15.3135 19.1873 14.25 17.8758 14.25C16.5635 14.25 15.5 15.3135 15.5 16.625C15.5 17.9365 16.5635 19 17.8758 19C19.1873 19 20.25 17.9365 20.25 16.625Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>', tl = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.25 2.75H2.75V17.25H11L17.25 21V17.25H21.25V2.75Z" stroke-width="1.5" class="stroke-primary"/></svg>', rl = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M11.8629 12.4258L14.5719 7.83633" stroke-width="1.5" class="stroke-primary"/><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><path d="M18.9996 12L21.9996 12" stroke-width="1.5" class="stroke-primary"/><path d="M2.00037 12L5.00037 12" stroke-width="1.5" class="stroke-primary"/><path d="M15.4993 5.93683L16.9999 3.3377" stroke-width="1.5" class="stroke-primary"/><path d="M8.49894 18.0609L6.99963 20.6578" stroke-width="1.5" class="stroke-primary"/><path d="M15.4993 18.0631L16.9999 20.6622" stroke-width="1.5" class="stroke-primary"/><path d="M8.49894 5.93904L6.99963 3.34216" stroke-width="1.5" class="stroke-primary"/></svg>', al = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 3.3125L14.6356 9.18487L21.035 9.87684L16.2645 14.1981L17.584 20.4982L12 17.2965L6.41604 20.4982L7.73546 14.1981L2.96496 9.87684L9.36437 9.18487L12 3.3125Z" stroke-width="1.5" class="stroke-primary"/></svg>', sl = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20.75 3.25V20.75H3.25V3.25H20.75Z" stroke-width="1.5" class="stroke-primary"/></svg>', nl = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6.1483 3.90479L4.32415 5.72894L2.5 7.55309" stroke-width="1.5" class="stroke-primary"/><path d="M17.8517 3.90479L19.6758 5.72894L21.5 7.55309" stroke-width="1.5" class="stroke-primary"/><path clip-rule="evenodd" d="M19.9999 14C19.9999 18.4186 16.4186 21.9999 12 21.9999C7.5814 21.9999 4 18.4186 4 14C4 11.8844 4.82099 9.96076 6.16178 8.53022C7.62137 6.97293 9.69696 6 12 6C16.4186 6 19.9999 9.5814 19.9999 14Z" stroke-width="1.5" class="stroke-primary"/><path d="M11.531 13.9541L15.1793 10.2732" stroke-width="1.5" class="stroke-primary"/></svg>', ll = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M10 5H21.0005" stroke-width="1.5" class="stroke-primary"/><path d="M10 19H21.0005" stroke-width="1.5" class="stroke-primary"/><path d="M10 12H21.0005" stroke-width="1.5" class="stroke-primary"/><circle cx="4.5" cy="19" r="1.5" stroke-width="1.5" class="stroke-primary"/><circle cx="4.5" cy="12" r="1.5" stroke-width="1.5" class="stroke-primary"/><circle cx="4.5" cy="5" r="1.5" stroke-width="1.5" class="stroke-primary"/></svg>', il = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path clip-rule="evenodd" d="M12.25 21.7539L21.75 12.2539L12.25 2.75391L2.75 2.75391L2.75 12.2539L12.25 21.7539Z" stroke-width="1.5" class="stroke-primary"/><path d="M8.09375 10.0312C7.05819 10.0312 6.21875 9.19175 6.21875 8.15624C6.21875 7.12071 7.05819 6.28125 8.09375 6.28125C9.12931 6.28125 9.96875 7.12071 9.96875 8.15624C9.96875 9.19175 9.12931 10.0312 8.09375 10.0312Z" stroke-width="1.5" class="stroke-primary"/></svg>', ol = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M4 4.75H20" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M4 12H20" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M4 19.25H14" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/></svg>', ul = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.99988L3.5 6.99988L12 11.9999L20.5 6.99988L12 1.99988Z" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.96135 11.8424L11.6229 17.4644L12.0001 17.6839L12.3773 17.4644L22.0391 11.8422L20.5558 10.9699L12.0001 15.9484L3.44465 10.97L1.96135 11.8424Z" class="fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.96135 16.3425L11.6229 21.9645L12.0001 22.184L12.3773 21.9645L22.0391 16.3424L20.5558 15.47L12.0001 20.4486L3.44465 15.4702L1.96135 16.3425Z" class="fill-primary"/></svg>', dl = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20.854 6.75H18.4192V21.25H5.58085V6.75H3.146" stroke-width="1.5" class="stroke-primary"/><path d="M8.5 6.25L9.5 3.25H14.5L15.5 6.25" stroke-width="1.5" class="stroke-primary"/><path d="M5 6.75H19" stroke-width="1.5" class="stroke-primary"/></svg>', cl = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M18.0039 15.2498L22.0039 15.2498" stroke-width="1.5" class="stroke-primary"/><path d="M6 8.74979L2 8.74979" stroke-width="1.5" class="stroke-primary"/><path d="M15.25 17.9998L15.25 21.9998" stroke-width="1.5" class="stroke-primary"/><path d="M8.75 5.99979L8.75 1.99979" stroke-width="1.5" class="stroke-primary"/><path d="M12.8782 15.3515L7.05005 21.1797L2.80741 16.937L8.64335 11.1011" stroke-width="1.5" class="stroke-primary"/><path d="M11.1205 8.64604L16.9465 2.82001L21.1892 7.06265L15.3556 12.8963" stroke-width="1.5" class="stroke-primary"/></svg>', pl = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M16.8274 17.5918C16.1247 15.6037 14.2287 14.1793 12 14.1793C9.77131 14.1793 7.87529 15.6037 7.17261 17.5918" stroke-width="1.5" class="stroke-primary"/><circle cx="12" cy="9.63" r="2.275" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><rect x="3.249" y="17.341" width="17.525" height="3.408" rx="1.25" stroke-width="1.5" class="stroke-primary"/><path d="M3.25 19.0444L3.25 3.55542" stroke-width="1.5" class="stroke-primary"/><path d="M20.7739 18.7627L20.7739 3.55542" stroke-width="1.5" class="stroke-primary"/><rect x="15.091" y="2.72" width="6.3" height="3.484" rx="1.742" class="fill-primary"/><rect x="8.791" y="2.486" width="6.3" height="3.718" rx="1.859" class="fill-primary"/><rect x="2.491" y="2.687" width="6.3" height="3.517" rx="1.759" class="fill-primary"/><rect x="2.487" y="2.486" width="19.025" height="2.138" rx="1.069" class="fill-primary"/></svg>', hl = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="18.122" r="1" transform="rotate(-45 12 18.122)" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M7.10352 14.2148C9.80976 11.5089 14.1968 11.5079 16.9043 14.2119L15.8438 15.2725C13.7221 13.1542 10.2845 13.1552 8.16406 15.2754C8.16325 15.2762 8.16194 15.2765 8.16113 15.2773L7.10059 14.2168C7.1014 14.216 7.1027 14.2157 7.10352 14.2148ZM3.89062 11.0068C8.36866 6.53145 15.6275 6.53276 20.1045 11.0098L20.1055 11.0107L19.0449 12.0713L19.0439 12.0703C15.1527 8.17909 8.84342 8.17779 4.95117 12.0674L3.89062 11.0068ZM0.686523 7.80274C6.93495 1.55485 17.0653 1.5555 23.3135 7.80372L22.2529 8.86426C16.5905 3.20183 7.40971 3.20118 1.74707 8.86329L0.686523 7.80274Z" class="fill-primary"/></svg>', ml = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M13.1572 14.0216C15.2826 14.9221 17.8333 14.5061 19.5659 12.7735C20.6653 11.6741 21.2346 10.2453 21.2738 8.80474L19.8239 7.35487L17.9856 9.19319C17.1305 10.0482 15.7443 10.0482 14.8892 9.19319C14.0342 8.33816 14.0342 6.95188 14.8892 6.09684L16.7275 4.25852L15.2777 2.80865C13.8371 2.84783 12.4084 3.41713 11.3089 4.51655C9.57633 6.24915 9.16031 8.79977 10.0609 10.9252L3.052 17.9341L6.14835 21.0304L13.1572 14.0216Z" stroke-width="1.5" class="stroke-primary"/></svg>', vl = {
  "16/arrow.revolving.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M2.11365 14.5094V10.4266H6.19638" stroke-width="2" class="stroke-primary"/><path d="M14.0828 1.91727L14.0828 6L10 6" stroke-width="2" class="stroke-primary"/><path d="M2.11365 7.99999C2.11365 4.72143 4.77239 2.06363 8.05212 2.06363C10.5443 2.06363 12.678 3.59831 13.5589 5.77386M3.14151 11.3392C4.21042 12.907 6.01101 13.9364 8.05212 13.9364C10.9513 13.9364 13.3652 11.8596 13.8864 9.11306" stroke-width="2" class="stroke-primary"/></svg>',
  "16/cross": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M13.3917 2.60834L2.60833 13.3917M13.3917 13.3917L2.60828 2.60835" stroke-width="1.5" class="stroke-primary"/></svg>',
  "16/fastBackward.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M2.4801 7.99951L9.42542 12.8882V3.11084L2.4801 7.99951Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M10.0499 5.02588V10.9731L14.8234 14.3335V1.6665L10.0499 5.02588Z" class="fill-primary"/></svg>',
  "16/fastForward.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M13.52 7.99951L6.57465 12.8882V3.11084L13.52 7.99951Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M5.95013 5.02588V10.9731L1.1767 14.3335V1.6665L5.95013 5.02588Z" class="fill-primary"/></svg>',
  "16/pause.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M3.50061 1.66666H5.50061V14.3333H3.50061V1.66666Z" class="fill-primary"/><path d="M10.5 1.66666H12.5V14.3333H10.5V1.66666Z" class="fill-primary"/></svg>',
  "16/pencil.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.1792 4.45266L10.7266 1L8.65541 3.08071L12.1081 6.53337L14.1792 4.45266ZM10.8621 7.7851L7.40941 4.33245L2.1709 9.59506L1 14.2963L5.62852 13.0427L10.8621 7.7851Z" class="fill-primary"/></svg>',
  "16/play.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M11.1963 7.99966L4.25 12.8883V3.11099L11.1963 7.99966Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  "16/plus": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M8 1.25V14.75" stroke-width="1.5" class="stroke-primary"/><path d="M14.75 8L1.25 8" stroke-width="1.5" class="stroke-primary"/></svg>',
  "16/status.down": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M16 13.6533L15.0479 15H0.952148L0 13.6533L7.28613 1H8.72363L16 13.6533ZM7.99414 10.5C7.38426 10.5001 6.88965 10.9974 6.88965 11.6104C6.88984 12.2231 7.38438 12.7196 7.99414 12.7197H8.00586C8.61552 12.7195 9.11016 12.2231 9.11035 11.6104C9.11035 10.9975 8.61564 10.5002 8.00586 10.5H7.99414ZM7.16504 9.28516H8.83496V5.94141H7.16504V9.28516Z" class="fill-secondary"/><path d="M8.43457 1.5L15.4062 13.625L14.7891 14.5H1.21094L0.592773 13.626L7.57617 1.5H8.43457Z" class="stroke-primary"/></svg>',
  "16/status.ok": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.0026 15.3978C12.0882 15.3978 15.4002 12.0858 15.4002 8.00022C15.4002 3.91466 12.0882 0.602661 8.0026 0.602661C3.91704 0.602661 0.605042 3.91466 0.605042 8.00022C0.605042 12.0858 3.91704 15.3978 8.0026 15.3978ZM6.91545 11.344L11.8395 6.42404L10.6592 5.24268L6.91594 8.98277L5.34113 7.40796L4.16026 8.58883L6.91545 11.344Z" class="fill-secondary"/><circle cx="8" cy="8" r="6.898" class="stroke-primary"/></svg>',
  "16/status.partial": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M8.00293 0.602539C12.0885 0.602539 15.4003 3.91449 15.4004 8C15.4004 12.0856 12.0885 15.3975 8.00293 15.3975C3.91753 15.3973 0.605469 12.0854 0.605469 8C0.605523 3.9146 3.91756 0.602725 8.00293 0.602539ZM7.89062 10.0996C7.33847 10.0996 6.89084 10.5475 6.89062 11.0996V11.3223C6.89065 11.8745 7.33836 12.3223 7.89062 12.3223H8.11328C8.66535 12.322 9.11326 11.8744 9.11328 11.3223V11.0996C9.11307 10.5476 8.66524 10.0998 8.11328 10.0996H7.89062ZM7.16602 8.66699H8.83301V4H7.16602V8.66699Z" class="fill-secondary"/><circle cx="8.003" cy="8" r="6.898" class="stroke-primary"/></svg>',
  "16/stop.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M13.5837 2.41666V13.5836H2.41669V2.41666H13.5837Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  "16/triangle.filled+exclamationMark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.6069 14.5625H1.39261L0.499756 13.3001L7.33092 1.4375H8.67775L15.4998 13.3001L14.6069 14.5625ZM8.83481 5.94141V9.28524H7.16481V5.94141H8.83481ZM7.99437 10.7747C7.38438 10.7747 6.88989 11.2716 6.88989 11.8847C6.88989 12.4977 7.38438 12.9947 7.99437 12.9947H8.00541C8.6154 12.9947 9.10989 12.4977 9.10989 11.8847C9.10989 11.2716 8.6154 10.7747 8.00541 10.7747H7.99437Z" class="fill-primary"/></svg>',
  "16/wrench.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M13.8606 8.61134C12.515 9.95686 10.5343 10.2799 8.88366 9.58058L3.32544 15L0.995667 12.6702L6.47906 7.17598C5.7797 5.52539 6.10279 3.5446 7.44831 2.19908C8.30211 1.34528 9.4117 0.903166 10.5304 0.872742L11.7859 2.12826L9.14987 4.83984L11.1843 6.93878L13.8904 4.23272L15.1869 5.52924C15.1565 6.64795 14.7144 7.75754 13.8606 8.61134Z" class="fill-primary"/></svg>',
  "20/form/checkbox": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><rect x="2" y="2" width="16" height="16" rx="1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "20/form/checkbox.filled+checkmark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path d="M17 1.25C17.9665 1.25 18.75 2.0335 18.75 3V17C18.75 17.9665 17.9665 18.75 17 18.75H3C2.0335 18.75 1.25 17.9665 1.25 17V3C1.25 2.0335 2.0335 1.25 3 1.25H17ZM8.94922 11.8887L6.53027 9.46973L5.46973 10.5303L9.05078 14.1113L9.57617 13.4805L14.5762 7.48047L13.4238 6.51953L8.94922 11.8887Z" class="fill-primary"/></svg>',
  "20/form/checkbox.filled+dash": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path d="M17 1.25C17.9665 1.25 18.75 2.0335 18.75 3V17C18.75 17.9665 17.9665 18.75 17 18.75H3C2.0335 18.75 1.25 17.9665 1.25 17V3C1.25 2.0335 2.0335 1.25 3 1.25H17ZM6 9.25V10.75H14V9.25H6Z" class="fill-primary"/></svg>',
  "20/form/checkmark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path d="M6 10L9 13L14 7" stroke-width="1.5" class="stroke-primary"/></svg>',
  "20/form/radio": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "20/form/radio.selected": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><circle cx="10" cy="10" r="3.25" class="fill-primary"/></svg>',
  "20/pulse": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path d="M6.5 11.125V12H7.11303L7.32239 11.4238L6.5 11.125ZM9.17981 3.75L10.0455 3.6226L8.35741 3.45117L9.17981 3.75ZM11.2033 17.5L10.3376 17.6274L11.9928 17.8773L11.2033 17.5ZM14.25 11.125V10.25H13.6984L13.4605 10.7477L14.25 11.125ZM2 11.125V12H6.5V11.125V10.25H2V11.125ZM6.5 11.125L7.32239 11.4238L10.0022 4.04883L9.17981 3.75L8.35741 3.45117L5.67761 10.8262L6.5 11.125ZM11.2033 17.5L11.9928 17.8773L15.0395 11.5023L14.25 11.125L13.4605 10.7477L10.4138 17.1227L11.2033 17.5ZM14.25 11.125V12H18V11.125V10.25H14.25V11.125ZM9.17981 3.75L8.31413 3.8774L10.3376 17.6274L11.2033 17.5L12.069 17.3726L10.0455 3.6226L9.17981 3.75Z" class="fill-primary"/></svg>',
  "30/circle+checkmark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30"><circle cx="15" cy="15" r="14.5" class="stroke-primary"/><path d="M9.56256 16.3125L12.7501 19.5L20.8126 11.4375" stroke-width="1.125" class="stroke-primary"/></svg>',
  "30/circle.filled+checkmark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30"><path d="M9.56256 16.3125L12.7501 19.5L20.8126 11.4375" stroke-width="1.125" class="stroke-backdrop"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM13.1478 19.8978L21.2103 11.8352L20.4148 11.0398L12.7501 18.7045L9.96031 15.9148L9.16481 16.7102L12.3523 19.8978L12.7501 20.2955L13.1478 19.8978Z" class="fill-secondary"/><circle cx="15" cy="15" r="14.5" class="stroke-primary"/></svg>',
  "30/circle.filled+triangle.filled+excalmationMark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30"><circle cx="15" cy="15" r="15" class="fill-primary"/><path d="M13 11H17V20H13z" class="fill-backdrop"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.9376 20.75H8.06256L7.12506 19.4375L14.2978 7.25L15.712 7.25081L22.8751 19.4375L21.9376 20.75ZM15.7501 11.9416V15.2854H14.2501V11.9416H15.7501ZM14.9954 16.7748C14.4802 16.7748 14.0626 17.1945 14.0626 17.7123C14.0626 18.2301 14.4802 18.6498 14.9954 18.6498H15.0047C15.5199 18.6498 15.9376 18.2301 15.9376 17.7123C15.9376 17.1945 15.5199 16.7748 15.0047 16.7748H14.9954Z" class="fill-secondary"/></svg>',
  activityIndicator: As,
  activityMonitor: Rs,
  "activityMonitor.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke-width="1.5" stroke-linejoin="bevel" d="M2.75 2.75H6.25V14.25H2.75z" class="stroke-primary fill-primary"/><path stroke-width="1.5" stroke-linejoin="bevel" d="M10.25 7.75H13.75V17.25H10.25z" class="stroke-primary fill-primary"/><path d="M2 21.25H22" stroke-width="1.5" class="stroke-primary"/><path stroke-width="1.5" stroke-linejoin="bevel" d="M17.75 10.752H21.25V21.25H17.75z" class="stroke-primary fill-primary"/></svg>',
  alarm: Is,
  "allotment/grid": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M2 4L4 2" stroke-width="1.5" class="stroke-primary"/><path d="M20 22L22 20" stroke-width="1.5" class="stroke-primary"/><path d="M2 10L10 2" stroke-width="1.5" class="stroke-primary"/><path d="M14 22L22 14" stroke-width="1.5" class="stroke-primary"/><path d="M2 16L16 2" stroke-width="1.5" class="stroke-primary"/><path d="M8 22L22 8" stroke-width="1.5" class="stroke-primary"/><path d="M2 22L22 2" stroke-width="1.5" class="stroke-primary"/></svg>',
  "allotment/grid+dedicated": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#Xnyq)"><path d="M9.08301 15.875C9.08301 15.9082 9.08467 15.9414 9.08496 15.9746L2.53027 22.5303L1.46973 21.4697L9.08301 13.8564V15.875ZM9.73242 19.6523C9.87254 20.0494 10.0335 20.4377 10.2148 20.8154C10.218 20.822 10.2214 20.8284 10.2246 20.835L8.53027 22.5303L7.46973 21.4697L9.62109 19.3174C9.65687 19.4296 9.6933 19.5415 9.73242 19.6523ZM16.5303 2.53027L2.53027 16.5303L1.46973 15.4697L15.4697 1.46973L16.5303 2.53027ZM18.6357 12.1074C18.6088 12.0921 18.5821 12.0769 18.5557 12.0615C18.582 12.0769 18.6088 12.0921 18.6357 12.1074ZM18.2832 11.8926C18.2908 11.8975 18.298 11.9033 18.3057 11.9082C18.2714 11.8861 18.237 11.865 18.2041 11.8428L18.2832 11.8926ZM10.5303 2.53027L2.53027 10.5303L1.46973 9.46973L9.46973 1.46973L10.5303 2.53027ZM22.5303 2.53027L17.6641 7.39551L17.5 7.24902L15.2324 9.27051C15.2071 9.29305 15.1631 9.32441 15.1016 9.36523C14.9316 9.4781 14.6227 9.65491 14.1631 9.85352L13.877 9.97168C13.4902 10.1256 13.0995 10.2547 12.7441 10.3574C12.6677 10.3796 12.5924 10.3985 12.5195 10.418L21.4697 1.46973L22.5303 2.53027ZM22.5303 8.53027L21.0986 9.96094C20.6863 9.79575 20.3716 9.64141 20.1494 9.51758C20.0527 9.46371 19.9731 9.41651 19.9111 9.37598L19.7666 9.27051L19.7148 9.22363L21.4697 7.46973L22.5303 8.53027ZM4.53027 2.53027L2.53027 4.53027L1.46973 3.46973L3.46973 1.46973L4.53027 2.53027Z" class="fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 11.2682L17.7704 11.5093C18.2727 11.9573 19.1001 12.3953 20.0131 12.7587C20.9186 13.119 21.8674 13.3899 22.5831 13.5199L22.9167 13.5805V15.875C22.9167 19.2945 20.7829 22.4124 17.6681 23.8282L17.5 23.9046L17.3319 23.8282C14.2172 22.4124 12.0834 19.2945 12.0834 15.875V13.5805L12.417 13.5199C13.1327 13.3899 14.0815 13.119 14.987 12.7587C15.9 12.3953 16.7274 11.9573 17.2296 11.5093L17.5 11.2682ZM14.4769 17.8817L16.6189 20.0236L20.523 16.1228L19.7573 15.3564L16.6192 18.4919L15.243 17.1157L14.4769 17.8817Z" class="fill-primary"/><path d="M17.5 23.4576C14.5209 22.1034 12.4896 19.1243 12.4896 15.8743V13.9189C13.9803 13.648 16.3889 12.8027 17.5 11.8118C18.6111 12.8027 21.0198 13.648 22.5105 13.9189V15.8743C22.5105 19.1243 20.4792 22.1034 17.5 23.4576Z" stroke-width=".813" class="stroke-primary"/></g><defs><clipPath id="Xnyq"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath></defs></svg>',
  "allotment/grid+fullDowntime": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#DBCY)" fill-rule="evenodd" clip-rule="evenodd" class="fill-primary"><path d="M17.5003 11.6769C14.2844 11.6769 11.6774 14.2839 11.6774 17.4998C11.6774 20.7157 14.2844 23.3227 17.5003 23.3227C20.7162 23.3227 23.3232 20.7157 23.3232 17.4998C23.3232 14.2839 20.7162 11.6769 17.5003 11.6769ZM15.5931 20.4677L20.4681 15.5927L19.4075 14.532L14.5325 19.407L15.5931 20.4677Z"/><path d="M2.53039 4.53039L4.53039 2.53039L3.46973 1.46973L1.46973 3.46973L2.53039 4.53039ZM2.53039 10.5304L10.5304 2.53039L9.46973 1.46973L1.46973 9.46973L2.53039 10.5304ZM2.53039 16.5304L16.5304 2.53039L15.4697 1.46973L1.46973 15.4697L2.53039 16.5304ZM16.5065 8.55428L22.5304 2.53039L21.4697 1.46973L13.5076 9.43181C14.429 8.97504 15.4397 8.67143 16.5065 8.55428ZM8.55428 16.5065C8.67143 15.4397 8.97504 14.429 9.43181 13.5076L1.46973 21.4697L2.53039 22.5304L8.55428 16.5065ZM8.87166 20.0678C9.02825 20.5948 9.23181 21.1016 9.47748 21.5833L8.53039 22.5304L7.46973 21.4697L8.87166 20.0678ZM21.5833 9.47748C21.1016 9.23181 20.5948 9.02825 20.0678 8.87166L21.4697 7.46973L22.5304 8.53039L21.5833 9.47748Z"/></g><defs><clipPath id="DBCY"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath></defs></svg>',
  "allotment/grid+partialDowntime": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#SpRt)"><g clip-path="url(#TFWN)"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.3232 17.4998C23.3232 20.7157 20.7162 23.3227 17.5003 23.3227C14.2844 23.3227 11.6774 20.7157 11.6774 17.4998C11.6774 14.2839 14.2844 11.6769 17.5003 11.6769C20.7162 11.6769 23.3232 14.2839 23.3232 17.4998ZM16.7499 14.2498H18.2499V18.0415H16.7499V14.2498ZM17.5006 19.3054C17.002 19.3054 16.5978 19.7096 16.5978 20.2082C16.5978 20.7068 17.002 21.111 17.5006 21.111C17.9991 21.111 18.4033 20.7068 18.4033 20.2082C18.4033 19.7096 17.9991 19.3054 17.5006 19.3054Z" class="fill-primary"/></g><path fill-rule="evenodd" clip-rule="evenodd" d="M2.53039 4.53039L4.53039 2.53039L3.46973 1.46973L1.46973 3.46973L2.53039 4.53039ZM2.53039 10.5304L10.5304 2.53039L9.46973 1.46973L1.46973 9.46973L2.53039 10.5304ZM2.53039 16.5304L16.5304 2.53039L15.4697 1.46973L1.46973 15.4697L2.53039 16.5304ZM16.5065 8.55428L22.5304 2.53039L21.4697 1.46973L13.5076 9.43181C14.429 8.97504 15.4397 8.67143 16.5065 8.55428ZM8.55428 16.5065C8.67143 15.4397 8.97504 14.429 9.43181 13.5076L1.46973 21.4697L2.53039 22.5304L8.55428 16.5065ZM8.87166 20.0678C9.02825 20.5948 9.23181 21.1016 9.47748 21.5833L8.53039 22.5304L7.46973 21.4697L8.87166 20.0678ZM21.5833 9.47748C21.1016 9.23181 20.5948 9.02825 20.0678 8.87166L21.4697 7.46973L22.5304 8.53039L21.5833 9.47748Z" class="fill-primary"/></g><defs><clipPath id="SpRt"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath><clipPath id="TFWN"><path transform="translate(11 11)" d="M0 0H13V13H0z" class="fill-primary"/></clipPath></defs></svg>',
  "allotment/grid+puzzlePiece": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#vLVX)" class="fill-primary"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.53039 4.53033L4.53039 2.53033L3.46973 1.46967L1.46973 3.46967L2.53039 4.53033ZM2.53039 10.5303L10.5304 2.53033L9.46973 1.46967L1.46973 9.46967L2.53039 10.5303ZM2.53039 16.5303L16.5304 2.53033L15.4697 1.46967L1.46973 15.4697L2.53039 16.5303ZM14.2311 10.8296L22.5304 2.53033L21.4697 1.46967L12.1098 10.8296H14.2311ZM9.00006 16.0607V13.9393L1.46973 21.4697L2.53039 22.5303L9.00006 16.0607ZM9.00006 19.9393V22.0607L8.53039 22.5303L7.46973 21.4697L9.00006 19.9393ZM20.2311 10.8296H18.1098L21.4697 7.46967L22.5304 8.53033L20.2311 10.8296Z"/><path d="M17.3375 18.918C17.0996 18.7894 16.8334 18.7221 16.563 18.7221C16.2926 18.7221 16.0264 18.7894 15.7885 18.918C15.5506 19.0465 15.3484 19.2323 15.2002 19.4585C15.0521 19.6847 14.9626 19.9443 14.9398 20.2137C14.917 20.4832 14.9617 20.7541 15.0698 21.002V21.5721H12.0834V13.4283H14.9673V13.9166C14.9188 14.1533 14.9237 14.3978 14.9814 14.6324C15.0391 14.867 15.1483 15.0858 15.3011 15.2729C15.4538 15.4601 15.6463 15.611 15.8646 15.7146C16.0828 15.8182 16.3214 15.8719 16.563 15.8719C16.8046 15.8719 17.0431 15.8182 17.2614 15.7146C17.4797 15.611 17.6721 15.4601 17.8249 15.2729C17.9776 15.0858 18.0868 14.867 18.1446 14.6324C18.2023 14.3978 18.2071 14.1533 18.1587 13.9166V13.4283H21.0703V15.9655H21.3121C21.4867 15.9045 21.6702 15.8732 21.8551 15.8728C22.0924 15.8728 22.3267 15.9246 22.5418 16.0246C22.7569 16.1246 22.9476 16.2704 23.1005 16.4517C23.2534 16.6331 23.3648 16.8457 23.427 17.0746C23.4892 17.3035 23.5006 17.5432 23.4605 17.777C23.4204 18.0108 23.3297 18.2331 23.1947 18.4281C23.0598 18.6232 22.8838 18.7865 22.6792 18.9065C22.4746 19.0265 22.2462 19.1004 22.0101 19.1229C21.774 19.1455 21.5357 19.1162 21.3121 19.0371H21.0703V21.5721H18.0562V21.002C18.1643 20.7541 18.209 20.4832 18.1862 20.2137C18.1634 19.9443 18.0739 19.6847 17.9257 19.4585C17.7776 19.2323 17.5754 19.0465 17.3375 18.918Z"/></g><defs><clipPath id="vLVX"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath></defs></svg>',
  "allotment/grid+visibility": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#Ydbh)" class="fill-primary"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.53039 4.53039L4.53039 2.53039L3.46973 1.46973L1.46973 3.46973L2.53039 4.53039ZM2.53039 10.5304L10.5304 2.53039L9.46973 1.46973L1.46973 9.46973L2.53039 10.5304ZM2.53039 16.5304L16.5304 2.53039L15.4697 1.46973L1.46973 15.4697L2.53039 16.5304ZM14.8346 10.2261L22.5304 2.53039L21.4697 1.46973L1.46973 21.4697L2.53039 22.5304L7.5029 17.5579L7.46685 17.4999L8.59379 15.6888C9.26135 14.6159 10.2734 13.2113 11.6612 12.0454C12.5159 11.3274 13.5784 10.6482 14.8346 10.2261ZM9.00091 19.9385L7.46973 21.4697L8.53039 22.5304L9.90467 21.1561C9.56454 20.7393 9.26366 20.3266 9.00091 19.9385ZM20.6541 10.4067C20.1419 10.1999 19.5943 10.0344 19.0124 9.92701L21.4697 7.46973L22.5304 8.53039L20.6541 10.4067Z"/><path d="M17.5 12.7894C19.0499 12.7894 20.3573 13.4594 21.4092 14.3431C22.4588 15.2248 23.2763 16.3367 23.8594 17.2737L24 17.5003L23.8594 17.7269C23.2763 18.6639 22.4587 19.7758 21.4092 20.6575C20.3573 21.5412 19.0499 22.2112 17.5 22.2112C15.9501 22.2112 14.6427 21.5412 13.5908 20.6575C12.5413 19.7758 11.7237 18.6639 11.1406 17.7269L11 17.5003L11.1406 17.2737C11.7237 16.3367 12.5412 15.2248 13.5908 14.3431C14.6427 13.4594 15.9501 12.7894 17.5 12.7894ZM17.5 15.4105C17.0868 15.4105 16.6824 15.5334 16.3389 15.763C15.9955 15.9926 15.7274 16.3189 15.5693 16.7005C15.4113 17.0822 15.3706 17.5023 15.4512 17.9075C15.5318 18.3127 15.7304 18.6847 16.0225 18.9769C16.3147 19.2691 16.6875 19.4685 17.0928 19.5491C17.4979 19.6296 17.9182 19.5881 18.2998 19.43C18.6814 19.2718 19.0078 19.0039 19.2373 18.6605C19.4667 18.317 19.5888 17.9133 19.5889 17.5003C19.5889 16.9463 19.3692 16.4146 18.9775 16.0228C18.5857 15.631 18.0541 15.4105 17.5 15.4105Z"/></g><defs><clipPath id="Ydbh"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath></defs></svg>',
  angle: Ys,
  "angle.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.4219 2.98633L13.3721 10.959C15.1093 13.0628 16.2475 15.6825 16.5234 18.5527H23.7979V21.5527H0L18.1738 1L20.4219 2.98633ZM6.6582 18.5527H13.5029C13.2604 16.5738 12.498 14.7576 11.3525 13.2432L6.6582 18.5527Z" class="fill-primary"/></svg>',
  antenna: Ns,
  "antenna.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6.65151 6.206C7.08675 5.14456 7.72727 4.17951 8.53635 3.36621L20.9427 15.6579C19.3108 17.3001 17.0942 18.2282 14.779 18.2386C12.4638 18.2491 10.2389 17.3411 8.59217 15.7137C7.77577 14.9077 7.12655 13.9485 6.68173 12.891C6.23692 11.8336 6.00528 10.6987 6.00009 9.55154C5.9949 8.40435 6.21628 7.26743 6.65151 6.206Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M18.5 8.25C18.5 6.7312 17.2688 5.49997 15.75 5.49997" stroke-width="1.5" class="stroke-primary"/><path d="M21.75 8.25C21.75 4.93629 19.0637 2.25 15.75 2.25" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.22195 16.5898L6.19516 16.5718L6.11194 16.6952L6.10931 16.6934L2.53027 22H10.9998V19.8125L10.9798 19.799C9.25549 19.0746 7.66779 18.0219 6.31226 16.6799C6.28201 16.65 6.25192 16.62 6.22195 16.5898ZM6.59726 18.6523L5.35107 20.4999H9.3363L6.59726 18.6523Z" class="fill-primary"/><path d="M6.53003 18.5511L9.42328 20.5308H5.19696L6.53003 18.5511Z" class="fill-primary"/></svg>',
  "antenna.filled+stroke": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6.22156 16.5879C6.25149 16.618 6.28217 16.6479 6.31238 16.6777C7.66782 18.0195 9.25522 19.0726 10.9794 19.7969L10.9999 19.8105V21.998H2.53015L6.10925 16.6914L6.11218 16.6924L6.19519 16.5693L6.22156 16.5879ZM17.952 18.4258C17.0891 18.7361 16.1806 18.9244 15.2518 18.9746L14.7821 18.9883C12.4255 18.9989 10.1549 18.1336 8.4071 16.5693L8.06531 16.2471C7.2895 15.4812 6.65223 14.5882 6.18152 13.6074L5.99011 13.1816C5.56748 12.1768 5.32209 11.1076 5.26355 10.0215L5.24988 9.55469C5.24736 8.99448 5.2966 8.4369 5.39246 7.8877L17.952 18.4258ZM20.7264 16.8604C20.3261 17.1857 19.9019 17.4762 19.4579 17.7305L5.81824 6.28613C5.86255 6.16398 5.9085 6.04232 5.95789 5.92188L6.14539 5.49414C6.24206 5.28797 6.34683 5.086 6.45789 4.8877L20.7264 16.8604ZM9.06433 2.83301L21.4706 15.125L22.0038 15.6533L21.829 15.8281L7.29773 3.63379C7.51803 3.35576 7.75363 3.08936 8.00476 2.83691L8.5321 2.30664L9.06433 2.83301ZM15.7499 4.74902C17.6829 4.74902 19.2499 6.31602 19.2499 8.24902H17.7499C17.7499 7.14445 16.8545 6.24902 15.7499 6.24902V4.74902ZM15.7499 1.49902C19.4778 1.49902 22.4999 4.5211 22.4999 8.24902H20.9999C20.9999 5.34953 18.6494 2.99902 15.7499 2.99902V1.49902Z" class="fill-primary"/><path d="M3.5719 2.44543L23.062 18.7996L22.0978 19.9486L2.60772 3.5945L3.5719 2.44543Z" class="fill-secondary"/></svg>',
  antennaDish: Fs,
  "antennaDish.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M18.2681 11C18.2681 8.09054 15.9095 5.73199 13.0001 5.73199" stroke-width="1.5" class="stroke-primary"/><path d="M22.1302 11C22.1302 5.95765 18.0425 1.87 13.0001 1.87" stroke-width="1.5" class="stroke-primary"/><path d="M3.41606 7.20104C3.93327 5.9397 4.69443 4.7929 5.65589 3.82642L20.3989 18.433C18.4595 20.3846 15.8255 21.4874 13.0743 21.4999C10.323 21.5123 7.67912 20.4333 5.72222 18.4994C4.75207 17.5416 3.98056 16.4018 3.45198 15.1451C2.92339 13.8885 2.64811 12.5399 2.64195 11.1767C2.63579 9.81343 2.89886 8.46238 3.41606 7.20104Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  antennaPedestal: Es,
  archive: zs,
  "archive.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.42379 2H19.5762L22.75 13.9017V14H16.5365L15.5365 16H8.46353L7.46353 14H1.25V13.9017L4.42379 2ZM15.5 6H8.5V7.5H15.5V6ZM16.5 10H7.5V11.5H16.5V10Z" class="fill-primary"/><path d="M22.75 15.5V22H1.25V15.5H6.53647L7.53647 17.5H16.4635L17.4635 15.5H22.75Z" class="fill-primary"/></svg>',
  "arrow.diagonal.bordered": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6.75 11.7566V17.25H12.25" stroke-width="1.5" class="stroke-primary"/><path d="M17.25 12.25V6.75H11.75" stroke-width="1.5" class="stroke-primary"/><path d="M6.96204 17.0378L17.0379 6.96191" stroke-width="1.5" class="stroke-primary"/><path d="M2.75 2.75H21.25V21.25H2.75V2.75Z" stroke-width="1.5" stroke-linecap="round" class="stroke-primary"/></svg>',
  "arrow.down": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 19V4" stroke-width="1.5" class="stroke-primary"/><path d="M18.0245 12.9502L12.0005 19.0002L5.97546 12.9502" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.down+line.bottom": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20 21.25H4" stroke-width="1.5" class="stroke-primary"/><path d="M12 17V3.5M12 17L17.5 11.5M12 17L6.5 11.5" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.down+line.top": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 20.5L12 7M12 20.5L6.5 15M12 20.5L17.5 15" stroke-width="1.5" class="stroke-primary"/><path d="M2.75 2.75L21.25 2.75" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.down.bordered": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M2.75 2.75H21.25V21.25H2.75V2.75Z" stroke-width="1.5" stroke-linecap="round" class="stroke-primary"/><path d="M12 16.7598L12 6" stroke-width="1.5" class="stroke-primary"/><path d="M17.5 11.5L12 17L6.5 11.5" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.down.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12.0015 20.563L4.9126 13.4458L7.03857 11.3286L10.5015 14.8052V3.43701H13.5015V14.8042L16.9624 11.3286L19.0874 13.4458L12.0015 20.563Z" class="fill-primary"/></svg>',
  "arrow.down.filled+line.bottom.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6.99902 9.04688L10.5 12.3574V2H13.5V12.3828L17.0127 9.07617L19.0693 11.2607L12.0059 17.9102L4.93848 11.2266L6.99902 9.04688Z" class="fill-primary"/><path d="M21.25 21.5225L2.75 21.5225" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.down.filled+line.top.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.001 13.1367L13.5 16.4473V6.08984H10.5V16.4727L6.9873 13.166L4.93066 15.3506L11.9941 22L19.0615 15.3164L17.001 13.1367Z" class="fill-primary"/><path d="M2.75 2.47754L21.25 2.47754" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.downRight.bordered": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.0946 17.2144L6.60355 6.14645" stroke-width="1.5" class="stroke-primary"/><path d="M17 9V17H9" stroke-width="1.5" class="stroke-primary"/><path d="M2.75 2.75H21.25V21.25H2.75V2.75Z" stroke-width="1.5" stroke-linecap="round" class="stroke-primary"/></svg>',
  "arrow.left": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M4.25 11.9999L19.25 11.9999" stroke-width="1.5" class="stroke-primary"/><path d="M10.2998 18.0244L4.24976 12.0004L10.2998 5.97541" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.left+line.left": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7 12L20.5 12M7 12L12.5 17.5M7 12L12.5 6.5" stroke-width="1.5" class="stroke-primary"/><path d="M2.75 21.25L2.75 2.75" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.left+line.right": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.5 12L17 12M3.5 12L9 17.5M3.5 12L9 6.5" stroke-width="1.5" class="stroke-primary"/><path d="M21.25 2.75L21.25 21.25" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.left.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.43701 11.9985L10.5542 19.0874L12.6714 16.9614L9.19482 13.4985H20.563V10.4985H9.1958L12.6714 7.0376L10.5542 4.9126L3.43701 11.9985Z" class="fill-primary"/></svg>',
  "arrow.left.filled+line.left.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M14.9531 6.99902L11.6426 10.5H22V13.5H11.6172L14.9238 17.0127L12.7393 19.0693L6.08984 12.0059L12.7734 4.93848L14.9531 6.99902Z" class="fill-primary"/><path d="M2.47754 21.25L2.47754 2.75" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.left.filled+line.right.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M10.8633 6.99902L7.55273 10.5H17.9102V13.5H7.52734L10.834 17.0127L8.64941 19.0693L2 12.0059L8.68359 4.93848L10.8633 6.99902Z" class="fill-primary"/><path d="M21.5225 21.25L21.5225 2.75" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.leftIn+arrow.rightIn": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.0112 7.05022L14.0615 12L19.0112 16.9497" stroke-width="1.5" class="stroke-primary"/><path d="M14.7559 12L23.5948 11.9999" stroke-width="1.5" class="stroke-primary"/><path d="M4.99121 16.9497L9.94096 12L4.99121 7.05025" stroke-width="1.5" class="stroke-primary"/><path d="M9.18931 12L0.350427 12.0001" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.leftOut+arrow.rightOut": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.5521 7.05022L22.5019 12L17.5521 16.9497" stroke-width="1.5" class="stroke-primary"/><path d="M21.8465 12L13.0076 11.9999" stroke-width="1.5" class="stroke-primary"/><path d="M6.35876 16.9497L1.40902 12L6.35876 7.05025" stroke-width="1.5" class="stroke-primary"/><path d="M2.16066 12L10.9995 12.0001" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.revolving": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M23.3234 10.8697L19.3023 14.8907L15.2813 10.8697M15.4112 19.4842C13.9227 20.5328 12.1075 21.1485 10.1485 21.1485C5.09592 21.1485 1 17.0526 1 12C1 6.94746 5.09592 2.85154 10.1485 2.85154C15.2011 2.85154 19.297 6.94746 19.297 12V14.012" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.revolving.ccw": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M0.676636 10.8697L4.69767 14.8908L8.71872 10.8697M8.58884 19.4842C10.0773 20.5328 11.8925 21.1485 13.8515 21.1485C18.9041 21.1485 23 17.0526 23 12.0001C23 6.94748 18.9041 2.85156 13.8515 2.85156C8.79894 2.85156 4.70303 6.94748 4.70303 12.0001V14.012" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.right": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.75 12.0001L4.75 12.0001" stroke-width="1.5" class="stroke-primary"/><path d="M13.7002 5.97535L19.7502 11.9993L13.7002 18.0243" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.right+line.left": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20.5 12L7 12M20.5 12L15 17.5M20.5 12L15 6.5" stroke-width="1.5" class="stroke-primary"/><path d="M2.75 21.25L2.75 2.75" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.right+line.right": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17 12L3.5 12M17 12L11.5 17.5M17 12L11.5 6.5" stroke-width="1.5" class="stroke-primary"/><path d="M21.25 2.75L21.25 21.25" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.right.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.876 12L14.7588 19.0889L12.6416 16.9629L16.1182 13.5H4.75V10.5H16.1172L12.6416 7.03906L14.7588 4.91406L21.876 12Z" class="fill-primary"/></svg>',
  "arrow.right.filled+line.left.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M13.1367 6.99902L16.4473 10.5H6.08984V13.5H16.4727L13.166 17.0127L15.3506 19.0693L22 12.0059L15.3164 4.93848L13.1367 6.99902Z" class="fill-primary"/><path d="M2.47754 21.25L2.47754 2.75" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.right.filled+line.right.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M9.04688 6.99902L12.3574 10.5H2V13.5H12.3828L9.07617 17.0127L11.2607 19.0693L17.9102 12.0059L11.2266 4.93848L9.04688 6.99902Z" class="fill-primary"/><path d="M21.5225 21.25L21.5225 2.75" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.simple.down": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M18.2985 9L12.2745 15.05L6.24951 9" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.simple.down.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M18.0246 8.97266L12.0006 15.0227L5.97559 8.97266" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.simple.left": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M15 18.2985L8.95 12.2745L15 6.24951" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.simple.left.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M15.0254 18.0256L8.97539 12.0016L15.0254 5.97656" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.simple.right": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M9 5.70149L15.05 11.7255L9 17.7505" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.simple.right.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M8.97461 5.97444L15.0246 11.9984L8.97461 18.0234" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.simple.up": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M5.70149 15L11.7255 8.95L17.7505 15" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.simple.up.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M5.97541 15.0234L11.9994 8.97344L18.0244 15.0234" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.up": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 5V20" stroke-width="1.5" class="stroke-primary"/><path d="M5.97559 11.0498L11.9996 4.9998L18.0246 11.0498" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.up+line.bottom": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 3.5V17M12 3.5L17.5 9M12 3.5L6.5 9" stroke-width="1.5" class="stroke-primary"/><path d="M21.25 21.25H2.75" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.up+line.top": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20 2.75H4" stroke-width="1.5" class="stroke-primary"/><path d="M12 7V20.5M12 7L17.5 12.5M12 7L6.5 12.5" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.up.bordered": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M2.75 21.25H21.25V2.75H2.75V21.25Z" stroke-width="1.5" stroke-linecap="round" class="stroke-primary"/><path d="M12 7.24018L12 18" stroke-width="1.5" class="stroke-primary"/><path d="M17.5 12.5L12 7L6.5 12.5" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.up.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12.0015 3.43701L4.9126 10.5542L7.03857 12.6714L10.5015 9.19482V20.563H13.5015V9.1958L16.9624 12.6714L19.0874 10.5542L12.0015 3.43701Z" class="fill-primary"/></svg>',
  "arrow.up.filled+line.bottom.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6.99902 10.8633L10.5 7.55273V17.9102H13.5V7.52734L17.0127 10.834L19.0693 8.64941L12.0059 2L4.93848 8.68359L6.99902 10.8633Z" class="fill-primary"/><path d="M21.25 21.5225L2.75 21.5225" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.up.filled+line.top.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.001 14.9531L13.5 11.6426V22H10.5V11.6172L6.9873 14.9238L4.93066 12.7393L11.9941 6.08984L19.0615 12.7734L17.001 14.9531Z" class="fill-primary"/><path d="M2.75 2.47754L21.25 2.47754" stroke-width="3" class="stroke-primary"/></svg>',
  "arrow.upRight": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.0288 6.96328L6.42216 17.5699" stroke-width="1.5" class="stroke-primary"/><path d="M17.248 15.3136V6.7499H8.70972" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.upRight+arrow.downLeft": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M14.25 2.75195H21.25V9.75195" stroke-width="1.5" class="stroke-primary"/><path d="M9.75 21.25H2.75V14.25" stroke-width="1.5" class="stroke-primary"/><path d="M20.75 3.25L14.4999 9.5" stroke-width="1.5" class="stroke-primary"/><path d="M3.25 20.75L9.50008 14.5" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrow.upRight.bordered": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M16.9298 7.02728L6.85355 17.1036" stroke-width="1.5" class="stroke-primary"/><path d="M17 15V7H9" stroke-width="1.5" class="stroke-primary"/><path d="M2.75 2.75H21.25V21.25H2.75V2.75Z" stroke-width="1.5" stroke-linecap="round" class="stroke-primary"/></svg>',
  "arrows.leftRight+line.leftRight": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.9158 7.74703L13.6686 12.0005L17.9209 16.2527" stroke-width="1.5" class="stroke-primary"/><path d="M6.08473 7.74703L10.3319 12.0005L6.07963 16.2527" stroke-width="1.5" class="stroke-primary"/><path d="M14.3296 12H21.7501" stroke-width="1.5" class="stroke-primary"/><path d="M9.67102 12H2.25052" stroke-width="1.5" class="stroke-primary"/><path d="M21.36 21.25V2.75" stroke-width="1.5" class="stroke-primary"/><path d="M2.65625 2.75V21.25" stroke-width="1.5" class="stroke-primary"/></svg>',
  "arrows.revolving": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.41541 23.0208V16.8967H9.53951" stroke-width="1.826" class="stroke-primary"/><path d="M21.6501 2.20226L21.6501 8.32636L15.526 8.32636" stroke-width="1.826" class="stroke-primary"/><path d="M2.19116 12.001C2.19116 6.58936 6.57813 2.20239 11.9897 2.20239C16.1019 2.20239 19.6224 4.73553 21.076 8.32649M3.88715 17.5126C5.65086 20.1004 8.62187 21.7995 11.9897 21.7995C16.7734 21.7995 20.7564 18.3716 21.6163 13.8382" stroke-width="1.826" class="stroke-primary"/></svg>',
  "arrows.upDown": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M16.8 19V5" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M20.8244 14.9502L16.8004 19.0002L12.7754 14.9502" stroke-width="1.5" class="stroke-primary"/><path d="M7.75073 5.00024L7.75073 19.0002" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M3.72639 9.05005L7.75039 5.00005L11.7754 9.05005" stroke-width="1.5" class="stroke-primary"/></svg>',
  backslash: qs,
  "backslash.big": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.9879 21.9874L2.01215 2.0116" stroke-width="1.5" class="stroke-primary"/></svg>',
  "backslash.medium": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20.0001 20.0001L4.00012 4.00006" stroke-width="1.5" class="stroke-primary"/></svg>',
  bankNotes: Us,
  bell: Ks,
  "bell.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="11.928" cy="20" r="2" stroke-width="1.5" class="stroke-primary fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.9429 3.59447C10.9429 3.59447 10.8186 1.59425 12 1.60281C13.1814 1.61137 13.0571 3.59447 13.0571 3.59447V3.81401C14.6426 3.9635 15.7292 4.43055 16.4829 5.02709C17.4113 5.76183 17.7551 6.63232 17.9234 7.08709C17.9866 7.25782 18.0411 7.50494 18.0887 7.74735C18.1399 8.00867 18.195 8.32922 18.252 8.68279C18.3472 9.27293 18.4512 9.97552 18.5556 10.681L18.6175 11.0995C18.7432 11.9465 18.8671 12.7656 18.9776 13.3916C19.0331 13.706 19.0829 13.9583 19.1256 14.1357C19.1359 14.1787 19.145 14.2138 19.1527 14.242C19.3769 14.4327 19.9117 14.7719 21.0259 14.9677V16.4078H2.97351V14.9736C4.08766 14.7778 4.62243 14.4327 4.84665 14.242C4.85442 14.2138 4.86351 14.1787 4.87382 14.1357C4.91646 13.9583 4.96629 13.706 5.02181 13.3916C5.13232 12.7656 5.25614 11.9465 5.38183 11.0995L5.44376 10.6813C5.54814 9.97581 5.65213 9.27293 5.74733 8.68279C5.80437 8.32922 5.85943 8.00867 5.9107 7.74735C5.95827 7.50494 6.01279 7.25782 6.07598 7.08709C6.24428 6.63232 6.58808 5.76183 7.51645 5.02709C8.27029 4.43048 9.35703 3.96338 10.9429 3.81396V3.59447Z" class="fill-primary"/></svg>',
  "book.open": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6.68187 3C5.33401 3 4.03856 3.22517 2.83443 3.63941L2.25006 3.84044L2.25 20.41L3.43835 20.0013C4.4521 19.6525 5.54334 19.4625 6.6818 19.4625C8.45475 19.4625 10.1156 19.9233 11.5478 20.7298L12 20.9844L12.4521 20.7298C13.8844 19.9233 15.5452 19.4625 17.3181 19.4625C18.4566 19.4625 19.5479 19.6525 20.5616 20.0013L21.7499 20.41L21.75 3.84044L21.1656 3.63941C19.9615 3.22517 18.6661 3 17.3182 3C15.4006 3 13.5911 3.45569 12 4.2611C10.409 3.45569 8.59948 3 6.68187 3Z" stroke-width="1.5" class="stroke-primary"/><path d="M12 17.25L12 7.25" stroke-width="1.5" class="stroke-primary"/></svg>',
  "book.open.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.3184 2.25C18.75 2.25002 20.1275 2.48978 21.4092 2.93066L21.9941 3.13086L22.5 3.30566V21.4609L21.5059 21.1191L20.3174 20.7109C19.3814 20.3889 18.3728 20.2129 17.3184 20.2129C15.7795 20.2129 14.3343 20.5869 13.0703 21.2471L12.8203 21.3828L12.3682 21.6377L12 21.8447L11.6318 21.6377L11.1797 21.3828C9.85765 20.6385 8.32304 20.2129 6.68164 20.2129C5.7591 20.2129 4.87159 20.3473 4.03711 20.5967L3.68262 20.7109L2.49414 21.1191L1.5 21.4609V3.30566L2.00586 3.13086L2.59082 2.93066L3.0752 2.77441C4.21722 2.43317 5.42879 2.25002 6.68164 2.25C8.58442 2.25 10.3898 2.67234 12 3.42676C13.6103 2.67232 15.4155 2.25 17.3184 2.25ZM11.25 7.25V17.25H12.75V7.25H11.25Z" class="fill-primary"/></svg>',
  burger: Ws,
  "burger.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M4 4.75H20" stroke-width="3" stroke-linejoin="round" class="stroke-primary"/><path d="M4 12H20" stroke-width="3" stroke-linejoin="round" class="stroke-primary"/><path d="M4 19.25H20" stroke-width="3" stroke-linejoin="round" class="stroke-primary"/></svg>',
  calendar: js,
  "calendar+circle": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="19.5" cy="19.5" r="3.5" stroke-width="1.5" class="stroke-primary"/><path d="M21.25 12V4H2.75V21.25H12" stroke-width="1.5" class="stroke-primary"/><path d="M6 8.75H18" stroke-width="1.5" class="stroke-primary"/><path d="M17.25 4V1" stroke-width="1.5" class="stroke-primary"/><path d="M6.75 4V1" stroke-width="1.5" class="stroke-primary"/></svg>',
  "calendar+cross": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.25 12V4H2.75V21.25H12" stroke-width="1.5" class="stroke-primary"/><path d="M6 8.75H18" stroke-width="1.5" class="stroke-primary"/><path d="M17.25 4V1" stroke-width="1.5" class="stroke-primary"/><path d="M6.75 4V1" stroke-width="1.5" class="stroke-primary"/><path d="M21.6516 16.3483L16.3483 21.6516" stroke-width="1.5" class="stroke-primary"/><path d="M21.6517 21.6516L16.3484 16.3483" stroke-width="1.5" class="stroke-primary"/></svg>',
  "calendar+list": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.25 12V4H2.75V21.25H12" stroke-width="1.5" class="stroke-primary"/><path d="M6 8.75H18" stroke-width="1.5" class="stroke-primary"/><path d="M14 15H24" stroke-width="1.5" class="stroke-primary"/><path d="M14 18.6215H24" stroke-width="1.5" class="stroke-primary"/><path d="M14 22.2432H24" stroke-width="1.5" class="stroke-primary"/><path d="M17.25 4V1" stroke-width="1.5" class="stroke-primary"/><path d="M6.75 4V1" stroke-width="1.5" class="stroke-primary"/></svg>',
  "calendar+play": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.25 12V4H2.75V21.25H12" stroke-width="1.5" class="stroke-primary"/><path d="M6 8.75H18" stroke-width="1.5" class="stroke-primary"/><path d="M17.25 4V1" stroke-width="1.5" class="stroke-primary"/><path d="M6.75 4V1" stroke-width="1.5" class="stroke-primary"/><path d="M22.585 18.5312L16 22.6465V14.415L22.585 18.5312Z" stroke-width="1.5" class="stroke-primary"/></svg>',
  "calendar+plus": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.25 12V4H2.75V21.25H12" stroke-width="1.5" class="stroke-primary"/><path d="M6 8.75H18" stroke-width="1.5" class="stroke-primary"/><path d="M17.25 4V1" stroke-width="1.5" class="stroke-primary"/><path d="M6.75 4V1" stroke-width="1.5" class="stroke-primary"/><path d="M19 15.25V22.75" stroke-width="1.5" class="stroke-primary"/><path d="M22.75 19L15.25 19" stroke-width="1.5" class="stroke-primary"/></svg>',
  "calendar+stop": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.25 12V4H2.75V21.25H12" stroke-width="1.5" class="stroke-primary"/><path d="M6 8.75H18" stroke-width="1.5" class="stroke-primary"/><path d="M17.25 4V1" stroke-width="1.5" class="stroke-primary"/><path d="M6.75 4V1" stroke-width="1.5" class="stroke-primary"/><path stroke-width="1.5" d="M15.75 15.75H22V22H15.75z" class="stroke-primary"/></svg>',
  "calendar.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7.5 3.25H16.5V1H18V3.25H22V22H2V3.25H6V1H7.5V3.25ZM6 8V9.5H18V8H6Z" class="fill-primary"/></svg>',
  "caret.down.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M11.9998 16L17.9595 9.97075H6.04013L11.9998 16Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  "caret.left.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7.98047 11.9992L14.0097 6.03954V17.9589L7.98047 11.9992Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  "caret.leftRight.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20.0195 11.9992L13.9903 17.9589V6.03954L20.0195 11.9992Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M3.98047 11.9992L10.0097 17.9589V6.03954L3.98047 11.9992Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  "caret.right.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M16.0195 11.9992L9.99028 17.9589V6.03954L16.0195 11.9992Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  "caret.up.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M11.9998 7.96094L17.9595 13.9902H6.04013L11.9998 7.96094Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  "caret.upDown.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M11.9998 3.96094L17.9595 9.99019H6.04013L11.9998 3.96094Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M11.9998 20L17.9595 13.9707H6.04013L11.9998 20Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  chart: Qs,
  checklist: Xs,
  checkmark: Gs,
  "checkmark.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M4.75012 13.75L9.00012 18L19.7501 7.24997" stroke-width="3" class="stroke-primary"/></svg>',
  "circle+checkmark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><path d="M7.12598 11.9976L10.3735 15.245L16.874 8.75" stroke-width="1.5" class="stroke-primary"/></svg>',
  "circle+cross": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M8.25 8.25L15.75 15.75" stroke-width="1.5" class="stroke-primary"/><path d="M15.75 8.25L8.25 15.75" stroke-width="1.5" class="stroke-primary"/><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "circle+exclamationMark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M11.9951 6.75V12.75" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.875 15.625C10.875 15.0037 11.3762 14.5 11.9944 14.5H12.0056C12.6238 14.5 13.125 15.0037 13.125 15.625C13.125 16.2463 12.6238 16.75 12.0056 16.75H11.9944C11.3762 16.75 10.875 16.2463 10.875 15.625Z" class="fill-primary"/><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "circle+info": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 10.75V17" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.875 8.125C10.875 7.50368 11.3762 7 11.9944 7H12.0056C12.6238 7 13.125 7.50368 13.125 8.125C13.125 8.74632 12.6238 9.25 12.0056 9.25H11.9944C11.3762 9.25 10.875 8.74632 10.875 8.125Z" class="fill-primary"/><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "circle+pencil": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M14.8877 6.64014L17.3626 9.11501L10.9986 15.479L7.63989 16.3629L8.52378 13.0041L14.8877 6.64014Z" stroke-width="1.5" class="stroke-primary"/><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.0938 10.4991L13.0001 8.40533L14.4052 7L16.499 9.09375L15.0938 10.4991Z" class="fill-primary"/></svg>',
  "circle+pulse": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M9.59815 12.1625V12.9125H10.1532L10.3154 12.3817L9.59815 12.1625ZM11.5 5.9375L12.2441 5.84331L10.7827 5.71836L11.5 5.9375ZM13.0625 18.2812L12.3184 18.3754L13.7636 18.5476L13.0625 18.2812ZM15.3867 12.1625V11.4125H14.8693L14.6856 11.8962L15.3867 12.1625ZM5.82886 12.9125H9.59815V11.4125H5.82886V12.9125ZM10.3154 12.3817L12.2173 6.15664L10.7827 5.71836L8.88088 11.9434L10.3154 12.3817ZM10.7559 6.03169L12.3184 18.3754L13.8066 18.1871L12.2441 5.84331L10.7559 6.03169ZM13.7636 18.5476L16.0878 12.4289L14.6856 11.8962L12.3614 18.0149L13.7636 18.5476ZM15.3867 12.9125H18.6849V11.4125H15.3867V12.9125Z" class="fill-primary"/><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "circle+questionMark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M9.50042 9.93297C9.46877 7.27695 13.7435 6.25819 14.7941 8.81761C15.8894 11.7794 12.0002 11.3771 12.0002 13.9331" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.9287 16.6677C10.9287 16.0789 11.406 15.6016 11.9948 15.6016H12.0055C12.5943 15.6016 13.0716 16.0789 13.0716 16.6677C13.0716 17.2565 12.5943 17.7338 12.0055 17.7338H11.9948C11.406 17.7338 10.9287 17.2565 10.9287 16.6677Z" class="fill-primary"/><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "circle+total": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><path d="M8 9.25H16" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M8 14.75H16" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "circle.dashed": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path clip-rule="evenodd" d="M22.0002 11.9999C22.0002 17.5232 17.5235 21.9999 12.0002 21.9999C6.477 21.9999 2.00024 17.5232 2.00024 11.9999C2.00024 6.4767 6.477 1.99994 12.0002 1.99994C17.5235 1.99994 22.0002 6.4767 22.0002 11.9999Z" stroke-width="1.5" stroke-dasharray="3 3" class="stroke-primary"/></svg>',
  "circle.filled+arrow.down": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM11 7V14.8896L7.13281 11.7256L5.86719 13.2744L11.3672 17.7744L12 18.292L12.6328 17.7744L18.1328 13.2744L16.8672 11.7256L13 14.8896V7H11Z" class="fill-primary"/><path d="M17.5 12.5L12 17M6.5 12.5L12 17M12 17L12 7" stroke-width="2" class="stroke-backdrop"/></svg>',
  "circle.filled+checkmark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM10.374 13.8311L7.83301 11.29L7.12598 11.998L6.41895 12.7051L10.373 16.6592L11.0801 15.9521L17.5811 9.45703L16.167 8.04297L10.374 13.8311Z" class="fill-primary"/><path d="M7.12598 11.9976L10.3735 15.245L16.874 8.75" stroke-width="2" class="stroke-backdrop"/></svg>',
  "circle.filled+cross": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM15.0429 7.54289L12 10.5858L8.95711 7.54289L7.54289 8.95711L10.5858 12L7.54289 15.0429L8.95711 16.4571L12 13.4142L15.0429 16.4571L16.4571 15.0429L13.4142 12L16.4571 8.95711L15.0429 7.54289Z" class="fill-primary"/></svg>',
  "circle.filled+exclamationMark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM12 15.333C11.0796 15.3331 10.334 16.0796 10.334 17C10.3342 17.9203 11.0797 18.6659 12 18.666C12.9204 18.666 13.6668 17.9203 13.667 17C13.667 16.0795 12.9205 15.333 12 15.333ZM10.75 13H13.25V6H10.75V13Z" class="fill-primary"/><path d="M10.7501 5.99973H13.2501V12.9997H10.7501V5.99973Z" class="fill-backdrop"/><rect x="10.334" y="15.333" width="3.333" height="3.333" rx="1.667" class="fill-backdrop"/></svg>',
  "circle.filled+info": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM10.75 18.3301H13.25V11.3301H10.75V18.3301ZM12 5.99707C11.0797 5.99716 10.3341 6.74276 10.334 7.66309C10.334 8.58351 11.0796 9.32999 12 9.33008C12.9205 9.33008 13.667 8.58356 13.667 7.66309C13.6669 6.7427 12.9204 5.99707 12 5.99707Z" class="fill-primary"/><path d="M10.75 18.33H13.25V11.33H10.75V18.33Z" class="fill-backdrop"/><rect width="3.333" height="3.333" rx="1.667" transform="matrix(1 0 0 -1 10.334 9.33)" class="fill-backdrop"/></svg>',
  "circle.filled+minus": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM6.5 11V13H17.5V11H6.5Z" class="fill-primary"/><path d="M17.5 12L6.5 12" stroke-width="2" class="stroke-backdrop"/></svg>',
  "circle.filled+plus": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM11 11H6.5V13H11V17.5H13V13H17.5V11H13V6.5H11V11Z" class="fill-primary"/><path d="M12 6.5V17.5" stroke-width="2" class="stroke-backdrop"/><path d="M17.5 12L6.5 12" stroke-width="2" class="stroke-backdrop"/></svg>',
  "circle.filled+slash": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-secondary fill-primary"/><path d="M7.5 16.5L16.5 7.5" stroke-width="1.5" class="stroke-secondary"/></svg>',
  "circle.incomplete+checkmark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.0001 3.33765C19.9892 5.06658 22.0001 8.29826 22.0001 12C22.0001 17.5233 17.5233 22 12.0001 22C8.16942 22 4.84213 19.8466 3.1626 16.6842" stroke-width="1.5" class="stroke-primary"/><path clip-rule="evenodd" d="M22.0001 11.9999C22.0001 17.5232 17.5234 21.9999 12.0001 21.9999C6.47688 21.9999 2.00012 17.5232 2.00012 11.9999C2.00012 6.4767 6.47688 1.99994 12.0001 1.99994C17.5234 1.99994 22.0001 6.4767 22.0001 11.9999Z" stroke-width="1.5" stroke-dasharray="3 3" class="stroke-primary"/><path d="M7.12585 11.9975L10.3734 15.245L16.8738 8.74994" stroke-width="1.5" class="stroke-primary"/></svg>',
  clock: Js,
  "clock+arrow.downRight": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M15 22H22V15" stroke-width="1.5" class="stroke-primary"/><path d="M21.5001 21.502L15.25 15.252" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.58325 10.9999C2.58325 6.35152 6.35152 2.58325 10.9999 2.58325C15.3124 2.58325 18.8673 5.82656 19.3586 10.007C19.8799 10.0274 20.3898 10.0922 20.8846 10.1976C20.4762 5.096 16.2067 1.08325 10.9999 1.08325C5.5231 1.08325 1.08325 5.5231 1.08325 10.9999C1.08325 16.2067 5.096 20.4762 10.1976 20.8846C10.0922 20.3898 10.0274 19.8799 10.007 19.3586C5.82656 18.8673 2.58325 15.3124 2.58325 10.9999ZM11.7499 11.636V5.75H10.2499V10.886H6.5V12.386H10.9999H11.7499V11.636Z" class="fill-primary"/></svg>',
  "clock+arrow.left": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M18.9993 23.4504L14.0495 18.5006L18.9993 13.5509" stroke-width="1.5" class="stroke-primary"/><path d="M14.7556 18.5019L23.5945 18.5019" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.3665 10.0626C18.9003 5.85555 15.3335 2.58336 11.0021 2.5832C6.35375 2.5832 2.58516 6.35179 2.58516 11.0002C2.58531 15.0665 5.46927 18.4589 9.30326 19.2447C9.31744 19.7759 9.37764 20.2957 9.48004 20.8001C4.72585 20.0678 1.08532 15.9593 1.08516 11.0002C1.08516 5.52337 5.52532 1.0832 11.0021 1.0832C16.2709 1.08337 20.5796 5.19274 20.8992 10.3811C20.4049 10.2322 19.8926 10.1247 19.3665 10.0626ZM11.7521 12.3859V5.75019H10.2521V10.8859H6.50215V12.3859H11.7521Z" class="fill-primary"/></svg>',
  "clock+arrow.right": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#kZvO)"><path d="M17.8992 23.4504L22.8489 18.5006L17.8992 13.5509" stroke-width="1.5" class="stroke-primary"/><path d="M22.143 18.5019L13.3041 18.5019" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.3602 10.007C18.8688 5.82676 15.3144 2.58336 11.0021 2.5832C6.35375 2.5832 2.58516 6.35179 2.58516 11.0002C2.58532 15.312 5.82809 18.8662 10.0078 19.3581C10.0282 19.8794 10.0929 20.3893 10.1983 20.8841C5.09749 20.475 1.08532 16.2063 1.08516 11.0002C1.08516 5.52337 5.52532 1.0832 11.0021 1.0832C16.2087 1.08336 20.4777 5.09629 20.8862 10.1978C20.3913 10.0923 19.8815 10.0275 19.3602 10.007ZM11.7521 12.3859V5.75019H10.2521V10.8859H6.50215V12.3859H11.7521Z" class="fill-primary"/></g><defs><clipPath id="kZvO"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath></defs></svg>',
  "clock+arrow.upRight": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.58325 10.9999C2.58325 6.35152 6.35152 2.58325 10.9999 2.58325C15.3124 2.58325 18.8673 5.82656 19.3586 10.007C19.8799 10.0274 20.3898 10.0922 20.8846 10.1976C20.4762 5.096 16.2067 1.08325 10.9999 1.08325C5.5231 1.08325 1.08325 5.5231 1.08325 10.9999C1.08325 16.2067 5.096 20.4762 10.1976 20.8846C10.0922 20.3898 10.0274 19.8799 10.007 19.3586C5.82656 18.8673 2.58325 15.3124 2.58325 10.9999ZM11.7499 11.636V5.75H10.2499V10.886H6.5V12.386H10.9999H11.7499V11.636Z" class="fill-primary"/><path d="M15 16H22V23" stroke-width="1.5" class="stroke-primary"/><path d="M21.5001 16.498L15.25 22.748" stroke-width="1.5" class="stroke-primary"/></svg>',
  "clock+play": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M22.585 18.5312L16 22.6465V14.415L22.585 18.5312Z" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.58325 11.4999C2.58325 6.85152 6.35152 3.08325 10.9999 3.08325C15.3124 3.08325 18.8673 6.32656 19.3586 10.507C19.8799 10.5274 20.3898 10.5922 20.8846 10.6976C20.4762 5.596 16.2067 1.58325 10.9999 1.58325C5.5231 1.58325 1.08325 6.0231 1.08325 11.4999C1.08325 16.7067 5.096 20.9762 10.1976 21.3846C10.0922 20.8898 10.0274 20.3799 10.007 19.8586C5.82656 19.3673 2.58325 15.8124 2.58325 11.4999ZM11.7499 12.136V6.25H10.2499V11.386H6.5V12.886H10.9999H11.7499V12.136Z" class="fill-primary"/></svg>',
  "clock+stop": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke-width="1.5" d="M15.75 15.75H22V22H15.75z" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.58325 11.4999C2.58325 6.85152 6.35152 3.08325 10.9999 3.08325C15.3124 3.08325 18.8673 6.32656 19.3586 10.507C19.8799 10.5274 20.3898 10.5922 20.8846 10.6976C20.4762 5.596 16.2067 1.58325 10.9999 1.58325C5.5231 1.58325 1.08325 6.0231 1.08325 11.4999C1.08325 16.7067 5.096 20.9762 10.1976 21.3846C10.0922 20.8898 10.0274 20.3799 10.007 19.8586C5.82656 19.3673 2.58325 15.8124 2.58325 11.4999ZM11.7499 12.136V6.25H10.2499V11.386H6.5V12.886H10.9999H11.7499V12.136Z" class="fill-primary"/></svg>',
  "clock+tilde": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.58443 10.9997C2.58443 6.35128 6.3527 2.58301 11.0011 2.58301C15.6495 2.58301 19.4178 6.35128 19.4178 10.9997C19.4178 11.1705 19.4127 11.3402 19.4026 11.5085C19.9117 11.5309 20.4098 11.5956 20.8935 11.6992C20.9096 11.4681 20.9178 11.2348 20.9178 10.9997C20.9178 5.52285 16.4779 1.08301 11.0011 1.08301C5.52428 1.08301 1.08443 5.52285 1.08443 10.9997C1.08443 16.1411 4.99721 20.3687 10.0075 20.8672C10.0026 20.7453 10.0001 20.6228 10.0001 20.4997C10.0001 20.1155 10.0242 19.737 10.0709 19.3655C5.86021 18.9026 2.58443 15.3337 2.58443 10.9997ZM11.7511 11.6358V5.74976H10.2511V10.8858H6.50118V12.3858H11.0011H11.7511V11.6358Z" class="fill-primary"/><path d="M13.5 17.8764V17.8183C13.5 16.538 14.538 15.5 15.8183 15.5C16.4896 15.5 17.1278 15.7909 17.5682 16.2975L18.7589 17.6675C19.1503 18.1178 19.7176 18.3764 20.3142 18.3764C21.4524 18.3764 22.375 17.4538 22.375 16.3157V16" stroke-width="1.5" class="stroke-primary"/></svg>',
  "clock.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM10.6611 6.84668V13.2617L11.1484 13.5527L14.9189 15.8018L15.4307 14.9424L15.9434 14.084L12.6611 12.125V6.84668H10.6611Z" class="fill-primary"/></svg>',
  "clock.filled+arrow.downRight": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M10.1494 0.4375C15.1647 0.4375 19.2926 4.22448 19.8359 9.09473C18.9876 8.82976 18.0851 8.6875 17.1494 8.6875C12.1789 8.6875 8.14941 12.7169 8.14941 17.6875C8.14941 18.4068 8.2361 19.1058 8.39551 19.7764C3.84814 18.95 0.399414 14.9733 0.399414 10.1875C0.399414 4.80272 4.76464 0.4375 10.1494 0.4375ZM8.14941 8.82422H5.27344V10.8242H10.1494V3.91016H8.14941V8.82422Z" class="fill-primary"/><path d="M19.5303 18.4697V13.2803H21.0303V21.0303H13.2803V19.5303H18.4697L13 14.0605L14.0605 13L19.5303 18.4697Z" class="fill-primary"/></svg>',
  "clock.filled+arrow.right": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M10.1494 0.84375C15.1647 0.84375 19.2926 4.63073 19.8359 9.50098C18.9876 9.23601 18.0851 9.09375 17.1494 9.09375C12.1789 9.09375 8.14941 13.1232 8.14941 18.0938C8.14941 18.813 8.2361 19.5121 8.39551 20.1826C3.84814 19.3563 0.399414 15.3795 0.399414 10.5938C0.399414 5.20897 4.76464 0.84375 10.1494 0.84375ZM8.14941 9.23047H5.27344V11.2305H10.1494V4.31641H8.14941V9.23047Z" class="fill-primary"/><path d="M22.6055 17.4795L17.125 22.96L16.0645 21.8994L19.7305 18.2324H12V16.7334H19.7373L16.0645 13.0605L17.125 12L22.6055 17.4795Z" class="fill-primary"/></svg>',
  "clock.filled+arrow.right+line.right": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M10 1.25C15.0152 1.25 19.1432 5.03698 19.6865 9.90723C18.8381 9.64223 17.9357 9.5 17 9.5C12.0294 9.5 8 13.5294 8 18.5C8.00004 19.2193 8.08665 19.9184 8.24609 20.5889C3.69872 19.7625 0.25 15.7858 0.25 11C0.25 5.61522 4.61522 1.25 10 1.25ZM8 9.63672H5.12402V11.6367H10V4.72266H8V9.63672Z" class="fill-primary"/><path d="M20.9102 17.499L15.4297 22.9795L14.3691 21.9189L18.0352 18.252H10.3047V16.7529H18.042L14.3691 13.0801L15.4297 12.0195L20.9102 17.499Z" class="fill-primary"/><path d="M21.9102 12.0391H23.4102V22.9991H21.9102V12.0391Z" class="fill-primary"/></svg>',
  "clock.filled+arrow.upRight": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.0303 20.75H19.5303V15.5605L14.0605 21.0303L13 19.9697L18.4697 14.5H13.2803V13H21.0303V20.75Z" class="fill-primary"/><path d="M10.1494 0.03125C15.1647 0.03125 19.2926 3.81823 19.8359 8.68848C18.9876 8.42351 18.0851 8.28125 17.1494 8.28125C12.1789 8.28125 8.14941 12.3107 8.14941 17.2812C8.14941 18.0005 8.2361 18.6996 8.39551 19.3701C3.84814 18.5438 0.399414 14.567 0.399414 9.78125C0.399414 4.39647 4.76464 0.0312501 10.1494 0.03125ZM8.14941 8.41797H5.27344V10.418H10.1494V3.50391H8.14941V8.41797Z" class="fill-primary"/></svg>',
  "clock.filled+play.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M10.1494 0.03125C15.2907 0.03125 19.4987 4.0109 19.8691 9.05762C19.0586 8.81781 18.2008 8.68755 17.3125 8.6875C12.3419 8.6875 8.3125 12.7169 8.3125 17.6875C8.3125 18.2678 8.36869 18.835 8.47363 19.3848C3.88761 18.5901 0.399414 14.5944 0.399414 9.78125C0.399414 4.39647 4.76464 0.0312501 10.1494 0.03125ZM8.14941 8.41797H5.27344V10.418H10.1494V3.50391H8.14941V8.41797Z" class="fill-primary"/><path d="M21.1689 18.5312L16.75 21.293V15.7686L21.1689 18.5312Z" stroke-width="3" class="stroke-primary fill-primary"/></svg>',
  "clock.filled+stop.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M10.1494 0.03125C15.2907 0.03125 19.4987 4.0109 19.8691 9.05762C19.0586 8.81781 18.2008 8.68755 17.3125 8.6875C12.3419 8.6875 8.3125 12.7169 8.3125 17.6875C8.3125 18.2678 8.36869 18.835 8.47363 19.3848C3.88761 18.5901 0.399414 14.5944 0.399414 9.78125C0.399414 4.39647 4.76464 0.0312501 10.1494 0.03125ZM8.14941 8.41797H5.27344V10.418H10.1494V3.50391H8.14941V8.41797Z" class="fill-primary"/><path stroke-width="1.5" d="M14.75 15.156H21V21.406H14.75z" class="stroke-primary fill-primary"/></svg>',
  codeBrackets: en,
  cog: tn,
  "cog.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M14.9814 2.59766L15.3906 5.10449C15.7086 5.25927 16.0142 5.43497 16.3057 5.62988L18.6787 4.73242L19.2754 4.50684L19.5938 5.05957L21.835 8.94043L22.1533 9.49316L21.6602 9.89648L19.7129 11.4873C19.7255 11.6672 19.7344 11.8485 19.7344 12.0312C19.7344 12.2136 19.7255 12.3946 19.7129 12.5742L21.6602 14.166L22.1533 14.5693L21.835 15.1221L19.5928 19.0049L19.2734 19.5576L18.6768 19.3301L16.3086 18.4297C16.0163 18.6254 15.7097 18.8017 15.3906 18.957L14.9814 21.4648L14.8789 22.0938H9.12109L9.01855 21.4648L8.6084 18.957C8.29041 18.8022 7.98478 18.6266 7.69336 18.4316L5.32129 19.3301L4.72461 19.5557L4.40625 19.0029L2.16504 15.1221L1.8457 14.5693L2.33984 14.166L4.28418 12.5752C4.27155 12.3953 4.26562 12.2139 4.26562 12.0312C4.26562 11.8483 4.27151 11.6665 4.28418 11.4863L2.33984 9.89648L1.8457 9.49316L2.16504 8.94043L4.40625 5.05762L4.72559 4.50488L5.32324 4.73242L7.69043 5.63184C7.98271 5.43612 8.28937 5.25981 8.6084 5.10449L9.01855 2.59766L9.12109 1.96875H14.8789L14.9814 2.59766ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z" class="fill-primary"/></svg>',
  collection: rn,
  component: an,
  copy: sn,
  "copy.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M9 3H20V16H9z" class="fill-primary"/><path d="M7 18H16V21H4V7H7V18ZM16 16H9V7H16V16Z" class="fill-primary"/></svg>',
  cross: nn,
  "cross.big": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.4595 4.27373L4.25721 19.476" stroke-width="1.5" class="stroke-primary"/><path d="M19.4595 19.4761L4.25721 4.27381" stroke-width="1.5" class="stroke-primary"/></svg>',
  "cross.big.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.4595 4.27373L4.25721 19.476" stroke-width="3" class="stroke-primary"/><path d="M19.4595 19.4761L4.25721 4.27381" stroke-width="3" class="stroke-primary"/></svg>',
  curlyBraces: ln,
  "curlyBraces+dots": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="18.25" r="1.25" class="fill-primary"/><circle cx="8" cy="18.25" r="1.25" class="fill-primary"/><circle cx="16" cy="18.25" r="1.25" class="fill-primary"/><path d="M19 3H20C20.5523 3 21 3.44772 21 4V9.5C21 11 22 12 23.5 12H24" stroke-width="1.5" class="stroke-primary"/><path d="M19 21H20C20.5523 21 21 20.5523 21 20V14.5C21 13 22 12 23.5 12H24" stroke-width="1.5" class="stroke-primary"/><path d="M5 21H4C3.44772 21 3 20.5523 3 20V14.5C3 13 2 12 0.5 12H0" stroke-width="1.5" class="stroke-primary"/><path d="M5 3H4C3.44772 3 3 3.44772 3 4V9.5C3 11 2 12 0.5 12H0" stroke-width="1.5" class="stroke-primary"/></svg>',
  deprecated: on,
  discovery: un,
  document: dn,
  "document+braces": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M11.9583 22H11.3749C10.8226 22 10.3749 21.5523 10.3749 21V18.0278C10.3749 17.1111 9.58325 16.5 8.39575 16.5H7.99992" stroke-width="1.5" class="stroke-primary"/><path d="M11.9583 11H11.3749C10.8226 11 10.3749 11.4477 10.3749 12V14.9722C10.3749 15.8889 9.58325 16.5 8.39575 16.5H7.99992" stroke-width="1.5" class="stroke-primary"/><path d="M19 11H19.6C20.1523 11 20.6 11.4477 20.6 12V14.9722C20.6 15.8889 21.4 16.5 22.6 16.5H23" stroke-width="1.5" class="stroke-primary"/><path d="M19 22H19.6C20.1523 22 20.6 21.5523 20.6 21V18.0278C20.6 17.1111 21.4 16.5 22.6 16.5H23" stroke-width="1.5" class="stroke-primary"/><path d="M17.2546 7.50189V2.75189H7.75346L2.75464 7.75189L2.75474 21.2519H6.00474" stroke-width="1.5" class="stroke-primary"/></svg>',
  "document+cog": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.25 7.5V2.75H7.74882L2.75 7.75L2.7501 21.25H7.0001" stroke-width="1.5" class="stroke-primary"/><path d="M15.1713 10.75H17.0908L18.0576 12.8389L18.5408 13.1208L20.8259 12.9201L21.7836 14.5837L20.4629 16.4671V17.0338L21.7869 18.921L20.8233 20.59L18.5399 20.3792L18.0567 20.6611L17.0908 22.75H15.1713L14.2054 20.6611L13.7222 20.3792L11.4378 20.5786L10.4803 18.9161L11.7974 17.0329V16.4662L10.4803 14.5821L11.4378 12.9196L13.7222 13.1208L14.2054 12.8389L15.1713 10.75Z" stroke-width="1.5" class="stroke-primary"/><circle cx="16.134" cy="16.75" r="1.25" class="fill-primary"/></svg>',
  "document+cross": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M15.25 9.5L8.75 16M15.25 16L8.75 9.5" stroke-width="1.5" class="stroke-primary"/><path d="M19.25 21.25V2.75H9.75L4.75 7.75V21.25H19.25Z" stroke-width="1.5" class="stroke-primary"/></svg>',
  "document+pencil": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7 21.25H2.75V7.75L7.75 2.75H17.25V7" stroke-width="1.5" class="stroke-primary"/><path d="M19.5947 10.553L22.4232 13.3814L14.9428 20.9008L11.1544 21.9268L12.1144 18.0724L19.5947 10.553Z" stroke-width="1.5" class="stroke-primary"/><path d="M20.3489 15.9211L17.4023 12.9744" stroke-width="1.5" class="stroke-primary"/></svg>',
  "document.filled+braces": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.9785 7.75098H11.375C9.02857 7.7513 7.125 9.65344 7.125 12.001V13.251H5.5V19.751H7.125V21.0137L7.12988 21.207L7.13086 21.2197C7.14445 21.4872 7.18338 21.7479 7.24414 22H1.97852V7.43945L7.41797 2H17.9785V7.75098Z" class="fill-primary"/><path d="M11.958 11.75H11.375C11.237 11.7501 11.125 11.862 11.125 12V14.9727L11.1104 15.2285C11.054 15.7257 10.8326 16.1613 10.4873 16.499C10.8914 16.8937 11.1249 17.4236 11.125 18.0273V21C11.125 21.138 11.237 21.2499 11.375 21.25H11.958V22.75H11.375C10.4086 22.7499 9.625 21.9664 9.625 21V18.0273C9.62489 17.8078 9.53926 17.6427 9.37207 17.5137C9.1885 17.3721 8.86803 17.25 8.39551 17.25H8V15.75H8.39551C8.86803 15.75 9.1885 15.6279 9.37207 15.4863C9.53926 15.3573 9.62489 15.1922 9.625 14.9727V12C9.625 11.0336 10.4086 10.2501 11.375 10.25H11.958V11.75Z" class="fill-primary"/><path d="M19.7793 10.2588C20.6616 10.3486 21.3496 11.094 21.3496 12V14.9727C21.3497 15.189 21.435 15.3531 21.6055 15.4834C21.7928 15.6265 22.1192 15.7499 22.5996 15.75H23V17.25H22.5996C22.1192 17.2501 21.7928 17.3735 21.6055 17.5166C21.435 17.6469 21.3497 17.811 21.3496 18.0273V21C21.3496 21.906 20.6616 22.6514 19.7793 22.7412L19.5996 22.75H19V21.25H19.5996L19.6504 21.2451C19.7643 21.2218 19.8496 21.1208 19.8496 21V18.0273C19.8497 17.4229 20.0851 16.8935 20.4902 16.5C20.0851 16.1065 19.8497 15.5771 19.8496 14.9727V12C19.8496 11.8792 19.7643 11.7782 19.6504 11.7549L19.5996 11.75H19V10.25H19.5996L19.7793 10.2588Z" class="fill-primary"/></svg>',
  "document.filled+cog.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M18.6396 12.3096L18.7129 12.3525L21.2373 12.1309L22.6719 14.623L21.2129 16.7041V16.7969L22.6758 18.8818L21.2324 21.3809L18.71 21.1484L18.6387 21.1904L17.5703 23.5H14.6914L13.624 21.1904L13.5498 21.1475L11.0264 21.3672L9.59277 18.877L11.0479 16.7969V16.7021L9.59277 14.6211L11.0264 12.1309L13.5498 12.3525L13.624 12.3096L14.6914 10H17.5703L18.6396 12.3096ZM16.1377 15.4951C15.8337 15.4951 15.5555 15.6044 15.3389 15.7852C15.0609 16.0144 14.8838 16.3616 14.8838 16.75C14.8838 17.4404 15.4434 18 16.1338 18L16.1357 17.999L16.1377 18C16.8279 18 17.3874 17.4395 17.3877 16.748C17.3877 16.0563 16.8281 15.4951 16.1377 15.4951Z" class="fill-primary"/><path d="M7.43934 2H18V8.5H13.7328L12.6829 10.7706L10.2046 10.5523L7.81671 14.6989L9.25007 16.7493L7.81653 18.799L9.65991 22H2V7.43934L7.43934 2Z" class="fill-primary"/></svg>',
  "document.filled+text": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 2H9.43934L4 7.43934V22H20V2ZM17.4397 9.25085H6.55969V10.7491H17.4397V9.25085ZM17.4402 12.6379H6.56018V14.1362H17.4402V12.6379ZM17.4402 16.0253H6.56018V17.5236H17.4402V16.0253Z" class="fill-primary"/></svg>',
  exclamationMark: cn,
  "exclamationMark.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 3.60156L12 13.8016" stroke-width="3" stroke-linejoin="round" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.65 17.911C10.65 17.1654 11.2514 16.561 11.9933 16.561H12.0067C12.7486 16.561 13.35 17.1654 13.35 17.911C13.35 18.6566 12.7486 19.261 12.0067 19.261H11.9933C11.2514 19.261 10.65 18.6566 10.65 17.911Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary fill-primary"/></svg>',
  eye: pn,
  "eye.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M13.3511 12.9028C13.5297 12.6356 13.625 12.3214 13.625 12C13.625 11.569 13.4538 11.1557 13.149 10.851C12.8443 10.5462 12.431 10.375 12 10.375C11.6786 10.375 11.3644 10.4703 11.0972 10.6489C10.83 10.8274 10.6217 11.0812 10.4987 11.3781C10.3757 11.6751 10.3435 12.0018 10.4062 12.317C10.4689 12.6322 10.6237 12.9218 10.851 13.149C11.0782 13.3763 11.3678 13.5311 11.683 13.5938C11.9982 13.6565 12.3249 13.6243 12.6219 13.5013C12.9188 13.3783 13.1726 13.17 13.3511 12.9028Z" class="fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 12C20.5 15.2143 16.9706 19.5 12 19.5C7.02944 19.5 3.5 15.2143 1.5 12C3.5 8.78571 7.02944 4.5 12 4.5C16.9706 4.5 20.5 8.78571 22.5 12ZM16.5 12C16.5 12.89 16.2361 13.76 15.7416 14.5001C15.2471 15.2401 14.5443 15.8169 13.7221 16.1575C12.8998 16.4981 11.995 16.5872 11.1221 16.4135C10.2492 16.2399 9.44736 15.8113 8.81802 15.182C8.18868 14.5526 7.7601 13.7508 7.58647 12.8779C7.41283 12.005 7.50195 11.1002 7.84254 10.2779C8.18314 9.45566 8.75991 8.75285 9.49994 8.25839C10.24 7.76392 11.11 7.5 12 7.5C13.1935 7.5 14.3381 7.97411 15.182 8.81802C16.0259 9.66193 16.5 10.8065 16.5 12Z" class="fill-primary"/><path d="M13.3511 12.9028C13.5297 12.6356 13.625 12.3214 13.625 12C13.625 11.569 13.4538 11.1557 13.149 10.851C12.8443 10.5462 12.431 10.375 12 10.375C11.6786 10.375 11.3644 10.4703 11.0972 10.6489C10.83 10.8274 10.6217 11.0812 10.4987 11.3781C10.3757 11.6751 10.3435 12.0018 10.4062 12.317C10.4689 12.6322 10.6237 12.9218 10.851 13.149C11.0782 13.3763 11.3678 13.5311 11.683 13.5938C11.9982 13.6565 12.3249 13.6243 12.6219 13.5013C12.9188 13.3783 13.1726 13.17 13.3511 12.9028Z" stroke-width="1.5" class="stroke-primary"/><path clip-rule="evenodd" d="M22.5 12C20.5 15.2143 16.9706 19.5 12 19.5C7.02944 19.5 3.5 15.2143 1.5 12C3.5 8.78571 7.02944 4.5 12 4.5C16.9706 4.5 20.5 8.78571 22.5 12ZM16.5 12C16.5 12.89 16.2361 13.76 15.7416 14.5001C15.2471 15.2401 14.5443 15.8169 13.7221 16.1575C12.8998 16.4981 11.995 16.5872 11.1221 16.4135C10.2492 16.2399 9.44736 15.8113 8.81802 15.182C8.18868 14.5526 7.7601 13.7508 7.58647 12.8779C7.41283 12.005 7.50195 11.1002 7.84254 10.2779C8.18314 9.45566 8.75991 8.75285 9.49994 8.25839C10.24 7.76392 11.11 7.5 12 7.5C13.1935 7.5 14.3381 7.97411 15.182 8.81802C16.0259 9.66193 16.5 10.8065 16.5 12Z" stroke-width="1.5" class="stroke-primary"/></svg>',
  "eye.filled+stroke": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M8.42871 13.1396C8.6101 13.7078 8.92404 14.2268 9.34863 14.6514L9.55176 14.8408C10.0409 15.2624 10.6322 15.5512 11.2686 15.6777C11.3444 15.6928 11.4208 15.7035 11.4971 15.7139L15.8945 19.4033C14.7134 19.9278 13.4151 20.25 12 20.25C9.28565 20.25 6.99549 19.0768 5.15332 17.5293C3.31534 15.9852 1.88432 14.0374 0.863281 12.3965L0.616211 12L0.863281 11.6035C1.44964 10.6612 2.17114 9.61759 3.02734 8.60742L8.42871 13.1396ZM18.5684 17.7549C18.1721 18.0717 17.7567 18.3706 17.3213 18.6436L13.498 15.4355C13.9732 15.2283 14.3981 14.9263 14.748 14.5488L18.5684 17.7549ZM12 3.75C14.7143 3.75 17.0045 4.92315 18.8467 6.4707C20.6847 8.01482 22.1157 9.96259 23.1367 11.6035L23.3838 12L23.1367 12.3965C22.2808 13.772 21.1354 15.3617 19.7051 16.75L15.5332 13.25C15.6745 12.8504 15.75 12.4283 15.75 12C15.75 11.0678 15.4029 10.1713 14.7803 9.4834L14.6514 9.34863C13.9481 8.64537 12.9946 8.25 12 8.25C11.3514 8.25 10.7151 8.41755 10.1533 8.73535L6.36621 5.55762C7.97085 4.48459 9.85258 3.75 12 3.75ZM13.6934 13.6641C13.5117 13.849 13.301 14.0039 13.0684 14.1211L12.9092 14.1943C12.6884 14.2858 12.4561 14.3414 12.2207 14.3633L9.63379 12.1934C9.60304 11.8186 9.66081 11.4405 9.80566 11.0908C9.8749 10.9237 9.96235 10.7658 10.0664 10.6201L13.6934 13.6641ZM12 9.625C12.6299 9.625 13.2343 9.87491 13.6797 10.3203C14.1251 10.7657 14.375 11.3701 14.375 12C14.375 12.0888 14.3692 12.177 14.3594 12.2646L11.3291 9.72266C11.5458 9.65869 11.7715 9.625 12 9.625ZM9.01172 9.73535C8.87483 9.91599 8.75393 10.109 8.65137 10.3125L8.53516 10.5645C8.46032 10.7451 8.39997 10.9306 8.35449 11.1191L4.04102 7.5C4.38876 7.14855 4.75346 6.80729 5.13672 6.48438L9.01172 9.73535Z" class="fill-primary"/><path d="M2.12695 3.9375L21.6171 20.2916L20.6529 21.4407L1.16277 5.08657L2.12695 3.9375Z" class="fill-secondary"/></svg>',
  fastBackward: hn,
  "fastBackward.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.06726 12L14.5135 20.0547V3.94434L3.06726 12Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M15.0743 7.53906V16.46L22.2365 21.5V2.5L15.0743 7.53906Z" class="fill-primary"/></svg>',
  fastForward: mn,
  "fastForward.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20.9327 12L9.48645 20.0547V3.94434L20.9327 12Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M8.92566 7.53906V16.46L1.76355 21.5V2.5L8.92566 7.53906Z" class="fill-primary"/></svg>',
  filter: vn,
  "filter.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M9.99903 20.5952V14.5L3.68933 7.25V2.75H20.3117V7.25L13.9999 14.5V18.2984L9.99903 20.5952Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  flag: fn,
  gauge: wn,
  "gauge.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.3999 19.9698C22.26 18.4242 22.75 16.6443 22.75 14.75C22.75 8.81294 17.9371 4 12 4C6.06294 4 1.25 8.81294 1.25 14.75C1.25 16.615 1.72491 18.369 2.56039 19.8978L21.3999 19.9698ZM2.77934 15.4922H4.89323C4.86698 15.2458 4.85352 14.9956 4.85352 14.7422C4.85352 14.4888 4.86698 14.2386 4.89323 13.9922H2.7806C2.76033 14.2421 2.75 14.4949 2.75 14.75C2.75 14.9998 2.7599 15.2474 2.77934 15.4922ZM4.95034 8.761L6.54784 10.3585C6.70351 10.1657 6.87093 9.97925 7.05009 9.80009C7.22925 9.62093 7.4157 9.45351 7.6085 9.29784L6.011 7.70034C5.62953 8.02473 5.27473 8.37953 4.95034 8.761ZM11.1035 5.54289V7.7819C11.3499 7.75565 11.6001 7.74219 11.8535 7.74219C12.1069 7.74219 12.3571 7.75565 12.6035 7.7819V5.51937C12.404 5.50652 12.2028 5.5 12 5.5C11.6976 5.5 11.3985 5.51451 11.1035 5.54289ZM17.9889 7.70027L16.3916 9.2976C16.777 9.60783 17.1331 9.96229 17.4517 10.3588L19.0496 8.76092C18.7252 8.37946 18.3704 8.02466 17.9889 7.70027ZM14.7058 12.7932L12.5428 17.8557L11.1634 17.2664L13.3264 12.2039L14.7058 12.7932ZM18.8535 14.7422C18.8535 14.4888 18.8401 14.2386 18.8138 13.9922H21.2194C21.2397 14.2421 21.25 14.4949 21.25 14.75C21.25 14.9998 21.2401 15.2474 21.2207 15.4922H18.8138C18.8401 15.2458 18.8535 14.9956 18.8535 14.7422Z" class="fill-primary"/></svg>',
  globe: gn,
  "globe+orbit": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path clip-rule="evenodd" d="M21 12C21 16.9709 16.9709 21 12 21C7.02908 21 3 16.9709 3 12C3 7.02908 7.02908 3 12 3C16.9709 3 21 7.02908 21 12Z" stroke-width="1.5" class="stroke-secondary"/><path d="M4.20947 8.23883L7.14746 7.59489C7.18642 7.58635 7.21659 7.55547 7.22421 7.51631L7.56237 5.77815C7.56826 5.74787 7.5878 5.72201 7.6153 5.70806L9.71893 4.64133C9.74583 4.62769 9.76514 4.60264 9.77147 4.57315L10.0001 3.50937M13.3735 19.8729V18.9614C13.3735 18.9334 13.3853 18.9067 13.4059 18.8877L14.7087 17.6905C14.7341 17.6672 14.7457 17.6323 14.7393 17.5983L14.497 16.3175C14.492 16.2915 14.4976 16.2646 14.5125 16.2427L15.6792 14.5269C15.7166 14.472 15.691 14.3966 15.6279 14.3757L14.5419 14.0174C14.5092 14.0066 14.4843 13.9797 14.4761 13.9462L14.0187 12.0762C14.0078 12.0315 13.9676 12 13.9216 12H12.7827C12.7562 12 12.7308 12.0105 12.712 12.0293L12.4358 12.3054C12.3985 12.3427 12.3385 12.3446 12.2989 12.3096L11.7655 11.8389C11.7472 11.8228 11.7237 11.8139 11.6993 11.8139L9.31693 11.8139C9.28603 11.8139 9.25686 11.8282 9.23792 11.8526L7.61095 13.9494C7.58703 13.9803 7.58322 14.0222 7.60121 14.0568L8.4403 15.6728C8.45534 15.7017 8.48356 15.7215 8.51591 15.7258L10.5176 15.9912C10.5579 15.9965 10.5909 16.0257 10.6012 16.065L11.4988 19.4919C11.5082 19.5275 11.5363 19.5551 11.572 19.5638L13.25 19.9701C13.3129 19.9853 13.3735 19.9377 13.3735 19.8729Z" stroke-width="1.5" class="stroke-secondary"/><path d="M21 12.6804L18.7517 10.6647C18.6927 10.6118 18.5985 10.6453 18.5862 10.7237L18.195 13.2159C18.1851 13.2789 18.1196 13.3167 18.0601 13.2937L16.5401 12.7052C16.5016 12.6903 16.4762 12.6532 16.4762 12.6119V10.5964C16.4762 10.5624 16.4589 10.5308 16.4303 10.5124L14.2005 9.07727C14.1844 9.06688 14.1656 9.06136 14.1464 9.06136H11.1741C11.0901 9.06136 11.0435 8.96411 11.0962 8.89868L12.4733 7.18658C12.4823 7.17537 12.4936 7.16624 12.5065 7.15981L13.7839 6.52109C13.8377 6.49419 13.8558 6.42623 13.8224 6.37618L13.1045 5.29926C13.0798 5.26218 13.0826 5.21323 13.1113 5.17921L14.1758 3.92063L14.9545 3.42712" stroke-width="1.5" class="stroke-secondary"/><path d="M21.8273 16.7399C21.8273 16.7399 22.8799 17.8927 22.8799 18.9953C22.8799 23.8203 12.9852 18.6146 8.88726 15.3073C4.78934 12 0.55061 7.5011 1.30375 4.75634C2.04714 2.04711 5.02485 3.72008 5.02485 3.72008" stroke-width="1.5" class="stroke-primary"/></svg>',
  "globe.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M16.2139 12.75C16.0705 15.8579 14.937 19.2831 12.083 22.7471C12.0554 22.7473 12.0277 22.75 12 22.75C11.972 22.75 11.944 22.7473 11.916 22.7471C9.06227 19.2832 7.92945 15.8578 7.78613 12.75H16.2139ZM6.28516 12.75C6.41445 15.834 7.42361 19.1768 9.85449 22.5352C5.18322 21.5891 1.61363 17.6153 1.27832 12.75H6.28516ZM22.7217 12.75C22.3864 17.6156 18.8163 21.5895 14.1445 22.5352C16.5757 19.1767 17.5855 15.8341 17.7148 12.75H22.7217ZM9.79004 1.47852C8.34102 3.47085 6.93621 6.30125 6.44922 9.61426C6.37078 10.148 6.31622 10.694 6.28906 11.25H1.27832C1.61208 6.40715 5.15044 2.44795 9.79004 1.47852ZM12.1045 1.25195C13.6849 3.01673 15.5179 6.09368 16.0674 9.83203C16.1353 10.2943 16.1831 10.7676 16.209 11.25H7.79102C7.81694 10.7676 7.86565 10.2943 7.93359 9.83203C8.48308 6.09409 10.3143 3.01678 11.8945 1.25195C11.9297 1.25162 11.9648 1.25 12 1.25C12.0349 1.25 12.0697 1.25162 12.1045 1.25195ZM14.209 1.47852C18.849 2.44761 22.3879 6.40683 22.7217 11.25H17.7109C17.6838 10.694 17.6302 10.148 17.5518 9.61426C17.0647 6.30093 15.6581 3.4709 14.209 1.47852Z" class="fill-primary"/></svg>',
  home: yn,
  "home.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.2501 21.25H14.2501V14.75H9.75006V21.25H2.75006V11.2217L11.0134 2.75H12.9577L21.2501 11.2122V21.25Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  "horizon+satellite": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25"><path d="M12.2109 8.58636C12.324 9.68512 13.3064 10.4841 14.4052 10.371" stroke-width="1.5" class="stroke-primary"/><path d="M9.53963 9.70683C9.76586 11.9044 11.7307 13.5024 13.9282 13.2762" stroke-width="1.5" class="stroke-primary"/><circle cx="15.746" cy="6.669" r="1.25" transform="rotate(38.613 15.746 6.67)" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary fill-primary"/><path d="M8.45907 17.8509C10.7458 19.3279 12.6855 21.0815 14.221 22.9676L12.2376 22.9677C10.9534 21.5669 9.41528 20.2542 7.64523 19.1109C5.76168 17.8944 3.81098 16.9965 1.89387 16.4006L1.8963 14.8327C4.0952 15.4679 6.32482 16.4724 8.45907 17.8509Z" class="fill-primary"/><path d="M6.0572 2.26651C5.85682 2.17903 5.65558 2.09406 5.45509 2.00898L6.16965 2.00782L6.0572 2.26651ZM9.54951 3.91882C8.97276 3.6245 8.39386 3.3398 7.81489 3.06582L8.31555 2.00808L9.0713 2.00795C9.45816 2.19544 9.84505 2.38677 10.2306 2.58353L9.54951 3.91882ZM21.8292 10.075C22.3465 10.4891 22.854 10.9101 23.3533 11.335L22.923 11.8429L22.3839 12.4759C21.8961 12.0609 21.3992 11.6507 20.8938 11.2461L21.8292 10.075ZM12.9359 5.77474C12.3782 5.44767 11.8182 5.13044 11.257 4.82287L11.6472 4.10886L11.9777 3.50732C12.5517 3.82193 13.1231 4.14856 13.6935 4.48303L12.9359 5.77474ZM18.6737 7.69973C19.2131 8.08205 19.7458 8.46859 20.2687 8.86248L19.3676 10.0615C18.8594 9.67866 18.3428 9.30013 17.8185 8.92839C18.1794 8.6175 18.4597 8.21848 18.628 7.76324L18.6737 7.69973Z" class="fill-primary"/></svg>',
  horizonAxis: kn,
  hourglass: Cn,
  "hourglass.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M18.9951 8.31055L18.7764 8.53027L15.3066 12L18.7764 15.4697L18.9951 15.6895V22H5V15.6895L8.68945 12L5 8.31055V2H18.9951V8.31055ZM8.5 17V18.5H15.5V17H8.5Z" class="fill-primary"/></svg>',
  id: bn,
  image: Ln,
  infinity: Mn,
  "information.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 19.8297L12 9.62971" stroke-width="3" stroke-linejoin="round" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.35 5.52029C13.35 6.26587 12.7486 6.87029 12.0067 6.87029H11.9933C11.2514 6.87029 10.65 6.26587 10.65 5.52029C10.65 4.7747 11.2514 4.17028 11.9933 4.17028H12.0067C12.7486 4.17028 13.35 4.7747 13.35 5.52029Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary fill-primary"/></svg>',
  key: Vn,
  lightning: xn,
  "lightning.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M4.00012 12.9999L15.5001 1.99994L13.5001 10.9999H20.5001L9.50012 22L11.0001 12.9999H4.00012Z" class="fill-primary"/></svg>',
  "list.framed": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M9.25 15.501H18.749000000000002V17.000999999999998H9.25z" class="fill-primary"/><path d="M9.25 11.501H18.749000000000002V13.001H9.25z" class="fill-primary"/><path d="M5.25 7H18.749000000000002V8.5H5.25z" class="fill-primary"/><path d="M5.25 15.251H7.25V17.250999999999998H5.25z" class="fill-primary"/><path d="M5.25 11.251H7.25V13.251H5.25z" class="fill-primary"/><path d="M2.00012 3.75122H22.0001V20.249H2.00012V3.75122Z" stroke-width="1.5" stroke-linecap="round" class="stroke-primary"/></svg>',
  "list.framed.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.75 3.00122H1.25V20.999H22.75V3.00122ZM9.25049 15.5007H18.7493V17.0007H9.25049V15.5007ZM18.7493 11.5007H9.25049V13.0007H18.7493V11.5007ZM5.25049 7H18.7493V8.5H5.25049V7ZM7.25049 15.2507H5.25049V17.2507H7.25049V15.2507ZM5.25049 11.2507H7.25049V13.2507H5.25049V11.2507Z" class="fill-primary"/></svg>',
  lock: Dn,
  "lock.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.25 8.75H20.75V21.25H3.25V8.75Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M7.25 9.75V6.99426C7.25 4.37091 9.37665 2.24426 12 2.24426C14.6234 2.24426 16.75 4.37091 16.75 6.99426V9.75" stroke-width="3" class="stroke-primary"/></svg>',
  "lock.keyhole": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.24988 8.75H20.7499V21.25H3.24988V8.75Z" stroke-width="1.5" class="stroke-primary"/><path d="M12 12.75V17.25" stroke-width="1.5" class="stroke-primary"/><path d="M7.25 8.5V6.25C7.25 3.62665 9.37665 1.5 12 1.5C14.6234 1.5 16.75 3.62665 16.75 6.25V8.5" stroke-width="1.5" class="stroke-primary"/></svg>',
  "lock.keyhole.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.5 8H2.5V22.0001H21.5V8ZM11.2501 17.4231V12.5769H12.7501V17.4231H11.2501Z" class="fill-primary"/><path d="M7.25 9.71069V6.97925C7.25 4.3559 9.37665 2.22925 12 2.22925C14.6234 2.22925 16.75 4.3559 16.75 6.97925V9.71069" stroke-width="3" class="stroke-primary"/></svg>',
  magicWand: Hn,
  magnifyingGlass: Tn,
  "magnifyingGlass+graph": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><ellipse cx="7.5" cy="7.5" rx="7.5" ry="7.5" transform="matrix(-1 0 0 1 21.25 2.76)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><path d="M8.52405 16.0021L4.00002 20.517" stroke-width="1.5" class="stroke-primary"/><path stroke-width="1.5" d="M9.907 8.095L9.907 13.11" class="stroke-primary"/><path stroke-width="1.5" d="M12.592 6.545L12.592 13.11" class="stroke-primary"/><path stroke-width="1.5" d="M15.251 10.174L15.251 13.11" class="stroke-primary"/><path stroke-width="1.5" d="M17.692 8.524L17.692 13.11" class="stroke-primary"/></svg>',
  "magnifyingGlass.ccw": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><ellipse cx="7.5" cy="7.5" rx="7.5" ry="7.5" transform="matrix(-1 0 0 1 21.25 2.75)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><path d="M8.5238 15.9928L3.99978 20.5076" stroke-width="1.5" class="stroke-primary"/></svg>',
  mapMarker: $n,
  "mapMarker.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 2C14.1621 2.0001 16.2358 2.8589 17.7646 4.3877C19.2936 5.91667 20.1523 7.99103 20.1523 10.1533C20.1522 11.6002 19.63 13.0512 18.9043 14.3779C18.175 15.7111 17.2113 16.9713 16.2646 18.0508C15.316 19.1326 14.3693 20.0491 13.6611 20.6943C13.3067 21.0173 13.0103 21.2739 12.8018 21.4502C12.6976 21.5382 12.6146 21.6066 12.5576 21.6533C12.5295 21.6764 12.5074 21.6947 12.4922 21.707C12.4849 21.713 12.4787 21.7184 12.4746 21.7217C12.4726 21.7232 12.4699 21.7247 12.4688 21.7256L12.4668 21.7275L11.9648 22.1279L11.4922 21.6934C10.8375 21.0912 8.91396 19.5517 7.20117 17.5586C5.49638 15.5748 3.84695 12.9763 3.84668 10.1533C3.84668 7.99119 4.70562 5.91663 6.23438 4.3877C7.76326 2.85881 9.83784 2.0001 12 2ZM12 7.57812C11.3142 7.57812 10.6568 7.85098 10.1719 8.33594C9.68692 8.82089 9.41406 9.47823 9.41406 10.1641C9.41406 10.6754 9.56556 11.1754 9.84961 11.6006C10.1338 12.0258 10.5382 12.357 11.0107 12.5527C11.4832 12.7484 12.0033 12.8 12.5049 12.7002C13.0063 12.6004 13.4666 12.3537 13.8281 11.9922C14.1897 11.6306 14.4363 11.1704 14.5361 10.6689C14.6359 10.1674 14.5843 9.64728 14.3887 9.1748C14.1929 8.70229 13.8618 8.29782 13.4365 8.01367C13.0113 7.72962 12.5114 7.57813 12 7.57812Z" class="fill-primary"/><path d="M12 8.32812C12.3631 8.32812 12.7181 8.4358 13.02 8.63754C13.3219 8.83927 13.5572 9.126 13.6962 9.46148C13.8351 9.79695 13.8715 10.1661 13.8007 10.5222C13.7298 10.8784 13.555 11.2055 13.2982 11.4623C13.0414 11.719 12.7143 11.8939 12.3582 11.9647C12.002 12.0356 11.6329 11.9992 11.2974 11.8602C10.9619 11.7213 10.6752 11.486 10.4735 11.184C10.2717 10.8821 10.1641 10.5272 10.1641 10.1641C10.1641 9.67714 10.3575 9.21016 10.7018 8.86586C11.0461 8.52155 11.5131 8.32813 12 8.32812Z" stroke-width="1.5" class="stroke-backdrop fill-backdrop"/></svg>',
  meatballs: Sn,
  message: _n,
  "message.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M22.75 21.25H1.25V2.75H22.75V21.25ZM11.9922 12.5312L5.58984 7.27344L4.63965 8.42871L11.9922 14.4678L19.3447 8.42871L18.3945 7.27344L11.9922 12.5312Z" class="fill-primary"/></svg>',
  monitor: On,
  notFound: Pn,
  officeBuilding: Bn,
  "officeBuilding.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M14.5 12.7209H22V21.2209H14.5V12.7209Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 21.9992H1.25V1.99921H12.75V21.9992ZM5.25 7.49921H9.25V5.99921H5.25V7.49921Z" class="fill-primary"/></svg>',
  orbit: Zn,
  "orbit.dotted": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M14.4915 20.7453C9.64109 22.0449 4.65546 19.1665 3.35579 14.3161C2.05613 9.46564 4.93458 4.48001 9.785 3.18035C13.8773 2.08382 18.0658 3.96138 20.0557 7.48807" stroke-width="1.5" stroke-dasharray="3 3" class="stroke-primary"/><circle cx="1.75" cy="1.75" r="1.75" transform="matrix(-1 0 0 1 18 18.25)" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><circle cx="2.5" cy="2.5" r="2.5" transform="matrix(-1 0 0 1 14.5 9.5)" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/></svg>',
  pause: An,
  "pause.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M5.5 2.5H8.5V21.5H5.5V2.5Z" class="fill-primary"/><path d="M15.492 2.5H18.492V21.5H15.492z" class="fill-primary"/></svg>',
  pencil: Rn,
  "pencil+line": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M15.4802 2.50122L18.9759 5.99691L9.49495 15.5261L4.81278 16.7942L5.99926 12.0304L7.43892 10.5841L15.4802 2.50122Z" stroke-width="1.5" class="stroke-primary"/><path d="M3 21.25L21 21.25" stroke-width="1.5" class="stroke-primary"/><path d="M13 5L16 8" stroke-width="1.5" class="stroke-primary"/></svg>',
  "pencil.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M16.7101 11.8477L9.11536 19.4785L2.66418 21.2256L4.29602 14.6729L11.8986 7.03516L16.7101 11.8477ZM21.0333 7.50586L18.1915 10.3594L13.379 5.54688L16.2208 2.69336L21.0333 7.50586Z" class="fill-primary"/></svg>',
  "pencil.filled+line": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3 21.25L21 21.25" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.0353 5.99558L15.4789 1.43921L12.9957 3.93503L17.5521 8.49141L20.0353 5.99558ZM16.4941 9.55476L11.9377 4.99838L5.32161 11.6482L3.77649 17.8519L9.88497 16.1975L16.4941 9.55476Z" class="fill-primary"/></svg>',
  "pencil.filled+line.dotted": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3 21.25H6" stroke-width="1.5" class="stroke-primary"/><path d="M8 21.25H11" stroke-width="1.5" class="stroke-primary"/><path d="M13 21.25H16" stroke-width="1.5" class="stroke-primary"/><path d="M18 21.25H21" stroke-width="1.5" class="stroke-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.0353 5.99558L15.4789 1.43921L12.9957 3.93503L17.5521 8.49141L20.0353 5.99558ZM16.4941 9.55476L11.9377 4.99838L5.32161 11.6482L3.77649 17.8519L9.88497 16.1975L16.4941 9.55476Z" class="fill-primary"/></svg>',
  percentSign: In,
  play: Yn,
  "play.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M17.1963 12L5.75 20.0547V3.94434L17.1963 12Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  plus: Nn,
  "plus.big": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 3V21" stroke-width="1.5" class="stroke-primary"/><path d="M21 12L3 12" stroke-width="1.5" class="stroke-primary"/></svg>',
  "plus.big.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 3V21" stroke-width="3" class="stroke-primary"/><path d="M21 12L3 12" stroke-width="3" class="stroke-primary"/></svg>',
  powerButton: Fn,
  "powerButton.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1V13V1Z" class="fill-primary"/><path d="M12 1V13" stroke-width="3" stroke-linejoin="round" class="stroke-primary"/><path d="M7.48438 6.49707C5.96876 7.79307 5.00008 9.73039 5 11.9111C5.00007 15.851 8.15894 19 12 19C15.8411 19 18.9999 15.851 19 11.9111C18.9999 9.73973 18.0396 7.80959 16.5352 6.51367V2.91895C19.7782 4.58698 21.9999 7.98683 22 11.9111L21.9873 12.4307C21.7194 17.7611 17.3502 22 12 22C6.47719 22 2.00007 17.4829 2 11.9111L2.0127 11.3926C2.19906 7.68097 4.37446 4.49983 7.48438 2.90918V6.49707Z" class="fill-primary"/></svg>',
  profile: En,
  "profile.circled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M5.42188 19.3357C6.66246 16.9444 9.14266 15.313 11.9999 15.313C14.8572 15.313 17.3374 16.9444 18.578 19.3357" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><circle cx="12" cy="9" r="3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/><circle cx="12" cy="12" r="10" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "profile.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="7" r="4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary fill-primary"/><path d="M2.87439 21.2443C2.87439 21.2443 8.19246 21.2443 12 21.2443C15.8075 21.2443 21.1255 21.2443 21.1255 21.2443C20.3512 17.183 16.4585 14.25 12 14.25C7.54144 14.25 3.64879 17.183 2.87439 21.2443Z" class="fill-primary"/></svg>',
  "profile.filled+lock": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="7" r="4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary fill-primary"/><path d="M12.0004 14.25C13.1271 14.25 14.2176 14.4242 15.2308 14.7451C15.2012 14.9132 15.1849 15.0865 15.1849 15.2637C15.1849 15.3383 15.1903 15.4122 15.1957 15.4854H13.6722V20.7461H2.87439C3.64879 16.9741 7.54184 14.25 12.0004 14.25Z" class="fill-primary"/><path d="M15.2922 17.0349H21.1256V21.2016H15.2922V17.0349Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M16.6257 17.0349V16.2849C16.6257 15.4105 17.3346 14.7016 18.2091 14.7016C19.0835 14.7016 19.7924 15.4105 19.7924 16.2849V17.0349" stroke-width="1.5" class="stroke-primary"/></svg>',
  "profileGroup.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M2.88672 7.23559C2.88672 5.72111 4.12568 4.50732 5.63672 4.50732C7.14775 4.50732 8.38672 5.72111 8.38672 7.23559C8.38672 8.75007 7.14775 9.96386 5.63672 9.96386C4.12568 9.96386 2.88672 8.75007 2.88672 7.23559Z" class="fill-primary"/><path d="M8.7386 12.7222C9.09751 13.1313 9.38781 13.6039 9.60104 14.117C9.08403 14.3556 8.60701 14.6721 8.19102 15.0582C7.80684 15.4148 7.48668 15.8197 7.23742 16.2576L1.25 16.2576C1.25 14.9316 1.71217 13.6598 2.53484 12.7222C3.35751 11.7846 4.47329 11.2578 5.63672 11.2578C6.80015 11.2578 7.91593 11.7846 8.7386 12.7222Z" class="fill-primary"/><path d="M15.809 15.0582C16.1933 15.4149 16.5136 15.82 16.7629 16.2581H22.624C22.624 14.932 22.1619 13.6603 21.3392 12.7227C20.5165 11.7851 19.4007 11.2583 18.2373 11.2583C17.0739 11.2583 15.9581 11.7851 15.1354 12.7227C14.7877 13.119 14.5044 13.5749 14.2932 14.0695C14.851 14.313 15.3648 14.6459 15.809 15.0582Z" class="fill-primary"/><path d="M15.4873 7.23608C15.4873 5.72159 16.7263 4.50781 18.2373 4.50781C19.7483 4.50781 20.9873 5.72159 20.9873 7.23608C20.9873 8.75056 19.7483 9.96434 18.2373 9.96434C16.7263 9.96434 15.4873 8.75056 15.4873 7.23608Z" class="fill-primary"/><path d="M9.25 10.5603C9.25 9.04581 10.489 7.83203 12 7.83203C13.511 7.83203 14.75 9.04581 14.75 10.5603C14.75 12.0748 13.511 13.2886 12 13.2886C10.489 13.2886 9.25 12.0748 9.25 10.5603Z" class="fill-primary"/><path d="M15.1019 16.0469C15.9245 16.9846 16.3867 18.2563 16.3867 19.5823L7.61328 19.5823C7.61328 18.2563 8.07545 16.9846 8.89812 16.0469C9.72079 15.1093 10.8366 14.5825 12 14.5825C13.1634 14.5825 14.2792 15.1093 15.1019 16.0469Z" class="fill-primary"/></svg>',
  pulse: zn,
  puzzlePiece: qn,
  "puzzlePiece.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M11.6999 14.6179C11.2607 14.3806 10.7693 14.2563 10.2701 14.2564C9.77081 14.2563 9.27941 14.3806 8.84019 14.6179C8.40097 14.8553 8.02776 15.1982 7.75422 15.6158C7.48068 16.0335 7.31544 16.5127 7.27339 17.0101C7.23134 17.5076 7.31381 18.0077 7.51337 18.4653V19.5178H2V4.48309H7.32413V5.38462C7.23471 5.82159 7.24362 6.27297 7.35021 6.70607C7.45679 7.13916 7.65839 7.54313 7.94039 7.88868C8.22239 8.23424 8.57773 8.51273 8.98067 8.70398C9.3836 8.89523 9.82404 8.99446 10.2701 8.99446C10.7161 8.99446 11.1565 8.89523 11.5594 8.70398C11.9624 8.51273 12.3177 8.23423 12.5997 7.88868C12.8817 7.54312 13.0833 7.13916 13.1899 6.70607C13.2965 6.27297 13.3054 5.82159 13.216 5.38462V4.48309H18.5912V9.16722H19.0377C19.36 9.05469 19.6988 8.99684 20.0402 8.99606C20.4781 8.99605 20.9108 9.0917 21.3079 9.27631C21.705 9.46093 22.057 9.73006 22.3393 10.0649C22.6215 10.3997 22.8273 10.7922 22.9421 11.2148C23.0569 11.6374 23.078 12.08 23.0039 12.5116C22.9298 12.9433 22.7624 13.3535 22.5132 13.7137C22.2641 14.0738 21.9393 14.3752 21.5616 14.5968C21.1838 14.8183 20.7622 14.9547 20.3263 14.9964C19.8903 15.038 19.4505 14.984 19.0377 14.8379H18.5912V19.5178H13.0267V18.4653C13.2263 18.0077 13.3088 17.5076 13.2667 17.0101C13.2247 16.5127 13.0594 16.0335 12.7859 15.6158C12.5124 15.1982 12.1391 14.8553 11.6999 14.6179Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  questionMark: Un,
  radioWave: Kn,
  "radioWave.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M2 12C4 -8.58307e-06 10 1.43051e-05 12 12C14 24 20 24 22 12" stroke-width="3" class="stroke-primary"/></svg>',
  radome: Wn,
  "radome.blank": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7.5 18.4902V22.7812H16.5V18.4902" stroke-width="1.5" class="stroke-primary"/><path d="M17.25 20H6.75" stroke-width="1.5" class="stroke-primary"/><circle cx="12" cy="10.75" r="9.25" stroke-width="1.5" class="stroke-primary"/></svg>',
  receipt: jn,
  rocket: Qn,
  satellite: Xn,
  "satellite.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M8.34352 18.3139C6.89127 18.3139 5.71399 17.1366 5.71399 15.6843" stroke-width="1.5" class="stroke-primary"/><path d="M8.34377 21.2599C5.28004 21.2599 2.79639 18.7763 2.79639 15.7125" stroke-width="1.5" class="stroke-primary"/><path d="M14.8849 13.1956C14.8771 13.2719 14.8696 13.3609 14.8566 13.4601C14.8076 13.8332 14.7181 14.3509 14.5583 14.9254C14.2877 15.8975 13.8317 16.9663 13.084 17.7918L6.6054 11.3132C7.54558 10.4139 8.64428 9.95228 9.57746 9.71809C10.1217 9.58156 10.6004 9.52467 10.9399 9.50196C11.0315 9.49583 11.1131 9.49501 11.1823 9.49298L14.8849 13.1956ZM11.4516 9.49022L11.4509 9.48953L11.4502 9.48884L11.4516 9.49022Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M11 10.25L18.25 2.99994L21.75 6.49991L14.5 13.75" stroke-width="1.5" class="stroke-primary"/><path d="M21.9749 11.2855L19.5 13.7604L17.0251 11.2855L19.5 8.81066L21.9749 11.2855Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M20.9057 5.90864L14.541 12.2733L12.0661 9.79842L18.4308 3.43377L20.9057 5.90864Z" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M15.8284 5.38909L13.3536 7.86396L10.5251 5.03553L13 2.56066L15.8284 5.38909Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  "satellite.filled+stroke": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M3.54688 15.7109C3.54688 18.3605 5.6952 20.5088 8.34473 20.5088V22.0088C4.86678 22.0088 2.04687 19.1889 2.04688 15.7109H3.54688ZM6.46387 15.6836C6.46387 16.7216 7.30571 17.5635 8.34375 17.5635V19.0635C6.47728 19.0635 4.96387 17.5501 4.96387 15.6836H6.46387ZM15.0088 15.9551C14.6275 16.9778 14.0255 18.0568 13.0713 18.8389L5.5625 11.3301C6.16716 10.6024 6.85983 10.0777 7.55371 9.7002L15.0088 15.9551ZM16.2246 13.083L15.5723 13.7373C15.5443 13.9265 15.506 14.1413 15.458 14.375L9.12598 9.0625C9.92891 8.83251 10.628 8.76321 11.0537 8.74414L16.2246 13.083ZM15.8438 4.34375L18.25 1.93945L22.8105 6.5L22.2803 7.03027L20.5293 8.7793L23.0352 11.2852L20.0146 14.3057L12.0625 7.63281L9.46484 5.03516L13 1.5L15.8438 4.34375Z" class="fill-primary"/><path d="M3.57227 2.44531L23.0624 18.7995L22.0982 19.9485L2.60808 3.59438L3.57227 2.44531Z" class="fill-secondary"/></svg>',
  shield: Gn,
  "shield+checkmark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#iZse)" stroke-width="1.5" class="stroke-primary"><path d="M12 1.5C13.0257 2.41475 14.6503 3.26208 16.3623 3.94336C18.0744 4.62467 19.874 5.13964 21.25 5.38965V9C21.25 14.8123 17.731 20.1556 12.5107 22.7568L12 23L11.4893 22.7568C6.26905 20.1556 2.75 14.8123 2.75 9V5.38965C4.12602 5.13964 5.92565 4.62467 7.6377 3.94336C9.34967 3.26208 10.9743 2.41475 12 1.5Z"/><path d="M8 12L11 15L16 9"/></g><defs><clipPath id="iZse"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath></defs></svg>',
  "shield+cross": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M15.6241 8.3764L8.3763 15.6242" stroke-width="1.5" class="stroke-primary"/><path d="M15.6237 15.6243L8.37581 8.37648" stroke-width="1.5" class="stroke-primary"/><path d="M12 1.34058C13.0257 2.25533 14.6503 3.10265 16.3623 3.78394C18.0744 4.46524 19.874 4.98022 21.25 5.23022V8.84058C21.25 14.6529 17.731 19.9962 12.5107 22.5974L12 22.8406L11.4893 22.5974C6.26905 19.9962 2.75 14.6529 2.75 8.84058V5.23022C4.12602 4.98022 5.92565 4.46525 7.6377 3.78394C9.34967 3.10265 10.9743 2.25533 12 1.34058Z" stroke-width="1.5" class="stroke-primary"/></svg>',
  "shield+orbit": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.34058C13.0257 2.25533 14.6503 3.10265 16.3623 3.78394C18.0744 4.46524 19.874 4.98022 21.25 5.23022V8.84058C21.25 14.6529 17.731 19.9962 12.5107 22.5974L12 22.8406L11.4893 22.5974C6.26905 19.9962 2.75 14.6529 2.75 8.84058V5.23022C4.12602 4.98022 5.92565 4.46525 7.6377 3.78394C9.34967 3.10265 10.9743 2.25533 12 1.34058Z" stroke-width="1.5" class="stroke-primary"/><path d="M10.5158 16.2564C12.963 16.9121 15.4785 15.4598 16.1342 13.0126C16.7899 10.5653 15.3376 8.04988 12.8904 7.39415C10.8257 6.8409 8.71237 7.78821 7.70837 9.56758M10.5114 15.8804C10.5114 16.368 10.1161 16.7633 9.6285 16.7633C9.14086 16.7633 8.74555 16.368 8.74555 15.8804C8.74555 15.3927 9.14086 14.9974 9.6285 14.9974C10.1161 14.9974 10.5114 15.3927 10.5114 15.8804ZM13.0342 11.844C13.0342 12.5407 12.4694 13.1054 11.7728 13.1054C11.0762 13.1054 10.5114 12.5407 10.5114 11.844C10.5114 11.1474 11.0762 10.5827 11.7728 10.5827C12.4694 10.5827 13.0342 11.1474 13.0342 11.844Z" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "shield.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.4992 0.781146L12 0.335938L11.5008 0.781146C10.5735 1.60812 9.04606 2.41678 7.36048 3.08756C5.68881 3.75281 3.93713 4.25292 2.61593 4.49296L2 4.60486V8.84088C2 15.1537 5.93935 20.9099 11.6896 23.5237L12 23.6647L12.3103 23.5237C18.0606 20.9099 22 15.1537 22 8.84088V4.60486L21.3841 4.49296C20.0629 4.25292 18.3112 3.75281 16.6395 3.08756C14.9539 2.41678 13.4264 1.60812 12.4992 0.781146Z" class="fill-primary"/><path d="M12 22.8398C6.5 20.3398 2.75 14.8398 2.75 8.83984V5.22984C5.50207 4.72984 9.94872 3.16926 12 1.33984C14.0512 3.16926 18.498 4.72984 21.25 5.22984V8.83984C21.25 14.8398 17.5 20.3398 12 22.8398Z" stroke-width="1.5" class="stroke-secondary"/></svg>',
  "shield.filled+checkmark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.495117L12.4992 0.940325C13.4264 1.7673 14.9539 2.57596 16.6395 3.24674C18.3112 3.91199 20.0629 4.4121 21.3841 4.65214L22 4.76404V9.00006C22 15.3129 18.0606 21.0691 12.3103 23.6828L12 23.8239L11.6896 23.6828C5.93935 21.0691 2 15.3129 2 9.00006V4.76404L2.61593 4.65214C3.93713 4.4121 5.68881 3.91199 7.36048 3.24674C9.04606 2.57596 10.5735 1.7673 11.5008 0.940325L12 0.495117ZM6.4189 12.7047L10.3732 16.659L17.5808 9.45747L16.1672 8.04266L10.3738 13.8312L7.83311 11.2905L6.4189 12.7047Z" class="fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.5808 9.45729L10.3733 16.6588L6.41895 12.7046L7.83315 11.2903L10.3738 13.831L16.1672 8.04248L17.5808 9.45729Z" class="fill-backdrop"/><path d="M12 22.9986C6.5 20.4986 2.75 14.9986 2.75 8.99863V5.38863C5.50207 4.88863 9.94872 3.32804 12 1.49863C14.0512 3.32804 18.498 4.88863 21.25 5.38863V8.99863C21.25 14.9986 17.5 20.4986 12 22.9986Z" stroke-width="1.5" class="stroke-secondary"/></svg>',
  "shield.filled+cross": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12.499 0.78125C13.4263 1.60822 14.9541 2.41711 16.6396 3.08789C18.3112 3.75305 20.0627 4.25312 21.3838 4.49316L22 4.60449V8.84082C22 15.1535 18.0607 20.9096 12.3105 23.5234L12 23.665L11.6895 23.5234C5.93929 20.9096 2 15.1535 2 8.84082V4.60449L2.61621 4.49316C3.93733 4.25312 5.68884 3.75305 7.36035 3.08789C9.04593 2.41711 10.5737 1.60822 11.501 0.78125L12 0.335938L12.499 0.78125ZM7.3125 8.9043L10.4092 12L7.31348 15.0967L8.9043 16.6885L12 13.5908L15.0967 16.6875L16.6875 15.0967L13.5908 12L16.6875 8.9043L15.0967 7.31348L12 10.4092L8.9043 7.3125L7.3125 8.9043Z" class="fill-primary"/><path d="M12 10.4092L15.0967 7.31348L16.6875 8.9043L13.5908 12L16.6875 15.0967L15.0967 16.6875L12 13.5908L8.9043 16.6885L7.31348 15.0967L10.4092 12L7.3125 8.9043L8.9043 7.3125L12 10.4092Z" class="fill-backdrop"/><path d="M12 22.8398C6.5 20.3398 2.75 14.8398 2.75 8.83984V5.22984C5.50207 4.72984 9.94872 3.16926 12 1.33984C14.0512 3.16926 18.498 4.72984 21.25 5.22984V8.83984C21.25 14.8398 17.5 20.3398 12 22.8398Z" stroke-width="1.5" class="stroke-secondary"/></svg>',
  "shield.filled+exclamationMark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#Tmqz)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.4992 0.940264L12 0.495056L11.5008 0.940264C10.5735 1.76724 9.04606 2.5759 7.36048 3.24668C5.68881 3.91192 3.93713 4.41204 2.61593 4.65208L2 4.76398V9C2 15.3128 5.93935 21.069 11.6896 23.6828L12 23.8238L12.3103 23.6828C18.0606 21.069 22 15.3128 22 9V4.76398L21.3841 4.65208C20.0629 4.41204 18.3112 3.91192 16.6395 3.24668C14.9539 2.5759 13.4264 1.76723 12.4992 0.940264ZM13 7H11V12.9998H13V7ZM12 18C12.8285 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8285 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18Z" class="fill-primary"/><path d="M11 7H13V12.9998H11V7Z" class="fill-backdrop"/><path d="M13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5C10.5 15.6716 11.1716 15 12 15C12.8284 15 13.5 15.6716 13.5 16.5Z" class="fill-backdrop"/><path d="M12 23C6.5 20.5 2.75 15 2.75 9V5.39C5.50207 4.89 9.94872 3.32941 12 1.5C14.0512 3.32941 18.498 4.89 21.25 5.39V9C21.25 15 17.5 20.5 12 23Z" stroke-width="1.5" class="stroke-secondary"/></g><defs><clipPath id="Tmqz"><path d="M0 0H24V24H0z" class="fill-primary"/></clipPath></defs></svg>',
  slash: Jn,
  sliders: el,
  speechBubble: tl,
  "speechBubble.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.25 2.75H2.75V17.25H11L17.25 21V17.25H21.25V2.75Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  "speechBubble.filled+dots": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 2H2V18H10.7923L18 22.3246V18H22V2ZM8.67063 10.3098C8.67063 11.3328 7.84128 12.1621 6.81822 12.1621C5.79517 12.1621 4.96582 11.3328 4.96582 10.3098C4.96582 9.28683 5.79517 8.45752 6.81822 8.45752C7.84128 8.45752 8.67063 9.28683 8.67063 10.3098ZM12 12.1623C13.023 12.1623 13.8524 11.333 13.8524 10.3099C13.8524 9.28687 13.023 8.45752 12 8.45752C10.9769 8.45752 10.1476 9.28687 10.1476 10.3099C10.1476 11.333 10.9769 12.1623 12 12.1623ZM19.0342 10.3099C19.0342 11.333 18.2048 12.1623 17.1817 12.1623C16.1587 12.1623 15.3293 11.333 15.3293 10.3099C15.3293 9.28687 16.1587 8.45752 17.1817 8.45752C18.2048 8.45752 19.0342 9.28687 19.0342 10.3099Z" class="fill-primary"/></svg>',
  "speechBubble.filled+text": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 2H2V18H10.7923L18 22.3246V18H22V2ZM4.71191 6.3161H19.2882V4.8161H4.71191V6.3161ZM4.71191 10.5513H19.2882V9.05133H4.71191V10.5513ZM4.71191 14.7866H13.8221V13.2866H4.71191V14.7866Z" class="fill-primary"/></svg>',
  speedometer: rl,
  "speedometer.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.937 17.9371 22.75 12 22.75C6.06312 22.7498 1.25002 17.9369 1.25 12C1.25 6.06306 6.06311 1.2502 12 1.25ZM6.85059 19.7852L8.14941 20.5352L9.64941 17.9375L8.34961 17.1875L6.85059 19.7852ZM14.3506 17.9346L15.8506 20.5342L17.1504 19.7842L15.6494 17.1846L14.3506 17.9346ZM10.916 12.6191L11.5156 13.0684L12.1172 13.5176L15.6787 8.75293L15.0781 8.30469L14.4775 7.85547L10.916 12.6191ZM2.5 12.75H5.5V11.25H2.5V12.75ZM18.5 12.75H21.5V11.25H18.5V12.75ZM14.3506 6.06543L15.6494 6.81543L17.1504 4.21582L15.8506 3.46582L14.3506 6.06543ZM6.85059 4.21484L8.34961 6.8125L9.64941 6.0625L8.14941 3.46484L6.85059 4.21484Z" class="fill-primary"/></svg>',
  star: al,
  "star.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 3.3125L14.6356 9.18487L21.035 9.87684L16.2645 14.1981L17.584 20.4982L12 17.2965L6.41604 20.4982L7.73546 14.1981L2.96496 9.87684L9.36437 9.18487L12 3.3125Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  stop: sl,
  "stop.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M20.75 3.25V20.75H3.25V3.25H20.75Z" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  stopwatch: nl,
  table: ll,
  "table.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M10 5H21.0005" stroke-width="3" class="stroke-primary"/><path d="M10 19H21.0005" stroke-width="3" class="stroke-primary"/><path d="M10 12H21.0005" stroke-width="3" class="stroke-primary"/><circle cx="4.5" cy="19" r="1.5" stroke-width="1.5" class="stroke-primary fill-primary"/><circle cx="4.5" cy="12" r="1.5" stroke-width="1.5" class="stroke-primary fill-primary"/><circle cx="4.5" cy="5" r="1.5" stroke-width="1.5" class="stroke-primary fill-primary"/></svg>',
  tag: il,
  text: ol,
  "text+pencil": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.5947 10.553L22.4232 13.3814L14.9428 20.9008L11.1544 21.9268L12.1144 18.0724L19.5947 10.553Z" stroke-width="1.5" class="stroke-primary"/><path d="M20.3489 15.9211L17.4023 12.9744" stroke-width="1.5" class="stroke-primary"/><path d="M2 2.75H14" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M2 9H14" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/><path d="M2 15.25H8" stroke-width="1.5" stroke-linejoin="round" class="stroke-primary"/></svg>',
  "text/circle+c": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12.2667 5.59998C14.3285 5.59998 16 7.27145 16 9.33331V9.63539H13.7792C13.7513 9.02897 13.3385 7.86644 12 7.86644C10.8457 7.86644 10.3664 9.00441 10.3663 9.63539V12V14.3844C10.3664 15.0154 10.7723 16.1742 12 16.1742C13.2277 16.1742 13.6589 15.1054 13.7792 14.6031H16V14.6666C16 16.7285 14.3285 18.4 12.2667 18.4H11.7333C9.67147 18.4 8 16.7285 8 14.6666V9.33331C8 7.27145 9.67147 5.59998 11.7333 5.59998H12.2667Z" class="fill-primary"/><circle cx="12" cy="12" r="11.25" stroke-width="1.5" class="stroke-primary"/></svg>',
  "text/circle+e": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.25" stroke-width="1.5" class="stroke-primary"/><path d="M16.7998 8.21912H10.6484V10.6918H14.8027V13.3011H10.6484V15.7738H16.7998V18.3998H8V5.59998H16.7998V8.21912Z" class="fill-primary"/></svg>',
  "text/circle+t": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.25" stroke-width="1.5" class="stroke-primary"/><path d="M16.6306 8.29431H13.2742V18.3998H10.5994V8.29431H7.19995V5.59998H16.6306V8.29431Z" class="fill-primary"/></svg>',
  "text/circle.filled+c": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C9.66386e-08 5.37258 5.37258 9.66416e-08 12 0ZM11.7334 5.59961C9.67164 5.59961 8.00016 7.27128 8 9.33301V14.667C8.00019 16.7287 9.67165 18.4004 11.7334 18.4004H12.2666C14.3283 18.4004 15.9998 16.7287 16 14.667V14.6035H13.7793C13.6589 15.106 13.2274 16.1738 12 16.1738C10.7726 16.1738 10.3665 15.0158 10.3662 14.3848V9.63574C10.3663 9.00476 10.8457 7.86621 12 7.86621C13.3385 7.86621 13.7514 9.02932 13.7793 9.63574H16V9.33301C15.9998 7.27128 14.3284 5.59961 12.2666 5.59961H11.7334Z" class="fill-secondary"/><path d="M12.2667 5.59998C14.3285 5.59998 16 7.27145 16 9.33331V9.63539H13.7792C13.7513 9.02897 13.3385 7.86644 12 7.86644C10.8457 7.86644 10.3664 9.00441 10.3663 9.63539V12V14.3844C10.3664 15.0154 10.7723 16.1742 12 16.1742C13.2277 16.1742 13.6589 15.1054 13.7792 14.6031H16V14.6666C16 16.7285 14.3285 18.4 12.2667 18.4H11.7333C9.67147 18.4 8 16.7285 8 14.6666V9.33331C8 7.27145 9.67147 5.59998 11.7333 5.59998H12.2667Z" class="fill-backdrop"/><circle cx="12" cy="12" r="11.25" stroke-width="1.5" class="stroke-primary"/></svg>',
  "text/circle.filled+e": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C9.66386e-08 5.37258 5.37258 9.66416e-08 12 0ZM8 5.59961V18.3994H16.7998V15.7734H10.6484V13.3008H14.8027V10.6914H10.6484V8.21875H16.7998V5.59961H8Z" class="fill-secondary"/><circle cx="12" cy="12" r="11.25" stroke-width="1.5" class="stroke-primary"/><path d="M16.7998 8.21912H10.6484V10.6918H14.8027V13.3011H10.6484V15.7738H16.7998V18.3998H8V5.59998H16.7998V8.21912Z" class="fill-backdrop"/></svg>',
  "text/circle.filled+t": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C9.66386e-08 5.37258 5.37258 9.66416e-08 12 0ZM7.2002 5.59961V8.29395H10.5996V18.3994H13.2744V8.29395H16.6309V5.59961H7.2002Z" class="fill-secondary"/><circle cx="12" cy="12" r="11.25" stroke-width="1.5" class="stroke-primary"/><path d="M16.6306 8.29431H13.2742V18.3998H10.5994V8.29431H7.19995V5.59998H16.6306V8.29431Z" class="fill-backdrop"/></svg>',
  "text/cs": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M4.2749 6C6.2079 6 7.7749 7.567 7.7749 9.5V9.7832H5.30811C5.28199 9.21468 4.81374 8.76172 4.23877 8.76172C3.64725 8.76192 3.16756 9.24146 3.16748 9.83301V14.1904C3.16756 14.782 3.64725 15.2615 4.23877 15.2617C4.74426 15.2617 5.167 14.9113 5.27979 14.4404H7.7749V14.5C7.7749 16.433 6.2079 18 4.2749 18H3.7749C1.84191 18 0.274902 16.433 0.274902 14.5V9.5C0.274902 7.567 1.84191 6 3.7749 6H4.2749Z" class="fill-primary"/><path d="M22.2255 9.83426C22.2255 8.47605 21.1244 7.375 19.7662 7.375H19.5755H19.2603C17.9402 7.375 16.8701 8.4451 16.8701 9.76513C16.8701 10.3311 17.1899 10.8484 17.6962 11.1014L21.6968 13.1007C22.1094 13.3069 22.3701 13.7285 22.3701 14.1898C22.3701 15.5347 21.2798 16.625 19.9349 16.625H19.5755H19.3066C17.961 16.625 16.8701 15.5342 16.8701 14.1885" stroke-width="2.75" class="stroke-primary"/></svg>',
  "text/eirp": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M10.7539 2.52441H5.51172V4.64941H9.05176V6.8916H5.51172V9.0166H10.7539V11.2734H3.25391V0.273438H10.7539V2.52441Z" class="fill-primary"/><path d="M15.3633 0.253906H17.6133V11.2539H15.3633V0.253906Z" class="fill-primary"/><path d="M7.33911 12.6479C9.22621 12.6481 10.756 14.1778 10.7561 16.0649C10.7561 17.4494 9.93206 18.6403 8.74829 19.1772L11.2864 23.7417H8.71118L6.34302 19.4819H5.50415V23.7417H3.25415V13.7729L4.37915 12.6479H7.33911ZM5.50415 17.2319H7.33911C7.98361 17.2318 8.5061 16.7095 8.5061 16.0649C8.50603 15.4205 7.98356 14.8981 7.33911 14.8979H5.50415V17.2319Z" class="fill-primary"/><path d="M3.253 12.646H4.68V13.773000000000001H3.253z" class="fill-primary"/><path d="M17.3171 12.6492C19.2042 12.6493 20.7341 14.1791 20.7341 16.0662C20.7341 17.9533 19.2043 19.483 17.3171 19.4832H15.4822V23.7429H13.2322V13.7742L14.3572 12.6492H17.3171ZM15.4822 17.2332H17.3171C17.9616 17.233 18.4841 16.7107 18.4841 16.0662C18.4841 15.4217 17.9616 14.8993 17.3171 14.8992H15.4822V17.2332Z" class="fill-primary"/><path d="M13.231 12.647H14.658V13.774000000000001H13.231z" class="fill-primary"/></svg>',
  "text/gt": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6.05884 0.199768C7.99183 0.199768 9.55884 1.76677 9.55884 3.69977V3.98297H7.07349C6.96668 3.40187 6.45793 2.96149 5.84595 2.96149C5.1564 2.9615 4.5979 3.52096 4.5979 4.21051V8.21246C4.5979 8.90201 5.1564 9.46148 5.84595 9.46149C6.5355 9.46149 7.09497 8.90202 7.09497 8.21246V7.19293H9.55884V8.69977C9.55884 10.6328 7.99183 12.1998 6.05884 12.1998H5.55884C3.62584 12.1998 2.05884 10.6328 2.05884 8.69977V3.69977C2.05884 1.76677 3.62584 0.199768 5.55884 0.199768H6.05884Z" class="fill-primary"/><path d="M6.056 5.753H9.558V7.772H6.056z" class="fill-primary"/><path d="M21.9741 14.4614H19.4429V23.7338H17.0054V14.4614H14.4741V11.7338H21.9741V14.4614Z" class="fill-primary"/><path d="M7.42328 18.4341L15.7619 3.99094" stroke-width="2.25" class="stroke-primary"/></svg>',
  "text/hdr": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7.79932 18H5.54932V13.6475H2.54932V18H0.299316V6H2.54932V10.9092H5.54932V6H7.79932V18Z" class="fill-primary"/><path d="M11.9993 6.00464C13.9805 6.10709 15.5559 7.77545 15.5559 9.81812V14.1814C15.5559 16.2241 13.9805 17.8924 11.9993 17.9949L11.8059 17.9998H8.05591V5.99976H11.8059L11.9993 6.00464ZM10.4153 8.45483V15.5457H11.8098L11.9534 15.5339C12.6566 15.4181 13.2053 14.4568 13.2053 13.2888V10.7107C13.2053 9.54281 12.6566 8.58246 11.9534 8.46655L11.8098 8.45483H10.4153Z" class="fill-primary"/><path d="M20.0388 6.00244C22.0408 6.00244 23.6638 7.62541 23.6638 9.62744C23.6638 11.1746 22.6942 12.4938 21.3298 13.0142L23.531 18.0005H21.072L18.9753 13.2524H18.0037V18.0005H15.7537V7.12744L16.8787 6.00244H20.0388ZM18.0037 11.0024H20.0388C20.7982 11.0024 21.4138 10.3868 21.4138 9.62744C21.4138 8.86805 20.7982 8.25244 20.0388 8.25244H18.0037V11.0024Z" class="fill-primary"/><path d="M15.753 6H17.18V7.127H15.753z" class="fill-primary"/></svg>',
  "text/if": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.7124 8.45453H14.4702V10.7729H18.0103V13.2192H14.4702V17.9995H12.2124V5.99945H19.7124V8.45453Z" class="fill-primary"/><path d="M6.8562 5.99945H9.1062V17.9995H6.8562V5.99945Z" class="fill-primary"/></svg>',
  "text/rf": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M6.78564 6.00189C8.78768 6.00189 10.4106 7.62486 10.4106 9.62689C10.4106 11.1272 9.49907 12.4137 8.19971 12.9648L10.9663 17.9999H8.39795L5.78955 13.2519H4.75049V17.9999H2.50049V7.12689L3.62549 6.00189H6.78564ZM4.75049 11.0019H6.78564C7.54504 11.0019 8.16064 10.3863 8.16064 9.62689C8.16064 8.8675 7.54503 8.25189 6.78564 8.25189H4.75049V11.0019Z" class="fill-primary"/><path d="M2.5 5.999H3.927V7.1259999999999994H2.5z" class="fill-primary"/><path d="M21.4327 8.45752H16.1906V10.7759H19.7306V13.2222H16.1906V18.0024H13.9327V6.00244H21.4327V8.45752Z" class="fill-primary"/></svg>',
  "text/tm": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.7252 13.1855L21.0494 6H23.7418V18H21.8756V11.4785L20.7252 18H18.7545L17.608 11.6455V18H15.7418V6H18.4215L19.7252 13.1855Z" class="fill-primary"/><path d="M7.77441 8.72754H5.24316V18H2.80566V8.72754H0.274414V6H7.77441V8.72754Z" class="fill-primary"/></svg>',
  "text/ttc": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M7.80005 8.61572H5.2688V17.8882H2.8313V8.61572H0.300049V5.88818H7.80005V8.61572Z" class="fill-primary"/><path d="M15.75 8.61572H13.2188V17.8882H10.7812V8.61572H8.25V5.88818H15.75V8.61572Z" class="fill-primary"/><path d="M20.2 5.88818C22.1329 5.88818 23.7 7.45519 23.7 9.38818V9.67139H21.2332C21.207 9.10287 20.7388 8.6499 20.1638 8.6499C19.5723 8.6501 19.0926 9.12964 19.0925 9.72119V14.0786C19.0926 14.6702 19.5723 15.1497 20.1638 15.1499C20.6693 15.1499 21.0921 14.7995 21.2048 14.3286H23.7V14.3882C23.7 16.3212 22.1329 17.8882 20.2 17.8882H19.7C17.767 17.8882 16.2 16.3212 16.2 14.3882V9.38818C16.2 7.45519 17.767 5.88818 19.7 5.88818H20.2Z" class="fill-primary"/></svg>',
  "text/url": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M1 6.34998V14.5C1 15.8807 2.11929 17 3.5 17C4.88071 17 6 15.8807 6 14.5V6.34998" stroke-width="1.5" stroke-linejoin="bevel" class="stroke-primary"/><path d="M18.75 6.34998V16.85H23.75" stroke-width="1.5" class="stroke-primary"/><path d="M12.5 6.34998C14.2949 6.34998 15.75 7.80505 15.75 9.59998C15.75 11.0073 14.8551 12.2047 13.6035 12.6566L16.0029 17.6H14.3359L12.0303 12.85H10.75V17.6H9.25V6.34998H12.5ZM10.75 11.35H12.5C13.4665 11.35 14.25 10.5665 14.25 9.59998C14.25 8.63348 13.4665 7.84998 12.5 7.84998H10.75V11.35Z" class="fill-primary"/></svg>',
  tier: ul,
  "tier.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M11.9803 2.40918L3.48035 7.40918L11.9803 12.4092L20.4803 7.40918L11.9803 2.40918Z" class="fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9803 1.53906L21.9596 7.4092L11.9803 13.2793L2.0011 7.4092L11.9803 1.53906Z" class="fill-primary"/><path d="M11.9802 14.4899L18.9822 10.4147L21.95 12.1599L12.7351 17.5222L11.9802 17.9606L11.2263 17.5222L2.00366 12.155L4.97046 10.4108L11.9802 14.4899Z" class="fill-primary"/><path d="M21.9619 16.6521L12.7354 22.0222L11.9805 22.4607L11.2266 22.0222L2 16.6531L4.9668 14.908L11.9805 18.99L18.9951 14.908L21.9619 16.6521Z" class="fill-primary"/></svg>',
  trashCan: dl,
  "trashCan.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M8.5 6.25L9.5 3.25H14.5L15.5 6.25" stroke-width="1.5" class="stroke-primary"/><path d="M19.1697 22H4.83081V9.5H19.1697V22ZM8.99976 19H10.9998V12H8.99976V19ZM12.9998 19H14.9998V12H12.9998V19ZM20.3503 7.5H3.65015V6H20.3503V7.5Z" class="fill-primary"/></svg>',
  "triangle+exclamationMark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M21.5 21.25H2.5L1.5 19L11 2.75L13 2.75118L22.5 19L21.5 21.25Z" stroke-width="1.5" class="stroke-primary"/><circle cx="12" cy="17" r="1" class="fill-primary"/><path d="M12 9V14" stroke-width="1.5" class="stroke-primary"/></svg>',
  "triangle.filled+exclamationMark": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M12.9492 3.00098L22.5 19.25L21.25 21H2.75L1.5 19.25L11.0635 3L12.9492 3.00098ZM11.9941 15.7002C11.3072 15.7002 10.75 16.2598 10.75 16.9502C10.7502 17.6403 11.3074 18.2002 11.9941 18.2002H12.0059C12.6926 18.2002 13.2498 17.6403 13.25 16.9502C13.25 16.2598 12.6928 15.7002 12.0059 15.7002H11.9941ZM11 13.7139H13V9.25586H11V13.7139Z" class="fill-primary"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.0001 9.2554V13.7138H11.0001V9.2554H13.0001Z" class="fill-backdrop"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.7501 16.9497C10.7501 16.2594 11.307 15.6997 11.9939 15.6997H12.0063C12.6933 15.6997 13.2501 16.2594 13.2501 16.9497C13.2501 17.6401 12.6933 18.1997 12.0063 18.1997H11.9939C11.307 18.1997 10.7501 17.6401 10.7501 16.9497Z" class="fill-backdrop"/></svg>',
  unlinked: cl,
  vendor: pl,
  wifi: hl,
  "wifi+stroke": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="18.122" r="1" transform="rotate(-45 12 18.122)" stroke-width="1.5" class="stroke-primary fill-primary"/><path d="M3.57129 2.42969L23.0614 18.7838L22.0972 19.9329L2.60711 3.57875L3.57129 2.42969Z" class="fill-primary"/><path d="M12.3311 13.6947C10.8344 13.6054 9.30764 14.1315 8.16406 15.2748C8.16331 15.2756 8.16195 15.2761 8.16113 15.2768L7.10059 14.2162C7.1014 14.2155 7.10277 14.215 7.10352 14.2143C8.11878 13.1992 9.37072 12.5647 10.6816 12.3109L12.3311 13.6947ZM12.9404 12.2484C14.3899 12.4447 15.7896 13.0982 16.9043 14.2113L16.1631 14.9516L12.9404 12.2484ZM12.1055 7.65275C15.0035 7.68028 17.8934 8.79817 20.1045 11.0092L20.1055 11.0102L19.0449 12.0707L19.0439 12.0697C17.657 10.6828 15.9621 9.79244 14.1797 9.39396L12.1055 7.65275ZM7.94238 10.0121C6.85794 10.4946 5.84081 11.1778 4.95117 12.0668L3.89062 11.0063C4.73431 10.1631 5.67678 9.47888 6.68066 8.95353L7.94238 10.0121ZM11.5684 9.16056C10.9053 9.18885 10.2445 9.28185 9.59668 9.44181L8.21973 8.28653C8.79653 8.08591 9.38699 7.93627 9.9834 7.83048L11.5684 9.16056ZM7.47363 3.767C12.9089 2.16976 19.0254 3.51526 23.3135 7.80314L22.2529 8.86368C18.625 5.23588 13.5525 3.93189 8.88672 4.95255L7.47363 3.767ZM4.21191 6.88224C3.33799 7.43967 2.51038 8.0995 1.74707 8.86271L0.686523 7.80216C1.4133 7.07547 2.19311 6.434 3.0127 5.87638L4.21191 6.88224ZM7.14551 5.44962C6.62408 5.63439 6.11107 5.84985 5.60938 6.0961L4.36426 5.05216C4.84432 4.79129 5.33499 4.55714 5.83398 4.34903L7.14551 5.44962Z" class="fill-primary"/></svg>',
  wrench: ml,
  "wrench.filled": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M19.5659 12.7734C17.8333 14.506 15.2826 14.9221 13.1572 14.0215L6 21L3 18L10.0609 10.9251C9.16031 8.79971 9.57633 6.24909 11.3089 4.51649C12.4084 3.41707 13.8371 2.84777 15.2777 2.80859L16.8944 4.4253L13.5 7.91694L16.1197 10.6197L19.6043 7.13517L21.2738 8.80468C21.2346 10.2452 20.6653 11.674 19.5659 12.7734Z" class="fill-primary"/></svg>'
}, S1 = {
  ...vl
}, y3 = Object.keys(S1).sort(), ea = {
  ...S1
}, fl = ke({
  name: "KIcon",
  data() {
    return {
      rootClass: "kcl-icon"
    };
  },
  props: {
    name: {
      type: String,
      required: !1
    }
  },
  computed: {
    rootClasses() {
      return [this.rootClass, `${this.rootClass}-ICON`];
    },
    rootProps() {
      return {
        style: {
          ...this.sizeVariables
        }
      };
    },
    sizeVariables() {
      return this.width === this.height ? {
        "--size": `${this.width}px`
      } : {
        "--width": `${this.width}px`,
        "--height": `${this.height}px`
      };
    },
    icon() {
      if (this.name) {
        if (!ea[this.name])
          return console.warn(`Icon not found: '${this.name}'`), ea.notFound;
      } else return null;
      return ea[this.name];
    },
    size() {
      const e = (this.icon ?? "").match(/viewBox="([^"]+)"/);
      if (!e)
        return this.defaultSize;
      const [, , t, a] = e[1].split(" ").map((s) => parseInt(s));
      return {
        width: t,
        height: a
      };
    },
    defaultSize() {
      return {
        width: 24,
        height: 24
      };
    },
    width() {
      return this.size.width;
    },
    height() {
      return this.size.height;
    }
  }
}), wl = ["innerHTML"];
function gl(e, t, a, s, r, l) {
  return c(), k("div", Ee({ class: e.rootClass }, e.rootProps, { innerHTML: e.icon }), null, 16, wl);
}
const Ie = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [s, r] of t)
    a[s] = r;
  return a;
}, St = /* @__PURE__ */ Ie(fl, [["render", gl]]), _1 = Symbol("kclUseKey"), O1 = "abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ".split(""), yl = "123456789".split(""), kl = O1.concat(yl), Cl = /* @__PURE__ */ (() => {
  const e = [], t = (s) => s[Math.floor(Math.random() * s.length)], a = (s = 4) => {
    const r = new Array(s).fill(null).reduce((l, n, i) => i === 0 ? t(O1) : `${l}${t(kl)}`, "");
    return e.includes(r) ? a() : (e.push(r), r);
  };
  return a;
})(), Er = () => Cl(), Ha = (e = {}) => {
  const t = e.key ?? _1, a = e.id ?? Er();
  return Hs(t, a), a;
}, Gt = (e = {}) => {
  const t = e.key ?? _1;
  return Ds(
    t,
    () => e.fallbackId ?? Er(),
    !0
  );
}, bl = ke({
  name: "KCheckbox",
  components: {
    KIcon: St
  },
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: Boolean,
      required: !1,
      default: !1
    },
    indeterminate: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    name: {
      type: String,
      required: !1,
      default: ""
    }
  },
  data() {
    return {
      rootClass: "kcl-checkbox",
      controlId: Gt()
    };
  },
  watch: {
    indeterminate() {
      this.syncIndeterminateState();
    }
  },
  mounted() {
    this.syncIndeterminateState();
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    iconName() {
      return this.indeterminate ? "20/form/checkbox.filled+dash" : this.value ? "20/form/checkbox.filled+checkmark" : "20/form/checkbox";
    },
    rootClasses() {
      return [
        this.rootClass,
        {
          "is-disabled": this.disabled,
          "is-checked": this.value,
          "is-indeterminate": this.indeterminate
        }
      ];
    }
  },
  methods: {
    syncIndeterminateState() {
      const e = this.$refs.input;
      e && (e.indeterminate = this.indeterminate);
    }
  }
}), Ll = { class: "kcl-checkbox--indicator" }, Ml = ["id", "disabled", "name", "aria-checked"];
function Vl(e, t, a, s, r, l) {
  const n = Ae("KIcon");
  return c(), k("span", {
    class: ue(e.rootClasses)
  }, [
    O("span", Ll, [
      He(n, {
        class: "kcl-checkbox--icon",
        name: e.iconName
      }, null, 8, ["name"]),
      At(O("input", {
        id: e.controlId,
        ref: "input",
        "onUpdate:modelValue": t[0] || (t[0] = (i) => e.value = i),
        type: "checkbox",
        disabled: e.disabled,
        name: e.name,
        "aria-checked": e.indeterminate ? "mixed" : e.value
      }, null, 8, Ml), [
        [Ts, e.value]
      ])
    ])
  ], 2);
}
const P1 = /* @__PURE__ */ Ie(bl, [["render", Vl]]), xl = ke({
  name: "KRadio",
  components: {
    KIcon: St
  },
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: [Boolean, String, Number],
      required: !1,
      default: void 0
    },
    value: {
      type: [Boolean, String, Number],
      required: !1,
      default: !0
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    name: {
      type: String,
      required: !1,
      default: ""
    }
  },
  data() {
    return {
      rootClass: "kcl-radio",
      controlId: Gt()
    };
  },
  computed: {
    checked() {
      return this.modelValue === this.value;
    },
    iconName() {
      return this.checked ? "20/form/radio.selected" : "20/form/radio";
    },
    rootClasses() {
      return [
        this.rootClass,
        {
          "is-disabled": this.disabled,
          "is-checked": this.checked
        }
      ];
    }
  },
  methods: {
    handleChange() {
      this.disabled || this.$emit("update:modelValue", this.value);
    }
  }
}), Dl = { class: "kcl-radio--indicator" }, Hl = ["id", "checked", "disabled", "name", "value"];
function Tl(e, t, a, s, r, l) {
  const n = Ae("KIcon");
  return c(), k("span", {
    class: ue(e.rootClasses)
  }, [
    O("span", Dl, [
      He(n, {
        class: "kcl-radio--icon",
        name: e.iconName
      }, null, 8, ["name"]),
      O("input", {
        id: e.controlId,
        type: "radio",
        checked: e.checked,
        disabled: e.disabled,
        name: e.name,
        value: e.value,
        onChange: t[0] || (t[0] = (...i) => e.handleChange && e.handleChange(...i))
      }, null, 40, Hl)
    ])
  ], 2);
}
const B1 = /* @__PURE__ */ Ie(xl, [["render", Tl]]);
function mt(e) {
  "@babel/helpers - typeof";
  return mt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mt(e);
}
function fe(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function le(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function pe(e) {
  le(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || mt(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Tt(e, t) {
  le(2, arguments);
  var a = pe(e), s = fe(t);
  return isNaN(s) ? /* @__PURE__ */ new Date(NaN) : (s && a.setDate(a.getDate() + s), a);
}
function wt(e, t) {
  le(2, arguments);
  var a = pe(e), s = fe(t);
  if (isNaN(s))
    return /* @__PURE__ */ new Date(NaN);
  if (!s)
    return a;
  var r = a.getDate(), l = new Date(a.getTime());
  l.setMonth(a.getMonth() + s + 1, 0);
  var n = l.getDate();
  return r >= n ? l : (a.setFullYear(l.getFullYear(), l.getMonth(), r), a);
}
function Z1(e, t) {
  if (le(2, arguments), !t || mt(t) !== "object") return /* @__PURE__ */ new Date(NaN);
  var a = t.years ? fe(t.years) : 0, s = t.months ? fe(t.months) : 0, r = t.weeks ? fe(t.weeks) : 0, l = t.days ? fe(t.days) : 0, n = t.hours ? fe(t.hours) : 0, i = t.minutes ? fe(t.minutes) : 0, u = t.seconds ? fe(t.seconds) : 0, p = pe(e), h = s || a ? wt(p, s + a * 12) : p, d = l || r ? Tt(h, l + r * 7) : h, y = i + n * 60, L = u + y * 60, V = L * 1e3, Z = new Date(d.getTime() + V);
  return Z;
}
function $l(e, t) {
  le(2, arguments);
  var a = pe(e).getTime(), s = fe(t);
  return new Date(a + s);
}
var Sl = {};
function Dt() {
  return Sl;
}
function Wt(e, t) {
  var a, s, r, l, n, i, u, p;
  le(1, arguments);
  var h = Dt(), d = fe((a = (s = (r = (l = t == null ? void 0 : t.weekStartsOn) !== null && l !== void 0 ? l : t == null || (n = t.locale) === null || n === void 0 || (i = n.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && r !== void 0 ? r : h.weekStartsOn) !== null && s !== void 0 ? s : (u = h.locale) === null || u === void 0 || (p = u.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var y = pe(e), L = y.getDay(), V = (L < d ? 7 : 0) + L - d;
  return y.setDate(y.getDate() - V), y.setHours(0, 0, 0, 0), y;
}
function Ar(e) {
  return le(1, arguments), Wt(e, {
    weekStartsOn: 1
  });
}
function _l(e) {
  le(1, arguments);
  var t = pe(e), a = t.getFullYear(), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(a + 1, 0, 4), s.setHours(0, 0, 0, 0);
  var r = Ar(s), l = /* @__PURE__ */ new Date(0);
  l.setFullYear(a, 0, 4), l.setHours(0, 0, 0, 0);
  var n = Ar(l);
  return t.getTime() >= r.getTime() ? a + 1 : t.getTime() >= n.getTime() ? a : a - 1;
}
function Ol(e) {
  le(1, arguments);
  var t = _l(e), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0);
  var s = Ar(a);
  return s;
}
function Rr(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function r1(e) {
  le(1, arguments);
  var t = pe(e);
  return t.setHours(0, 0, 0, 0), t;
}
var Pl = 864e5;
function Bl(e, t) {
  le(2, arguments);
  var a = r1(e), s = r1(t), r = a.getTime() - Rr(a), l = s.getTime() - Rr(s);
  return Math.round((r - l) / Pl);
}
function Zl(e, t) {
  le(2, arguments);
  var a = fe(t), s = a * 3;
  return wt(e, s);
}
function Ta(e, t) {
  le(2, arguments);
  var a = fe(t);
  return wt(e, a * 12);
}
var $a = 6e4, Sa = 36e5, Al = 1e3;
function A1(e) {
  return le(1, arguments), e instanceof Date || mt(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function wr(e) {
  if (le(1, arguments), !A1(e) && typeof e != "number")
    return !1;
  var t = pe(e);
  return !isNaN(Number(t));
}
function a1(e) {
  le(1, arguments);
  var t = pe(e), a = Math.floor(t.getMonth() / 3) + 1;
  return a;
}
function R1(e, t) {
  var a;
  le(1, arguments);
  var s = e || {}, r = pe(s.start), l = pe(s.end), n = l.getTime();
  if (!(r.getTime() <= n))
    throw new RangeError("Invalid interval");
  var i = [], u = r;
  u.setHours(0, 0, 0, 0);
  var p = Number((a = void 0) !== null && a !== void 0 ? a : 1);
  if (p < 1 || isNaN(p)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; u.getTime() <= n; )
    i.push(pe(u)), u.setDate(u.getDate() + p), u.setHours(0, 0, 0, 0);
  return i;
}
function yr(e) {
  le(1, arguments);
  var t = pe(e), a = t.getMonth(), s = a - a % 3;
  return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
}
function Rl(e) {
  le(1, arguments);
  var t = e || {}, a = pe(t.start), s = pe(t.end), r = s.getTime();
  if (!(a.getTime() <= r))
    throw new RangeError("Invalid interval");
  var l = yr(a), n = yr(s);
  r = n.getTime();
  for (var i = [], u = l; u.getTime() <= r; )
    i.push(pe(u)), u = Zl(u, 1);
  return i;
}
function Il(e) {
  le(1, arguments);
  var t = pe(e), a = t.getFullYear();
  return t.setFullYear(a + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Yl(e) {
  le(1, arguments);
  var t = pe(e), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(t.getFullYear(), 0, 1), a.setHours(0, 0, 0, 0), a;
}
function Nl(e, t) {
  var a, s, r, l, n, i, u, p;
  le(1, arguments);
  var h = Dt(), d = fe((a = (s = (r = (l = t == null ? void 0 : t.weekStartsOn) !== null && l !== void 0 ? l : t == null || (n = t.locale) === null || n === void 0 || (i = n.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && r !== void 0 ? r : h.weekStartsOn) !== null && s !== void 0 ? s : (u = h.locale) === null || u === void 0 || (p = u.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var y = pe(e), L = y.getDay(), V = (L < d ? -7 : 0) + 6 - (L - d);
  return y.setDate(y.getDate() + V), y.setHours(23, 59, 59, 999), y;
}
function s1(e) {
  le(1, arguments);
  var t = pe(e), a = t.getMonth(), s = a - a % 3 + 3;
  return t.setMonth(s, 0), t.setHours(23, 59, 59, 999), t;
}
function I1(e, t) {
  le(2, arguments);
  var a = fe(t);
  return $l(e, -a);
}
var Fl = 864e5;
function El(e) {
  le(1, arguments);
  var t = pe(e), a = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var s = t.getTime(), r = a - s;
  return Math.floor(r / Fl) + 1;
}
function nr(e) {
  le(1, arguments);
  var t = 1, a = pe(e), s = a.getUTCDay(), r = (s < t ? 7 : 0) + s - t;
  return a.setUTCDate(a.getUTCDate() - r), a.setUTCHours(0, 0, 0, 0), a;
}
function Y1(e) {
  le(1, arguments);
  var t = pe(e), a = t.getUTCFullYear(), s = /* @__PURE__ */ new Date(0);
  s.setUTCFullYear(a + 1, 0, 4), s.setUTCHours(0, 0, 0, 0);
  var r = nr(s), l = /* @__PURE__ */ new Date(0);
  l.setUTCFullYear(a, 0, 4), l.setUTCHours(0, 0, 0, 0);
  var n = nr(l);
  return t.getTime() >= r.getTime() ? a + 1 : t.getTime() >= n.getTime() ? a : a - 1;
}
function zl(e) {
  le(1, arguments);
  var t = Y1(e), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var s = nr(a);
  return s;
}
var ql = 6048e5;
function N1(e) {
  le(1, arguments);
  var t = pe(e), a = nr(t).getTime() - zl(t).getTime();
  return Math.round(a / ql) + 1;
}
function jt(e, t) {
  var a, s, r, l, n, i, u, p;
  le(1, arguments);
  var h = Dt(), d = fe((a = (s = (r = (l = t == null ? void 0 : t.weekStartsOn) !== null && l !== void 0 ? l : t == null || (n = t.locale) === null || n === void 0 || (i = n.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && r !== void 0 ? r : h.weekStartsOn) !== null && s !== void 0 ? s : (u = h.locale) === null || u === void 0 || (p = u.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var y = pe(e), L = y.getUTCDay(), V = (L < d ? 7 : 0) + L - d;
  return y.setUTCDate(y.getUTCDate() - V), y.setUTCHours(0, 0, 0, 0), y;
}
function _a(e, t) {
  var a, s, r, l, n, i, u, p;
  le(1, arguments);
  var h = pe(e), d = h.getUTCFullYear(), y = Dt(), L = fe((a = (s = (r = (l = t == null ? void 0 : t.firstWeekContainsDate) !== null && l !== void 0 ? l : t == null || (n = t.locale) === null || n === void 0 || (i = n.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && r !== void 0 ? r : y.firstWeekContainsDate) !== null && s !== void 0 ? s : (u = y.locale) === null || u === void 0 || (p = u.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(L >= 1 && L <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var V = /* @__PURE__ */ new Date(0);
  V.setUTCFullYear(d + 1, 0, L), V.setUTCHours(0, 0, 0, 0);
  var Z = jt(V, t), z = /* @__PURE__ */ new Date(0);
  z.setUTCFullYear(d, 0, L), z.setUTCHours(0, 0, 0, 0);
  var $ = jt(z, t);
  return h.getTime() >= Z.getTime() ? d + 1 : h.getTime() >= $.getTime() ? d : d - 1;
}
function Ul(e, t) {
  var a, s, r, l, n, i, u, p;
  le(1, arguments);
  var h = Dt(), d = fe((a = (s = (r = (l = t == null ? void 0 : t.firstWeekContainsDate) !== null && l !== void 0 ? l : t == null || (n = t.locale) === null || n === void 0 || (i = n.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && r !== void 0 ? r : h.firstWeekContainsDate) !== null && s !== void 0 ? s : (u = h.locale) === null || u === void 0 || (p = u.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && a !== void 0 ? a : 1), y = _a(e, t), L = /* @__PURE__ */ new Date(0);
  L.setUTCFullYear(y, 0, d), L.setUTCHours(0, 0, 0, 0);
  var V = jt(L, t);
  return V;
}
var Kl = 6048e5;
function F1(e, t) {
  le(1, arguments);
  var a = pe(e), s = jt(a, t).getTime() - Ul(a, t).getTime();
  return Math.round(s / Kl) + 1;
}
function Re(e, t) {
  for (var a = e < 0 ? "-" : "", s = Math.abs(e).toString(); s.length < t; )
    s = "0" + s;
  return a + s;
}
var Pt = {
  // Year
  y: function(t, a) {
    var s = t.getUTCFullYear(), r = s > 0 ? s : 1 - s;
    return Re(a === "yy" ? r % 100 : r, a.length);
  },
  // Month
  M: function(t, a) {
    var s = t.getUTCMonth();
    return a === "M" ? String(s + 1) : Re(s + 1, 2);
  },
  // Day of the month
  d: function(t, a) {
    return Re(t.getUTCDate(), a.length);
  },
  // AM or PM
  a: function(t, a) {
    var s = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return s.toUpperCase();
      case "aaa":
        return s;
      case "aaaaa":
        return s[0];
      case "aaaa":
      default:
        return s === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, a) {
    return Re(t.getUTCHours() % 12 || 12, a.length);
  },
  // Hour [0-23]
  H: function(t, a) {
    return Re(t.getUTCHours(), a.length);
  },
  // Minute
  m: function(t, a) {
    return Re(t.getUTCMinutes(), a.length);
  },
  // Second
  s: function(t, a) {
    return Re(t.getUTCSeconds(), a.length);
  },
  // Fraction of second
  S: function(t, a) {
    var s = a.length, r = t.getUTCMilliseconds(), l = Math.floor(r * Math.pow(10, s - 3));
    return Re(l, a.length);
  }
}, tr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Wl = {
  // Era
  G: function(t, a, s) {
    var r = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return s.era(r, {
          width: "abbreviated"
        });
      case "GGGGG":
        return s.era(r, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return s.era(r, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, a, s) {
    if (a === "yo") {
      var r = t.getUTCFullYear(), l = r > 0 ? r : 1 - r;
      return s.ordinalNumber(l, {
        unit: "year"
      });
    }
    return Pt.y(t, a);
  },
  // Local week-numbering year
  Y: function(t, a, s, r) {
    var l = _a(t, r), n = l > 0 ? l : 1 - l;
    if (a === "YY") {
      var i = n % 100;
      return Re(i, 2);
    }
    return a === "Yo" ? s.ordinalNumber(n, {
      unit: "year"
    }) : Re(n, a.length);
  },
  // ISO week-numbering year
  R: function(t, a) {
    var s = Y1(t);
    return Re(s, a.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, a) {
    var s = t.getUTCFullYear();
    return Re(s, a.length);
  },
  // Quarter
  Q: function(t, a, s) {
    var r = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (a) {
      case "Q":
        return String(r);
      case "QQ":
        return Re(r, 2);
      case "Qo":
        return s.ordinalNumber(r, {
          unit: "quarter"
        });
      case "QQQ":
        return s.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return s.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return s.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, a, s) {
    var r = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (a) {
      case "q":
        return String(r);
      case "qq":
        return Re(r, 2);
      case "qo":
        return s.ordinalNumber(r, {
          unit: "quarter"
        });
      case "qqq":
        return s.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return s.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return s.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, a, s) {
    var r = t.getUTCMonth();
    switch (a) {
      case "M":
      case "MM":
        return Pt.M(t, a);
      case "Mo":
        return s.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "MMM":
        return s.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return s.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return s.month(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, a, s) {
    var r = t.getUTCMonth();
    switch (a) {
      case "L":
        return String(r + 1);
      case "LL":
        return Re(r + 1, 2);
      case "Lo":
        return s.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "LLL":
        return s.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return s.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return s.month(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, a, s, r) {
    var l = F1(t, r);
    return a === "wo" ? s.ordinalNumber(l, {
      unit: "week"
    }) : Re(l, a.length);
  },
  // ISO week of year
  I: function(t, a, s) {
    var r = N1(t);
    return a === "Io" ? s.ordinalNumber(r, {
      unit: "week"
    }) : Re(r, a.length);
  },
  // Day of the month
  d: function(t, a, s) {
    return a === "do" ? s.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Pt.d(t, a);
  },
  // Day of year
  D: function(t, a, s) {
    var r = El(t);
    return a === "Do" ? s.ordinalNumber(r, {
      unit: "dayOfYear"
    }) : Re(r, a.length);
  },
  // Day of week
  E: function(t, a, s) {
    var r = t.getUTCDay();
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return s.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return s.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return s.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return s.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, a, s, r) {
    var l = t.getUTCDay(), n = (l - r.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "e":
        return String(n);
      case "ee":
        return Re(n, 2);
      case "eo":
        return s.ordinalNumber(n, {
          unit: "day"
        });
      case "eee":
        return s.day(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return s.day(l, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return s.day(l, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return s.day(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, a, s, r) {
    var l = t.getUTCDay(), n = (l - r.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "c":
        return String(n);
      case "cc":
        return Re(n, a.length);
      case "co":
        return s.ordinalNumber(n, {
          unit: "day"
        });
      case "ccc":
        return s.day(l, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return s.day(l, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return s.day(l, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return s.day(l, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, a, s) {
    var r = t.getUTCDay(), l = r === 0 ? 7 : r;
    switch (a) {
      case "i":
        return String(l);
      case "ii":
        return Re(l, a.length);
      case "io":
        return s.ordinalNumber(l, {
          unit: "day"
        });
      case "iii":
        return s.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return s.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return s.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return s.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, a, s) {
    var r = t.getUTCHours(), l = r / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return s.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return s.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return s.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, a, s) {
    var r = t.getUTCHours(), l;
    switch (r === 12 ? l = tr.noon : r === 0 ? l = tr.midnight : l = r / 12 >= 1 ? "pm" : "am", a) {
      case "b":
      case "bb":
        return s.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return s.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return s.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, a, s) {
    var r = t.getUTCHours(), l;
    switch (r >= 17 ? l = tr.evening : r >= 12 ? l = tr.afternoon : r >= 4 ? l = tr.morning : l = tr.night, a) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, a, s) {
    if (a === "ho") {
      var r = t.getUTCHours() % 12;
      return r === 0 && (r = 12), s.ordinalNumber(r, {
        unit: "hour"
      });
    }
    return Pt.h(t, a);
  },
  // Hour [0-23]
  H: function(t, a, s) {
    return a === "Ho" ? s.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Pt.H(t, a);
  },
  // Hour [0-11]
  K: function(t, a, s) {
    var r = t.getUTCHours() % 12;
    return a === "Ko" ? s.ordinalNumber(r, {
      unit: "hour"
    }) : Re(r, a.length);
  },
  // Hour [1-24]
  k: function(t, a, s) {
    var r = t.getUTCHours();
    return r === 0 && (r = 24), a === "ko" ? s.ordinalNumber(r, {
      unit: "hour"
    }) : Re(r, a.length);
  },
  // Minute
  m: function(t, a, s) {
    return a === "mo" ? s.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Pt.m(t, a);
  },
  // Second
  s: function(t, a, s) {
    return a === "so" ? s.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Pt.s(t, a);
  },
  // Fraction of second
  S: function(t, a) {
    return Pt.S(t, a);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, a, s, r) {
    var l = r._originalDate || t, n = l.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (a) {
      case "X":
        return l1(n);
      case "XXXX":
      case "XX":
        return zt(n);
      case "XXXXX":
      case "XXX":
      default:
        return zt(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, a, s, r) {
    var l = r._originalDate || t, n = l.getTimezoneOffset();
    switch (a) {
      case "x":
        return l1(n);
      case "xxxx":
      case "xx":
        return zt(n);
      case "xxxxx":
      case "xxx":
      default:
        return zt(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, a, s, r) {
    var l = r._originalDate || t, n = l.getTimezoneOffset();
    switch (a) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + n1(n, ":");
      case "OOOO":
      default:
        return "GMT" + zt(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, a, s, r) {
    var l = r._originalDate || t, n = l.getTimezoneOffset();
    switch (a) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + n1(n, ":");
      case "zzzz":
      default:
        return "GMT" + zt(n, ":");
    }
  },
  // Seconds timestamp
  t: function(t, a, s, r) {
    var l = r._originalDate || t, n = Math.floor(l.getTime() / 1e3);
    return Re(n, a.length);
  },
  // Milliseconds timestamp
  T: function(t, a, s, r) {
    var l = r._originalDate || t, n = l.getTime();
    return Re(n, a.length);
  }
};
function n1(e, t) {
  var a = e > 0 ? "-" : "+", s = Math.abs(e), r = Math.floor(s / 60), l = s % 60;
  if (l === 0)
    return a + String(r);
  var n = t;
  return a + String(r) + n + Re(l, 2);
}
function l1(e, t) {
  if (e % 60 === 0) {
    var a = e > 0 ? "-" : "+";
    return a + Re(Math.abs(e) / 60, 2);
  }
  return zt(e, t);
}
function zt(e, t) {
  var a = t || "", s = e > 0 ? "-" : "+", r = Math.abs(e), l = Re(Math.floor(r / 60), 2), n = Re(r % 60, 2);
  return s + l + a + n;
}
var i1 = function(t, a) {
  switch (t) {
    case "P":
      return a.date({
        width: "short"
      });
    case "PP":
      return a.date({
        width: "medium"
      });
    case "PPP":
      return a.date({
        width: "long"
      });
    case "PPPP":
    default:
      return a.date({
        width: "full"
      });
  }
}, E1 = function(t, a) {
  switch (t) {
    case "p":
      return a.time({
        width: "short"
      });
    case "pp":
      return a.time({
        width: "medium"
      });
    case "ppp":
      return a.time({
        width: "long"
      });
    case "pppp":
    default:
      return a.time({
        width: "full"
      });
  }
}, jl = function(t, a) {
  var s = t.match(/(P+)(p+)?/) || [], r = s[1], l = s[2];
  if (!l)
    return i1(t, a);
  var n;
  switch (r) {
    case "P":
      n = a.dateTime({
        width: "short"
      });
      break;
    case "PP":
      n = a.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      n = a.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      n = a.dateTime({
        width: "full"
      });
      break;
  }
  return n.replace("{{date}}", i1(r, a)).replace("{{time}}", E1(l, a));
}, wa = {
  p: E1,
  P: jl
}, Ql = ["D", "DD"], Xl = ["YY", "YYYY"];
function z1(e) {
  return Ql.indexOf(e) !== -1;
}
function q1(e) {
  return Xl.indexOf(e) !== -1;
}
function Ir(e, t, a) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Gl = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Jl = function(t, a, s) {
  var r, l = Gl[t];
  return typeof l == "string" ? r = l : a === 1 ? r = l.one : r = l.other.replace("{{count}}", a.toString()), s != null && s.addSuffix ? s.comparison && s.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ta(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.width ? String(t.width) : e.defaultWidth, s = e.formats[a] || e.formats[e.defaultWidth];
    return s;
  };
}
var ei = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ti = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ri = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ai = {
  date: ta({
    formats: ei,
    defaultWidth: "full"
  }),
  time: ta({
    formats: ti,
    defaultWidth: "full"
  }),
  dateTime: ta({
    formats: ri,
    defaultWidth: "full"
  })
}, si = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ni = function(t, a, s, r) {
  return si[t];
};
function hr(e) {
  return function(t, a) {
    var s = a != null && a.context ? String(a.context) : "standalone", r;
    if (s === "formatting" && e.formattingValues) {
      var l = e.defaultFormattingWidth || e.defaultWidth, n = a != null && a.width ? String(a.width) : l;
      r = e.formattingValues[n] || e.formattingValues[l];
    } else {
      var i = e.defaultWidth, u = a != null && a.width ? String(a.width) : e.defaultWidth;
      r = e.values[u] || e.values[i];
    }
    var p = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[p];
  };
}
var li = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ii = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, oi = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, ui = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, di = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ci = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, pi = function(t, a) {
  var s = Number(t), r = s % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return s + "st";
      case 2:
        return s + "nd";
      case 3:
        return s + "rd";
    }
  return s + "th";
}, hi = {
  ordinalNumber: pi,
  era: hr({
    values: li,
    defaultWidth: "wide"
  }),
  quarter: hr({
    values: ii,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: hr({
    values: oi,
    defaultWidth: "wide"
  }),
  day: hr({
    values: ui,
    defaultWidth: "wide"
  }),
  dayPeriod: hr({
    values: di,
    defaultWidth: "wide",
    formattingValues: ci,
    defaultFormattingWidth: "wide"
  })
};
function mr(e) {
  return function(t) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = a.width, r = s && e.matchPatterns[s] || e.matchPatterns[e.defaultMatchWidth], l = t.match(r);
    if (!l)
      return null;
    var n = l[0], i = s && e.parsePatterns[s] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(i) ? vi(i, function(d) {
      return d.test(n);
    }) : mi(i, function(d) {
      return d.test(n);
    }), p;
    p = e.valueCallback ? e.valueCallback(u) : u, p = a.valueCallback ? a.valueCallback(p) : p;
    var h = t.slice(n.length);
    return {
      value: p,
      rest: h
    };
  };
}
function mi(e, t) {
  for (var a in e)
    if (e.hasOwnProperty(a) && t(e[a]))
      return a;
}
function vi(e, t) {
  for (var a = 0; a < e.length; a++)
    if (t(e[a]))
      return a;
}
function fi(e) {
  return function(t) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = t.match(e.matchPattern);
    if (!s) return null;
    var r = s[0], l = t.match(e.parsePattern);
    if (!l) return null;
    var n = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    n = a.valueCallback ? a.valueCallback(n) : n;
    var i = t.slice(r.length);
    return {
      value: n,
      rest: i
    };
  };
}
var wi = /^(\d+)(th|st|nd|rd)?/i, gi = /\d+/i, yi = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, ki = {
  any: [/^b/i, /^(a|c)/i]
}, Ci = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, bi = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Li = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Mi = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Vi = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, xi = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Di = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Hi = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Ti = {
  ordinalNumber: fi({
    matchPattern: wi,
    parsePattern: gi,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: mr({
    matchPatterns: yi,
    defaultMatchWidth: "wide",
    parsePatterns: ki,
    defaultParseWidth: "any"
  }),
  quarter: mr({
    matchPatterns: Ci,
    defaultMatchWidth: "wide",
    parsePatterns: bi,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: mr({
    matchPatterns: Li,
    defaultMatchWidth: "wide",
    parsePatterns: Mi,
    defaultParseWidth: "any"
  }),
  day: mr({
    matchPatterns: Vi,
    defaultMatchWidth: "wide",
    parsePatterns: xi,
    defaultParseWidth: "any"
  }),
  dayPeriod: mr({
    matchPatterns: Di,
    defaultMatchWidth: "any",
    parsePatterns: Hi,
    defaultParseWidth: "any"
  })
}, U1 = {
  code: "en-US",
  formatDistance: Jl,
  formatLong: ai,
  formatRelative: ni,
  localize: hi,
  match: Ti,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, $i = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Si = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, _i = /^'([^]*?)'?$/, Oi = /''/g, Pi = /[a-zA-Z]/;
function Rt(e, t, a) {
  var s, r, l, n, i, u, p, h, d, y, L, V, Z, z, $, x, U, M;
  le(2, arguments);
  var R = String(t), E = Dt(), I = (s = (r = a == null ? void 0 : a.locale) !== null && r !== void 0 ? r : E.locale) !== null && s !== void 0 ? s : U1, ie = fe((l = (n = (i = (u = a == null ? void 0 : a.firstWeekContainsDate) !== null && u !== void 0 ? u : a == null || (p = a.locale) === null || p === void 0 || (h = p.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && i !== void 0 ? i : E.firstWeekContainsDate) !== null && n !== void 0 ? n : (d = E.locale) === null || d === void 0 || (y = d.options) === null || y === void 0 ? void 0 : y.firstWeekContainsDate) !== null && l !== void 0 ? l : 1);
  if (!(ie >= 1 && ie <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var K = fe((L = (V = (Z = (z = a == null ? void 0 : a.weekStartsOn) !== null && z !== void 0 ? z : a == null || ($ = a.locale) === null || $ === void 0 || (x = $.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && Z !== void 0 ? Z : E.weekStartsOn) !== null && V !== void 0 ? V : (U = E.locale) === null || U === void 0 || (M = U.options) === null || M === void 0 ? void 0 : M.weekStartsOn) !== null && L !== void 0 ? L : 0);
  if (!(K >= 0 && K <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!I.localize)
    throw new RangeError("locale must contain localize property");
  if (!I.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var w = pe(e);
  if (!wr(w))
    throw new RangeError("Invalid time value");
  var D = Rr(w), N = I1(w, D), G = {
    firstWeekContainsDate: ie,
    weekStartsOn: K,
    locale: I,
    _originalDate: w
  }, P = R.match(Si).map(function(f) {
    var _ = f[0];
    if (_ === "p" || _ === "P") {
      var H = wa[_];
      return H(f, I.formatLong);
    }
    return f;
  }).join("").match($i).map(function(f) {
    if (f === "''")
      return "'";
    var _ = f[0];
    if (_ === "'")
      return Bi(f);
    var H = Wl[_];
    if (H)
      return !(a != null && a.useAdditionalWeekYearTokens) && q1(f) && Ir(f, t, String(e)), !(a != null && a.useAdditionalDayOfYearTokens) && z1(f) && Ir(f, t, String(e)), H(N, f, I.localize, G);
    if (_.match(Pi))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + _ + "`");
    return f;
  }).join("");
  return P;
}
function Bi(e) {
  var t = e.match(_i);
  return t ? t[1].replace(Oi, "'") : e;
}
function Zi(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var a in t)
    Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
  return e;
}
function Ai(e) {
  le(1, arguments);
  var t = pe(e), a = t.getDay();
  return a;
}
function Ri(e) {
  le(1, arguments);
  var t = pe(e), a = t.getFullYear(), s = t.getMonth(), r = /* @__PURE__ */ new Date(0);
  return r.setFullYear(a, s + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function gt(e) {
  le(1, arguments);
  var t = pe(e), a = t.getHours();
  return a;
}
var Ii = 6048e5;
function Yi(e) {
  le(1, arguments);
  var t = pe(e), a = Ar(t).getTime() - Ol(t).getTime();
  return Math.round(a / Ii) + 1;
}
function xt(e) {
  le(1, arguments);
  var t = pe(e), a = t.getMinutes();
  return a;
}
function Se(e) {
  le(1, arguments);
  var t = pe(e), a = t.getMonth();
  return a;
}
function lr(e) {
  le(1, arguments);
  var t = pe(e), a = t.getSeconds();
  return a;
}
function Ni(e, t) {
  var a, s, r, l, n, i, u, p;
  le(1, arguments);
  var h = pe(e), d = h.getFullYear(), y = Dt(), L = fe((a = (s = (r = (l = t == null ? void 0 : t.firstWeekContainsDate) !== null && l !== void 0 ? l : t == null || (n = t.locale) === null || n === void 0 || (i = n.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && r !== void 0 ? r : y.firstWeekContainsDate) !== null && s !== void 0 ? s : (u = y.locale) === null || u === void 0 || (p = u.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(L >= 1 && L <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var V = /* @__PURE__ */ new Date(0);
  V.setFullYear(d + 1, 0, L), V.setHours(0, 0, 0, 0);
  var Z = Wt(V, t), z = /* @__PURE__ */ new Date(0);
  z.setFullYear(d, 0, L), z.setHours(0, 0, 0, 0);
  var $ = Wt(z, t);
  return h.getTime() >= Z.getTime() ? d + 1 : h.getTime() >= $.getTime() ? d : d - 1;
}
function Fi(e, t) {
  var a, s, r, l, n, i, u, p;
  le(1, arguments);
  var h = Dt(), d = fe((a = (s = (r = (l = t == null ? void 0 : t.firstWeekContainsDate) !== null && l !== void 0 ? l : t == null || (n = t.locale) === null || n === void 0 || (i = n.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && r !== void 0 ? r : h.firstWeekContainsDate) !== null && s !== void 0 ? s : (u = h.locale) === null || u === void 0 || (p = u.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && a !== void 0 ? a : 1), y = Ni(e, t), L = /* @__PURE__ */ new Date(0);
  L.setFullYear(y, 0, d), L.setHours(0, 0, 0, 0);
  var V = Wt(L, t);
  return V;
}
var Ei = 6048e5;
function zi(e, t) {
  le(1, arguments);
  var a = pe(e), s = Wt(a, t).getTime() - Fi(a, t).getTime();
  return Math.round(s / Ei) + 1;
}
function Ve(e) {
  return le(1, arguments), pe(e).getFullYear();
}
function kr(e, t) {
  le(2, arguments);
  var a = pe(e), s = pe(t);
  return a.getTime() > s.getTime();
}
function Cr(e, t) {
  le(2, arguments);
  var a = pe(e), s = pe(t);
  return a.getTime() < s.getTime();
}
function sr(e, t) {
  le(2, arguments);
  var a = pe(e), s = pe(t);
  return a.getTime() === s.getTime();
}
function o1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var a = 0, s = Array(t); a < t; a++) s[a] = e[a];
  return s;
}
function qi(e, t) {
  if (e) {
    if (typeof e == "string") return o1(e, t);
    var a = {}.toString.call(e).slice(8, -1);
    return a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set" ? Array.from(e) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? o1(e, t) : void 0;
  }
}
function u1(e, t) {
  var a = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!a) {
    if (Array.isArray(e) || (a = qi(e)) || t) {
      a && (e = a);
      var s = 0, r = function() {
      };
      return {
        s: r,
        n: function() {
          return s >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[s++]
          };
        },
        e: function(p) {
          throw p;
        },
        f: r
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var l, n = !0, i = !1;
  return {
    s: function() {
      a = a.call(e);
    },
    n: function() {
      var p = a.next();
      return n = p.done, p;
    },
    e: function(p) {
      i = !0, l = p;
    },
    f: function() {
      try {
        n || a.return == null || a.return();
      } finally {
        if (i) throw l;
      }
    }
  };
}
function ne(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ga(e, t) {
  return ga = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, s) {
    return a.__proto__ = s, a;
  }, ga(e, t);
}
function _e(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && ga(e, t);
}
function Yr(e) {
  return Yr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Yr(e);
}
function K1() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (K1 = function() {
    return !!e;
  })();
}
function Ui(e, t) {
  if (t && (mt(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return ne(e);
}
function Oe(e) {
  var t = K1();
  return function() {
    var a, s = Yr(e);
    if (t) {
      var r = Yr(this).constructor;
      a = Reflect.construct(s, arguments, r);
    } else a = s.apply(this, arguments);
    return Ui(this, a);
  };
}
function Te(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Ki(e, t) {
  if (mt(e) != "object" || !e) return e;
  var a = e[Symbol.toPrimitive];
  if (a !== void 0) {
    var s = a.call(e, t);
    if (mt(s) != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function W1(e) {
  var t = Ki(e, "string");
  return mt(t) == "symbol" ? t : t + "";
}
function Wi(e, t) {
  for (var a = 0; a < t.length; a++) {
    var s = t[a];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, W1(s.key), s);
  }
}
function $e(e, t, a) {
  return t && Wi(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function se(e, t, a) {
  return (t = W1(t)) in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}
var ji = 10, j1 = /* @__PURE__ */ function() {
  function e() {
    Te(this, e), se(this, "priority", void 0), se(this, "subPriority", 0);
  }
  return $e(e, [{
    key: "validate",
    value: function(a, s) {
      return !0;
    }
  }]), e;
}(), Qi = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a(s, r, l, n, i) {
    var u;
    return Te(this, a), u = t.call(this), u.value = s, u.validateValue = r, u.setValue = l, u.priority = n, i && (u.subPriority = i), u;
  }
  return $e(a, [{
    key: "validate",
    value: function(r, l) {
      return this.validateValue(r, this.value, l);
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return this.setValue(r, l, this.value, n);
    }
  }]), a;
}(j1), Xi = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", ji), se(ne(s), "subPriority", -1), s;
  }
  return $e(a, [{
    key: "set",
    value: function(r, l) {
      if (l.timestampIsSet)
        return r;
      var n = /* @__PURE__ */ new Date(0);
      return n.setFullYear(r.getUTCFullYear(), r.getUTCMonth(), r.getUTCDate()), n.setHours(r.getUTCHours(), r.getUTCMinutes(), r.getUTCSeconds(), r.getUTCMilliseconds()), n;
    }
  }]), a;
}(j1), Ze = /* @__PURE__ */ function() {
  function e() {
    Te(this, e), se(this, "incompatibleTokens", void 0), se(this, "priority", void 0), se(this, "subPriority", void 0);
  }
  return $e(e, [{
    key: "run",
    value: function(a, s, r, l) {
      var n = this.parse(a, s, r, l);
      return n ? {
        setter: new Qi(n.value, this.validate, this.set, this.priority, this.subPriority),
        rest: n.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(a, s, r) {
      return !0;
    }
  }]), e;
}(), Gi = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 140), se(ne(s), "incompatibleTokens", ["R", "u", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "G":
        case "GG":
        case "GGG":
          return n.era(r, {
            width: "abbreviated"
          }) || n.era(r, {
            width: "narrow"
          });
        case "GGGGG":
          return n.era(r, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return n.era(r, {
            width: "wide"
          }) || n.era(r, {
            width: "abbreviated"
          }) || n.era(r, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return l.era = n, r.setUTCFullYear(n, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze), We = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Lt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function je(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function qe(e, t) {
  var a = t.match(e);
  return a ? {
    value: parseInt(a[0], 10),
    rest: t.slice(a[0].length)
  } : null;
}
function Mt(e, t) {
  var a = t.match(e);
  if (!a)
    return null;
  if (a[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var s = a[1] === "+" ? 1 : -1, r = a[2] ? parseInt(a[2], 10) : 0, l = a[3] ? parseInt(a[3], 10) : 0, n = a[5] ? parseInt(a[5], 10) : 0;
  return {
    value: s * (r * Sa + l * $a + n * Al),
    rest: t.slice(a[0].length)
  };
}
function Q1(e) {
  return qe(We.anyDigitsSigned, e);
}
function Ke(e, t) {
  switch (e) {
    case 1:
      return qe(We.singleDigit, t);
    case 2:
      return qe(We.twoDigits, t);
    case 3:
      return qe(We.threeDigits, t);
    case 4:
      return qe(We.fourDigits, t);
    default:
      return qe(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Nr(e, t) {
  switch (e) {
    case 1:
      return qe(We.singleDigitSigned, t);
    case 2:
      return qe(We.twoDigitsSigned, t);
    case 3:
      return qe(We.threeDigitsSigned, t);
    case 4:
      return qe(We.fourDigitsSigned, t);
    default:
      return qe(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Oa(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function X1(e, t) {
  var a = t > 0, s = a ? t : 1 - t, r;
  if (s <= 50)
    r = e || 100;
  else {
    var l = s + 50, n = Math.floor(l / 100) * 100, i = e >= l % 100;
    r = e + n - (i ? 100 : 0);
  }
  return a ? r : 1 - r;
}
function G1(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var Ji = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 130), se(ne(s), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      var i = function(p) {
        return {
          year: p,
          isTwoDigitYear: l === "yy"
        };
      };
      switch (l) {
        case "y":
          return je(Ke(4, r), i);
        case "yo":
          return je(n.ordinalNumber(r, {
            unit: "year"
          }), i);
        default:
          return je(Ke(l.length, r), i);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l.isTwoDigitYear || l.year > 0;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      var i = r.getUTCFullYear();
      if (n.isTwoDigitYear) {
        var u = X1(n.year, i);
        return r.setUTCFullYear(u, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
      }
      var p = !("era" in l) || l.era === 1 ? n.year : 1 - n.year;
      return r.setUTCFullYear(p, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze), eo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 130), se(ne(s), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      var i = function(p) {
        return {
          year: p,
          isTwoDigitYear: l === "YY"
        };
      };
      switch (l) {
        case "Y":
          return je(Ke(4, r), i);
        case "Yo":
          return je(n.ordinalNumber(r, {
            unit: "year"
          }), i);
        default:
          return je(Ke(l.length, r), i);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l.isTwoDigitYear || l.year > 0;
    }
  }, {
    key: "set",
    value: function(r, l, n, i) {
      var u = _a(r, i);
      if (n.isTwoDigitYear) {
        var p = X1(n.year, u);
        return r.setUTCFullYear(p, 0, i.firstWeekContainsDate), r.setUTCHours(0, 0, 0, 0), jt(r, i);
      }
      var h = !("era" in l) || l.era === 1 ? n.year : 1 - n.year;
      return r.setUTCFullYear(h, 0, i.firstWeekContainsDate), r.setUTCHours(0, 0, 0, 0), jt(r, i);
    }
  }]), a;
}(Ze), to = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 130), se(ne(s), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l) {
      return Nr(l === "R" ? 4 : l.length, r);
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      var i = /* @__PURE__ */ new Date(0);
      return i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0), nr(i);
    }
  }]), a;
}(Ze), ro = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 130), se(ne(s), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l) {
      return Nr(l === "u" ? 4 : l.length, r);
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCFullYear(n, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze), ao = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 120), se(ne(s), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "Q":
        case "QQ":
          return Ke(l.length, r);
        case "Qo":
          return n.ordinalNumber(r, {
            unit: "quarter"
          });
        case "QQQ":
          return n.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return n.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return n.quarter(r, {
            width: "wide",
            context: "formatting"
          }) || n.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 1 && l <= 4;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCMonth((n - 1) * 3, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze), so = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 120), se(ne(s), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "q":
        case "qq":
          return Ke(l.length, r);
        case "qo":
          return n.ordinalNumber(r, {
            unit: "quarter"
          });
        case "qqq":
          return n.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || n.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return n.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return n.quarter(r, {
            width: "wide",
            context: "standalone"
          }) || n.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || n.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 1 && l <= 4;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCMonth((n - 1) * 3, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze), no = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), se(ne(s), "priority", 110), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      var i = function(p) {
        return p - 1;
      };
      switch (l) {
        case "M":
          return je(qe(We.month, r), i);
        case "MM":
          return je(Ke(2, r), i);
        case "Mo":
          return je(n.ordinalNumber(r, {
            unit: "month"
          }), i);
        case "MMM":
          return n.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return n.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return n.month(r, {
            width: "wide",
            context: "formatting"
          }) || n.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.month(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 0 && l <= 11;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCMonth(n, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze), lo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 110), se(ne(s), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      var i = function(p) {
        return p - 1;
      };
      switch (l) {
        case "L":
          return je(qe(We.month, r), i);
        case "LL":
          return je(Ke(2, r), i);
        case "Lo":
          return je(n.ordinalNumber(r, {
            unit: "month"
          }), i);
        case "LLL":
          return n.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || n.month(r, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return n.month(r, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return n.month(r, {
            width: "wide",
            context: "standalone"
          }) || n.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || n.month(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 0 && l <= 11;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCMonth(n, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze);
function io(e, t, a) {
  le(2, arguments);
  var s = pe(e), r = fe(t), l = F1(s, a) - r;
  return s.setUTCDate(s.getUTCDate() - l * 7), s;
}
var oo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 100), se(ne(s), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "w":
          return qe(We.week, r);
        case "wo":
          return n.ordinalNumber(r, {
            unit: "week"
          });
        default:
          return Ke(l.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 1 && l <= 53;
    }
  }, {
    key: "set",
    value: function(r, l, n, i) {
      return jt(io(r, n, i), i);
    }
  }]), a;
}(Ze);
function uo(e, t) {
  le(2, arguments);
  var a = pe(e), s = fe(t), r = N1(a) - s;
  return a.setUTCDate(a.getUTCDate() - r * 7), a;
}
var co = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 100), se(ne(s), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "I":
          return qe(We.week, r);
        case "Io":
          return n.ordinalNumber(r, {
            unit: "week"
          });
        default:
          return Ke(l.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 1 && l <= 53;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return nr(uo(r, n));
    }
  }]), a;
}(Ze), po = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ho = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], mo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 90), se(ne(s), "subPriority", 1), se(ne(s), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "d":
          return qe(We.date, r);
        case "do":
          return n.ordinalNumber(r, {
            unit: "date"
          });
        default:
          return Ke(l.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      var n = r.getUTCFullYear(), i = G1(n), u = r.getUTCMonth();
      return i ? l >= 1 && l <= ho[u] : l >= 1 && l <= po[u];
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCDate(n), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze), vo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 90), se(ne(s), "subpriority", 1), se(ne(s), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "D":
        case "DD":
          return qe(We.dayOfYear, r);
        case "Do":
          return n.ordinalNumber(r, {
            unit: "date"
          });
        default:
          return Ke(l.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      var n = r.getUTCFullYear(), i = G1(n);
      return i ? l >= 1 && l <= 366 : l >= 1 && l <= 365;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCMonth(0, n), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze);
function Pa(e, t, a) {
  var s, r, l, n, i, u, p, h;
  le(2, arguments);
  var d = Dt(), y = fe((s = (r = (l = (n = a == null ? void 0 : a.weekStartsOn) !== null && n !== void 0 ? n : a == null || (i = a.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && l !== void 0 ? l : d.weekStartsOn) !== null && r !== void 0 ? r : (p = d.locale) === null || p === void 0 || (h = p.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && s !== void 0 ? s : 0);
  if (!(y >= 0 && y <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var L = pe(e), V = fe(t), Z = L.getUTCDay(), z = V % 7, $ = (z + 7) % 7, x = ($ < y ? 7 : 0) + V - Z;
  return L.setUTCDate(L.getUTCDate() + x), L;
}
var fo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 90), se(ne(s), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "E":
        case "EE":
        case "EEE":
          return n.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(r, {
            width: "short",
            context: "formatting"
          }) || n.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return n.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return n.day(r, {
            width: "short",
            context: "formatting"
          }) || n.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return n.day(r, {
            width: "wide",
            context: "formatting"
          }) || n.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(r, {
            width: "short",
            context: "formatting"
          }) || n.day(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 0 && l <= 6;
    }
  }, {
    key: "set",
    value: function(r, l, n, i) {
      return r = Pa(r, n, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze), wo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 90), se(ne(s), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n, i) {
      var u = function(h) {
        var d = Math.floor((h - 1) / 7) * 7;
        return (h + i.weekStartsOn + 6) % 7 + d;
      };
      switch (l) {
        case "e":
        case "ee":
          return je(Ke(l.length, r), u);
        case "eo":
          return je(n.ordinalNumber(r, {
            unit: "day"
          }), u);
        case "eee":
          return n.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(r, {
            width: "short",
            context: "formatting"
          }) || n.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return n.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return n.day(r, {
            width: "short",
            context: "formatting"
          }) || n.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return n.day(r, {
            width: "wide",
            context: "formatting"
          }) || n.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(r, {
            width: "short",
            context: "formatting"
          }) || n.day(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 0 && l <= 6;
    }
  }, {
    key: "set",
    value: function(r, l, n, i) {
      return r = Pa(r, n, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze), go = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 90), se(ne(s), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n, i) {
      var u = function(h) {
        var d = Math.floor((h - 1) / 7) * 7;
        return (h + i.weekStartsOn + 6) % 7 + d;
      };
      switch (l) {
        case "c":
        case "cc":
          return je(Ke(l.length, r), u);
        case "co":
          return je(n.ordinalNumber(r, {
            unit: "day"
          }), u);
        case "ccc":
          return n.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || n.day(r, {
            width: "short",
            context: "standalone"
          }) || n.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return n.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return n.day(r, {
            width: "short",
            context: "standalone"
          }) || n.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return n.day(r, {
            width: "wide",
            context: "standalone"
          }) || n.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || n.day(r, {
            width: "short",
            context: "standalone"
          }) || n.day(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 0 && l <= 6;
    }
  }, {
    key: "set",
    value: function(r, l, n, i) {
      return r = Pa(r, n, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze);
function yo(e, t) {
  le(2, arguments);
  var a = fe(t);
  a % 7 === 0 && (a = a - 7);
  var s = 1, r = pe(e), l = r.getUTCDay(), n = a % 7, i = (n + 7) % 7, u = (i < s ? 7 : 0) + a - l;
  return r.setUTCDate(r.getUTCDate() + u), r;
}
var ko = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 90), se(ne(s), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      var i = function(p) {
        return p === 0 ? 7 : p;
      };
      switch (l) {
        case "i":
        case "ii":
          return Ke(l.length, r);
        case "io":
          return n.ordinalNumber(r, {
            unit: "day"
          });
        case "iii":
          return je(n.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(r, {
            width: "short",
            context: "formatting"
          }) || n.day(r, {
            width: "narrow",
            context: "formatting"
          }), i);
        case "iiiii":
          return je(n.day(r, {
            width: "narrow",
            context: "formatting"
          }), i);
        case "iiiiii":
          return je(n.day(r, {
            width: "short",
            context: "formatting"
          }) || n.day(r, {
            width: "narrow",
            context: "formatting"
          }), i);
        case "iiii":
        default:
          return je(n.day(r, {
            width: "wide",
            context: "formatting"
          }) || n.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(r, {
            width: "short",
            context: "formatting"
          }) || n.day(r, {
            width: "narrow",
            context: "formatting"
          }), i);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 1 && l <= 7;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r = yo(r, n), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(Ze), Co = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 80), se(ne(s), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "a":
        case "aa":
        case "aaa":
          return n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return n.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCHours(Oa(n), 0, 0, 0), r;
    }
  }]), a;
}(Ze), bo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 80), se(ne(s), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "b":
        case "bb":
        case "bbb":
          return n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return n.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCHours(Oa(n), 0, 0, 0), r;
    }
  }]), a;
}(Ze), Lo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 80), se(ne(s), "incompatibleTokens", ["a", "b", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "B":
        case "BB":
        case "BBB":
          return n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return n.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCHours(Oa(n), 0, 0, 0), r;
    }
  }]), a;
}(Ze), Mo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 70), se(ne(s), "incompatibleTokens", ["H", "K", "k", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "h":
          return qe(We.hour12h, r);
        case "ho":
          return n.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return Ke(l.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 1 && l <= 12;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      var i = r.getUTCHours() >= 12;
      return i && n < 12 ? r.setUTCHours(n + 12, 0, 0, 0) : !i && n === 12 ? r.setUTCHours(0, 0, 0, 0) : r.setUTCHours(n, 0, 0, 0), r;
    }
  }]), a;
}(Ze), Vo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 70), se(ne(s), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "H":
          return qe(We.hour23h, r);
        case "Ho":
          return n.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return Ke(l.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 0 && l <= 23;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCHours(n, 0, 0, 0), r;
    }
  }]), a;
}(Ze), xo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 70), se(ne(s), "incompatibleTokens", ["h", "H", "k", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "K":
          return qe(We.hour11h, r);
        case "Ko":
          return n.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return Ke(l.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 0 && l <= 11;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      var i = r.getUTCHours() >= 12;
      return i && n < 12 ? r.setUTCHours(n + 12, 0, 0, 0) : r.setUTCHours(n, 0, 0, 0), r;
    }
  }]), a;
}(Ze), Do = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 70), se(ne(s), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "k":
          return qe(We.hour24h, r);
        case "ko":
          return n.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return Ke(l.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 1 && l <= 24;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      var i = n <= 24 ? n % 24 : n;
      return r.setUTCHours(i, 0, 0, 0), r;
    }
  }]), a;
}(Ze), Ho = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 60), se(ne(s), "incompatibleTokens", ["t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "m":
          return qe(We.minute, r);
        case "mo":
          return n.ordinalNumber(r, {
            unit: "minute"
          });
        default:
          return Ke(l.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 0 && l <= 59;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCMinutes(n, 0, 0), r;
    }
  }]), a;
}(Ze), To = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 50), se(ne(s), "incompatibleTokens", ["t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l, n) {
      switch (l) {
        case "s":
          return qe(We.second, r);
        case "so":
          return n.ordinalNumber(r, {
            unit: "second"
          });
        default:
          return Ke(l.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, l) {
      return l >= 0 && l <= 59;
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCSeconds(n, 0), r;
    }
  }]), a;
}(Ze), $o = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 30), se(ne(s), "incompatibleTokens", ["t", "T"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l) {
      var n = function(u) {
        return Math.floor(u * Math.pow(10, -l.length + 3));
      };
      return je(Ke(l.length, r), n);
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return r.setUTCMilliseconds(n), r;
    }
  }]), a;
}(Ze), So = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 10), se(ne(s), "incompatibleTokens", ["t", "T", "x"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l) {
      switch (l) {
        case "X":
          return Mt(Lt.basicOptionalMinutes, r);
        case "XX":
          return Mt(Lt.basic, r);
        case "XXXX":
          return Mt(Lt.basicOptionalSeconds, r);
        case "XXXXX":
          return Mt(Lt.extendedOptionalSeconds, r);
        case "XXX":
        default:
          return Mt(Lt.extended, r);
      }
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return l.timestampIsSet ? r : new Date(r.getTime() - n);
    }
  }]), a;
}(Ze), _o = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 10), se(ne(s), "incompatibleTokens", ["t", "T", "X"]), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r, l) {
      switch (l) {
        case "x":
          return Mt(Lt.basicOptionalMinutes, r);
        case "xx":
          return Mt(Lt.basic, r);
        case "xxxx":
          return Mt(Lt.basicOptionalSeconds, r);
        case "xxxxx":
          return Mt(Lt.extendedOptionalSeconds, r);
        case "xxx":
        default:
          return Mt(Lt.extended, r);
      }
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return l.timestampIsSet ? r : new Date(r.getTime() - n);
    }
  }]), a;
}(Ze), Oo = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 40), se(ne(s), "incompatibleTokens", "*"), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r) {
      return Q1(r);
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return [new Date(n * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), a;
}(Ze), Po = /* @__PURE__ */ function(e) {
  _e(a, e);
  var t = Oe(a);
  function a() {
    var s;
    Te(this, a);
    for (var r = arguments.length, l = new Array(r), n = 0; n < r; n++)
      l[n] = arguments[n];
    return s = t.call.apply(t, [this].concat(l)), se(ne(s), "priority", 20), se(ne(s), "incompatibleTokens", "*"), s;
  }
  return $e(a, [{
    key: "parse",
    value: function(r) {
      return Q1(r);
    }
  }, {
    key: "set",
    value: function(r, l, n) {
      return [new Date(n), {
        timestampIsSet: !0
      }];
    }
  }]), a;
}(Ze), Bo = {
  G: new Gi(),
  y: new Ji(),
  Y: new eo(),
  R: new to(),
  u: new ro(),
  Q: new ao(),
  q: new so(),
  M: new no(),
  L: new lo(),
  w: new oo(),
  I: new co(),
  d: new mo(),
  D: new vo(),
  E: new fo(),
  e: new wo(),
  c: new go(),
  i: new ko(),
  a: new Co(),
  b: new bo(),
  B: new Lo(),
  h: new Mo(),
  H: new Vo(),
  K: new xo(),
  k: new Do(),
  m: new Ho(),
  s: new To(),
  S: new $o(),
  X: new So(),
  x: new _o(),
  t: new Oo(),
  T: new Po()
}, Zo = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ao = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ro = /^'([^]*?)'?$/, Io = /''/g, Yo = /\S/, No = /[a-zA-Z]/;
function ya(e, t, a, s) {
  var r, l, n, i, u, p, h, d, y, L, V, Z, z, $;
  le(3, arguments);
  var x = String(e), U = String(t), M = Dt(), R = (r = (l = void 0) !== null && l !== void 0 ? l : M.locale) !== null && r !== void 0 ? r : U1;
  if (!R.match)
    throw new RangeError("locale must contain match property");
  var E = fe((n = (i = (u = (p = void 0) !== null && p !== void 0 ? p : void 0) !== null && u !== void 0 ? u : M.firstWeekContainsDate) !== null && i !== void 0 ? i : (h = M.locale) === null || h === void 0 || (d = h.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(E >= 1 && E <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var I = fe((y = (L = (V = (Z = void 0) !== null && Z !== void 0 ? Z : void 0) !== null && V !== void 0 ? V : M.weekStartsOn) !== null && L !== void 0 ? L : (z = M.locale) === null || z === void 0 || ($ = z.options) === null || $ === void 0 ? void 0 : $.weekStartsOn) !== null && y !== void 0 ? y : 0);
  if (!(I >= 0 && I <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (U === "")
    return x === "" ? pe(a) : /* @__PURE__ */ new Date(NaN);
  var ie = {
    firstWeekContainsDate: E,
    weekStartsOn: I,
    locale: R
  }, K = [new Xi()], w = U.match(Ao).map(function(q) {
    var b = q[0];
    if (b in wa) {
      var v = wa[b];
      return v(q, R.formatLong);
    }
    return q;
  }).join("").match(Zo), D = [], N = u1(w), G;
  try {
    var P = function() {
      var b = G.value;
      !(s != null && s.useAdditionalWeekYearTokens) && q1(b) && Ir(b, U, e), !(s != null && s.useAdditionalDayOfYearTokens) && z1(b) && Ir(b, U, e);
      var v = b[0], oe = Bo[v];
      if (oe) {
        var ye = oe.incompatibleTokens;
        if (Array.isArray(ye)) {
          var re = D.find(function(de) {
            return ye.includes(de.token) || de.token === v;
          });
          if (re)
            throw new RangeError("The format string mustn't contain `".concat(re.fullToken, "` and `").concat(b, "` at the same time"));
        } else if (oe.incompatibleTokens === "*" && D.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(b, "` and any other token at the same time"));
        D.push({
          token: v,
          fullToken: b
        });
        var Me = oe.run(x, b, R.match, ie);
        if (!Me)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        K.push(Me.setter), x = Me.rest;
      } else {
        if (v.match(No))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + v + "`");
        if (b === "''" ? b = "'" : v === "'" && (b = Fo(b)), x.indexOf(b) === 0)
          x = x.slice(b.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (N.s(); !(G = N.n()).done; ) {
      var f = P();
      if (mt(f) === "object") return f.v;
    }
  } catch (q) {
    N.e(q);
  } finally {
    N.f();
  }
  if (x.length > 0 && Yo.test(x))
    return /* @__PURE__ */ new Date(NaN);
  var _ = K.map(function(q) {
    return q.priority;
  }).sort(function(q, b) {
    return b - q;
  }).filter(function(q, b, v) {
    return v.indexOf(q) === b;
  }).map(function(q) {
    return K.filter(function(b) {
      return b.priority === q;
    }).sort(function(b, v) {
      return v.subPriority - b.subPriority;
    });
  }).map(function(q) {
    return q[0];
  }), H = pe(a);
  if (isNaN(H.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var Y = I1(H, Rr(H)), m = {}, o = u1(_), T;
  try {
    for (o.s(); !(T = o.n()).done; ) {
      var B = T.value;
      if (!B.validate(Y, ie))
        return /* @__PURE__ */ new Date(NaN);
      var W = B.set(Y, m, ie);
      Array.isArray(W) ? (Y = W[0], Zi(m, W[1])) : Y = W;
    }
  } catch (q) {
    o.e(q);
  } finally {
    o.f();
  }
  return Y;
}
function Fo(e) {
  return e.match(Ro)[1].replace(Io, "'");
}
function d1(e, t) {
  le(2, arguments);
  var a = yr(e), s = yr(t);
  return a.getTime() === s.getTime();
}
function Eo(e, t) {
  le(2, arguments);
  var a = fe(t);
  return Tt(e, -a);
}
function zo(e, t) {
  var a;
  le(1, arguments);
  var s = fe((a = void 0) !== null && a !== void 0 ? a : 2);
  if (s !== 2 && s !== 1 && s !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var r = Wo(e), l;
  if (r.date) {
    var n = jo(r.date, s);
    l = Qo(n.restDateString, n.year);
  }
  if (!l || isNaN(l.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var i = l.getTime(), u = 0, p;
  if (r.time && (u = Xo(r.time), isNaN(u)))
    return /* @__PURE__ */ new Date(NaN);
  if (r.timezone) {
    if (p = Go(r.timezone), isNaN(p))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var h = new Date(i + u), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(h.getUTCFullYear(), h.getUTCMonth(), h.getUTCDate()), d.setHours(h.getUTCHours(), h.getUTCMinutes(), h.getUTCSeconds(), h.getUTCMilliseconds()), d;
  }
  return new Date(i + u + p);
}
var Sr = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, qo = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Uo = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Ko = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Wo(e) {
  var t = {}, a = e.split(Sr.dateTimeDelimiter), s;
  if (a.length > 2)
    return t;
  if (/:/.test(a[0]) ? s = a[0] : (t.date = a[0], s = a[1], Sr.timeZoneDelimiter.test(t.date) && (t.date = e.split(Sr.timeZoneDelimiter)[0], s = e.substr(t.date.length, e.length))), s) {
    var r = Sr.timezone.exec(s);
    r ? (t.time = s.replace(r[1], ""), t.timezone = r[1]) : t.time = s;
  }
  return t;
}
function jo(e, t) {
  var a = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), s = e.match(a);
  if (!s) return {
    year: NaN,
    restDateString: ""
  };
  var r = s[1] ? parseInt(s[1]) : null, l = s[2] ? parseInt(s[2]) : null;
  return {
    year: l === null ? r : l * 100,
    restDateString: e.slice((s[1] || s[2]).length)
  };
}
function Qo(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  var a = e.match(qo);
  if (!a) return /* @__PURE__ */ new Date(NaN);
  var s = !!a[4], r = vr(a[1]), l = vr(a[2]) - 1, n = vr(a[3]), i = vr(a[4]), u = vr(a[5]) - 1;
  if (s)
    return a2(t, i, u) ? Jo(t, i, u) : /* @__PURE__ */ new Date(NaN);
  var p = /* @__PURE__ */ new Date(0);
  return !t2(t, l, n) || !r2(t, r) ? /* @__PURE__ */ new Date(NaN) : (p.setUTCFullYear(t, l, Math.max(r, n)), p);
}
function vr(e) {
  return e ? parseInt(e) : 1;
}
function Xo(e) {
  var t = e.match(Uo);
  if (!t) return NaN;
  var a = ra(t[1]), s = ra(t[2]), r = ra(t[3]);
  return s2(a, s, r) ? a * Sa + s * $a + r * 1e3 : NaN;
}
function ra(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Go(e) {
  if (e === "Z") return 0;
  var t = e.match(Ko);
  if (!t) return 0;
  var a = t[1] === "+" ? -1 : 1, s = parseInt(t[2]), r = t[3] && parseInt(t[3]) || 0;
  return n2(s, r) ? a * (s * Sa + r * $a) : NaN;
}
function Jo(e, t, a) {
  var s = /* @__PURE__ */ new Date(0);
  s.setUTCFullYear(e, 0, 4);
  var r = s.getUTCDay() || 7, l = (t - 1) * 7 + a + 1 - r;
  return s.setUTCDate(s.getUTCDate() + l), s;
}
var e2 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function J1(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function t2(e, t, a) {
  return t >= 0 && t <= 11 && a >= 1 && a <= (e2[t] || (J1(e) ? 29 : 28));
}
function r2(e, t) {
  return t >= 1 && t <= (J1(e) ? 366 : 365);
}
function a2(e, t, a) {
  return t >= 1 && t <= 53 && a >= 0 && a <= 6;
}
function s2(e, t, a) {
  return e === 24 ? t === 0 && a === 0 : a >= 0 && a < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function n2(e, t) {
  return t >= 0 && t <= 59;
}
function es(e, t) {
  le(2, arguments);
  var a = pe(e), s = fe(t), r = a.getFullYear(), l = a.getDate(), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(r, s, 15), n.setHours(0, 0, 0, 0);
  var i = Ri(n);
  return a.setMonth(s, Math.min(l, i)), a;
}
function Fe(e, t) {
  if (le(2, arguments), mt(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var a = pe(e);
  return isNaN(a.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && a.setFullYear(t.year), t.month != null && (a = es(a, t.month)), t.date != null && a.setDate(fe(t.date)), t.hours != null && a.setHours(fe(t.hours)), t.minutes != null && a.setMinutes(fe(t.minutes)), t.seconds != null && a.setSeconds(fe(t.seconds)), t.milliseconds != null && a.setMilliseconds(fe(t.milliseconds)), a);
}
function ts(e, t) {
  le(2, arguments);
  var a = pe(e), s = fe(t);
  return a.setHours(s), a;
}
function Ba(e, t) {
  le(2, arguments);
  var a = pe(e), s = fe(t);
  return a.setMilliseconds(s), a;
}
function rs(e, t) {
  le(2, arguments);
  var a = pe(e), s = fe(t);
  return a.setMinutes(s), a;
}
function Za(e, t) {
  le(2, arguments);
  var a = pe(e), s = fe(t);
  return a.setSeconds(s), a;
}
function Vt(e, t) {
  le(2, arguments);
  var a = pe(e), s = fe(t);
  return isNaN(a.getTime()) ? /* @__PURE__ */ new Date(NaN) : (a.setFullYear(s), a);
}
function ir(e, t) {
  le(2, arguments);
  var a = fe(t);
  return wt(e, -a);
}
function l2(e, t) {
  if (le(2, arguments), !t || mt(t) !== "object") return /* @__PURE__ */ new Date(NaN);
  var a = t.years ? fe(t.years) : 0, s = t.months ? fe(t.months) : 0, r = t.weeks ? fe(t.weeks) : 0, l = t.days ? fe(t.days) : 0, n = t.hours ? fe(t.hours) : 0, i = t.minutes ? fe(t.minutes) : 0, u = t.seconds ? fe(t.seconds) : 0, p = ir(e, s + a * 12), h = Eo(p, l + r * 7), d = i + n * 60, y = u + d * 60, L = y * 1e3, V = new Date(h.getTime() - L);
  return V;
}
function as(e, t) {
  le(2, arguments);
  var a = fe(t);
  return Ta(e, -a);
}
function cr() {
  return c(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      O("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      O("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      O("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      O("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
cr.compatConfig = {
  MODE: 3
};
function ss() {
  return c(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      O("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      O("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
ss.compatConfig = {
  MODE: 3
};
function Aa() {
  return c(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      O("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Aa.compatConfig = {
  MODE: 3
};
function Ra() {
  return c(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      O("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
Ra.compatConfig = {
  MODE: 3
};
function Ia() {
  return c(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      O("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      O("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
Ia.compatConfig = {
  MODE: 3
};
function Ya() {
  return c(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      O("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Ya.compatConfig = {
  MODE: 3
};
function Na() {
  return c(), k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      O("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Na.compatConfig = {
  MODE: 3
};
function Fa(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ns = { exports: {} };
(function(e) {
  function t(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ns);
var i2 = ns.exports, ka = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(s) {
    if (s === null || s === !0 || s === !1)
      return NaN;
    var r = Number(s);
    return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
  }
  e.exports = t.default;
})(ka, ka.exports);
var o2 = ka.exports;
const u2 = /* @__PURE__ */ Fa(o2);
var Ca = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(s) {
    var r = new Date(Date.UTC(s.getFullYear(), s.getMonth(), s.getDate(), s.getHours(), s.getMinutes(), s.getSeconds(), s.getMilliseconds()));
    return r.setUTCFullYear(s.getFullYear()), s.getTime() - r.getTime();
  }
  e.exports = t.default;
})(Ca, Ca.exports);
var d2 = Ca.exports;
const c1 = /* @__PURE__ */ Fa(d2);
function c2(e, t) {
  var a = v2(t);
  return a.formatToParts ? h2(a, e) : m2(a, e);
}
var p2 = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function h2(e, t) {
  try {
    for (var a = e.formatToParts(t), s = [], r = 0; r < a.length; r++) {
      var l = p2[a[r].type];
      l >= 0 && (s[l] = parseInt(a[r].value, 10));
    }
    return s;
  } catch (n) {
    if (n instanceof RangeError)
      return [NaN];
    throw n;
  }
}
function m2(e, t) {
  var a = e.format(t).replace(/\u200E/g, ""), s = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [s[3], s[1], s[2], s[4], s[5], s[6]];
}
var aa = {};
function v2(e) {
  if (!aa[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    aa[e] = a ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return aa[e];
}
function Ea(e, t, a, s, r, l, n) {
  var i = /* @__PURE__ */ new Date(0);
  return i.setUTCFullYear(e, t, a), i.setUTCHours(s, r, l, n), i;
}
var p1 = 36e5, f2 = 6e4, sa = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function za(e, t, a) {
  var s, r;
  if (e === "" || (s = sa.timezoneZ.exec(e), s))
    return 0;
  var l;
  if (s = sa.timezoneHH.exec(e), s)
    return l = parseInt(s[1], 10), h1(l) ? -(l * p1) : NaN;
  if (s = sa.timezoneHHMM.exec(e), s) {
    l = parseInt(s[1], 10);
    var n = parseInt(s[2], 10);
    return h1(l, n) ? (r = Math.abs(l) * p1 + n * f2, l > 0 ? -r : r) : NaN;
  }
  if (y2(e)) {
    t = new Date(t || Date.now());
    var i = a ? t : w2(t), u = ba(i, e), p = a ? u : g2(t, u, e);
    return -p;
  }
  return NaN;
}
function w2(e) {
  return Ea(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function ba(e, t) {
  var a = c2(e, t), s = Ea(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), r = e.getTime(), l = r % 1e3;
  return r -= l >= 0 ? l : 1e3 + l, s - r;
}
function g2(e, t, a) {
  var s = e.getTime(), r = s - t, l = ba(new Date(r), a);
  if (t === l)
    return t;
  r -= l - t;
  var n = ba(new Date(r), a);
  return l === n ? l : Math.max(l, n);
}
function h1(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var m1 = {};
function y2(e) {
  if (m1[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), m1[e] = !0, !0;
  } catch {
    return !1;
  }
}
var ls = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, na = 36e5, v1 = 6e4, k2 = 2, lt = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: ls
};
function La(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = t || {}, s = a.additionalDigits == null ? k2 : u2(a.additionalDigits);
  if (s !== 2 && s !== 1 && s !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var r = C2(e), l = b2(r.date, s), n = l.year, i = l.restDateString, u = L2(i, n);
  if (isNaN(u))
    return /* @__PURE__ */ new Date(NaN);
  if (u) {
    var p = u.getTime(), h = 0, d;
    if (r.time && (h = M2(r.time), isNaN(h)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || a.timeZone) {
      if (d = za(r.timeZone || a.timeZone, new Date(p + h)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
    } else
      d = c1(new Date(p + h)), d = c1(new Date(p + h + d));
    return new Date(p + h + d);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function C2(e) {
  var t = {}, a = lt.dateTimePattern.exec(e), s;
  if (a ? (t.date = a[1], s = a[3]) : (a = lt.datePattern.exec(e), a ? (t.date = a[1], s = a[2]) : (t.date = null, s = e)), s) {
    var r = lt.timeZone.exec(s);
    r ? (t.time = s.replace(r[1], ""), t.timeZone = r[1].trim()) : t.time = s;
  }
  return t;
}
function b2(e, t) {
  var a = lt.YYY[t], s = lt.YYYYY[t], r;
  if (r = lt.YYYY.exec(e) || s.exec(e), r) {
    var l = r[1];
    return {
      year: parseInt(l, 10),
      restDateString: e.slice(l.length)
    };
  }
  if (r = lt.YY.exec(e) || a.exec(e), r) {
    var n = r[1];
    return {
      year: parseInt(n, 10) * 100,
      restDateString: e.slice(n.length)
    };
  }
  return {
    year: null
  };
}
function L2(e, t) {
  if (t === null)
    return null;
  var a, s, r, l;
  if (e.length === 0)
    return s = /* @__PURE__ */ new Date(0), s.setUTCFullYear(t), s;
  if (a = lt.MM.exec(e), a)
    return s = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1, w1(t, r) ? (s.setUTCFullYear(t, r), s) : /* @__PURE__ */ new Date(NaN);
  if (a = lt.DDD.exec(e), a) {
    s = /* @__PURE__ */ new Date(0);
    var n = parseInt(a[1], 10);
    return D2(t, n) ? (s.setUTCFullYear(t, 0, n), s) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = lt.MMDD.exec(e), a) {
    s = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1;
    var i = parseInt(a[2], 10);
    return w1(t, r, i) ? (s.setUTCFullYear(t, r, i), s) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = lt.Www.exec(e), a)
    return l = parseInt(a[1], 10) - 1, g1(t, l) ? f1(t, l) : /* @__PURE__ */ new Date(NaN);
  if (a = lt.WwwD.exec(e), a) {
    l = parseInt(a[1], 10) - 1;
    var u = parseInt(a[2], 10) - 1;
    return g1(t, l, u) ? f1(t, l, u) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function M2(e) {
  var t, a, s;
  if (t = lt.HH.exec(e), t)
    return a = parseFloat(t[1].replace(",", ".")), la(a) ? a % 24 * na : NaN;
  if (t = lt.HHMM.exec(e), t)
    return a = parseInt(t[1], 10), s = parseFloat(t[2].replace(",", ".")), la(a, s) ? a % 24 * na + s * v1 : NaN;
  if (t = lt.HHMMSS.exec(e), t) {
    a = parseInt(t[1], 10), s = parseInt(t[2], 10);
    var r = parseFloat(t[3].replace(",", "."));
    return la(a, s, r) ? a % 24 * na + s * v1 + r * 1e3 : NaN;
  }
  return null;
}
function f1(e, t, a) {
  t = t || 0, a = a || 0;
  var s = /* @__PURE__ */ new Date(0);
  s.setUTCFullYear(e, 0, 4);
  var r = s.getUTCDay() || 7, l = t * 7 + a + 1 - r;
  return s.setUTCDate(s.getUTCDate() + l), s;
}
var V2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], x2 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function is(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function w1(e, t, a) {
  if (t < 0 || t > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var s = is(e);
    if (s && a > x2[t] || !s && a > V2[t])
      return !1;
  }
  return !0;
}
function D2(e, t) {
  if (t < 1)
    return !1;
  var a = is(e);
  return !(a && t > 366 || !a && t > 365);
}
function g1(e, t, a) {
  return !(t < 0 || t > 52 || a != null && (a < 0 || a > 6));
}
function la(e, t, a) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || a != null && (a < 0 || a >= 60));
}
var Ma = { exports: {} }, Va = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(s, r) {
    if (s == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var l in r)
      Object.prototype.hasOwnProperty.call(r, l) && (s[l] = r[l]);
    return s;
  }
  e.exports = t.default;
})(Va, Va.exports);
var H2 = Va.exports;
(function(e, t) {
  var a = i2.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  var s = a(H2);
  function r(l) {
    return (0, s.default)({}, l);
  }
  e.exports = t.default;
})(Ma, Ma.exports);
var T2 = Ma.exports;
const $2 = /* @__PURE__ */ Fa(T2);
function S2(e, t, a) {
  var s = La(e, a), r = za(t, s, !0), l = new Date(s.getTime() - r), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(l.getUTCFullYear(), l.getUTCMonth(), l.getUTCDate()), n.setHours(l.getUTCHours(), l.getUTCMinutes(), l.getUTCSeconds(), l.getUTCMilliseconds()), n;
}
function _2(e, t, a) {
  if (typeof e == "string" && !e.match(ls)) {
    var s = $2(a);
    return s.timeZone = t, La(e, s);
  }
  var r = La(e, a), l = Ea(
    r.getFullYear(),
    r.getMonth(),
    r.getDate(),
    r.getHours(),
    r.getMinutes(),
    r.getSeconds(),
    r.getMilliseconds()
  ).getTime(), n = za(t, new Date(l));
  return new Date(l + n);
}
function y1(e) {
  return (t) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`)).slice(0, 2);
}
function O2(e) {
  return (t) => Rt(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "EEEEEE", { locale: e });
}
const P2 = (e, t, a) => {
  const s = [1, 2, 3, 4, 5, 6, 7];
  let r;
  if (e !== null)
    try {
      r = s.map(O2(e));
    } catch {
      r = s.map(y1(t));
    }
  else
    r = s.map(y1(t));
  const l = r.slice(0, a), n = r.slice(a + 1, r.length);
  return [r[a]].concat(...n).concat(...l);
}, qa = (e, t) => {
  const a = [];
  for (let s = +e[0]; s <= +e[1]; s++)
    a.push({ value: +s, text: `${s}` });
  return t ? a.reverse() : a;
}, os = (e, t, a) => {
  const s = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((l) => {
    const n = l < 10 ? `0${l}` : l;
    return /* @__PURE__ */ new Date(`2017-${n}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const l = a === "long" ? "MMMM" : "MMM";
      return s.map((n, i) => {
        const u = Rt(n, l, { locale: e });
        return {
          text: u.charAt(0).toUpperCase() + u.substring(1),
          value: i
        };
      });
    } catch {
    }
  const r = new Intl.DateTimeFormat(t, { month: a, timeZone: "UTC" });
  return s.map((l, n) => {
    const i = r.format(l);
    return {
      text: i.charAt(0).toUpperCase() + i.substring(1),
      value: n
    };
  });
}, B2 = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], Xe = (e) => {
  const t = g(e);
  return t != null && t.$el ? t == null ? void 0 : t.$el : t;
}, Z2 = (e) => Object.assign({ type: "dot" }, e), us = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, Fr = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Ge = (e) => e, k1 = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, C1 = (e) => e === null, A2 = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, R2 = (e) => {
  const t = [], a = (s) => s.filter((r) => r);
  for (let s = 0; s < e.length; s += 3) {
    const r = [e[s], e[s + 1], e[s + 2]];
    t.push(a(r));
  }
  return t;
}, br = (e, t, a) => {
  const s = a != null, r = t != null;
  if (!s && !r)
    return !1;
  const l = +a, n = +t;
  return s && r ? +e > l || +e < n : s ? +e > l : r ? +e < n : !1;
}, or = (e, t) => R2(e).map((a) => a.map((s) => {
  const { active: r, disabled: l, isBetween: n, highlighted: i } = t(s);
  return {
    ...s,
    active: r,
    disabled: l,
    className: {
      dp__overlay_cell_active: r,
      dp__overlay_cell: !r,
      dp__overlay_cell_disabled: l,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: l && r,
      dp__cell_in_between: n,
      "dp--highlighted": i
    }
  };
})), It = (e, t, a = !1) => {
  e && t.allowStopPropagation && (a && e.stopImmediatePropagation(), e.stopPropagation());
}, I2 = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function Y2(e, t) {
  let a = [...document.querySelectorAll(I2())];
  a = a.filter((r) => !e.contains(r) || r.hasAttribute("data-datepicker-instance"));
  const s = a.indexOf(e);
  if (s >= 0 && (t ? s - 1 >= 0 : s + 1 <= a.length))
    return a[s + (t ? -1 : 1)];
}
const N2 = (e, t) => {
  let a;
  return function(...s) {
    clearTimeout(a), a = setTimeout(() => {
      e(...s);
    }, t);
  };
}, b1 = (e, t, a, s, r) => {
  const l = ya(e, t.slice(0, e.length), /* @__PURE__ */ new Date());
  return wr(l) && A1(l) ? s || r ? l : Fe(l, {
    hours: +a.hours,
    minutes: +(a == null ? void 0 : a.minutes),
    seconds: +(a == null ? void 0 : a.seconds),
    milliseconds: 0
  }) : null;
}, F2 = (e, t, a, s, r) => {
  const l = Array.isArray(a) ? a[0] : a;
  if (typeof t == "string")
    return b1(e, t, l, s, r);
  if (Array.isArray(t)) {
    let n = null;
    for (const i of t)
      if (n = b1(e, i, l, s, r), n)
        break;
    return n;
  }
  return typeof t == "function" ? t(e) : null;
}, F = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), E2 = (e, t, a) => {
  if (t) {
    const r = (e.getMonth() + 1).toString().padStart(2, "0"), l = e.getDate().toString().padStart(2, "0"), n = e.getHours().toString().padStart(2, "0"), i = e.getMinutes().toString().padStart(2, "0"), u = a ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${r}-${l}T${n}:${i}:${u}.000Z`;
  }
  const s = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(s).toISOString();
}, st = (e) => {
  let t = F(JSON.parse(JSON.stringify(e)));
  return t = ts(t, 0), t = rs(t, 0), t = Za(t, 0), t = Ba(t, 0), t;
}, Yt = (e, t, a, s) => {
  let r = e ? F(e) : F();
  return (t || t === 0) && (r = ts(r, +t)), (a || a === 0) && (r = rs(r, +a)), (s || s === 0) && (r = Za(r, +s)), Ba(r, 0);
}, tt = (e, t) => !e || !t ? !1 : Cr(st(e), st(t)), Be = (e, t) => !e || !t ? !1 : sr(st(e), st(t)), at = (e, t) => !e || !t ? !1 : kr(st(e), st(t)), zr = (e, t, a) => e != null && e[0] && e != null && e[1] ? at(a, e[0]) && tt(a, e[1]) : e != null && e[0] && t ? at(a, e[0]) && tt(a, t) || tt(a, e[0]) && at(a, t) : !1, ft = (e) => {
  const t = Fe(new Date(e), { date: 1 });
  return st(t);
}, ia = (e, t, a) => t && (a || a === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((s) => s === t ? [s, a] : [s, isNaN(+e[s]) ? void 0 : +e[s]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, Ut = (e) => ({
  hours: gt(e),
  minutes: xt(e),
  seconds: lr(e)
}), ds = (e, t) => {
  if (t) {
    const a = Ve(F(t));
    if (a > e)
      return 12;
    if (a === e)
      return Se(F(t));
  }
}, cs = (e, t) => {
  if (t) {
    const a = Ve(F(t));
    return a < e ? -1 : a === e ? Se(F(t)) : void 0;
  }
}, ur = (e) => {
  if (e)
    return Ve(F(e));
}, yt = (e, t) => t ? S2(e, t) : e, ps = (e, t) => t ? _2(e, t) : e, z2 = (e) => e instanceof Date ? e : zo(e), hs = (e, t) => {
  const a = at(e, t) ? t : e, s = at(t, e) ? t : e;
  return R1({ start: a, end: s });
}, q2 = (e) => {
  const t = wt(e, 1);
  return { month: Se(t), year: Ve(t) };
}, Br = (e, t, a) => {
  const s = Wt(yt(e, t), { weekStartsOn: +a }), r = Nl(yt(e, t), { weekStartsOn: +a });
  return [s, r];
}, ms = (e, t) => {
  const a = {
    hours: gt(F()),
    minutes: xt(F()),
    seconds: t ? lr(F()) : 0
  };
  return Object.assign(a, e);
}, Zt = (e, t, a) => [Fe(F(e), { date: 1 }), Fe(F(), { month: t, year: a, date: 1 })], $t = (e, t, a) => {
  let s = e ? F(e) : F();
  return (t || t === 0) && (s = es(s, t)), a && (s = Vt(s, a)), s;
}, vs = (e, t, a, s, r) => {
  if (!s || r && !t || !r && !a)
    return !1;
  const l = r ? wt(e, 1) : ir(e, 1), n = [Se(l), Ve(l)];
  return r ? !K2(...n, t) : !U2(...n, a);
}, U2 = (e, t, a) => tt(...Zt(a, e, t)) || Be(...Zt(a, e, t)), K2 = (e, t, a) => at(...Zt(a, e, t)) || Be(...Zt(a, e, t)), fs = (e, t, a, s, r, l, n) => {
  if (typeof t == "function" && !n)
    return t(e);
  const i = a ? { locale: a } : void 0;
  return Array.isArray(e) ? `${Rt(e[0], l, i)}${r && !e[1] ? "" : s}${e[1] ? Rt(e[1], l, i) : ""}` : Rt(e, l, i);
}, rr = (e) => {
  if (e)
    return null;
  throw new Error(Fr.prop("partial-range"));
}, _r = (e, t) => {
  if (t)
    return e();
  throw new Error(Fr.prop("range"));
}, xa = (e) => Array.isArray(e) ? wr(e[0]) && (e[1] ? wr(e[1]) : !0) : e ? wr(e) : !1, W2 = (e, t) => Fe(t ?? F(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), oa = (e, t, a, s) => {
  if (!e)
    return !0;
  if (s) {
    const r = a === "max" ? Cr(e, t) : kr(e, t), l = { seconds: 0, milliseconds: 0 };
    return r || sr(Fe(e, l), Fe(t, l));
  }
  return a === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, ua = (e, t, a) => e ? W2(e, t) : F(a ?? t), L1 = (e, t, a, s, r) => {
  if (Array.isArray(s)) {
    const n = ua(e, s[0], t), i = ua(e, s[1], t);
    return oa(s[0], n, a, !!t) && oa(s[1], i, a, !!t) && r;
  }
  const l = ua(e, s, t);
  return oa(s, l, a, !!t) && r;
}, da = (e) => Fe(F(), Ut(e)), j2 = (e, t) => Array.isArray(e) ? e.map((a) => F(a)).filter((a) => Ve(F(a)) === t).map((a) => Se(a)) : [], ws = (e, t, a) => typeof e == "function" ? e({ month: t, year: a }) : !!e.months.find((s) => s.month === t && s.year === a), Ua = (e, t) => typeof e == "function" ? e(t) : e.years.includes(t), fr = Lr({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), gs = () => {
  const e = (a) => {
    fr.menuFocused = a;
  }, t = (a) => {
    fr.shiftKeyInMenu !== a && (fr.shiftKeyInMenu = a);
  };
  return {
    control: Q(() => ({ shiftKeyInMenu: fr.shiftKeyInMenu, menuFocused: fr.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
}, Ne = Lr({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), ca = ee(null), Or = ee(!1), pa = ee(!1), ha = ee(!1), ma = ee(!1), nt = ee(0), et = ee(0), Et = () => {
  const e = Q(() => Or.value ? [...Ne.selectionGrid, Ne.actionRow].filter((d) => d.length) : pa.value ? [
    ...Ne.timePicker[0],
    ...Ne.timePicker[1],
    ma.value ? [] : [ca.value],
    Ne.actionRow
  ].filter((d) => d.length) : ha.value ? [...Ne.monthPicker, Ne.actionRow] : [Ne.monthYear, ...Ne.calendar, Ne.time, Ne.actionRow].filter((d) => d.length)), t = (d) => {
    nt.value = d ? nt.value + 1 : nt.value - 1;
    let y = null;
    e.value[et.value] && (y = e.value[et.value][nt.value]), y || (nt.value = d ? nt.value - 1 : nt.value + 1);
  }, a = (d) => {
    et.value === 0 && !d || et.value === e.value.length && d || (et.value = d ? et.value + 1 : et.value - 1, e.value[et.value] ? e.value[et.value] && !e.value[et.value][nt.value] && nt.value !== 0 && (nt.value = e.value[et.value].length - 1) : et.value = d ? et.value - 1 : et.value + 1);
  }, s = (d) => {
    let y = null;
    e.value[et.value] && (y = e.value[et.value][nt.value]), y ? y.focus({ preventScroll: !Or.value }) : nt.value = d ? nt.value - 1 : nt.value + 1;
  }, r = () => {
    t(!0), s(!0);
  }, l = () => {
    t(!1), s(!1);
  }, n = () => {
    a(!1), s(!0);
  }, i = () => {
    a(!0), s(!0);
  }, u = (d, y) => {
    Ne[y] = d;
  }, p = (d, y) => {
    Ne[y] = d;
  }, h = () => {
    nt.value = 0, et.value = 0;
  };
  return {
    buildMatrix: u,
    buildMultiLevelMatrix: p,
    setTimePickerBackRef: (d) => {
      ca.value = d;
    },
    setSelectionGrid: (d) => {
      Or.value = d, h(), d || (Ne.selectionGrid = []);
    },
    setTimePicker: (d, y = !1) => {
      pa.value = d, ma.value = y, h(), d || (Ne.timePicker[0] = [], Ne.timePicker[1] = []);
    },
    setTimePickerElements: (d, y = 0) => {
      Ne.timePicker[y] = d;
    },
    arrowRight: r,
    arrowLeft: l,
    arrowUp: n,
    arrowDown: i,
    clearArrowNav: () => {
      Ne.monthYear = [], Ne.calendar = [], Ne.time = [], Ne.actionRow = [], Ne.selectionGrid = [], Ne.timePicker[0] = [], Ne.timePicker[1] = [], Or.value = !1, pa.value = !1, ma.value = !1, ha.value = !1, h(), ca.value = null;
    },
    setMonthPicker: (d) => {
      ha.value = d, h();
    },
    refSets: Ne
    // exposed for testing
  };
}, M1 = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), Q2 = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (t) => `Increment ${t}`,
  decrementValue: (t) => `Decrement ${t}`,
  openTpOverlay: (t) => `Open ${t} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: () => "",
  ...e ?? {}
}), V1 = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, X2 = (e) => {
  const t = typeof e == "object" && e, a = {
    static: !0,
    solo: !1
  };
  if (!e)
    return { ...a, count: V1(!1) };
  const s = t ? e : {}, r = t ? s.count ?? !0 : e, l = V1(r);
  return Object.assign(a, s, { count: l });
}, G2 = (e, t, a) => e || (typeof a == "string" ? a : t), J2 = (e) => typeof e == "boolean" ? e ? M1({}) : !1 : M1(e), e0 = (e) => {
  const t = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : { ...t, enabled: e };
}, t0 = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), r0 = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), a0 = (e) => {
  const t = { input: !1 };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...t
  };
}, s0 = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, ...e ?? {} }), n0 = (e, t, a) => {
  const s = {
    dates: Array.isArray(e) ? e.map((r) => F(r)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: t,
    options: { highlightDisabled: a }
  };
  return typeof e == "function" ? e : { ...s, ...e ?? {} };
}, l0 = (e) => typeof e == "object" ? {
  type: e.type,
  hideOnOffsetDates: e.hideOnOffsetDates ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, Qe = (e) => {
  const t = () => {
    const $ = e.enableSeconds ? ":ss" : "";
    return e.is24 ? `HH:mm${$}` : `hh:mm${$} aa`;
  }, a = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? "MM/dd/yyyy" : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy", s = ($) => ms($, e.enableSeconds), r = () => e.range ? e.startTime && Array.isArray(e.startTime) ? [s(e.startTime[0]), s(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? s(e.startTime) : null, l = Q(() => X2(e.multiCalendars)), n = Q(() => r()), i = Q(() => Q2(e.ariaLabels)), u = Q(() => t0(e.filters)), p = Q(() => J2(e.transitions)), h = Q(() => r0(e.actionRow)), d = Q(
    () => G2(e.previewFormat, e.format, a())
  ), y = Q(() => e0(e.textInput)), L = Q(() => a0(e.inline)), V = Q(() => s0(e.config)), Z = Q(
    () => n0(e.highlight, e.highlightWeekDays, e.highlightDisabledDays)
  ), z = Q(() => l0(e.weekNumbers));
  return {
    defaultedTransitions: p,
    defaultedMultiCalendars: l,
    defaultedStartTime: n,
    defaultedAriaLabels: i,
    defaultedFilters: u,
    defaultedActionRow: h,
    defaultedPreviewFormat: d,
    defaultedTextInput: y,
    defaultedInline: L,
    defaultedConfig: V,
    defaultedHighlight: Z,
    defaultedWeekNumbers: z,
    getDefaultPattern: a,
    getDefaultStartTime: r
  };
}, i0 = (e, t, a) => {
  const s = ee(), { defaultedTextInput: r, getDefaultPattern: l } = Qe(t), n = ee(""), i = Zr(t, "format");
  Ft(s, () => {
    e("internal-model-change", s.value);
  }), Ft(i, () => {
    P();
  });
  const u = (o) => ps(o, t.timezone), p = (o) => yt(o, t.timezone), h = (o, T, B = !1) => fs(
    o,
    t.format,
    t.formatLocale,
    r.value.rangeSeparator,
    t.modelAuto,
    T ?? l(),
    B
  ), d = (o) => o ? t.modelType ? _(o) : {
    hours: gt(o),
    minutes: xt(o),
    seconds: t.enableSeconds ? lr(o) : 0
  } : null, y = (o) => t.modelType ? _(o) : { month: Se(o), year: Ve(o) }, L = (o) => Array.isArray(o) ? t.multiDates ? o.map((T) => V(T, Vt(F(), T))) : _r(
    () => [
      Vt(F(), o[0]),
      o[1] ? Vt(F(), o[1]) : rr(t.partialRange)
    ],
    t.range
  ) : Vt(F(), +o), V = (o, T) => (typeof o == "string" || typeof o == "number") && t.modelType ? f(o) : T, Z = (o) => Array.isArray(o) ? [
    V(
      o[0],
      Yt(null, +o[0].hours, +o[0].minutes, o[0].seconds)
    ),
    V(
      o[1],
      Yt(null, +o[1].hours, +o[1].minutes, o[1].seconds)
    )
  ] : V(o, Yt(null, o.hours, o.minutes, o.seconds)), z = (o) => Array.isArray(o) ? t.multiDates ? o.map((T) => V(T, $t(null, +T.month, +T.year))) : _r(
    () => [
      V(o[0], $t(null, +o[0].month, +o[0].year)),
      V(
        o[1],
        o[1] ? $t(null, +o[1].month, +o[1].year) : rr(t.partialRange)
      )
    ],
    t.range
  ) : V(o, $t(null, +o.month, +o.year)), $ = (o) => {
    if (Array.isArray(o))
      return o.map((T) => f(T));
    throw new Error(Fr.dateArr("multi-dates"));
  }, x = (o) => {
    if (Array.isArray(o))
      return [F(o[0]), F(o[1])];
    throw new Error(Fr.dateArr("week-picker"));
  }, U = (o) => t.modelAuto ? Array.isArray(o) ? [f(o[0]), f(o[1])] : t.autoApply ? [f(o)] : [f(o), null] : Array.isArray(o) ? _r(
    () => [
      f(o[0]),
      o[1] ? f(o[1]) : rr(t.partialRange)
    ],
    t.range
  ) : f(o), M = () => {
    Array.isArray(s.value) && t.range && s.value.length === 1 && s.value.push(rr(t.partialRange));
  }, R = () => {
    const o = s.value;
    return [
      _(o[0]),
      o[1] ? _(o[1]) : rr(t.partialRange)
    ];
  }, E = () => s.value[1] ? R() : _(Ge(s.value[0])), I = () => (s.value || []).map((o) => _(o)), ie = () => (M(), t.modelAuto ? E() : t.multiDates ? I() : Array.isArray(s.value) ? _r(() => R(), t.range) : _(Ge(s.value))), K = (o) => !o || Array.isArray(o) && !o.length ? null : t.timePicker ? Z(Ge(o)) : t.monthPicker ? z(Ge(o)) : t.yearPicker ? L(Ge(o)) : t.multiDates ? $(Ge(o)) : t.weekPicker ? x(Ge(o)) : U(Ge(o)), w = (o) => {
    const T = K(o);
    xa(Ge(T)) ? (s.value = Ge(T), P()) : (s.value = null, n.value = "");
  }, D = () => {
    const o = (T) => Rt(T, r.value.format);
    return `${o(s.value[0])} ${r.value.rangeSeparator} ${s.value[1] ? o(s.value[1]) : ""}`;
  }, N = () => a.value && s.value ? Array.isArray(s.value) ? D() : Rt(s.value, r.value.format) : h(s.value), G = () => s.value ? t.multiDates ? s.value.map((o) => h(o)).join("; ") : r.value.enabled && typeof r.value.format == "string" ? N() : h(s.value) : "", P = () => {
    !t.format || typeof t.format == "string" || r.value.enabled && typeof r.value.format == "string" ? n.value = G() : n.value = t.format(s.value);
  }, f = (o) => {
    if (t.utc) {
      const T = new Date(o);
      return t.utc === "preserve" ? new Date(T.getTime() + T.getTimezoneOffset() * 6e4) : T;
    }
    return t.modelType ? t.modelType === "date" || t.modelType === "timestamp" ? p(new Date(o)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? ya(o, l(), /* @__PURE__ */ new Date()) : p(ya(o, t.modelType, /* @__PURE__ */ new Date())) : p(new Date(o));
  }, _ = (o) => o ? t.utc ? E2(o, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +u(o) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? h(u(o)) : h(u(o), t.modelType, !0) : u(o) : "", H = (o, T = !1) => {
    if (e("update:model-value", o), t.emitTimezone && T) {
      const B = Array.isArray(o) ? o.map((W) => yt(Ge(W)), t.emitTimezone) : yt(Ge(o), t.emitTimezone);
      e("update:model-timezone-value", B);
    }
  }, Y = (o) => Array.isArray(s.value) ? t.multiDates ? s.value.map((T) => o(T)) : [
    o(s.value[0]),
    s.value[1] ? o(s.value[1]) : rr(t.partialRange)
  ] : o(Ge(s.value)), m = (o) => H(Ge(Y(o)));
  return {
    inputValue: n,
    internalModelValue: s,
    checkBeforeEmit: () => s.value ? t.range ? t.partialRange ? s.value.length >= 1 : s.value.length === 2 : !!s.value : !1,
    parseExternalModelValue: w,
    formatInputValue: P,
    emitModelValue: () => (P(), t.monthPicker ? m(y) : t.timePicker ? m(d) : t.yearPicker ? m(Ve) : t.weekPicker ? H(
      s.value.map((o) => _(o)),
      !0
    ) : H(ie(), !0))
  };
}, o0 = (e, t) => {
  const { defaultedFilters: a } = Qe(e), { validateMonthYearInRange: s } = Jt(e), r = (p, h) => {
    let d = p;
    return a.value.months.includes(Se(d)) ? (d = h ? wt(p, 1) : ir(p, 1), r(d, h)) : d;
  }, l = (p, h) => {
    let d = p;
    return a.value.years.includes(Ve(d)) ? (d = h ? Ta(p, 1) : as(p, 1), l(d, h)) : d;
  }, n = (p, h = !1) => {
    const d = Fe(/* @__PURE__ */ new Date(), { month: e.month, year: e.year });
    let y = p ? wt(d, 1) : ir(d, 1);
    e.disableYearSelect && (y = Vt(y, e.year));
    let L = Se(y), V = Ve(y);
    a.value.months.includes(L) && (y = r(y, p), L = Se(y), V = Ve(y)), a.value.years.includes(V) && (y = l(y, p), V = Ve(y)), s(L, V, p, e.preventMinMaxNavigation) && i(L, V, h);
  }, i = (p, h, d) => {
    t("update-month-year", { month: p, year: h, fromNav: d });
  }, u = Q(() => (p) => vs(
    Fe(/* @__PURE__ */ new Date(), { month: e.month, year: e.year }),
    e.maxDate,
    e.minDate,
    e.preventMinMaxNavigation,
    p
  ));
  return { handleMonthYearChange: n, isDisabled: u, updateMonthYear: i };
};
var ar = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(ar || {}), vt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(vt || {}), qt = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(qt || {}), Kt = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(Kt || {}), bt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(bt || {});
const u0 = ({
  menuRef: e,
  menuRefInner: t,
  inputRef: a,
  pickerWrapperRef: s,
  inline: r,
  emit: l,
  props: n,
  slots: i
}) => {
  const u = ee({}), p = ee(!1), h = ee({
    top: "0",
    left: "0"
  }), d = ee(!1), y = Zr(n, "teleportCenter");
  Ft(y, () => {
    h.value = JSON.parse(JSON.stringify({})), M();
  });
  const L = (f) => {
    if (n.teleport) {
      const _ = f.getBoundingClientRect();
      return {
        left: _.left + window.scrollX,
        top: _.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, V = (f, _) => {
    h.value.left = `${f + _ - u.value.width}px`;
  }, Z = (f) => {
    h.value.left = `${f}px`;
  }, z = (f, _) => {
    n.position === ar.left && Z(f), n.position === ar.right && V(f, _), n.position === ar.center && (h.value.left = `${f + _ / 2 - u.value.width / 2}px`);
  }, $ = (f) => {
    const { width: _, height: H } = f.getBoundingClientRect(), { top: Y, left: m } = n.altPosition ? n.altPosition(f) : L(f);
    return { top: +Y, left: +m, width: _, height: H };
  }, x = () => {
    h.value.left = "50%", h.value.top = "50%", h.value.transform = "translate(-50%, -50%)", h.value.position = "fixed", delete h.value.opacity;
  }, U = () => {
    const f = Xe(a), { top: _, left: H, transform: Y } = n.altPosition(f);
    h.value = { top: `${_}px`, left: `${H}px`, transform: Y ?? "" };
  }, M = (f = !0) => {
    var _;
    if (!r.value.enabled) {
      if (y.value)
        return x();
      if (n.altPosition !== null)
        return U();
      if (f) {
        const H = n.teleport ? (_ = t.value) == null ? void 0 : _.$el : e.value;
        H && (u.value = H.getBoundingClientRect()), l("recalculate-position");
      }
      return D();
    }
  }, R = ({ inputEl: f, left: _, width: H }) => {
    window.screen.width > 768 && !p.value && z(_, H), ie(f);
  }, E = (f) => {
    const { top: _, left: H, height: Y, width: m } = $(f);
    h.value.top = `${Y + _ + +n.offset}px`, d.value = !1, p.value || (h.value.left = `${H + m / 2 - u.value.width / 2}px`), R({ inputEl: f, left: H, width: m });
  }, I = (f) => {
    const { top: _, left: H, width: Y } = $(f);
    h.value.top = `${_ - +n.offset - u.value.height}px`, d.value = !0, R({ inputEl: f, left: H, width: Y });
  }, ie = (f) => {
    if (n.autoPosition) {
      const { left: _, width: H } = $(f), { left: Y, right: m } = u.value;
      if (!p.value) {
        if (Math.abs(Y) !== Math.abs(m)) {
          if (Y <= 0)
            return p.value = !0, Z(_);
          if (m >= document.documentElement.clientWidth)
            return p.value = !0, V(_, H);
        }
        return z(_, H);
      }
    }
  }, K = () => {
    const f = Xe(a);
    if (f) {
      const { height: _ } = u.value, { top: H, height: Y } = f.getBoundingClientRect(), m = window.innerHeight - H - Y, o = H;
      return _ <= m ? qt.bottom : _ > m && _ <= o ? qt.top : m >= o ? qt.bottom : qt.top;
    }
    return qt.bottom;
  }, w = (f) => K() === qt.bottom ? E(f) : I(f), D = () => {
    const f = Xe(a);
    if (f)
      return n.autoPosition ? w(f) : E(f);
  }, N = function(f) {
    if (f) {
      const _ = f.scrollHeight > f.clientHeight, H = window.getComputedStyle(f).overflowY.indexOf("hidden") !== -1;
      return _ && !H;
    }
    return !0;
  }, G = function(f) {
    return !f || f === document.body || f.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : N(f) ? f : G(f.parentNode);
  }, P = (f) => {
    if (f)
      switch (n.position) {
        case ar.left:
          return { left: 0, transform: "translateX(0)" };
        case ar.right:
          return { left: `${f.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${f.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: d,
    menuStyle: h,
    xCorrect: p,
    setMenuPosition: M,
    getScrollableParent: G,
    shadowRender: (f, _) => {
      var H, Y, m;
      const o = document.createElement("div"), T = (H = Xe(a)) == null ? void 0 : H.getBoundingClientRect();
      o.setAttribute("id", "dp--temp-container");
      const B = (Y = s.value) != null && Y.clientWidth ? s.value : document.body;
      B.append(o);
      const W = P(T), q = Ss(
        f,
        {
          ..._,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...W }
        },
        Object.fromEntries(
          Object.keys(i).filter((b) => ["right-sidebar", "left-sidebar"].includes(b)).map((b) => [b, i[b]])
        )
      );
      t1(q, o), u.value = (m = q.el) == null ? void 0 : m.getBoundingClientRect(), t1(null, o), B.removeChild(o);
    }
  };
}, Bt = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] }
], d0 = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], c0 = {
  all: () => Bt,
  monthYear: () => Bt.filter((e) => e.use.includes("month-year")),
  input: () => d0,
  timePicker: () => Bt.filter((e) => e.use.includes("time")),
  action: () => Bt.filter((e) => e.use.includes("action")),
  calendar: () => Bt.filter((e) => e.use.includes("calendar")),
  menu: () => Bt.filter((e) => e.use.includes("menu")),
  shared: () => Bt.filter((e) => e.use.includes("shared")),
  yearMode: () => Bt.filter((e) => e.use.includes("year-mode"))
}, ct = (e, t, a) => {
  const s = [];
  return c0[t]().forEach((r) => {
    e[r.name] && s.push(r.name);
  }), a != null && a.length && a.forEach((r) => {
    r.slot && s.push(r.slot);
  }), s;
}, Mr = (e) => {
  const t = Q(() => (s) => e.value ? s ? e.value.open : e.value.close : ""), a = Q(() => (s) => e.value ? s ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: t, showTransition: !!e.value, menuTransition: a };
}, Vr = (e, t) => {
  const a = F(yt(/* @__PURE__ */ new Date(), e.timezone)), s = ee([{ month: Se(a), year: Ve(a) }]), r = Lr({
    hours: e.range ? [gt(a), gt(a)] : gt(a),
    minutes: e.range ? [xt(a), xt(a)] : xt(a),
    seconds: e.range ? [0, 0] : 0
  }), l = Q({
    get: () => e.internalModelValue,
    set: (u) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", u);
    }
  }), n = Q(
    () => (u) => s.value[u] ? s.value[u].month : 0
  ), i = Q(
    () => (u) => s.value[u] ? s.value[u].year : 0
  );
  return {
    calendars: s,
    time: r,
    modelValue: l,
    month: n,
    year: i
  };
}, p0 = (e, t) => {
  const { defaultedMultiCalendars: a, defaultedHighlight: s } = Qe(t), { isDisabled: r, matchDate: l } = Jt(t), n = ee(null), i = ee(F(yt(/* @__PURE__ */ new Date(), t.timezone))), u = (m) => {
    !m.current && t.hideOffsetDates || (n.value = m.value);
  }, p = () => {
    n.value = null;
  }, h = (m) => Array.isArray(e.value) && t.range && e.value[0] && n.value ? m ? at(n.value, e.value[0]) : tt(n.value, e.value[0]) : !0, d = (m, o) => {
    const T = () => e.value ? o ? e.value[0] || null : e.value[1] : null, B = e.value && Array.isArray(e.value) ? T() : null;
    return Be(F(m.value), B);
  }, y = (m) => {
    const o = Array.isArray(e.value) ? e.value[0] : null;
    return m ? !tt(n.value ?? null, o) : !0;
  }, L = (m, o = !0) => (t.range || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !m.current ? !1 : Be(F(m.value), e.value[o ? 0 : 1]) : t.range ? d(m, o) && y(o) || Be(m.value, Array.isArray(e.value) ? e.value[0] : null) && h(o) : !1, V = (m, o, T) => Array.isArray(e.value) && e.value[0] && e.value.length === 1 ? m ? !1 : T ? at(e.value[0], o.value) : tt(e.value[0], o.value) : !1, Z = (m) => !e.value || t.hideOffsetDates && !m.current ? !1 : t.range ? t.modelAuto && Array.isArray(e.value) ? Be(m.value, e.value[0] ? e.value[0] : i.value) : !1 : t.multiDates && Array.isArray(e.value) ? e.value.some((o) => Be(o, m.value)) : Be(m.value, e.value ? e.value : i.value), z = (m) => {
    if (t.autoRange || t.weekPicker) {
      if (n.value) {
        if (t.hideOffsetDates && !m.current)
          return !1;
        const o = Tt(n.value, +t.autoRange), T = Br(F(n.value), t.timezone, t.weekStart);
        return t.weekPicker ? Be(T[1], F(m.value)) : Be(o, F(m.value));
      }
      return !1;
    }
    return !1;
  }, $ = (m) => {
    if (t.autoRange || t.weekPicker) {
      if (n.value) {
        const o = Tt(n.value, +t.autoRange);
        if (t.hideOffsetDates && !m.current)
          return !1;
        const T = Br(F(n.value), t.timezone, t.weekStart);
        return t.weekPicker ? at(m.value, T[0]) && tt(m.value, T[1]) : at(m.value, n.value) && tt(m.value, o);
      }
      return !1;
    }
    return !1;
  }, x = (m) => {
    if (t.autoRange || t.weekPicker) {
      if (n.value) {
        if (t.hideOffsetDates && !m.current)
          return !1;
        const o = Br(F(n.value), t.timezone, t.weekStart);
        return t.weekPicker ? Be(o[0], m.value) : Be(n.value, m.value);
      }
      return !1;
    }
    return !1;
  }, U = (m) => zr(e.value, n.value, m.value), M = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, R = () => t.modelAuto ? us(t.internalModelValue) : !0, E = (m) => {
    if (Array.isArray(e.value) && e.value.length || t.weekPicker)
      return !1;
    const o = t.range ? !L(m) && !L(m, !1) : !0;
    return !r(m.value) && !Z(m) && !(!m.current && t.hideOffsetDates) && o;
  }, I = (m) => t.range ? t.modelAuto ? M() && Z(m) : !1 : Z(m), ie = (m) => {
    var o;
    return s.value ? typeof s.value == "function" ? s.value(m.value) : l(
      m.value,
      (o = t.arrMapValues) != null && o.highlightedDates ? t.arrMapValues.highlightedDates : s.value.dates
    ) : !1;
  }, K = (m) => {
    const o = r(m.value);
    return o && (typeof s.value == "function" ? !s.value(m.value, o) : !s.value.options.highlightDisabled);
  }, w = (m) => {
    var o;
    return typeof s.value == "function" ? s.value(m.value) : (o = s.value.weekdays) == null ? void 0 : o.includes(m.value.getDay());
  }, D = (m) => (t.range || t.weekPicker) && (!(a.value.count > 0) || m.current) && R() && !(!m.current && t.hideOffsetDates) && !Z(m) ? U(m) : !1, N = (m) => {
    const { isRangeStart: o, isRangeEnd: T } = f(m), B = t.range ? o || T : !1;
    return {
      dp__cell_offset: !m.current,
      dp__pointer: !t.disabled && !(!m.current && t.hideOffsetDates) && !r(m.value),
      dp__cell_disabled: r(m.value),
      dp__cell_highlight: !K(m) && (ie(m) || w(m)) && !I(m) && !B && !x(m) && !(D(m) && t.weekPicker) && !T,
      dp__cell_highlight_active: !K(m) && (ie(m) || w(m)) && I(m),
      dp__today: !t.noToday && Be(m.value, i.value) && m.current
    };
  }, G = (m) => ({
    dp__active_date: I(m),
    dp__date_hover: E(m)
  }), P = (m) => ({
    ..._(m),
    ...H(m),
    dp__range_between_week: D(m) && t.weekPicker
  }), f = (m) => {
    const o = a.value.count > 0 ? m.current && L(m) && R() : L(m) && R(), T = a.value.count > 0 ? m.current && L(m, !1) && R() : L(m, !1) && R();
    return { isRangeStart: o, isRangeEnd: T };
  }, _ = (m) => {
    const { isRangeStart: o, isRangeEnd: T } = f(m);
    return {
      dp__range_start: o,
      dp__range_end: T,
      dp__range_between: D(m) && !t.weekPicker,
      dp__date_hover_start: V(E(m), m, !0),
      dp__date_hover_end: V(E(m), m, !1)
    };
  }, H = (m) => ({
    ..._(m),
    dp__cell_auto_range: $(m),
    dp__cell_auto_range_start: x(m),
    dp__cell_auto_range_end: z(m)
  }), Y = (m) => t.range ? t.autoRange ? H(m) : t.modelAuto ? { ...G(m), ..._(m) } : _(m) : t.weekPicker ? P(m) : G(m);
  return {
    setHoverDate: u,
    clearHoverDate: p,
    getDayClassData: (m) => t.hideOffsetDates && !m.current ? {} : {
      ...N(m),
      ...Y(m),
      [t.dayClass ? t.dayClass(m.value) : ""]: !0,
      [t.calendarCellClassName]: !!t.calendarCellClassName
    }
  };
}, Jt = (e) => {
  const { defaultedFilters: t, defaultedHighlight: a } = Qe(e), s = () => {
    if (e.timezone)
      return e.timezone;
    if (e.utc)
      return "UTC";
  }, r = (w) => {
    const D = st(l(F(w))).toISOString(), [N] = D.split("T");
    return N;
  }, l = (w) => e.utc === "preserve" ? ps(w, s()) : yt(w, s()), n = (w) => {
    var D;
    const N = e.maxDate ? at(w, l(F(e.maxDate))) : !1, G = e.minDate ? tt(w, l(F(e.minDate))) : !1, P = h(
      l(w),
      (D = e.arrMapValues) != null && D.disabledDates ? e.arrMapValues.disabledDates : e.disabledDates
    ), f = t.value.months.map((o) => +o).includes(Se(w)), _ = e.disabledWeekDays.length ? e.disabledWeekDays.some((o) => +o === Ai(w)) : !1, H = y(w), Y = Ve(w), m = Y < +e.yearRange[0] || Y > +e.yearRange[1];
    return !(N || G || P || f || m || _ || H);
  }, i = (w, D) => tt(...Zt(e.minDate, w, D)) || Be(...Zt(e.minDate, w, D)), u = (w, D) => at(...Zt(e.maxDate, w, D)) || Be(...Zt(e.maxDate, w, D)), p = (w, D, N) => {
    let G = !1;
    return e.maxDate && N && u(w, D) && (G = !0), e.minDate && !N && i(w, D) && (G = !0), G;
  }, h = (w, D) => w ? D instanceof Map ? !!D.get(r(w)) : Array.isArray(D) ? D.some((N) => Be(l(F(N)), w)) : D ? D(F(JSON.parse(JSON.stringify(w)))) : !1 : !0, d = (w, D, N, G) => {
    let P = !1;
    return G ? e.minDate && e.maxDate ? P = p(w, D, N) : (e.minDate && i(w, D) || e.maxDate && u(w, D)) && (P = !0) : P = !0, P;
  }, y = (w) => {
    var D, N, G, P, f;
    return Array.isArray(e.allowedDates) && !((D = e.allowedDates) != null && D.length) ? !0 : (N = e.arrMapValues) != null && N.allowedDates ? !h(w, (G = e.arrMapValues) == null ? void 0 : G.allowedDates) : (P = e.allowedDates) != null && P.length ? !((f = e.allowedDates) != null && f.some(
      (_) => Be(st(_), l(st(w)))
    )) : !1;
  }, L = (w) => !n(w), V = (w) => e.noDisabledRange ? !R1({ start: w[0], end: w[1] }).some((D) => L(D)) : !0, Z = (w, D, N = 0) => {
    if (Array.isArray(D) && D[N]) {
      const G = Bl(w, D[N]), P = hs(D[N], w), f = P.length === 1 ? 0 : P.filter((H) => L(H)).length, _ = Math.abs(G) - f;
      if (e.minRange && e.maxRange)
        return _ >= +e.minRange && _ <= +e.maxRange;
      if (e.minRange)
        return _ >= +e.minRange;
      if (e.maxRange)
        return _ <= +e.maxRange;
    }
    return !0;
  }, z = (w) => new Map(w.map((D) => [r(D), !0])), $ = (w) => Array.isArray(w) && w.length > 0, x = () => {
    const w = {
      disabledDates: null,
      allowedDates: null,
      highlightedDates: null
    };
    return $(e.allowedDates) && (w.allowedDates = z(e.allowedDates)), typeof a.value != "function" && $(a.value.dates) && (w.highlightedDates = z(a.value.dates)), $(e.disabledDates) && (w.disabledDates = z(e.disabledDates)), w;
  }, U = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, M = (w) => Array.isArray(w) ? [w[0] ? da(w[0]) : null, w[1] ? da(w[1]) : null] : da(w), R = (w, D, N) => w.find(
    (G) => +G.hours === gt(D) && G.minutes === "*" ? !0 : +G.minutes === xt(D) && +G.hours === gt(D)
  ) && N, E = (w, D, N) => {
    const [G, P] = w, [f, _] = D;
    return !R(G, f, N) && !R(P, _, N) && N;
  }, I = (w, D) => {
    const N = Array.isArray(D) ? D : [D];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? E(e.disabledTimes, N, w) : !N.some((G) => R(e.disabledTimes, G, w)) : w;
  }, ie = (w, D) => {
    const N = Array.isArray(D) ? [Ut(D[0]), D[1] ? Ut(D[1]) : void 0] : Ut(D), G = !e.disabledTimes(N);
    return w && G;
  }, K = (w, D) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? I(D, w) : ie(D, w) : D;
  return {
    isDisabled: L,
    validateDate: n,
    validateMonthYearInRange: d,
    isDateRangeAllowed: V,
    checkMinMaxRange: Z,
    matchDate: h,
    mapDatesArrToMap: x,
    isValidTime: (w) => {
      let D = !0;
      if (!w || U())
        return !0;
      const N = !e.minDate && !e.maxDate ? M(w) : w;
      return (e.maxTime || e.maxDate) && (D = L1(
        e.maxTime,
        e.maxDate,
        "max",
        Ge(N),
        D
      )), (e.minTime || e.minDate) && (D = L1(
        e.minTime,
        e.minDate,
        "min",
        Ge(N),
        D
      )), K(w, D);
    }
  };
}, qr = () => {
  const e = Q(() => (s, r) => s == null ? void 0 : s.includes(r)), t = Q(() => (s, r) => s.count ? s.solo ? !0 : r === 0 : !0), a = Q(() => (s, r) => s.count ? s.solo ? !0 : r === s.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: t, showRightIcon: a };
}, h0 = (e, t, a) => {
  const s = ee(0), r = Lr({
    [Kt.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [Kt.calendar]: !1,
    [Kt.header]: !1
  }), l = Q(() => e.monthPicker), n = (d) => {
    var y;
    if ((y = e.flow) != null && y.length) {
      if (!d && l.value)
        return h();
      r[d] = !0, Object.keys(r).filter((L) => !r[L]).length || h();
    }
  }, i = () => {
    var d;
    (d = e.flow) != null && d.length && s.value !== -1 && (s.value += 1, t("flow-step", s.value), h());
  }, u = () => {
    s.value = -1;
  }, p = (d, y, ...L) => {
    e.flow[s.value] === d && a.value && a.value[y](...L);
  }, h = () => {
    p(bt.month, "toggleMonthPicker", !0), p(bt.year, "toggleYearPicker", !0), p(bt.calendar, "toggleTimePicker", !1, !0), p(bt.time, "toggleTimePicker", !0, !0);
    const d = e.flow[s.value];
    (d === bt.hours || d === bt.minutes || d === bt.seconds) && p(d, "toggleTimePicker", !0, !0, d);
  };
  return { childMount: n, updateFlowStep: i, resetFlow: u, flowStep: s };
}, Ur = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: String, default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Array, Function, Object],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: { type: Boolean, default: !1 },
  teleport: { type: [String, Boolean, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  calendarClassName: { type: String, default: null },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: Boolean, default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: Boolean, default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 }
}, kt = {
  ...Ur,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  arrMapValues: { type: Object, default: () => ({}) },
  noOverlayFocus: { type: Boolean, default: !1 }
}, m0 = {
  key: 1,
  class: "dp__input_wrap"
}, v0 = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], f0 = {
  key: 2,
  class: "dp__clear_icon"
}, w0 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Ur
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, {
      defaultedTextInput: l,
      defaultedAriaLabels: n,
      defaultedInline: i,
      defaultedConfig: u,
      getDefaultPattern: p,
      getDefaultStartTime: h
    } = Qe(r), { checkMinMaxRange: d } = Jt(r), y = ee(), L = ee(null), V = ee(!1), Z = ee(!1), z = Q(
      () => ({
        dp__pointer: !r.disabled && !r.readonly && !l.value.enabled,
        dp__disabled: r.disabled,
        dp__input_readonly: !l.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !r.hideInputIcon,
        dp__input_valid: !!r.state,
        dp__input_invalid: r.state === !1,
        dp__input_focus: V.value || r.isMenuOpen,
        dp__input_reg: !l.value.enabled,
        [r.inputClassName]: !!r.inputClassName
      })
    ), $ = () => {
      s("set-input-date", null), r.autoApply && (s("set-empty-date"), y.value = null);
    }, x = (P) => {
      const f = h();
      return F2(
        P,
        l.value.format ?? p(),
        f ?? ms({}, r.enableSeconds),
        r.inputValue,
        Z.value
      );
    }, U = (P) => {
      const { rangeSeparator: f } = l.value, [_, H] = P.split(`${f}`);
      if (_) {
        const Y = x(_.trim()), m = H ? x(H.trim()) : null, o = Y && m ? [Y, m] : [Y];
        d(m, o, 0) && (y.value = Y ? o : null);
      }
    }, M = () => {
      Z.value = !0;
    }, R = (P) => {
      if (r.range)
        U(P);
      else if (r.multiDates) {
        const f = P.split(";");
        y.value = f.map((_) => x(_.trim())).filter((_) => _);
      } else
        y.value = x(P);
    }, E = (P) => {
      var f;
      const _ = typeof P == "string" ? P : (f = P.target) == null ? void 0 : f.value;
      _ !== "" ? (l.value.openMenu && !r.isMenuOpen && s("open"), R(_), s("set-input-date", y.value)) : $(), Z.value = !1, s("update:input-value", _);
    }, I = (P) => {
      l.value.enabled ? (R(P.target.value), l.value.enterSubmit && xa(y.value) && r.inputValue !== "" ? (s("set-input-date", y.value, !0), y.value = null) : l.value.enterSubmit && r.inputValue === "" && (y.value = null, s("clear"))) : w(P);
    }, ie = (P) => {
      l.value.enabled && l.value.tabSubmit && R(P.target.value), l.value.tabSubmit && xa(y.value) && r.inputValue !== "" ? (s("set-input-date", y.value, !0, !0), y.value = null) : l.value.tabSubmit && r.inputValue === "" && (y.value = null, s("clear", !0));
    }, K = () => {
      var P;
      V.value = !0, s("focus"), l.value.enabled && l.value.selectOnFocus && ((P = L.value) == null || P.select());
    }, w = (P) => {
      P.preventDefault(), It(P, u.value, !0), l.value.enabled && l.value.openMenu && !i.value.input && !r.isMenuOpen ? s("open") : l.value.enabled || s("toggle");
    }, D = () => {
      s("real-blur"), V.value = !1, (!r.isMenuOpen || i.value.enabled && i.value.input) && s("blur"), r.autoApply && l.value.enabled && y.value && !r.isMenuOpen && (s("set-input-date", y.value), s("select-date"), y.value = null);
    }, N = (P) => {
      It(P, u.value, !0), s("clear");
    }, G = (P) => {
      if (!l.value.enabled) {
        if (P.code === "Tab")
          return;
        P.preventDefault();
      }
    };
    return t({
      focusInput: () => {
        var P;
        (P = L.value) == null || P.focus({ preventScroll: !0 });
      },
      setParsedDate: (P) => {
        y.value = P;
      }
    }), (P, f) => {
      var _;
      return c(), k("div", { onClick: w }, [
        P.$slots.trigger && !P.$slots["dp-input"] && !g(i).enabled ? X(P.$slots, "trigger", { key: 0 }) : S("", !0),
        !P.$slots.trigger && (!g(i).enabled || g(i).input) ? (c(), k("div", m0, [
          P.$slots["dp-input"] && !P.$slots.trigger && !g(i).enabled ? X(P.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: E,
            onEnter: I,
            onTab: ie,
            onClear: N,
            onBlur: D,
            onKeypress: G,
            onPaste: M,
            openMenu: () => P.$emit("open"),
            closeMenu: () => P.$emit("close"),
            toggleMenu: () => P.$emit("toggle")
          }) : S("", !0),
          P.$slots["dp-input"] ? S("", !0) : (c(), k("input", {
            key: 1,
            id: P.uid ? `dp-input-${P.uid}` : void 0,
            ref_key: "inputRef",
            ref: L,
            name: P.name,
            class: ue(z.value),
            inputmode: g(l).enabled ? "text" : "none",
            placeholder: P.placeholder,
            disabled: P.disabled,
            readonly: P.readonly,
            required: P.required,
            value: e.inputValue,
            autocomplete: P.autocomplete,
            "aria-label": (_ = g(n)) == null ? void 0 : _.input,
            "aria-disabled": P.disabled || void 0,
            "aria-invalid": P.state === !1 ? !0 : void 0,
            onInput: E,
            onKeydown: [
              be(I, ["enter"]),
              be(ie, ["tab"]),
              G
            ],
            onBlur: D,
            onFocus: K,
            onKeypress: G,
            onPaste: M
          }, null, 42, v0)),
          O("div", {
            onClick: f[2] || (f[2] = (H) => s("toggle"))
          }, [
            P.$slots["input-icon"] && !P.hideInputIcon ? (c(), k("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: f[0] || (f[0] = (H) => s("toggle"))
            }, [
              X(P.$slots, "input-icon")
            ])) : S("", !0),
            !P.$slots["input-icon"] && !P.hideInputIcon && !P.$slots["dp-input"] ? (c(), ce(g(cr), {
              key: 1,
              class: "dp__input_icon dp__input_icons",
              onClick: f[1] || (f[1] = (H) => s("toggle"))
            })) : S("", !0)
          ]),
          P.$slots["clear-icon"] && e.inputValue && P.clearable && !P.disabled && !P.readonly ? (c(), k("span", f0, [
            X(P.$slots, "clear-icon", { clear: N })
          ])) : S("", !0),
          P.clearable && !P.$slots["clear-icon"] && e.inputValue && !P.disabled && !P.readonly ? (c(), ce(g(ss), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            onClick: f[3] || (f[3] = xe((H) => N(H), ["prevent"]))
          })) : S("", !0)
        ])) : S("", !0)
      ]);
    };
  }
}), g0 = ["title"], y0 = { class: "dp__action_buttons" }, k0 = ["disabled"], C0 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...kt
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: t }) {
    const a = t, s = e, {
      defaultedActionRow: r,
      defaultedPreviewFormat: l,
      defaultedMultiCalendars: n,
      defaultedTextInput: i,
      defaultedInline: u,
      getDefaultPattern: p
    } = Qe(s), { isValidTime: h } = Jt(s), { buildMatrix: d } = Et(), y = ee(null), L = ee(null);
    ot(() => {
      s.arrowNavigation && d([Xe(y), Xe(L)], "actionRow");
    });
    const V = Q(() => s.range && !s.partialRange && s.internalModelValue ? s.internalModelValue.length === 2 : !0), Z = Q(() => !z.value || !$.value || !V.value), z = Q(() => !s.enableTimePicker || s.ignoreTimeValidation ? !0 : h(s.internalModelValue)), $ = Q(() => s.monthPicker ? s.range && Array.isArray(s.internalModelValue) ? !s.internalModelValue.filter((w) => !ie(w)).length : ie(s.internalModelValue) : !0), x = () => {
      const w = l.value;
      return s.timePicker || s.monthPicker, w(Ge(s.internalModelValue));
    }, U = () => {
      const w = s.internalModelValue;
      return n.value.count > 0 ? `${M(w[0])} - ${M(w[1])}` : [M(w[0]), M(w[1])];
    }, M = (w) => fs(
      w,
      l.value,
      s.formatLocale,
      i.value.rangeSeparator,
      s.modelAuto,
      p()
    ), R = Q(() => !s.internalModelValue || !s.menuMount ? "" : typeof l.value == "string" ? Array.isArray(s.internalModelValue) ? s.internalModelValue.length === 2 && s.internalModelValue[1] ? U() : s.multiDates ? s.internalModelValue.map((w) => `${M(w)}`) : s.modelAuto ? `${M(s.internalModelValue[0])}` : `${M(s.internalModelValue[0])} -` : M(s.internalModelValue) : x()), E = () => s.multiDates ? "; " : " - ", I = Q(
      () => Array.isArray(R.value) ? R.value.join(E()) : R.value
    ), ie = (w) => {
      if (!s.monthPicker)
        return !0;
      let D = !0;
      const N = F(ft(w));
      if (s.minDate && s.maxDate) {
        const G = F(ft(s.minDate)), P = F(ft(s.maxDate));
        return at(N, G) && tt(N, P) || Be(N, G) || Be(N, P);
      }
      if (s.minDate) {
        const G = F(ft(s.minDate));
        D = at(N, G) || Be(N, G);
      }
      if (s.maxDate) {
        const G = F(ft(s.maxDate));
        D = tt(N, G) || Be(N, G);
      }
      return D;
    }, K = () => {
      z.value && $.value && V.value ? a("select-date") : a("invalid-select");
    };
    return (w, D) => (c(), k("div", {
      class: "dp__action_row",
      style: dt(e.calendarWidth ? { width: `${e.calendarWidth}px` } : {})
    }, [
      w.$slots["action-row"] ? X(w.$slots, "action-row", Ue(Ee({ key: 0 }, {
        internalModelValue: w.internalModelValue,
        disabled: Z.value,
        selectDate: () => w.$emit("select-date"),
        closePicker: () => w.$emit("close-picker")
      }))) : (c(), k(he, { key: 1 }, [
        g(r).showPreview ? (c(), k("div", {
          key: 0,
          class: "dp__selection_preview",
          title: I.value
        }, [
          w.$slots["action-preview"] ? X(w.$slots, "action-preview", {
            key: 0,
            value: w.internalModelValue
          }) : S("", !0),
          w.$slots["action-preview"] ? S("", !0) : (c(), k(he, { key: 1 }, [
            Je(me(I.value), 1)
          ], 64))
        ], 8, g0)) : S("", !0),
        O("div", y0, [
          w.$slots["action-buttons"] ? X(w.$slots, "action-buttons", {
            key: 0,
            value: w.internalModelValue
          }) : S("", !0),
          w.$slots["action-buttons"] ? S("", !0) : (c(), k(he, { key: 1 }, [
            !g(u).enabled && g(r).showCancel ? (c(), k("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: y,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: D[0] || (D[0] = (N) => w.$emit("close-picker")),
              onKeydown: [
                D[1] || (D[1] = be((N) => w.$emit("close-picker"), ["enter"])),
                D[2] || (D[2] = be((N) => w.$emit("close-picker"), ["space"]))
              ]
            }, me(w.cancelText), 545)) : S("", !0),
            g(r).showNow ? (c(), k("button", {
              key: 1,
              ref_key: "cancelButtonRef",
              ref: y,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: D[3] || (D[3] = (N) => w.$emit("select-now")),
              onKeydown: [
                D[4] || (D[4] = be((N) => w.$emit("select-now"), ["enter"])),
                D[5] || (D[5] = be((N) => w.$emit("select-now"), ["space"]))
              ]
            }, me(w.nowButtonLabel), 545)) : S("", !0),
            g(r).showSelect ? (c(), k("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: L,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: Z.value,
              onKeydown: [
                be(K, ["enter"]),
                be(K, ["space"])
              ],
              onClick: K
            }, me(w.selectText), 41, k0)) : S("", !0)
          ], 64))
        ])
      ], 64))
    ], 4));
  }
}), b0 = ["onKeydown"], L0 = { class: "dp__selection_grid_header" }, M0 = ["aria-selected", "aria-disabled", "onClick", "onKeydown", "onMouseover"], V0 = ["aria-label"], xr = /* @__PURE__ */ ke({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: t, emit: a }) {
    const { setSelectionGrid: s, buildMultiLevelMatrix: r, setMonthPicker: l } = Et(), n = a, i = e, { defaultedAriaLabels: u, defaultedTextInput: p, defaultedConfig: h } = Qe(
      i
    ), { hideNavigationButtons: d } = qr(), y = ee(!1), L = ee(null), V = ee(null), Z = ee([]), z = ee(), $ = ee(null), x = ee(0), U = ee(null);
    Ps(() => {
      L.value = null;
    }), ot(() => {
      Nt().then(() => D()), i.noOverlayFocus || R(), M(!0);
    }), Da(() => M(!1));
    const M = (m) => {
      var o;
      i.arrowNavigation && ((o = i.headerRefs) != null && o.length ? l(m) : s(m));
    }, R = () => {
      var m;
      const o = Xe(V);
      o && (p.value.enabled || (L.value ? (m = L.value) == null || m.focus({ preventScroll: !0 }) : o.focus({ preventScroll: !0 })), y.value = o.clientHeight < o.scrollHeight);
    }, E = Q(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !i.useRelative,
        "dp--overlay-relative": i.useRelative
      })
    ), I = Q(
      () => i.useRelative ? { height: `${i.height}px`, width: "260px" } : void 0
    ), ie = Q(() => ({
      dp__overlay_col: !0
    })), K = Q(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: y.value,
        dp__button_bottom: i.isLast
      })
    ), w = Q(() => {
      var m, o;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((m = i.items) == null ? void 0 : m.length) <= 6,
        dp__container_block: ((o = i.items) == null ? void 0 : o.length) > 6
      };
    });
    Ft(
      () => i.items,
      () => D(),
      { deep: !0 }
    );
    const D = () => {
      Nt().then(() => {
        const m = Xe(L), o = Xe(V), T = Xe($), B = Xe(U), W = T ? T.getBoundingClientRect().height : 0;
        o && (o.getBoundingClientRect().height ? x.value = o.getBoundingClientRect().height - W : x.value = h.value.modeHeight - W), m && B && (B.scrollTop = m.offsetTop - B.offsetTop - (x.value / 2 - m.getBoundingClientRect().height) - W);
      });
    }, N = (m) => {
      m.disabled || n("selected", m.value);
    }, G = () => {
      n("toggle"), n("reset-flow");
    }, P = () => {
      i.escClose && G();
    }, f = (m, o, T, B) => {
      m && ((o.active || o.value === i.focusValue) && (L.value = m), i.arrowNavigation && (Array.isArray(Z.value[T]) ? Z.value[T][B] = m : Z.value[T] = [m], _()));
    }, _ = () => {
      var m, o;
      const T = (m = i.headerRefs) != null && m.length ? [i.headerRefs].concat(Z.value) : Z.value.concat([i.skipButtonRef ? [] : [$.value]]);
      r(Ge(T), (o = i.headerRefs) != null && o.length ? "monthPicker" : "selectionGrid");
    }, H = (m) => {
      i.arrowNavigation || It(m, h.value, !0);
    }, Y = (m) => {
      z.value = m, n("hover-value", m);
    };
    return t({ focusGrid: R }), (m, o) => {
      var T;
      return c(), k("div", {
        ref_key: "gridWrapRef",
        ref: V,
        class: ue(E.value),
        style: dt(I.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: [
          be(xe(P, ["prevent"]), ["esc"]),
          o[0] || (o[0] = be(xe((B) => H(B), ["prevent"]), ["left"])),
          o[1] || (o[1] = be(xe((B) => H(B), ["prevent"]), ["up"])),
          o[2] || (o[2] = be(xe((B) => H(B), ["prevent"]), ["down"])),
          o[3] || (o[3] = be(xe((B) => H(B), ["prevent"]), ["right"]))
        ]
      }, [
        O("div", {
          ref_key: "containerRef",
          ref: U,
          class: ue(w.value),
          role: "grid",
          style: dt({ height: `${x.value}px` })
        }, [
          O("div", L0, [
            X(m.$slots, "header")
          ]),
          m.$slots.overlay ? X(m.$slots, "overlay", { key: 0 }) : (c(!0), k(he, { key: 1 }, Pe(m.items, (B, W) => (c(), k("div", {
            key: W,
            class: ue(["dp__overlay_row", { dp__flex_row: m.items.length >= 3 }]),
            role: "row"
          }, [
            (c(!0), k(he, null, Pe(B, (q, b) => (c(), k("div", {
              key: q.value,
              ref_for: !0,
              ref: (v) => f(v, q, W, b),
              role: "gridcell",
              class: ue(ie.value),
              "aria-selected": q.active,
              "aria-disabled": q.disabled || void 0,
              tabindex: "0",
              onClick: (v) => N(q),
              onKeydown: [
                be(xe((v) => N(q), ["prevent"]), ["enter"]),
                be(xe((v) => N(q), ["prevent"]), ["space"])
              ],
              onMouseover: (v) => Y(q.value)
            }, [
              O("div", {
                class: ue(q.className)
              }, [
                m.$slots.item ? X(m.$slots, "item", {
                  key: 0,
                  item: q
                }) : S("", !0),
                m.$slots.item ? S("", !0) : (c(), k(he, { key: 1 }, [
                  Je(me(q.text), 1)
                ], 64))
              ], 2)
            ], 42, M0))), 128))
          ], 2))), 128))
        ], 6),
        m.$slots["button-icon"] ? At((c(), k("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: $,
          type: "button",
          "aria-label": (T = g(u)) == null ? void 0 : T.toggleOverlay,
          class: ue(K.value),
          tabindex: "0",
          onClick: G,
          onKeydown: [
            be(G, ["enter"]),
            be(G, ["tab"])
          ]
        }, [
          X(m.$slots, "button-icon")
        ], 42, V0)), [
          [Pr, !g(d)(m.hideNavigation, m.type)]
        ]) : S("", !0)
      ], 46, b0);
    };
  }
}), Kr = /* @__PURE__ */ ke({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean }
  },
  setup(e) {
    const t = e, a = Q(
      () => t.multiCalendars > 0 ? [...Array(t.multiCalendars).keys()] : [0]
    ), s = Q(() => ({
      dp__instance_calendar: t.multiCalendars > 0
    }));
    return (r, l) => (c(), k("div", {
      class: ue({
        dp__menu_inner: !r.stretch,
        "dp--menu--inner-stretched": r.stretch,
        dp__flex_display: r.multiCalendars > 0
      })
    }, [
      (c(!0), k(he, null, Pe(a.value, (n, i) => (c(), k("div", {
        key: n,
        class: ue(s.value)
      }, [
        X(r.$slots, "default", {
          instance: n,
          index: i
        })
      ], 2))), 128))
    ], 2));
  }
}), x0 = ["aria-label", "aria-disabled"], gr = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const a = t, s = ee(null);
    return ot(() => a("set-ref", s)), (r, l) => (c(), k("button", {
      ref_key: "elRef",
      ref: s,
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": r.ariaLabel,
      "aria-disabled": r.disabled || void 0,
      onClick: l[0] || (l[0] = (n) => r.$emit("activate")),
      onKeydown: [
        l[1] || (l[1] = be(xe((n) => r.$emit("activate"), ["prevent"]), ["enter"])),
        l[2] || (l[2] = be(xe((n) => r.$emit("activate"), ["prevent"]), ["space"]))
      ]
    }, [
      O("span", {
        class: ue(["dp__inner_nav", { dp__inner_nav_disabled: r.disabled }])
      }, [
        X(r.$slots, "default")
      ], 2)
    ], 40, x0));
  }
}), D0 = { class: "dp--year-mode-picker" }, H0 = ["aria-label"], ys = /* @__PURE__ */ ke({
  __name: "YearModePicker",
  props: {
    ...kt,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: t }) {
    const a = t, s = e, { showRightIcon: r, showLeftIcon: l } = qr(), { defaultedConfig: n, defaultedMultiCalendars: i, defaultedAriaLabels: u, defaultedTransitions: p } = Qe(s), { showTransition: h, transitionName: d } = Mr(p), y = (Z = !1, z) => {
      a("toggle-year-picker", { flow: Z, show: z });
    }, L = (Z) => {
      a("year-select", Z);
    }, V = (Z = !1) => {
      a("handle-year", Z);
    };
    return (Z, z) => {
      var $, x, U;
      return c(), k("div", D0, [
        g(l)(g(i), e.instance) ? (c(), ce(gr, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": ($ = g(u)) == null ? void 0 : $.prevYear,
          disabled: e.isDisabled(!1),
          onActivate: z[0] || (z[0] = (M) => V(!1))
        }, {
          default: ve(() => [
            Z.$slots["arrow-left"] ? X(Z.$slots, "arrow-left", { key: 0 }) : S("", !0),
            Z.$slots["arrow-left"] ? S("", !0) : (c(), ce(g(Aa), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled"])) : S("", !0),
        O("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": (x = g(u)) == null ? void 0 : x.openYearsOverlay,
          onClick: z[1] || (z[1] = () => y(!1)),
          onKeydown: z[2] || (z[2] = be(() => y(!1), ["enter"]))
        }, [
          Z.$slots.year ? X(Z.$slots, "year", {
            key: 0,
            year: e.year
          }) : S("", !0),
          Z.$slots.year ? S("", !0) : (c(), k(he, { key: 1 }, [
            Je(me(e.year), 1)
          ], 64))
        ], 40, H0),
        g(r)(g(i), e.instance) ? (c(), ce(gr, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": (U = g(u)) == null ? void 0 : U.nextYear,
          disabled: e.isDisabled(!0),
          onActivate: z[3] || (z[3] = (M) => V(!0))
        }, {
          default: ve(() => [
            Z.$slots["arrow-right"] ? X(Z.$slots, "arrow-right", { key: 0 }) : S("", !0),
            Z.$slots["arrow-right"] ? S("", !0) : (c(), ce(g(Ra), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled"])) : S("", !0),
        He(dr, {
          name: g(d)(e.showYearPicker),
          css: g(h)
        }, {
          default: ve(() => [
            e.showYearPicker ? (c(), ce(xr, {
              key: 0,
              items: e.items,
              "text-input": Z.textInput,
              "esc-close": Z.escClose,
              config: Z.config,
              "is-last": Z.autoApply && !g(n).keepActionRow,
              "hide-navigation": Z.hideNavigation,
              type: "year",
              onToggle: y,
              onSelected: z[4] || (z[4] = (M) => L(M))
            }, it({
              "button-icon": ve(() => [
                Z.$slots["calendar-icon"] ? X(Z.$slots, "calendar-icon", { key: 0 }) : S("", !0),
                Z.$slots["calendar-icon"] ? S("", !0) : (c(), ce(g(cr), { key: 1 }))
              ]),
              _: 2
            }, [
              Z.$slots["year-overlay-value"] ? {
                name: "item",
                fn: ve(({ item: M }) => [
                  X(Z.$slots, "year-overlay-value", {
                    text: M.text,
                    value: M.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation"])) : S("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), Ka = (e, t, a) => {
  if (t.value && Array.isArray(t.value))
    if (t.value.some((s) => Be(e, s))) {
      const s = t.value.filter((r) => !Be(r, e));
      t.value = s.length ? s : null;
    } else
      (a && +a > t.value.length || !a) && t.value.push(e);
  else
    t.value = [e];
}, Wa = (e, t, a) => {
  let s = e.value ? e.value.slice() : [];
  return s.length === 2 && s[1] !== null && (s = []), s.length ? tt(t, s[0]) ? (s.unshift(t), a("range-start", s[0]), a("range-start", s[1])) : (s[1] = t, a("range-end", t)) : (s = [t], a("range-start", t)), e.value = s, s;
}, Wr = (e, t, a, s) => {
  e[0] && e[1] && a && t("auto-apply"), e[0] && !e[1] && s && a && t("auto-apply");
}, ks = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t) => yt(F(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = yt(F(e.value), e.timezone));
}, Cs = ({
  multiCalendars: e,
  highlight: t,
  calendars: a,
  modelValue: s,
  props: r,
  year: l,
  month: n,
  emit: i
}) => {
  const u = Q(() => qa(r.yearRange, r.reverseYears)), p = ee([!1]), h = Q(() => (M, R) => {
    const E = Fe(ft(/* @__PURE__ */ new Date()), {
      month: n.value(M),
      year: l.value(M)
    });
    return vs(E, r.maxDate, r.minDate, r.preventMinMaxNavigation, R);
  }), d = () => {
    for (let M = 0; M < e.value.count; M++)
      if (M === 0)
        a.value[M] = a.value[0];
      else {
        const R = Fe(F(), a.value[M - 1]);
        a.value[M] = { month: Se(R), year: Ve(Ta(R, 1)) };
      }
  }, y = (M) => {
    if (!M)
      return d();
    const R = Fe(F(), a.value[M]);
    return a.value[0].year = Ve(as(R, e.value.count - 1)), d();
  }, L = (M) => r.focusStartDate ? M[0] : M[1] ? M[1] : M[0], V = () => {
    if (s.value) {
      const M = Array.isArray(s.value) ? L(s.value) : s.value;
      a.value[0] = { month: Se(M), year: Ve(M) };
    }
  };
  ot(() => {
    V(), e.value.count && d();
  });
  const Z = (M, R) => {
    a.value[R].year = M, e.value.count && !e.value.solo && y(R);
  }, z = Q(() => (M) => or(u.value, (R) => {
    const E = l.value(M) === R.value, I = br(R.value, ur(r.minDate), ur(r.maxDate)), ie = Ua(t.value, R.value);
    return { active: E, disabled: I, highlighted: ie };
  })), $ = (M, R) => {
    Z(M, R), U(R);
  }, x = (M, R = !1) => {
    if (!h.value(M, R)) {
      const E = R ? l.value(M) + 1 : l.value(M) - 1;
      Z(E, M);
    }
  }, U = (M, R = !1, E) => {
    R || i("reset-flow"), E !== void 0 ? p.value[M] = E : p.value[M] = !p.value[M], p.value || i("overlay-closed");
  };
  return {
    isDisabled: h,
    groupedYears: z,
    showYearPicker: p,
    selectYear: Z,
    toggleYearPicker: U,
    handleYearSelect: $,
    handleYear: x
  };
}, T0 = (e, t) => {
  const { defaultedMultiCalendars: a, defaultedAriaLabels: s, defaultedTransitions: r, defaultedConfig: l, defaultedHighlight: n } = Qe(e), { modelValue: i, year: u, month: p, calendars: h } = Vr(e, t), d = Q(() => os(e.formatLocale, e.locale, e.monthNameFormat)), y = ee(null), {
    selectYear: L,
    groupedYears: V,
    showYearPicker: Z,
    toggleYearPicker: z,
    handleYearSelect: $,
    handleYear: x,
    isDisabled: U
  } = Cs({
    modelValue: i,
    multiCalendars: a,
    highlight: n,
    calendars: h,
    year: u,
    month: p,
    props: e,
    emit: t
  });
  ot(() => {
    e.startDate && (i.value && e.focusStartDate || !i.value) && L(Ve(F(e.startDate)), 0);
  });
  const M = (H) => H ? { month: Se(H), year: Ve(H) } : { month: null, year: null }, R = () => i.value ? Array.isArray(i.value) ? i.value.map((H) => M(H)) : M(i.value) : M(), E = (H, Y) => {
    const m = h.value[H], o = R();
    return Array.isArray(o) ? o.some((T) => T.year === (m == null ? void 0 : m.year) && T.month === Y) : (m == null ? void 0 : m.year) === o.year && Y === o.month;
  }, I = (H, Y, m) => {
    var o, T;
    const B = R();
    return Array.isArray(B) ? u.value(Y) === ((o = B[m]) == null ? void 0 : o.year) && H === ((T = B[m]) == null ? void 0 : T.month) : !1;
  }, ie = (H, Y) => {
    if (e.range) {
      const m = R();
      if (Array.isArray(i.value) && Array.isArray(m)) {
        const o = I(H, Y, 0) || I(H, Y, 1), T = $t(ft(F()), H, u.value(Y));
        return zr(i.value, y.value, T) && !o;
      }
      return !1;
    }
    return !1;
  }, K = Q(() => (H) => or(d.value, (Y) => {
    const m = E(H, Y.value), o = br(
      Y.value,
      ds(u.value(H), e.minDate),
      cs(u.value(H), e.maxDate)
    ) || j2(e.disabledDates, u.value(H)).includes(Y.value), T = ie(Y.value, H), B = ws(n.value, Y.value, u.value(H));
    return { active: m, disabled: o, isBetween: T, highlighted: B };
  })), w = (H, Y) => $t(ft(F()), H, u.value(Y)), D = (H, Y) => {
    const m = i.value ? i.value : ft(/* @__PURE__ */ new Date());
    i.value = $t(m, H, u.value(Y)), t("auto-apply");
  }, N = (H, Y) => {
    const m = Wa(i, w(H, Y), t);
    Wr(m, t, e.autoApply, e.modelAuto);
  }, G = (H, Y) => {
    Ka(w(H, Y), i, e.multiDatesLimit), t("auto-apply", !0);
  }, P = (H, Y) => (h.value[Y].month = H, _(Y, h.value[Y].year, H), e.multiDates ? G(H, Y) : e.range ? N(H, Y) : D(H, Y)), f = (H, Y) => {
    L(H, Y), _(Y, H, null);
  }, _ = (H, Y, m) => {
    let o = m;
    if (!o && o !== 0) {
      const T = R();
      o = Array.isArray(T) ? T[H].month : T.month;
    }
    t("update-month-year", { instance: H, year: Y, month: o });
  };
  return {
    groupedMonths: K,
    groupedYears: V,
    year: u,
    isDisabled: U,
    defaultedMultiCalendars: a,
    defaultedAriaLabels: s,
    defaultedTransitions: r,
    defaultedConfig: l,
    showYearPicker: Z,
    modelValue: i,
    presetDate: (H, Y) => {
      ks({ value: H, modelValue: i, range: e.range, timezone: Y ? void 0 : e.timezone }), t("auto-apply");
    },
    setHoverDate: (H, Y) => {
      y.value = w(H, Y);
    },
    selectMonth: P,
    selectYear: f,
    toggleYearPicker: z,
    handleYearSelect: $,
    handleYear: x,
    getModelMonthYear: R
  };
}, $0 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...kt
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "mount"
  ],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = Qt(), l = ct(r, "yearMode"), n = e;
    ot(() => {
      n.shadow || s("mount", null);
    });
    const {
      groupedMonths: i,
      groupedYears: u,
      year: p,
      isDisabled: h,
      defaultedMultiCalendars: d,
      defaultedConfig: y,
      showYearPicker: L,
      modelValue: V,
      presetDate: Z,
      setHoverDate: z,
      selectMonth: $,
      selectYear: x,
      toggleYearPicker: U,
      handleYearSelect: M,
      handleYear: R,
      getModelMonthYear: E
    } = T0(n, s);
    return t({ getSidebarProps: () => ({
      modelValue: V,
      year: p,
      getModelMonthYear: E,
      selectMonth: $,
      selectYear: x,
      handleYear: R
    }), presetDate: Z, toggleYearPicker: (I) => U(0, I) }), (I, ie) => (c(), ce(Kr, {
      "multi-calendars": g(d).count,
      stretch: ""
    }, {
      default: ve(({ instance: K }) => [
        I.$slots["month-year"] ? X(I.$slots, "month-year", Ue(Ee({ key: 0 }, {
          year: g(p),
          months: g(i)(K),
          years: g(u)(K),
          selectMonth: g($),
          selectYear: g(x),
          instance: K
        }))) : (c(), ce(xr, {
          key: 1,
          items: g(i)(K),
          "arrow-navigation": I.arrowNavigation,
          "is-last": I.autoApply && !g(y).keepActionRow,
          "esc-close": I.escClose,
          height: g(y).modeHeight,
          config: I.config,
          "no-overlay-focus": !!(I.noOverlayFocus || I.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (w) => g($)(w, K),
          onHoverValue: (w) => g(z)(w, K)
        }, {
          header: ve(() => [
            He(ys, Ee(I.$props, {
              items: g(u)(K),
              instance: K,
              "show-year-picker": g(L)[K],
              year: g(p)(K),
              "is-disabled": (w) => g(h)(K, w),
              onHandleYear: (w) => g(R)(K, w),
              onYearSelect: (w) => g(M)(w, K),
              onToggleYearPicker: (w) => g(U)(K, w == null ? void 0 : w.flow, w == null ? void 0 : w.show)
            }), it({ _: 2 }, [
              Pe(g(l), (w, D) => ({
                name: w,
                fn: ve((N) => [
                  X(I.$slots, w, Ue(rt(N)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars"]));
  }
}), S0 = (e, t) => {
  const { modelValue: a } = Vr(e, t), s = ee(null), { defaultedHighlight: r, defaultedFilters: l } = Qe(e), n = ee();
  ot(() => {
    e.startDate && (a.value && e.focusStartDate || !a.value) && (n.value = Ve(F(e.startDate)));
  });
  const i = (d) => Array.isArray(a.value) ? a.value.some((y) => Ve(y) === d) : a.value ? Ve(a.value) === d : !1, u = (d) => e.range && Array.isArray(a.value) ? zr(a.value, s.value, h(d)) : !1, p = Q(() => or(qa(e.yearRange, e.reverseYears), (d) => {
    const y = i(d.value), L = br(d.value, ur(e.minDate), ur(e.maxDate)) || l.value.years.includes(d.value), V = u(d.value) && !y, Z = Ua(r.value, d.value);
    return { active: y, disabled: L, isBetween: V, highlighted: Z };
  })), h = (d) => Vt(ft(/* @__PURE__ */ new Date()), d);
  return {
    groupedYears: p,
    modelValue: a,
    focusYear: n,
    setHoverValue: (d) => {
      s.value = Vt(ft(/* @__PURE__ */ new Date()), d);
    },
    selectYear: (d) => {
      var y;
      if (e.multiDates)
        return a.value ? Array.isArray(a.value) && (((y = a.value) == null ? void 0 : y.map((L) => Ve(L))).includes(d) ? a.value = a.value.filter((L) => Ve(L) !== d) : a.value.push(Vt(st(F()), d))) : a.value = [Vt(st(F()), d)], t("auto-apply", !0);
      if (e.range) {
        const L = Wa(a, h(d), t);
        return Wr(L, t, e.autoApply, e.modelAuto);
      }
      a.value = h(d), t("auto-apply");
    }
  };
}, _0 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...kt
  },
  emits: ["update:internal-model-value", "reset-flow", "range-start", "range-end", "auto-apply"],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, { groupedYears: l, modelValue: n, focusYear: i, selectYear: u, setHoverValue: p } = S0(r, s), { defaultedConfig: h } = Qe(r);
    return t({ getSidebarProps: () => ({
      modelValue: n,
      selectYear: u
    }) }), (d, y) => (c(), k("div", null, [
      d.$slots["month-year"] ? X(d.$slots, "month-year", Ue(Ee({ key: 0 }, {
        years: g(l),
        selectYear: g(u)
      }))) : (c(), ce(xr, {
        key: 1,
        items: g(l),
        "is-last": d.autoApply && !g(h).keepActionRow,
        height: g(h).modeHeight,
        config: d.config,
        "no-overlay-focus": !!(d.noOverlayFocus || d.textInput),
        "focus-value": g(i),
        type: "year",
        "use-relative": "",
        onSelected: g(u),
        onHoverValue: g(p)
      }, it({ _: 2 }, [
        d.$slots["year-overlay-value"] ? {
          name: "item",
          fn: ve(({ item: L }) => [
            X(d.$slots, "year-overlay-value", {
              text: L.text,
              value: L.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), O0 = {
  key: 0,
  class: "dp__time_input"
}, P0 = ["aria-label", "onKeydown", "onClick"], B0 = /* @__PURE__ */ O("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), Z0 = /* @__PURE__ */ O("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), A0 = ["aria-label", "disabled", "onKeydown", "onClick"], R0 = ["aria-label", "onKeydown", "onClick"], I0 = /* @__PURE__ */ O("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), Y0 = /* @__PURE__ */ O("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), N0 = { key: 0 }, F0 = ["aria-label", "onKeydown"], E0 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...kt
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, { setTimePickerElements: l, setTimePickerBackRef: n } = Et(), { defaultedAriaLabels: i, defaultedTransitions: u, defaultedFilters: p, defaultedConfig: h } = Qe(r), { transitionName: d, showTransition: y } = Mr(u), L = Lr({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), V = ee("AM"), Z = ee(null), z = ee([]);
    ot(() => {
      s("mounted");
    });
    const $ = (v) => Fe(/* @__PURE__ */ new Date(), {
      hours: v.hours,
      minutes: v.minutes,
      seconds: r.enableSeconds ? v.seconds : 0,
      milliseconds: 0
    }), x = Q(
      () => (v) => P(v, r[v]) || M(v, r[v])
    ), U = Q(() => ({ hours: r.hours, minutes: r.minutes, seconds: r.seconds })), M = (v, oe) => r.range && !r.disableTimeRangeValidation ? !r.validateTime(v, oe) : !1, R = (v, oe) => {
      if (r.range && !r.disableTimeRangeValidation) {
        const ye = oe ? +r[`${v}Increment`] : -+r[`${v}Increment`], re = r[v] + ye;
        return !r.validateTime(v, re);
      }
      return !1;
    }, E = Q(() => (v) => !_(+r[v] + +r[`${v}Increment`], v) || R(v, !0)), I = Q(() => (v) => !_(+r[v] - +r[`${v}Increment`], v) || R(v, !1)), ie = (v, oe) => Z1(Fe(F(), v), oe), K = (v, oe) => l2(Fe(F(), v), oe), w = Q(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !r.timePickerInline,
        dp__time_col_reg_block: !r.enableSeconds && r.is24 && !r.timePickerInline,
        dp__time_col_reg_inline: !r.enableSeconds && r.is24 && r.timePickerInline,
        dp__time_col_reg_with_button: !r.enableSeconds && !r.is24,
        dp__time_col_sec: r.enableSeconds && r.is24,
        dp__time_col_sec_with_button: r.enableSeconds && !r.is24
      })
    ), D = Q(() => {
      const v = [{ type: "hours" }, { type: "", separator: !0 }, { type: "minutes" }];
      return r.enableSeconds ? v.concat([{ type: "", separator: !0 }, { type: "seconds" }]) : v;
    }), N = Q(() => D.value.filter((v) => !v.separator)), G = Q(() => (v) => {
      if (v === "hours") {
        const oe = T(+r.hours);
        return { text: oe < 10 ? `0${oe}` : `${oe}`, value: oe };
      }
      return { text: r[v] < 10 ? `0${r[v]}` : `${r[v]}`, value: r[v] };
    }), P = (v, oe) => {
      var ye;
      if (!r.disabledTimesConfig)
        return !1;
      const re = r.disabledTimesConfig(r.order, v === "hours" ? oe : void 0);
      return re[v] ? !!((ye = re[v]) != null && ye.includes(oe)) : !0;
    }, f = (v) => {
      const oe = r.is24 ? 24 : 12, ye = v === "hours" ? oe : 60, re = +r[`${v}GridIncrement`], Me = v === "hours" && !r.is24 ? re : 0, de = [];
      for (let A = Me; A < ye; A += re)
        de.push({ value: A, text: A < 10 ? `0${A}` : `${A}` });
      return v === "hours" && !r.is24 && de.push({ value: 0, text: "12" }), or(de, (A) => ({ active: !1, disabled: p.value.times[v].includes(A.value) || !_(A.value, v) || P(v, A.value) || M(v, A.value) }));
    }, _ = (v, oe) => {
      const ye = r.minTime ? $(ia(r.minTime)) : null, re = r.maxTime ? $(ia(r.maxTime)) : null, Me = $(ia(U.value, oe, v));
      return ye && re ? (Cr(Me, re) || sr(Me, re)) && (kr(Me, ye) || sr(Me, ye)) : ye ? kr(Me, ye) || sr(Me, ye) : re ? Cr(Me, re) || sr(Me, re) : !0;
    }, H = (v) => r[`no${v[0].toUpperCase() + v.slice(1)}Overlay`], Y = (v) => {
      H(v) || (L[v] = !L[v], L[v] || s("overlay-closed"));
    }, m = (v) => v === "hours" ? gt : v === "minutes" ? xt : lr, o = (v, oe = !0) => {
      const ye = oe ? ie : K, re = oe ? +r[`${v}Increment`] : -+r[`${v}Increment`];
      _(+r[v] + re, v) && s(
        `update:${v}`,
        m(v)(ye({ [v]: +r[v] }, { [v]: +r[`${v}Increment`] }))
      );
    }, T = (v) => r.is24 ? v : (v >= 12 ? V.value = "PM" : V.value = "AM", B2(v)), B = () => {
      V.value === "PM" ? (V.value = "AM", s("update:hours", r.hours - 12)) : (V.value = "PM", s("update:hours", r.hours + 12)), s("am-pm-change", V.value);
    }, W = (v) => {
      L[v] = !0;
    }, q = (v, oe, ye) => {
      if (v && r.arrowNavigation) {
        Array.isArray(z.value[oe]) ? z.value[oe][ye] = v : z.value[oe] = [v];
        const re = z.value.reduce(
          (Me, de) => de.map((A, J) => [...Me[J] || [], de[J]]),
          []
        );
        n(r.closeTimePickerBtn), Z.value && (re[1] = re[1].concat(Z.value)), l(re, r.order);
      }
    }, b = (v, oe) => (Y(v), v === "hours" && !r.is24 ? s(`update:${v}`, V.value === "PM" ? oe + 12 : oe) : s(`update:${v}`, oe));
    return t({ openChildCmp: W }), (v, oe) => {
      var ye;
      return v.disabled ? S("", !0) : (c(), k("div", O0, [
        (c(!0), k(he, null, Pe(D.value, (re, Me) => {
          var de, A, J;
          return c(), k("div", {
            key: Me,
            class: ue(w.value)
          }, [
            re.separator ? (c(), k(he, { key: 0 }, [
              Je(" : ")
            ], 64)) : (c(), k(he, { key: 1 }, [
              O("button", {
                ref_for: !0,
                ref: (Le) => q(Le, Me, 0),
                type: "button",
                class: ue({
                  dp__btn: !0,
                  dp__inc_dec_button: !v.timePickerInline,
                  dp__inc_dec_button_inline: v.timePickerInline,
                  dp__tp_inline_btn_top: v.timePickerInline,
                  dp__inc_dec_button_disabled: E.value(re.type)
                }),
                "aria-label": (de = g(i)) == null ? void 0 : de.incrementValue(re.type),
                tabindex: "0",
                onKeydown: [
                  be(xe((Le) => o(re.type), ["prevent"]), ["enter"]),
                  be(xe((Le) => o(re.type), ["prevent"]), ["space"])
                ],
                onClick: (Le) => o(re.type)
              }, [
                r.timePickerInline ? (c(), k(he, { key: 1 }, [
                  B0,
                  Z0
                ], 64)) : (c(), k(he, { key: 0 }, [
                  v.$slots["arrow-up"] ? X(v.$slots, "arrow-up", { key: 0 }) : S("", !0),
                  v.$slots["arrow-up"] ? S("", !0) : (c(), ce(g(Ya), { key: 1 }))
                ], 64))
              ], 42, P0),
              O("button", {
                ref_for: !0,
                ref: (Le) => q(Le, Me, 1),
                type: "button",
                "aria-label": (A = g(i)) == null ? void 0 : A.openTpOverlay(re.type),
                class: ue({
                  dp__time_display: !0,
                  dp__time_display_block: !v.timePickerInline,
                  dp__time_display_inline: v.timePickerInline,
                  "dp--time-invalid": x.value(re.type),
                  "dp--time-overlay-btn": !x.value(re.type)
                }),
                disabled: H(re.type),
                tabindex: "0",
                onKeydown: [
                  be(xe((Le) => Y(re.type), ["prevent"]), ["enter"]),
                  be(xe((Le) => Y(re.type), ["prevent"]), ["space"])
                ],
                onClick: (Le) => Y(re.type)
              }, [
                v.$slots[re.type] ? X(v.$slots, re.type, {
                  key: 0,
                  text: G.value(re.type).text,
                  value: G.value(re.type).value
                }) : S("", !0),
                v.$slots[re.type] ? S("", !0) : (c(), k(he, { key: 1 }, [
                  Je(me(G.value(re.type).text), 1)
                ], 64))
              ], 42, A0),
              O("button", {
                ref_for: !0,
                ref: (Le) => q(Le, Me, 2),
                type: "button",
                class: ue({
                  dp__btn: !0,
                  dp__inc_dec_button: !v.timePickerInline,
                  dp__inc_dec_button_inline: v.timePickerInline,
                  dp__tp_inline_btn_bottom: v.timePickerInline,
                  dp__inc_dec_button_disabled: I.value(re.type)
                }),
                "aria-label": (J = g(i)) == null ? void 0 : J.decrementValue(re.type),
                tabindex: "0",
                onKeydown: [
                  be(xe((Le) => o(re.type, !1), ["prevent"]), ["enter"]),
                  be(xe((Le) => o(re.type, !1), ["prevent"]), ["space"])
                ],
                onClick: (Le) => o(re.type, !1)
              }, [
                r.timePickerInline ? (c(), k(he, { key: 1 }, [
                  I0,
                  Y0
                ], 64)) : (c(), k(he, { key: 0 }, [
                  v.$slots["arrow-down"] ? X(v.$slots, "arrow-down", { key: 0 }) : S("", !0),
                  v.$slots["arrow-down"] ? S("", !0) : (c(), ce(g(Na), { key: 1 }))
                ], 64))
              ], 42, R0)
            ], 64))
          ], 2);
        }), 128)),
        v.is24 ? S("", !0) : (c(), k("div", N0, [
          v.$slots["am-pm-button"] ? X(v.$slots, "am-pm-button", {
            key: 0,
            toggle: B,
            value: V.value
          }) : S("", !0),
          v.$slots["am-pm-button"] ? S("", !0) : (c(), k("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: Z,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (ye = g(i)) == null ? void 0 : ye.amPmButton,
            tabindex: "0",
            onClick: B,
            onKeydown: [
              be(xe(B, ["prevent"]), ["enter"]),
              be(xe(B, ["prevent"]), ["space"])
            ]
          }, me(V.value), 41, F0))
        ])),
        (c(!0), k(he, null, Pe(N.value, (re, Me) => (c(), ce(dr, {
          key: Me,
          name: g(d)(L[re.type]),
          css: g(y)
        }, {
          default: ve(() => [
            L[re.type] ? (c(), ce(xr, {
              key: 0,
              items: f(re.type),
              "is-last": v.autoApply && !g(h).keepActionRow,
              "esc-close": v.escClose,
              type: re.type,
              "text-input": v.textInput,
              config: v.config,
              "arrow-navigation": v.arrowNavigation,
              onSelected: (de) => b(re.type, de),
              onToggle: (de) => Y(re.type),
              onResetFlow: oe[0] || (oe[0] = (de) => v.$emit("reset-flow"))
            }, it({
              "button-icon": ve(() => [
                v.$slots["clock-icon"] ? X(v.$slots, "clock-icon", { key: 0 }) : S("", !0),
                v.$slots["clock-icon"] ? S("", !0) : (c(), ce(Xt(v.timePickerInline ? g(cr) : g(Ia)), { key: 1 }))
              ]),
              _: 2
            }, [
              v.$slots[`${re.type}-overlay-value`] ? {
                name: "item",
                fn: ve(({ item: de }) => [
                  X(v.$slots, `${re.type}-overlay-value`, {
                    text: de.text,
                    value: de.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "onSelected", "onToggle"])) : S("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), z0 = { class: "dp--tp-wrap" }, q0 = ["aria-label", "tabindex"], U0 = ["tabindex"], K0 = ["aria-label"], bs = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...kt
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, { buildMatrix: l, setTimePicker: n } = Et(), i = Qt(), { defaultedTransitions: u, defaultedAriaLabels: p, defaultedTextInput: h, defaultedConfig: d } = Qe(r), { transitionName: y, showTransition: L } = Mr(u), { hideNavigationButtons: V } = qr(), Z = ee(null), z = ee(null), $ = ee([]), x = ee(null);
    ot(() => {
      s("mount"), !r.timePicker && r.arrowNavigation ? l([Xe(Z.value)], "time") : n(!0, r.timePicker);
    });
    const U = Q(() => r.range && r.modelAuto ? us(r.internalModelValue) : !0), M = ee(!1), R = (f) => ({
      hours: Array.isArray(r.hours) ? r.hours[f] : r.hours,
      minutes: Array.isArray(r.minutes) ? r.minutes[f] : r.minutes,
      seconds: Array.isArray(r.seconds) ? r.seconds[f] : r.seconds
    }), E = Q(() => {
      const f = [];
      if (r.range)
        for (let _ = 0; _ < 2; _++)
          f.push(R(_));
      else
        f.push(R(0));
      return f;
    }), I = (f, _ = !1, H = "") => {
      _ || s("reset-flow"), M.value = f, s(f ? "overlay-opened" : "overlay-closed"), r.arrowNavigation && n(f), Nt(() => {
        H !== "" && $.value[0] && $.value[0].openChildCmp(H);
      });
    }, ie = Q(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: r.autoApply && !d.value.keepActionRow
    })), K = ct(i, "timePicker"), w = (f, _, H) => r.range ? _ === 0 ? [f, E.value[1][H]] : [E.value[0][H], f] : f, D = (f) => {
      s("update:hours", f);
    }, N = (f) => {
      s("update:minutes", f);
    }, G = (f) => {
      s("update:seconds", f);
    }, P = () => {
      if (x.value && !h.value.enabled && !r.noOverlayFocus) {
        const f = A2(x.value);
        f && f.focus({ preventScroll: !0 });
      }
    };
    return t({ toggleTimePicker: I }), (f, _) => {
      var H;
      return c(), k("div", z0, [
        !f.timePicker && !f.timePickerInline ? At((c(), k("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: Z,
          type: "button",
          class: ue(ie.value),
          "aria-label": (H = g(p)) == null ? void 0 : H.openTimePicker,
          tabindex: f.noOverlayFocus ? void 0 : 0,
          onKeydown: [
            _[0] || (_[0] = be((Y) => I(!0), ["enter"])),
            _[1] || (_[1] = be((Y) => I(!0), ["space"]))
          ],
          onClick: _[2] || (_[2] = (Y) => I(!0))
        }, [
          f.$slots["clock-icon"] ? X(f.$slots, "clock-icon", { key: 0 }) : S("", !0),
          f.$slots["clock-icon"] ? S("", !0) : (c(), ce(g(Ia), { key: 1 }))
        ], 42, q0)), [
          [Pr, !g(V)(f.hideNavigation, "time")]
        ]) : S("", !0),
        He(dr, {
          name: g(y)(M.value),
          css: g(L) && !f.timePickerInline
        }, {
          default: ve(() => {
            var Y;
            return [
              M.value || f.timePicker || f.timePickerInline ? (c(), k("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: x,
                class: ue({
                  dp__overlay: !f.timePickerInline,
                  "dp--overlay-absolute": !r.timePicker && !f.timePickerInline,
                  "dp--overlay-relative": r.timePicker
                }),
                style: dt(f.timePicker ? { height: `${g(d).modeHeight}px` } : void 0),
                tabindex: f.timePickerInline ? void 0 : 0
              }, [
                O("div", {
                  class: ue(
                    f.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  f.$slots["time-picker-overlay"] ? X(f.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: D,
                    setMinutes: N,
                    setSeconds: G
                  }) : S("", !0),
                  f.$slots["time-picker-overlay"] ? S("", !0) : (c(), k("div", {
                    key: 1,
                    class: ue(f.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (c(!0), k(he, null, Pe(E.value, (m, o) => At((c(), ce(E0, Ee({ key: o }, {
                      ...f.$props,
                      order: o,
                      hours: m.hours,
                      minutes: m.minutes,
                      seconds: m.seconds,
                      closeTimePickerBtn: z.value,
                      disabledTimesConfig: e.disabledTimesConfig,
                      disabled: o === 0 ? f.fixedStart : f.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: $,
                      "validate-time": (T, B) => e.validateTime(T, w(B, o, T)),
                      "onUpdate:hours": (T) => D(w(T, o, "hours")),
                      "onUpdate:minutes": (T) => N(w(T, o, "minutes")),
                      "onUpdate:seconds": (T) => G(w(T, o, "seconds")),
                      onMounted: P,
                      onOverlayClosed: P,
                      onAmPmChange: _[3] || (_[3] = (T) => f.$emit("am-pm-change", T))
                    }), it({ _: 2 }, [
                      Pe(g(K), (T, B) => ({
                        name: T,
                        fn: ve((W) => [
                          X(f.$slots, T, Ue(rt(W)))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Pr, o === 0 ? !0 : U.value]
                    ])), 128))
                  ], 2)),
                  !f.timePicker && !f.timePickerInline ? At((c(), k("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: z,
                    type: "button",
                    class: ue(ie.value),
                    "aria-label": (Y = g(p)) == null ? void 0 : Y.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      _[4] || (_[4] = be((m) => I(!1), ["enter"])),
                      _[5] || (_[5] = be((m) => I(!1), ["space"]))
                    ],
                    onClick: _[6] || (_[6] = (m) => I(!1))
                  }, [
                    f.$slots["calendar-icon"] ? X(f.$slots, "calendar-icon", { key: 0 }) : S("", !0),
                    f.$slots["calendar-icon"] ? S("", !0) : (c(), ce(g(cr), { key: 1 }))
                  ], 42, K0)), [
                    [Pr, !g(V)(f.hideNavigation, "time")]
                  ]) : S("", !0)
                ], 2)
              ], 14, U0)) : S("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), Ls = (e, t, a, s) => {
  const r = ($, x) => Array.isArray(t[$]) ? t[$][x] : t[$], l = ($) => e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[$] : t.seconds : 0, n = ($, x) => $ ? x !== void 0 ? Yt($, r("hours", x), r("minutes", x), l(x)) : Yt($, t.hours, t.minutes, l()) : Za(F(), l(x)), i = ($, x) => {
    t[$] = x;
  }, u = ($, x) => {
    const U = Object.fromEntries(
      Object.keys(t).map((M) => M === $ ? [M, x] : [M, t[M]].slice())
    );
    if (e.range && !e.disableTimeRangeValidation) {
      const M = (E) => a.value ? Yt(
        a.value[E],
        U.hours[E],
        U.minutes[E],
        U.seconds[E]
      ) : null, R = (E) => Ba(a.value[E], 0);
      return !(Be(M(0), M(1)) && (kr(M(0), R(1)) || Cr(M(1), R(0))));
    }
    return !0;
  }, p = ($, x) => {
    u($, x) && (i($, x), s && s());
  }, h = ($) => {
    p("hours", $);
  }, d = ($) => {
    p("minutes", $);
  }, y = ($) => {
    p("seconds", $);
  }, L = ($, x, U, M) => {
    x && h($), !x && !U && d($), U && y($), a.value && M(a.value);
  }, V = ($) => {
    if ($) {
      const x = Array.isArray($), U = x ? [+$[0].hours, +$[1].hours] : +$.hours, M = x ? [+$[0].minutes, +$[1].minutes] : +$.minutes, R = x ? [+$[0].seconds, +$[1].seconds] : +$.seconds;
      i("hours", U), i("minutes", M), e.enableSeconds && i("seconds", R);
    }
  }, Z = ($, x) => {
    const U = {
      hours: Array.isArray(t.hours) ? t.hours[$] : t.hours,
      disabledArr: []
    };
    return (x || x === 0) && (U.hours = x), Array.isArray(e.disabledTimes) && (U.disabledArr = e.range && Array.isArray(e.disabledTimes[$]) ? e.disabledTimes[$] : e.disabledTimes), U;
  }, z = Q(() => ($, x) => {
    var U;
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: M, hours: R } = Z($, x), E = M.filter((I) => +I.hours === R);
      return ((U = E[0]) == null ? void 0 : U.minutes) === "*" ? { hours: [R], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (E == null ? void 0 : E.map((I) => +I.minutes)) ?? [],
        seconds: (E == null ? void 0 : E.map((I) => I.seconds ? +I.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: i,
    updateHours: h,
    updateMinutes: d,
    updateSeconds: y,
    getSetDateTime: n,
    updateTimeValues: L,
    getSecondsValue: l,
    assignStartTime: V,
    validateTime: u,
    disabledTimesConfig: z
  };
}, W0 = (e, t) => {
  const { modelValue: a, time: s } = Vr(e, t), { defaultedStartTime: r } = Qe(e), { updateTimeValues: l, getSetDateTime: n, setTime: i, assignStartTime: u, disabledTimesConfig: p, validateTime: h } = Ls(e, s, a), d = (x) => {
    const { hours: U, minutes: M, seconds: R } = x;
    return { hours: +U, minutes: +M, seconds: R ? +R : 0 };
  }, y = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const U = d(e.startTime[0]), M = d(e.startTime[1]);
        return [Fe(F(), U), Fe(F(), M)];
      }
      const x = d(e.startTime);
      return Fe(F(), x);
    }
    return e.range ? [null, null] : null;
  }, L = () => {
    if (e.range) {
      const [x, U] = y();
      a.value = [n(x, 0), n(U, 1)];
    } else
      a.value = n(y());
  }, V = (x) => Array.isArray(x) ? [Ut(F(x[0])), Ut(F(x[1]))] : [Ut(x ?? F())], Z = (x, U, M) => {
    i("hours", x), i("minutes", U), i("seconds", e.enableSeconds ? M : 0);
  }, z = () => {
    const [x, U] = V(a.value);
    return e.range ? Z(
      [x.hours, U.hours],
      [x.minutes, U.minutes],
      [x.seconds, U.minutes]
    ) : Z(x.hours, x.minutes, x.seconds);
  };
  ot(() => {
    if (!e.shadow)
      return u(r.value), a.value ? z() : L();
  });
  const $ = () => {
    Array.isArray(a.value) ? a.value = a.value.map((x, U) => x && n(x, U)) : a.value = n(a.value), t("time-update");
  };
  return {
    modelValue: a,
    time: s,
    disabledTimesConfig: p,
    updateTime: (x, U = !0, M = !1) => {
      l(x, U, M, $);
    },
    validateTime: h
  };
}, j0 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...kt
  },
  emits: ["update:internal-model-value", "time-update", "am-pm-change"],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, l = Qt(), n = ct(l, "timePicker"), { time: i, modelValue: u, disabledTimesConfig: p, updateTime: h, validateTime: d } = W0(r, s);
    return t({ getSidebarProps: () => ({
      modelValue: u,
      time: i,
      updateTime: h
    }) }), (y, L) => (c(), ce(Kr, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: ve(() => [
        He(bs, Ee(y.$props, {
          hours: g(i).hours,
          minutes: g(i).minutes,
          seconds: g(i).seconds,
          "internal-model-value": y.internalModelValue,
          "disabled-times-config": g(p),
          "validate-time": g(d),
          "onUpdate:hours": L[0] || (L[0] = (V) => g(h)(V)),
          "onUpdate:minutes": L[1] || (L[1] = (V) => g(h)(V, !1)),
          "onUpdate:seconds": L[2] || (L[2] = (V) => g(h)(V, !1, !0)),
          onAmPmChange: L[3] || (L[3] = (V) => y.$emit("am-pm-change", V))
        }), it({ _: 2 }, [
          Pe(g(n), (V, Z) => ({
            name: V,
            fn: ve((z) => [
              X(y.$slots, V, Ue(rt(z)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), Q0 = { class: "dp__month_year_row" }, X0 = ["aria-label", "onClick", "onKeydown"], G0 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...kt
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed"],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, {
      defaultedTransitions: l,
      defaultedAriaLabels: n,
      defaultedMultiCalendars: i,
      defaultedFilters: u,
      defaultedConfig: p,
      defaultedHighlight: h
    } = Qe(r), { transitionName: d, showTransition: y } = Mr(l), { buildMatrix: L } = Et(), { handleMonthYearChange: V, isDisabled: Z, updateMonthYear: z } = o0(r, s), { showLeftIcon: $, showRightIcon: x } = qr(), U = ee(!1), M = ee(!1), R = ee([null, null, null, null]);
    ot(() => {
      s("mount");
    });
    const E = (o) => ({
      get: () => r[o],
      set: (T) => {
        const B = o === vt.month ? vt.year : vt.month;
        s("update-month-year", { [o]: T, [B]: r[B] }), o === vt.month ? P(!0) : f(!0);
      }
    }), I = Q(E(vt.month)), ie = Q(E(vt.year)), K = Q(() => (o) => ({
      month: r.month,
      year: r.year,
      items: o === vt.month ? r.months : r.years,
      instance: r.instance,
      updateMonthYear: z,
      toggle: o === vt.month ? P : f
    })), w = Q(() => r.months.find((T) => T.value === r.month) || { text: "", value: 0 }), D = Q(() => or(r.months, (o) => {
      const T = r.month === o.value, B = br(
        o.value,
        ds(r.year, r.minDate),
        cs(r.year, r.maxDate)
      ) || u.value.months.includes(o.value), W = ws(h.value, o.value, r.year);
      return { active: T, disabled: B, highlighted: W };
    })), N = Q(() => or(r.years, (o) => {
      const T = r.year === o.value, B = br(o.value, ur(r.minDate), ur(r.maxDate)) || u.value.years.includes(o.value), W = Ua(h.value, o.value);
      return { active: T, disabled: B, highlighted: W };
    })), G = (o, T) => {
      T !== void 0 ? o.value = T : o.value = !o.value, o.value || s("overlay-closed");
    }, P = (o = !1, T) => {
      _(o), G(U, T);
    }, f = (o = !1, T) => {
      _(o), G(M, T);
    }, _ = (o) => {
      o || s("reset-flow");
    }, H = (o, T) => {
      r.arrowNavigation && (R.value[T] = Xe(o), L(R.value, "monthYear"));
    }, Y = Q(() => {
      var o, T;
      return [
        {
          type: vt.month,
          index: 1,
          toggle: P,
          modelValue: I.value,
          updateModelValue: (B) => I.value = B,
          text: w.value.text,
          showSelectionGrid: U.value,
          items: D.value,
          ariaLabel: (o = n.value) == null ? void 0 : o.openMonthsOverlay
        },
        {
          type: vt.year,
          index: 2,
          toggle: f,
          modelValue: ie.value,
          updateModelValue: (B) => ie.value = B,
          text: r.year,
          showSelectionGrid: M.value,
          items: N.value,
          ariaLabel: (T = n.value) == null ? void 0 : T.openYearsOverlay
        }
      ];
    }), m = Q(() => r.disableYearSelect ? [Y.value[0]] : r.yearFirst ? [...Y.value].reverse() : Y.value);
    return t({
      toggleMonthPicker: P,
      toggleYearPicker: f,
      handleMonthYearChange: V
    }), (o, T) => {
      var B, W, q;
      return c(), k("div", Q0, [
        o.$slots["month-year"] ? X(o.$slots, "month-year", Ue(Ee({ key: 0 }, { month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: g(z), handleMonthYearChange: g(V), instance: e.instance }))) : (c(), k(he, { key: 1 }, [
          g($)(g(i), e.instance) && !o.vertical ? (c(), ce(gr, {
            key: 0,
            "aria-label": (B = g(n)) == null ? void 0 : B.prevMonth,
            disabled: g(Z)(!1),
            onActivate: T[0] || (T[0] = (b) => g(V)(!1, !0)),
            onSetRef: T[1] || (T[1] = (b) => H(b, 0))
          }, {
            default: ve(() => [
              o.$slots["arrow-left"] ? X(o.$slots, "arrow-left", { key: 0 }) : S("", !0),
              o.$slots["arrow-left"] ? S("", !0) : (c(), ce(g(Aa), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : S("", !0),
          O("div", {
            class: ue(["dp__month_year_wrap", {
              dp__year_disable_select: o.disableYearSelect
            }])
          }, [
            (c(!0), k(he, null, Pe(m.value, (b, v) => (c(), k(he, {
              key: b.type
            }, [
              O("button", {
                ref_for: !0,
                ref: (oe) => H(oe, v + 1),
                type: "button",
                class: "dp__btn dp__month_year_select",
                tabindex: "0",
                "aria-label": b.ariaLabel,
                onClick: b.toggle,
                onKeydown: [
                  be(xe(b.toggle, ["prevent"]), ["enter"]),
                  be(xe(b.toggle, ["prevent"]), ["space"])
                ]
              }, [
                o.$slots[b.type] ? X(o.$slots, b.type, {
                  key: 0,
                  text: b.text,
                  value: r[b.type]
                }) : S("", !0),
                o.$slots[b.type] ? S("", !0) : (c(), k(he, { key: 1 }, [
                  Je(me(b.text), 1)
                ], 64))
              ], 40, X0),
              He(dr, {
                name: g(d)(b.showSelectionGrid),
                css: g(y)
              }, {
                default: ve(() => [
                  b.showSelectionGrid ? (c(), ce(xr, {
                    key: 0,
                    items: b.items,
                    "arrow-navigation": o.arrowNavigation,
                    "hide-navigation": o.hideNavigation,
                    "is-last": o.autoApply && !g(p).keepActionRow,
                    "skip-button-ref": !1,
                    config: o.config,
                    type: b.type,
                    "header-refs": [],
                    "esc-close": o.escClose,
                    "text-input": o.textInput,
                    onSelected: b.updateModelValue,
                    onToggle: b.toggle
                  }, it({
                    "button-icon": ve(() => [
                      o.$slots["calendar-icon"] ? X(o.$slots, "calendar-icon", { key: 0 }) : S("", !0),
                      o.$slots["calendar-icon"] ? S("", !0) : (c(), ce(g(cr), { key: 1 }))
                    ]),
                    _: 2
                  }, [
                    o.$slots[`${b.type}-overlay-value`] ? {
                      name: "item",
                      fn: ve(({ item: oe }) => [
                        X(o.$slots, `${b.type}-overlay-value`, {
                          text: oe.text,
                          value: oe.value
                        })
                      ]),
                      key: "0"
                    } : void 0,
                    o.$slots[`${b.type}-overlay`] ? {
                      name: "overlay",
                      fn: ve(() => [
                        X(o.$slots, `${b.type}-overlay`, Ue(rt(K.value(b.type))))
                      ]),
                      key: "1"
                    } : void 0,
                    o.$slots[`${b.type}-overlay-header`] ? {
                      name: "header",
                      fn: ve(() => [
                        X(o.$slots, `${b.type}-overlay-header`, {
                          toggle: b.toggle
                        })
                      ]),
                      key: "2"
                    } : void 0
                  ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "text-input", "onSelected", "onToggle"])) : S("", !0)
                ]),
                _: 2
              }, 1032, ["name", "css"])
            ], 64))), 128))
          ], 2),
          g($)(g(i), e.instance) && o.vertical ? (c(), ce(gr, {
            key: 1,
            "aria-label": (W = g(n)) == null ? void 0 : W.prevMonth,
            disabled: g(Z)(!1),
            onActivate: T[2] || (T[2] = (b) => g(V)(!1, !0))
          }, {
            default: ve(() => [
              o.$slots["arrow-up"] ? X(o.$slots, "arrow-up", { key: 0 }) : S("", !0),
              o.$slots["arrow-up"] ? S("", !0) : (c(), ce(g(Ya), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : S("", !0),
          g(x)(g(i), e.instance) ? (c(), ce(gr, {
            key: 2,
            ref: "rightIcon",
            disabled: g(Z)(!0),
            "aria-label": (q = g(n)) == null ? void 0 : q.nextMonth,
            onActivate: T[3] || (T[3] = (b) => g(V)(!0, !0)),
            onSetRef: T[4] || (T[4] = (b) => H(b, o.disableYearSelect ? 2 : 3))
          }, {
            default: ve(() => [
              o.$slots[o.vertical ? "arrow-down" : "arrow-right"] ? X(o.$slots, o.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : S("", !0),
              o.$slots[o.vertical ? "arrow-down" : "arrow-right"] ? S("", !0) : (c(), ce(Xt(o.vertical ? g(Na) : g(Ra)), { key: 1 }))
            ]),
            _: 3
          }, 8, ["disabled", "aria-label"])) : S("", !0)
        ], 64))
      ]);
    };
  }
}), J0 = ["aria-label"], e5 = {
  class: "dp__calendar_header",
  role: "row"
}, t5 = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, r5 = /* @__PURE__ */ O("div", { class: "dp__calendar_header_separator" }, null, -1), a5 = ["aria-label"], s5 = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, n5 = { class: "dp__cell_inner" }, l5 = ["id", "aria-selected", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], i5 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...kt
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, { buildMultiLevelMatrix: l } = Et(), {
      defaultedTransitions: n,
      defaultedConfig: i,
      defaultedAriaLabels: u,
      defaultedMultiCalendars: p,
      defaultedWeekNumbers: h
    } = Qe(r), d = ee(null), y = ee({
      bottom: "",
      left: "",
      transform: ""
    }), L = ee([]), V = ee(null), Z = ee(!0), z = ee(""), $ = ee({ startX: 0, endX: 0, startY: 0, endY: 0 }), x = ee([]), U = ee({ left: "50%" }), M = Q(() => r.calendar ? r.calendar(r.mappedDates) : r.mappedDates), R = Q(() => r.dayNames ? Array.isArray(r.dayNames) ? r.dayNames : r.dayNames(r.locale, +r.weekStart) : P2(r.formatLocale, r.locale, +r.weekStart));
    ot(() => {
      s("mount", { cmp: "calendar", refs: L }), i.value.noSwipe || V.value && (V.value.addEventListener("touchstart", f, { passive: !1 }), V.value.addEventListener("touchend", _, { passive: !1 }), V.value.addEventListener("touchmove", H, { passive: !1 })), r.monthChangeOnScroll && V.value && V.value.addEventListener("wheel", o, { passive: !1 });
    });
    const E = (b) => b ? r.vertical ? "vNext" : "next" : r.vertical ? "vPrevious" : "previous", I = (b, v) => {
      if (r.transitions) {
        const oe = st($t(F(), r.month, r.year));
        z.value = at(st($t(F(), b, v)), oe) ? n.value[E(!0)] : n.value[E(!1)], Z.value = !1, Nt(() => {
          Z.value = !0;
        });
      }
    }, ie = Q(
      () => ({
        [r.calendarClassName]: !!r.calendarClassName
      })
    ), K = Q(() => (b) => {
      const v = Z2(b);
      return {
        dp__marker_dot: v.type === "dot",
        dp__marker_line: v.type === "line"
      };
    }), w = Q(() => (b) => Be(b, d.value)), D = Q(() => ({
      dp__calendar: !0,
      dp__calendar_next: p.value.count > 0 && r.instance !== 0
    })), N = Q(() => (b) => r.hideOffsetDates ? b.current : !0), G = async (b, v, oe) => {
      var ye, re;
      if (s("set-hover-date", b), (re = (ye = b.marker) == null ? void 0 : ye.tooltip) != null && re.length) {
        const Me = Xe(L.value[v][oe]);
        if (Me) {
          const { width: de, height: A } = Me.getBoundingClientRect();
          d.value = b.value;
          let J = { left: `${de / 2}px` }, Le = -50;
          if (await Nt(), x.value[0]) {
            const { left: ae, width: Ye } = x.value[0].getBoundingClientRect();
            ae < 0 && (J = { left: "0" }, Le = 0, U.value.left = `${de / 2}px`), window.innerWidth < ae + Ye && (J = { right: "0" }, Le = 0, U.value.left = `${Ye - de / 2}px`);
          }
          y.value = {
            bottom: `${A}px`,
            ...J,
            transform: `translateX(${Le}%)`
          }, s("tooltip-open", b.marker);
        }
      }
    }, P = (b) => {
      d.value && (d.value = null, y.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), s("tooltip-close", b.marker));
    }, f = (b) => {
      $.value.startX = b.changedTouches[0].screenX, $.value.startY = b.changedTouches[0].screenY;
    }, _ = (b) => {
      $.value.endX = b.changedTouches[0].screenX, $.value.endY = b.changedTouches[0].screenY, Y();
    }, H = (b) => {
      r.vertical && !r.inline && b.preventDefault();
    }, Y = () => {
      const b = r.vertical ? "Y" : "X";
      Math.abs($.value[`start${b}`] - $.value[`end${b}`]) > 10 && s("handle-swipe", $.value[`start${b}`] > $.value[`end${b}`] ? "right" : "left");
    }, m = (b, v, oe) => {
      b && (Array.isArray(L.value[v]) ? L.value[v][oe] = b : L.value[v] = [b]), r.arrowNavigation && l(L.value, "calendar");
    }, o = (b) => {
      r.monthChangeOnScroll && (b.preventDefault(), s("handle-scroll", b));
    }, T = (b) => h.value.type === "local" ? zi(b.value, { weekStartsOn: +r.weekStart }) : h.value.type === "iso" ? Yi(b.value) : typeof h.value.type == "function" ? h.value.type(b.value) : "", B = (b) => {
      const v = b[0];
      return h.value.hideOnOffsetDates ? b.some((oe) => oe.current) ? T(v) : "" : T(v);
    }, W = (b, v) => {
      It(b, i.value), s("select-date", v);
    }, q = (b) => {
      It(b, i.value);
    };
    return t({ triggerTransition: I }), (b, v) => {
      var oe;
      return c(), k("div", {
        class: ue(D.value)
      }, [
        O("div", {
          ref_key: "calendarWrapRef",
          ref: V,
          role: "grid",
          class: ue(ie.value),
          "aria-label": (oe = g(u)) == null ? void 0 : oe.calendarWrap
        }, [
          (c(), k(he, { key: 0 }, [
            O("div", e5, [
              b.weekNumbers ? (c(), k("div", t5, me(b.weekNumName), 1)) : S("", !0),
              (c(!0), k(he, null, Pe(R.value, (ye, re) => (c(), k("div", {
                key: re,
                class: "dp__calendar_header_item",
                role: "gridcell"
              }, [
                b.$slots["calendar-header"] ? X(b.$slots, "calendar-header", {
                  key: 0,
                  day: ye,
                  index: re
                }) : S("", !0),
                b.$slots["calendar-header"] ? S("", !0) : (c(), k(he, { key: 1 }, [
                  Je(me(ye), 1)
                ], 64))
              ]))), 128))
            ]),
            r5,
            He(dr, {
              name: z.value,
              css: !!b.transitions
            }, {
              default: ve(() => {
                var ye;
                return [
                  Z.value ? (c(), k("div", {
                    key: 0,
                    class: "dp__calendar",
                    role: "rowgroup",
                    "aria-label": ((ye = g(u)) == null ? void 0 : ye.calendarDays) || void 0
                  }, [
                    (c(!0), k(he, null, Pe(M.value, (re, Me) => (c(), k("div", {
                      key: Me,
                      class: "dp__calendar_row",
                      role: "row"
                    }, [
                      b.weekNumbers ? (c(), k("div", s5, [
                        O("div", n5, me(B(re.days)), 1)
                      ])) : S("", !0),
                      (c(!0), k(he, null, Pe(re.days, (de, A) => {
                        var J, Le, ae;
                        return c(), k("div", {
                          id: de.value.toISOString().split("T")[0],
                          ref_for: !0,
                          ref: (Ye) => m(Ye, Me, A),
                          key: A + Me,
                          role: "gridcell",
                          class: "dp__calendar_item",
                          "aria-selected": de.classData.dp__active_date || de.classData.dp__range_start || de.classData.dp__range_start,
                          "aria-disabled": de.classData.dp__cell_disabled || void 0,
                          "aria-label": (Le = (J = g(u)) == null ? void 0 : J.day) == null ? void 0 : Le.call(J, de),
                          tabindex: "0",
                          onClick: xe((Ye) => W(Ye, de), ["prevent"]),
                          onKeydown: [
                            be((Ye) => b.$emit("select-date", de), ["enter"]),
                            be((Ye) => b.$emit("handle-space", de), ["space"])
                          ],
                          onMouseenter: (Ye) => G(de, Me, A),
                          onMouseleave: (Ye) => P(de)
                        }, [
                          O("div", {
                            class: ue(["dp__cell_inner", de.classData])
                          }, [
                            b.$slots.day && N.value(de) ? X(b.$slots, "day", {
                              key: 0,
                              day: +de.text,
                              date: de.value
                            }) : S("", !0),
                            b.$slots.day ? S("", !0) : (c(), k(he, { key: 1 }, [
                              Je(me(de.text), 1)
                            ], 64)),
                            de.marker && N.value(de) ? (c(), k(he, { key: 2 }, [
                              b.$slots.marker ? X(b.$slots, "marker", {
                                key: 0,
                                marker: de.marker,
                                day: +de.text,
                                date: de.value
                              }) : (c(), k("div", {
                                key: 1,
                                class: ue(K.value(de.marker)),
                                style: dt(de.marker.color ? { backgroundColor: de.marker.color } : {})
                              }, null, 6))
                            ], 64)) : S("", !0),
                            w.value(de.value) ? (c(), k("div", {
                              key: 3,
                              ref_for: !0,
                              ref_key: "activeTooltip",
                              ref: x,
                              class: "dp__marker_tooltip",
                              style: dt(y.value)
                            }, [
                              (ae = de.marker) != null && ae.tooltip ? (c(), k("div", {
                                key: 0,
                                class: "dp__tooltip_content",
                                onClick: q
                              }, [
                                (c(!0), k(he, null, Pe(de.marker.tooltip, (Ye, ut) => (c(), k("div", {
                                  key: ut,
                                  class: "dp__tooltip_text"
                                }, [
                                  b.$slots["marker-tooltip"] ? X(b.$slots, "marker-tooltip", {
                                    key: 0,
                                    tooltip: Ye,
                                    day: de.value
                                  }) : S("", !0),
                                  b.$slots["marker-tooltip"] ? S("", !0) : (c(), k(he, { key: 1 }, [
                                    O("div", {
                                      class: "dp__tooltip_mark",
                                      style: dt(Ye.color ? { backgroundColor: Ye.color } : {})
                                    }, null, 4),
                                    O("div", null, me(Ye.text), 1)
                                  ], 64))
                                ]))), 128)),
                                O("div", {
                                  class: "dp__arrow_bottom_tp",
                                  style: dt(U.value)
                                }, null, 4)
                              ])) : S("", !0)
                            ], 4)) : S("", !0)
                          ], 2)
                        ], 40, l5);
                      }), 128))
                    ]))), 128))
                  ], 8, a5)) : S("", !0)
                ];
              }),
              _: 3
            }, 8, ["name", "css"])
          ], 64))
        ], 10, J0)
      ], 2);
    };
  }
}), x1 = (e) => Array.isArray(e), o5 = (e, t, a, s) => {
  const r = ee([]), { modelValue: l, calendars: n, time: i } = Vr(e, t), { defaultedMultiCalendars: u, defaultedStartTime: p } = Qe(e), { validateMonthYearInRange: h, isDisabled: d, isDateRangeAllowed: y, checkMinMaxRange: L } = Jt(e), { updateTimeValues: V, getSetDateTime: Z, setTime: z, assignStartTime: $, validateTime: x, disabledTimesConfig: U } = Ls(e, i, l, s), M = Q(
    () => (C) => n.value[C] ? n.value[C].month : 0
  ), R = Q(
    () => (C) => n.value[C] ? n.value[C].year : 0
  ), E = (C, j, we) => {
    var De, ze;
    n.value[C] || (n.value[C] = { month: 0, year: 0 }), n.value[C].month = C1(j) ? (De = n.value[C]) == null ? void 0 : De.month : j, n.value[C].year = C1(we) ? (ze = n.value[C]) == null ? void 0 : ze.year : we;
  }, I = () => {
    e.autoApply && t("select-date");
  };
  Ft(l, (C, j) => {
    JSON.stringify(C) !== JSON.stringify(j) && w();
  }), ot(() => {
    e.shadow || (l.value || (o(), p.value && $(p.value)), w(!0), e.focusStartDate && e.startDate && o());
  });
  const ie = Q(() => {
    var C;
    return (C = e.flow) != null && C.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
  }), K = () => {
    e.autoApply && ie.value && t("auto-apply", e.partialFlow);
  }, w = (C = !1) => {
    if (l.value)
      return Array.isArray(l.value) ? (r.value = l.value, _(C)) : N(l.value, C);
    if (u.value.count && C && !e.startDate)
      return D(F(), C);
  }, D = (C, j = !1) => {
    if ((!u.value.count || !u.value.static || j) && E(0, Se(C), Ve(C)), u.value.count && (!u.value.solo || !l.value))
      for (let we = 1; we < u.value.count; we++) {
        const De = Fe(F(), { month: M.value(we - 1), year: R.value(we - 1) }), ze = Z1(De, { months: 1 });
        n.value[we] = { month: Se(ze), year: Ve(ze) };
      }
  }, N = (C, j) => {
    D(C), z("hours", gt(C)), z("minutes", xt(C)), z("seconds", lr(C)), u.value.count && j && m();
  }, G = (C) => {
    if (u.value.count) {
      if (u.value.solo)
        return 0;
      const j = Se(C[0]), we = Se(C[1]);
      return Math.abs(we - j) < u.value.count ? 0 : 1;
    }
    return 1;
  }, P = (C, j) => {
    C[1] && e.showLastInRange ? D(C[G(C)], j) : D(C[0], j);
    const we = (De, ze) => [
      De(C[0]),
      C[1] ? De(C[1]) : i[ze][1]
    ];
    z("hours", we(gt, "hours")), z("minutes", we(xt, "minutes")), z("seconds", we(lr, "seconds"));
  }, f = (C, j) => {
    if ((e.range || e.weekPicker) && !e.multiDates)
      return P(C, j);
    if (e.multiDates && j) {
      const we = C[C.length - 1];
      return N(we, j);
    }
  }, _ = (C) => {
    const j = l.value;
    f(j, C), u.value.count && u.value.solo && m();
  }, H = (C, j) => {
    const we = Fe(F(), { month: M.value(j), year: R.value(j) }), De = C < 0 ? wt(we, 1) : ir(we, 1);
    h(Se(De), Ve(De), C < 0, e.preventMinMaxNavigation) && (E(j, Se(De), Ve(De)), t("update-month-year", { instance: j, month: Se(De), year: Ve(De) }), u.value.count && !u.value.solo && Y(j), a());
  }, Y = (C) => {
    for (let j = C - 1; j >= 0; j--) {
      const we = ir(Fe(F(), { month: M.value(j + 1), year: R.value(j + 1) }), 1);
      E(j, Se(we), Ve(we));
    }
    for (let j = C + 1; j <= u.value.count - 1; j++) {
      const we = wt(Fe(F(), { month: M.value(j - 1), year: R.value(j - 1) }), 1);
      E(j, Se(we), Ve(we));
    }
  }, m = () => {
    if (Array.isArray(l.value) && l.value.length === 2) {
      const C = F(
        F(l.value[1] ? l.value[1] : wt(l.value[0], 1))
      ), [j, we] = [Se(l.value[0]), Ve(l.value[0])], [De, ze] = [Se(l.value[1]), Ve(l.value[1])];
      (j !== De || j === De && we !== ze) && u.value.solo && E(1, Se(C), Ve(C));
    } else
      l.value && !Array.isArray(l.value) && (E(0, Se(l.value), Ve(l.value)), D(F()));
  }, o = () => {
    e.startDate && (E(0, Se(F(e.startDate)), Ve(F(e.startDate))), u.value.count && Y(0));
  }, T = N2((C, j) => {
    e.monthChangeOnScroll && H(e.monthChangeOnScroll !== "inverse" ? -C.deltaY : C.deltaY, j);
  }, 50), B = (C, j, we = !1) => {
    e.monthChangeOnArrows && e.vertical === we && W(C, j);
  }, W = (C, j) => {
    H(C === "right" ? -1 : 1, j);
  }, q = (C) => e.markers.find(
    (j) => Be(z2(C.value), yt(F(j.date), e.timezone))
  ), b = (C, j) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [C == 0, !0];
      case "fair":
        return [C == 0 || j > C, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, v = (C, j, we, De) => {
    if (e.sixWeeks && C.length < 6) {
      const ze = 6 - C.length, Ct = (j.getDay() + 7 - De) % 7, Ot = 6 - (we.getDay() + 7 - De) % 7, [te, Ce] = b(Ct, Ot);
      for (let ge = 1; ge <= ze; ge++)
        if (Ce ? !!(ge % 2) == te : te) {
          const ht = C[0].days[0], Ht = oe(Tt(ht.value, -7), Se(j));
          C.unshift({ days: Ht });
        } else {
          const ht = C[C.length - 1], Ht = ht.days[ht.days.length - 1], Jr = oe(Tt(Ht.value, 1), Se(j));
          C.push({ days: Jr });
        }
    }
    return C;
  }, oe = (C, j) => {
    const we = F(C), De = [];
    for (let ze = 0; ze < 7; ze++) {
      const Ct = Tt(we, ze), Ot = Se(Ct) !== j;
      De.push({
        text: e.hideOffsetDates && Ot ? "" : Ct.getDate(),
        value: Ct,
        current: !Ot,
        classData: {}
      });
    }
    return De;
  }, ye = (C, j) => {
    const we = [], De = new Date(j, C), ze = new Date(j, C + 1, 0), Ct = e.weekStart, Ot = Wt(De, { weekStartsOn: Ct }), te = (Ce) => {
      const ge = oe(Ce, C);
      if (we.push({ days: ge }), !we[we.length - 1].days.some(
        (ht) => Be(st(ht.value), st(ze))
      )) {
        const ht = Tt(Ce, 7);
        te(ht);
      }
    };
    return te(Ot), v(we, De, ze, Ct);
  }, re = (C) => (l.value = Br(F(C.value), e.timezone, e.weekStart), t("date-update", C.value), K()), Me = (C) => {
    const j = Yt(F(C.value), i.hours, i.minutes, er());
    t("date-update", j), e.multiDates ? Ka(j, l, e.multiDatesLimit) : l.value = j, s(), Nt().then(() => {
      K();
    });
  }, de = (C) => e.noDisabledRange ? hs(r.value[0], C).some((j) => d(j)) : !1, A = () => {
    r.value = l.value ? l.value.slice() : [], r.value.length === 2 && !(e.fixedStart || e.fixedEnd) && (r.value = []);
  }, J = (C, j) => {
    const we = [F(C.value), Tt(F(C.value), +e.autoRange)];
    y(we) ? (j && Le(C.value), r.value = we) : t("invalid-date", C.value);
  }, Le = (C) => {
    const j = Se(F(C)), we = Ve(F(C));
    if (E(0, j, we), u.value.count > 0)
      for (let De = 1; De < u.value.count; De++) {
        const ze = q2(
          Fe(F(C), { year: M.value(De - 1), month: R.value(De - 1) })
        );
        E(De, ze.month, ze.year);
      }
  }, ae = (C) => Array.isArray(l.value) && l.value.length === 2 ? e.fixedStart && (at(C, l.value[0]) || Be(C, l.value[0])) ? [l.value[0], C] : e.fixedEnd && (tt(C, l.value[1]) || Be(C, l.value[1])) ? [C, l.value[1]] : (t("invalid-fixed-range", C), l.value) : [], Ye = (C) => {
    if (de(C.value) || !L(C.value, l.value, e.fixedStart ? 0 : 1))
      return t("invalid-date", C.value);
    r.value = ae(F(C.value));
  }, ut = (C, j) => {
    if (A(), e.autoRange)
      return J(C, j);
    if (e.fixedStart || e.fixedEnd)
      return Ye(C);
    r.value[0] ? L(F(C.value), l.value) && !de(C.value) ? tt(F(C.value), F(r.value[0])) ? (r.value.unshift(F(C.value)), t("range-end", r.value[0])) : (r.value[1] = F(C.value), t("range-end", r.value[1])) : (e.autoApply && t("auto-apply-invalid", C.value), t("invalid-date", C.value)) : (r.value[0] = F(C.value), t("range-start", r.value[0]));
  }, er = (C = !0) => e.enableSeconds ? Array.isArray(i.seconds) ? C ? i.seconds[0] : i.seconds[1] : i.seconds : 0, _t = (C) => {
    r.value[C] = Yt(
      r.value[C],
      i.hours[C],
      i.minutes[C],
      er(C !== 1)
    );
  }, Hr = () => {
    var C, j;
    r.value[0] && r.value[1] && +((C = r.value) == null ? void 0 : C[0]) > +((j = r.value) == null ? void 0 : j[1]) && (r.value.reverse(), t("range-start", r.value[0]), t("range-end", r.value[1]));
  }, Tr = () => {
    r.value.length && (r.value[0] && !r.value[1] ? _t(0) : (_t(0), _t(1), s()), Hr(), l.value = r.value.slice(), Wr(r.value, t, e.autoApply, e.modelAuto));
  }, Qr = (C, j = !1) => {
    if (d(C.value) || !C.current && e.hideOffsetDates)
      return t("invalid-date", C.value);
    if (e.weekPicker)
      return re(C);
    if (!e.range)
      return Me(C);
    x1(i.hours) && x1(i.minutes) && !e.multiDates && (ut(C, j), Tr());
  }, pr = (C, j) => {
    var we;
    E(C, j.month, j.year), u.value.count && !u.value.solo && Y(C), t("update-month-year", { instance: C, month: j.month, year: j.year }), a(u.value.solo ? C : void 0);
    const De = (we = e.flow) != null && we.length ? e.flow[e.flowStep] : void 0;
    !j.fromNav && (De === bt.month || De === bt.year) && s();
  }, pt = (C, j) => {
    ks({ value: C, modelValue: l, range: e.range, timezone: j ? void 0 : e.timezone }), I(), e.multiCalendars && Nt().then(() => w(!0));
  }, Xr = () => {
    e.range ? l.value && Array.isArray(l.value) && l.value[0] ? l.value = tt(F(), l.value[0]) ? [F(), l.value[0]] : [l.value[0], F()] : l.value = [F()] : l.value = F(), I();
  }, Gr = () => {
    if (Array.isArray(l.value))
      if (e.multiDates) {
        const C = $r();
        l.value[l.value.length - 1] = Z(C);
      } else
        l.value = l.value.map((C, j) => C && Z(C, j));
    else
      l.value = Z(l.value);
    t("time-update");
  }, $r = () => Array.isArray(l.value) && l.value.length ? l.value[l.value.length - 1] : null;
  return {
    calendars: n,
    modelValue: l,
    month: M,
    year: R,
    time: i,
    disabledTimesConfig: U,
    validateTime: x,
    getCalendarDays: ye,
    getMarker: q,
    handleScroll: T,
    handleSwipe: W,
    handleArrow: B,
    selectDate: Qr,
    updateMonthYear: pr,
    presetDate: pt,
    selectCurrentDate: Xr,
    updateTime: (C, j = !0, we = !1) => {
      V(C, j, we, Gr);
    }
  };
}, u5 = { key: 0 }, d5 = /* @__PURE__ */ ke({
  __name: "DatePicker",
  props: {
    ...kt
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, {
      calendars: l,
      month: n,
      year: i,
      modelValue: u,
      time: p,
      disabledTimesConfig: h,
      validateTime: d,
      getCalendarDays: y,
      getMarker: L,
      handleArrow: V,
      handleScroll: Z,
      handleSwipe: z,
      selectDate: $,
      updateMonthYear: x,
      presetDate: U,
      selectCurrentDate: M,
      updateTime: R
    } = o5(r, s, m, o), E = Qt(), { setHoverDate: I, getDayClassData: ie, clearHoverDate: K } = p0(u, r), { defaultedMultiCalendars: w } = Qe(r), D = ee([]), N = ee([]), G = ee(null), P = ct(E, "calendar"), f = ct(E, "monthYear"), _ = ct(E, "timePicker"), H = (B) => {
      r.shadow || s("mount", B);
    };
    Ft(
      l,
      () => {
        r.shadow || setTimeout(() => {
          s("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const Y = Q(() => (B) => y(n.value(B), i.value(B)).map((W) => ({
      ...W,
      days: W.days.map((q) => (q.marker = L(q), q.classData = ie(q), q))
    })));
    function m(B) {
      var W;
      B || B === 0 ? (W = N.value[B]) == null || W.triggerTransition(n.value(B), i.value(B)) : N.value.forEach((q, b) => q.triggerTransition(n.value(b), i.value(b)));
    }
    function o() {
      s("update-flow-step");
    }
    const T = (B, W = !1) => {
      $(B, W), r.spaceConfirm && s("select-date");
    };
    return t({
      clearHoverDate: K,
      presetDate: U,
      selectCurrentDate: M,
      toggleMonthPicker: (B, W, q = 0) => {
        var b;
        (b = D.value[q]) == null || b.toggleMonthPicker(B, W);
      },
      toggleYearPicker: (B, W, q = 0) => {
        var b;
        (b = D.value[q]) == null || b.toggleYearPicker(B, W);
      },
      toggleTimePicker: (B, W, q) => {
        var b;
        (b = G.value) == null || b.toggleTimePicker(B, W, q);
      },
      handleArrow: V,
      updateMonthYear: x,
      getSidebarProps: () => ({
        modelValue: u,
        month: n,
        year: i,
        time: p,
        updateTime: R,
        updateMonthYear: x,
        selectDate: $,
        presetDate: U
      })
    }), (B, W) => (c(), k(he, null, [
      He(Kr, {
        "multi-calendars": g(w).count
      }, {
        default: ve(({ instance: q, index: b }) => [
          B.disableMonthYearSelect ? S("", !0) : (c(), ce(G0, Ee({
            key: 0,
            ref: (v) => {
              v && (D.value[b] = v);
            },
            months: g(os)(B.formatLocale, B.locale, B.monthNameFormat),
            years: g(qa)(B.yearRange, B.reverseYears),
            month: g(n)(q),
            year: g(i)(q),
            instance: q
          }, B.$props, {
            onMount: W[0] || (W[0] = (v) => H(g(Kt).header)),
            onResetFlow: W[1] || (W[1] = (v) => B.$emit("reset-flow")),
            onUpdateMonthYear: (v) => g(x)(q, v),
            onOverlayClosed: W[2] || (W[2] = (v) => B.$emit("focus-menu"))
          }), it({ _: 2 }, [
            Pe(g(f), (v, oe) => ({
              name: v,
              fn: ve((ye) => [
                X(B.$slots, v, Ue(rt(ye)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          He(i5, Ee({
            ref: (v) => {
              v && (N.value[b] = v);
            },
            "mapped-dates": Y.value(q),
            month: g(n)(q),
            year: g(i)(q),
            instance: q
          }, B.$props, {
            onSelectDate: (v) => g($)(v, q !== 1),
            onHandleSpace: (v) => T(v, q !== 1),
            onSetHoverDate: W[3] || (W[3] = (v) => g(I)(v)),
            onHandleScroll: (v) => g(Z)(v, q),
            onHandleSwipe: (v) => g(z)(v, q),
            onMount: W[4] || (W[4] = (v) => H(g(Kt).calendar)),
            onResetFlow: W[5] || (W[5] = (v) => B.$emit("reset-flow")),
            onTooltipOpen: W[6] || (W[6] = (v) => B.$emit("tooltip-open", v)),
            onTooltipClose: W[7] || (W[7] = (v) => B.$emit("tooltip-close", v))
          }), it({ _: 2 }, [
            Pe(g(P), (v, oe) => ({
              name: v,
              fn: ve((ye) => [
                X(B.$slots, v, Ue(rt({ ...ye })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars"]),
      B.enableTimePicker ? (c(), k("div", u5, [
        B.$slots["time-picker"] ? X(B.$slots, "time-picker", Ue(Ee({ key: 0 }, { time: g(p), updateTime: g(R) }))) : (c(), ce(bs, Ee({
          key: 1,
          ref_key: "timePickerRef",
          ref: G
        }, B.$props, {
          hours: g(p).hours,
          minutes: g(p).minutes,
          seconds: g(p).seconds,
          "internal-model-value": B.internalModelValue,
          "disabled-times-config": g(h),
          "validate-time": g(d),
          onMount: W[8] || (W[8] = (q) => H(g(Kt).timePicker)),
          "onUpdate:hours": W[9] || (W[9] = (q) => g(R)(q)),
          "onUpdate:minutes": W[10] || (W[10] = (q) => g(R)(q, !1)),
          "onUpdate:seconds": W[11] || (W[11] = (q) => g(R)(q, !1, !0)),
          onResetFlow: W[12] || (W[12] = (q) => B.$emit("reset-flow")),
          onOverlayClosed: W[13] || (W[13] = (q) => B.$emit("time-picker-close")),
          onOverlayOpened: W[14] || (W[14] = (q) => B.$emit("time-picker-open", q)),
          onAmPmChange: W[15] || (W[15] = (q) => B.$emit("am-pm-change", q))
        }), it({ _: 2 }, [
          Pe(g(_), (q, b) => ({
            name: q,
            fn: ve((v) => [
              X(B.$slots, q, Ue(rt(v)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : S("", !0)
    ], 64));
  }
}), c5 = (e, t) => {
  const a = ee(), { defaultedMultiCalendars: s, defaultedConfig: r, defaultedHighlight: l } = Qe(e), { modelValue: n, year: i, month: u, calendars: p } = Vr(e, t), { isDisabled: h } = Jt(e), { selectYear: d, groupedYears: y, showYearPicker: L, isDisabled: V, toggleYearPicker: Z, handleYearSelect: z, handleYear: $ } = Cs({
    modelValue: n,
    multiCalendars: s,
    highlight: l,
    calendars: p,
    month: u,
    year: i,
    props: e,
    emit: t
  }), x = (K, w) => [K, w].map((D) => Rt(D, "MMMM", { locale: e.formatLocale })).join("-"), U = Q(() => (K) => n.value ? Array.isArray(n.value) ? n.value.some((w) => d1(K, w)) : d1(n.value, K) : !1), M = (K) => {
    if (e.range) {
      if (Array.isArray(n.value)) {
        const w = Be(K, n.value[0]) || Be(K, n.value[1]);
        return zr(n.value, a.value, K) && !w;
      }
      return !1;
    }
    return !1;
  }, R = Q(() => (K) => {
    const w = Fe(/* @__PURE__ */ new Date(), { year: i.value(K) });
    return Rl({
      start: Yl(w),
      end: Il(w)
    }).map((D) => {
      const N = yr(D), G = s1(D), P = h(D), f = M(N), _ = typeof l.value == "function" ? l.value({ quarter: a1(N), year: Ve(N) }) : !!l.value.quarters.find(
        (H) => H.quarter === a1(N) && H.year === Ve(N)
      );
      return {
        text: x(N, G),
        value: N,
        active: U.value(N),
        highlighted: _,
        disabled: P,
        isBetween: f
      };
    });
  }), E = (K) => {
    Ka(K, n, e.multiDatesLimit), t("auto-apply", !0);
  }, I = (K) => {
    const w = Wa(n, K, t);
    Wr(w, t, e.autoApply, e.modelAuto);
  }, ie = (K) => {
    n.value = K, t("auto-apply");
  };
  return {
    defaultedConfig: r,
    defaultedMultiCalendars: s,
    groupedYears: y,
    year: i,
    isDisabled: V,
    quarters: R,
    showYearPicker: L,
    modelValue: n,
    setHoverDate: (K) => {
      a.value = K;
    },
    selectYear: d,
    selectQuarter: (K, w, D) => {
      if (!D)
        return p.value[w].month = Se(s1(K)), e.multiDates ? E(K) : e.range ? I(K) : ie(K);
    },
    toggleYearPicker: Z,
    handleYearSelect: z,
    handleYear: $
  };
}, p5 = { class: "dp--quarter-items" }, h5 = ["disabled", "onClick", "onMouseover"], m5 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...kt
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end"
  ],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, l = Qt(), n = ct(l, "yearMode"), {
      defaultedMultiCalendars: i,
      defaultedConfig: u,
      groupedYears: p,
      year: h,
      isDisabled: d,
      quarters: y,
      modelValue: L,
      showYearPicker: V,
      setHoverDate: Z,
      selectQuarter: z,
      toggleYearPicker: $,
      handleYearSelect: x,
      handleYear: U
    } = c5(r, s);
    return t({ getSidebarProps: () => ({
      modelValue: L,
      year: h,
      selectQuarter: z,
      handleYearSelect: x,
      handleYear: U
    }) }), (M, R) => (c(), ce(Kr, {
      "multi-calendars": g(i).count,
      stretch: ""
    }, {
      default: ve(({ instance: E }) => [
        O("div", {
          class: "dp-quarter-picker-wrap",
          style: dt({ minHeight: `${g(u).modeHeight}px` })
        }, [
          O("div", null, [
            He(ys, Ee(M.$props, {
              items: g(p)(E),
              instance: E,
              "show-year-picker": g(V)[E],
              year: g(h)(E),
              "is-disabled": (I) => g(d)(E, I),
              onHandleYear: (I) => g(U)(E, I),
              onYearSelect: (I) => g(x)(I, E),
              onToggleYearPicker: (I) => g($)(E, I == null ? void 0 : I.flow, I == null ? void 0 : I.show)
            }), it({ _: 2 }, [
              Pe(g(n), (I, ie) => ({
                name: I,
                fn: ve((K) => [
                  X(M.$slots, I, Ue(rt(K)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          O("div", p5, [
            (c(!0), k(he, null, Pe(g(y)(E), (I, ie) => (c(), k("div", { key: ie }, [
              O("button", {
                type: "button",
                class: ue(["dp--qr-btn", {
                  "dp--qr-btn-active": I.active,
                  "dp--qr-btn-between": I.isBetween,
                  "dp--qr-btn-disabled": I.disabled,
                  "dp--highlighted": I.highlighted
                }]),
                disabled: I.disabled,
                onClick: (K) => g(z)(I.value, E, I.disabled),
                onMouseover: (K) => g(Z)(I.value)
              }, [
                M.$slots.quarter ? X(M.$slots, "quarter", {
                  key: 0,
                  value: I.value,
                  text: I.text
                }) : (c(), k(he, { key: 1 }, [
                  Je(me(I.text), 1)
                ], 64))
              ], 42, h5)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars"]));
  }
}), v5 = ["id"], f5 = {
  key: 0,
  class: "dp__sidebar_left"
}, w5 = {
  key: 1,
  class: "dp--preset-dates"
}, g5 = ["onClick", "onKeydown"], y5 = {
  key: 2,
  class: "dp__sidebar_right"
}, k5 = {
  key: 3,
  class: "dp__action_extra"
}, D1 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Ur,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    arrMapValues: { type: Object, default: () => ({}) },
    noOverlayFocus: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, l = Q(() => {
      const { openOnTop: A, ...J } = r;
      return {
        ...J,
        flowStep: ie.value,
        noOverlayFocus: r.noOverlayFocus
      };
    }), { setMenuFocused: n, setShiftKey: i, control: u } = gs(), p = Qt(), { defaultedTextInput: h, defaultedInline: d, defaultedConfig: y } = Qe(r), L = ee(null), V = ee(0), Z = ee(null), z = ee(null), $ = ee(!1), x = ee(null);
    ot(() => {
      if (!r.shadow) {
        $.value = !0, U(), window.addEventListener("resize", U);
        const A = Xe(Z);
        if (A && !h.value.enabled && !d.value.enabled && (n(!0), G()), A) {
          const J = (Le) => {
            y.value.allowPreventDefault && Le.preventDefault(), It(Le, y.value, !0);
          };
          A.addEventListener("pointerdown", J), A.addEventListener("mousedown", J);
        }
      }
    }), Da(() => {
      window.removeEventListener("resize", U);
    });
    const U = () => {
      const A = Xe(z);
      A && (V.value = A.getBoundingClientRect().width);
    }, { arrowRight: M, arrowLeft: R, arrowDown: E, arrowUp: I } = Et(), { flowStep: ie, updateFlowStep: K, childMount: w, resetFlow: D } = h0(r, s, x), N = Q(() => r.monthPicker ? $0 : r.yearPicker ? _0 : r.timePicker ? j0 : r.quarterPicker ? m5 : d5), G = () => {
      const A = Xe(Z);
      A && A.focus({ preventScroll: !0 });
    }, P = Q(() => {
      var A;
      return ((A = x.value) == null ? void 0 : A.getSidebarProps()) || {};
    }), f = () => {
      r.openOnTop && s("recalculate-position");
    }, _ = ct(p, "action"), H = Q(() => r.monthPicker || r.yearPicker ? ct(p, "monthYear") : r.timePicker ? ct(p, "timePicker") : ct(p, "shared")), Y = Q(() => r.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), m = Q(() => ({
      dp__menu_disabled: r.disabled,
      dp__menu_readonly: r.readonly
    })), o = Q(
      () => ({
        dp__menu: !0,
        dp__menu_index: !d.value.enabled,
        dp__relative: d.value.enabled,
        [r.menuClassName]: !!r.menuClassName
      })
    ), T = (A) => {
      It(A, y.value, !0);
    }, B = () => {
      r.escClose && s("close-picker");
    }, W = (A) => {
      if (r.arrowNavigation) {
        if (A === "up")
          return I();
        if (A === "down")
          return E();
        if (A === "left")
          return R();
        if (A === "right")
          return M();
      } else
        A === "left" || A === "up" ? ye("handleArrow", "left", 0, A === "up") : ye("handleArrow", "right", 0, A === "down");
    }, q = (A) => {
      i(A.shiftKey), !r.disableMonthYearSelect && A.code === "Tab" && A.target.classList.contains("dp__menu") && u.value.shiftKeyInMenu && (A.preventDefault(), It(A, y.value, !0), s("close-picker"));
    }, b = () => {
      G(), s("time-picker-close");
    }, v = (A) => {
      var J, Le, ae;
      (J = x.value) == null || J.toggleTimePicker(!1, !1), (Le = x.value) == null || Le.toggleMonthPicker(!1, !1, A), (ae = x.value) == null || ae.toggleYearPicker(!1, !1, A);
    }, oe = (A, J = 0) => {
      var Le, ae, Ye;
      return A === "month" ? (Le = x.value) == null ? void 0 : Le.toggleMonthPicker(!1, !0, J) : A === "year" ? (ae = x.value) == null ? void 0 : ae.toggleYearPicker(!1, !0, J) : A === "time" ? (Ye = x.value) == null ? void 0 : Ye.toggleTimePicker(!0, !1) : v(J);
    }, ye = (A, ...J) => {
      var Le, ae;
      (Le = x.value) != null && Le[A] && ((ae = x.value) == null || ae[A](...J));
    }, re = () => {
      ye("selectCurrentDate");
    }, Me = (A, J) => {
      ye("presetDate", A, J);
    }, de = () => {
      ye("clearHoverDate");
    };
    return t({
      updateMonthYear: (A, J) => {
        ye("updateMonthYear", A, J);
      },
      switchView: oe
    }), (A, J) => {
      var Le;
      return c(), k("div", {
        id: A.uid ? `dp-menu-${A.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: Z,
        tabindex: "0",
        role: "dialog",
        class: ue(o.value),
        onMouseleave: de,
        onClick: T,
        onKeydown: [
          be(B, ["esc"]),
          J[18] || (J[18] = be(xe((ae) => W("left"), ["prevent"]), ["left"])),
          J[19] || (J[19] = be(xe((ae) => W("up"), ["prevent"]), ["up"])),
          J[20] || (J[20] = be(xe((ae) => W("down"), ["prevent"]), ["down"])),
          J[21] || (J[21] = be(xe((ae) => W("right"), ["prevent"]), ["right"])),
          q
        ]
      }, [
        (A.disabled || A.readonly) && g(d).enabled ? (c(), k("div", {
          key: 0,
          class: ue(m.value)
        }, null, 2)) : S("", !0),
        !g(d).enabled && !A.teleportCenter ? (c(), k("div", {
          key: 1,
          class: ue(Y.value)
        }, null, 2)) : S("", !0),
        O("div", {
          ref_key: "innerMenuRef",
          ref: z,
          class: ue({
            dp__menu_content_wrapper: ((Le = A.presetDates) == null ? void 0 : Le.length) || !!A.$slots["left-sidebar"] || !!A.$slots["right-sidebar"]
          }),
          style: dt({ "--dp-menu-width": `${V.value}px` })
        }, [
          A.$slots["left-sidebar"] ? (c(), k("div", f5, [
            X(A.$slots, "left-sidebar", Ue(rt(P.value)))
          ])) : S("", !0),
          A.presetDates.length ? (c(), k("div", w5, [
            (c(!0), k(he, null, Pe(A.presetDates, (ae, Ye) => (c(), k(he, { key: Ye }, [
              ae.slot ? X(A.$slots, ae.slot, {
                key: 0,
                presetDate: Me,
                label: ae.label,
                value: ae.value
              }) : (c(), k("button", {
                key: 1,
                type: "button",
                style: dt(ae.style || {}),
                class: "dp__btn dp--preset-range",
                onClick: xe((ut) => Me(ae.value, ae.noTz), ["prevent"]),
                onKeydown: [
                  be(xe((ut) => Me(ae.value, ae.noTz), ["prevent"]), ["enter"]),
                  be(xe((ut) => Me(ae.value, ae.noTz), ["prevent"]), ["space"])
                ]
              }, me(ae.label), 45, g5))
            ], 64))), 128))
          ])) : S("", !0),
          O("div", {
            ref_key: "calendarWrapperRef",
            ref: L,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (c(), ce(Xt(N.value), Ee({
              ref_key: "dynCmpRef",
              ref: x
            }, l.value, {
              "flow-step": g(ie),
              onMount: g(w),
              onUpdateFlowStep: g(K),
              onResetFlow: g(D),
              onFocusMenu: G,
              onSelectDate: J[0] || (J[0] = (ae) => A.$emit("select-date")),
              onDateUpdate: J[1] || (J[1] = (ae) => A.$emit("date-update", ae)),
              onTooltipOpen: J[2] || (J[2] = (ae) => A.$emit("tooltip-open", ae)),
              onTooltipClose: J[3] || (J[3] = (ae) => A.$emit("tooltip-close", ae)),
              onAutoApply: J[4] || (J[4] = (ae) => A.$emit("auto-apply", ae)),
              onRangeStart: J[5] || (J[5] = (ae) => A.$emit("range-start", ae)),
              onRangeEnd: J[6] || (J[6] = (ae) => A.$emit("range-end", ae)),
              onInvalidFixedRange: J[7] || (J[7] = (ae) => A.$emit("invalid-fixed-range", ae)),
              onTimeUpdate: J[8] || (J[8] = (ae) => A.$emit("time-update")),
              onAmPmChange: J[9] || (J[9] = (ae) => A.$emit("am-pm-change", ae)),
              onTimePickerOpen: J[10] || (J[10] = (ae) => A.$emit("time-picker-open", ae)),
              onTimePickerClose: b,
              onRecalculatePosition: f,
              onUpdateMonthYear: J[11] || (J[11] = (ae) => A.$emit("update-month-year", ae)),
              onAutoApplyInvalid: J[12] || (J[12] = (ae) => A.$emit("auto-apply-invalid", ae)),
              onInvalidDate: J[13] || (J[13] = (ae) => A.$emit("invalid-date", ae)),
              "onUpdate:internalModelValue": J[14] || (J[14] = (ae) => A.$emit("update:internal-model-value", ae))
            }), it({ _: 2 }, [
              Pe(H.value, (ae, Ye) => ({
                name: ae,
                fn: ve((ut) => [
                  X(A.$slots, ae, Ue(rt({ ...ut })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          A.$slots["right-sidebar"] ? (c(), k("div", y5, [
            X(A.$slots, "right-sidebar", Ue(rt(P.value)))
          ])) : S("", !0),
          A.$slots["action-extra"] ? (c(), k("div", k5, [
            A.$slots["action-extra"] ? X(A.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: re
            }) : S("", !0)
          ])) : S("", !0)
        ], 6),
        !A.autoApply || g(y).keepActionRow ? (c(), ce(C0, Ee({
          key: 2,
          "menu-mount": $.value
        }, l.value, {
          "calendar-width": V.value,
          onClosePicker: J[15] || (J[15] = (ae) => A.$emit("close-picker")),
          onSelectDate: J[16] || (J[16] = (ae) => A.$emit("select-date")),
          onInvalidSelect: J[17] || (J[17] = (ae) => A.$emit("invalid-select")),
          onSelectNow: re
        }), it({ _: 2 }, [
          Pe(g(_), (ae, Ye) => ({
            name: ae,
            fn: ve((ut) => [
              X(A.$slots, ae, Ue(rt({ ...ut })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : S("", !0)
      ], 42, v5);
    };
  }
}), C5 = typeof window < "u" ? window : void 0, va = () => {
}, b5 = (e) => _s() ? (Os(e), !0) : !1, L5 = (e, t, a, s) => {
  if (!e)
    return va;
  let r = va;
  const l = Ft(
    () => g(e),
    (i) => {
      r(), i && (i.addEventListener(t, a, s), r = () => {
        i.removeEventListener(t, a, s), r = va;
      });
    },
    { immediate: !0, flush: "post" }
  ), n = () => {
    l(), r();
  };
  return b5(n), n;
}, M5 = (e, t, a, s = {}) => {
  const { window: r = C5, event: l = "pointerdown" } = s;
  return r ? L5(r, l, (n) => {
    const i = Xe(e), u = Xe(t);
    !i || !u || i === n.target || n.composedPath().includes(i) || n.composedPath().includes(u) || a(n);
  }, { passive: !0 }) : void 0;
}, V5 = /* @__PURE__ */ ke({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Ur
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date"
  ],
  setup(e, { expose: t, emit: a }) {
    const s = a, r = e, l = Qt(), n = ee(!1), i = Zr(r, "modelValue"), u = Zr(r, "timezone"), p = ee(null), h = ee(null), d = ee(null), y = ee(!1), L = ee(null), V = ee(!1), Z = ee(!1), { setMenuFocused: z, setShiftKey: $ } = gs(), { clearArrowNav: x } = Et(), { mapDatesArrToMap: U, validateDate: M, isValidTime: R } = Jt(r), { defaultedTransitions: E, defaultedTextInput: I, defaultedInline: ie, defaultedConfig: K } = Qe(r), { menuTransition: w, showTransition: D } = Mr(E);
    ot(() => {
      W(r.modelValue), Nt().then(() => {
        if (!ie.value.enabled) {
          const te = m(L.value);
          te == null || te.addEventListener("scroll", A), window == null || window.addEventListener("resize", J);
        }
      }), ie.value.enabled && (n.value = !0), window == null || window.addEventListener("keyup", Le), window == null || window.addEventListener("keydown", ae);
    });
    const N = Q(() => U());
    Da(() => {
      if (!ie.value.enabled) {
        const te = m(L.value);
        te == null || te.removeEventListener("scroll", A), window == null || window.removeEventListener("resize", J);
      }
      window == null || window.removeEventListener("keyup", Le), window == null || window.removeEventListener("keydown", ae);
    });
    const G = ct(l, "all", r.presetDates), P = ct(l, "input");
    Ft(
      [i, u],
      () => {
        W(i.value);
      },
      { deep: !0 }
    );
    const { openOnTop: f, menuStyle: _, xCorrect: H, setMenuPosition: Y, getScrollableParent: m, shadowRender: o } = u0({
      menuRef: p,
      menuRefInner: h,
      inputRef: d,
      pickerWrapperRef: L,
      inline: ie,
      emit: s,
      props: r,
      slots: l
    }), {
      inputValue: T,
      internalModelValue: B,
      parseExternalModelValue: W,
      emitModelValue: q,
      formatInputValue: b,
      checkBeforeEmit: v
    } = i0(s, r, y), oe = Q(
      () => ({
        dp__main: !0,
        dp__theme_dark: r.dark,
        dp__theme_light: !r.dark,
        dp__flex_display: ie.value.enabled,
        dp__flex_display_with_input: ie.value.input
      })
    ), ye = Q(() => r.dark ? "dp__theme_dark" : "dp__theme_light"), re = Q(() => ({
      to: typeof r.teleport == "boolean" ? "body" : r.teleport,
      disabled: !r.teleport || ie.value.enabled
    })), Me = Q(() => ({ class: "dp__outer_menu_wrap" })), de = Q(() => ie.value.enabled && (r.timePicker || r.monthPicker || r.yearPicker || r.quarterPicker)), A = () => {
      n.value && (K.value.closeOnScroll ? pt() : Y());
    }, J = () => {
      n.value && Y();
    }, Le = (te) => {
      te.key === "Tab" && !ie.value.enabled && !r.teleport && K.value.tabOutClosesMenu && (L.value.contains(document.activeElement) || pt()), Z.value = te.shiftKey;
    }, ae = (te) => {
      Z.value = te.shiftKey;
    }, Ye = () => {
      !r.disabled && !r.readonly && (o(D1, r), Y(!1), n.value = !0, n.value && s("open"), n.value || pr(), W(r.modelValue));
    }, ut = () => {
      var te;
      T.value = "", pr(), (te = d.value) == null || te.setParsedDate(null), s("update:model-value", null), s("update:model-timezone-value", null), s("cleared"), K.value.closeOnClearValue && pt();
    }, er = () => {
      const te = B.value;
      return !te || !Array.isArray(te) && M(te) ? !0 : Array.isArray(te) ? r.multiDates || te.length === 2 && M(te[0]) && M(te[1]) ? !0 : r.partialRange && !r.timePicker ? M(te[0]) : !1 : !1;
    }, _t = () => {
      v() && er() ? (q(), pt()) : s("invalid-select", B.value);
    }, Hr = (te) => {
      Tr(), q(), K.value.closeOnAutoApply && !te && pt();
    }, Tr = () => {
      d.value && I.value.enabled && d.value.setParsedDate(B.value);
    }, Qr = (te = !1) => {
      r.autoApply && R(B.value) && er() && (r.range && Array.isArray(B.value) ? (r.partialRange || B.value.length === 2) && Hr(te) : Hr(te));
    }, pr = () => {
      I.value.enabled || (B.value = null);
    }, pt = () => {
      ie.value.enabled || (n.value && (n.value = !1, H.value = !1, z(!1), $(!1), x(), s("closed"), T.value && W(i.value)), pr(), s("blur"));
    }, Xr = (te, Ce, ge = !1) => {
      if (!te) {
        B.value = null;
        return;
      }
      const ht = Array.isArray(te) ? !te.some((Jr) => !M(Jr)) : M(te), Ht = R(te);
      ht && Ht && (B.value = te, Ce && (V.value = ge, _t(), s("text-submit")));
    }, Gr = () => {
      r.autoApply && R(B.value) && q(), Tr();
    }, $r = () => n.value ? pt() : Ye(), C = (te) => {
      B.value = te;
    }, j = () => {
      I.value.enabled && (y.value = !0, b()), s("focus");
    }, we = () => {
      if (I.value.enabled && (y.value = !1, W(r.modelValue), V.value)) {
        const te = Y2(L.value, Z.value);
        te == null || te.focus();
      }
      s("blur");
    }, De = (te) => {
      h.value && h.value.updateMonthYear(0, {
        month: k1(te.month),
        year: k1(te.year)
      });
    }, ze = (te) => {
      W(te ?? r.modelValue);
    }, Ct = (te, Ce) => {
      var ge;
      (ge = h.value) == null || ge.switchView(te, Ce);
    }, Ot = (te) => K.value.onClickOutside ? K.value.onClickOutside(te) : pt();
    return M5(p, d, () => Ot(er)), t({
      closeMenu: pt,
      selectDate: _t,
      clearValue: ut,
      openMenu: Ye,
      onScroll: A,
      formatInputValue: b,
      // exposed for testing purposes
      updateInternalModelValue: C,
      // modify internal modelValue
      setMonthYear: De,
      parseModel: ze,
      switchView: Ct,
      toggleMenu: $r
    }), (te, Ce) => (c(), k("div", {
      ref_key: "pickerWrapperRef",
      ref: L,
      class: ue(oe.value),
      "data-datepicker-instance": ""
    }, [
      He(w0, Ee({
        ref_key: "inputRef",
        ref: d,
        "input-value": g(T),
        "onUpdate:inputValue": Ce[0] || (Ce[0] = (ge) => e1(T) ? T.value = ge : null),
        "is-menu-open": n.value
      }, te.$props, {
        onClear: ut,
        onOpen: Ye,
        onSetInputDate: Xr,
        onSetEmptyDate: g(q),
        onSelectDate: _t,
        onToggle: $r,
        onClose: pt,
        onFocus: j,
        onBlur: we,
        onRealBlur: Ce[1] || (Ce[1] = (ge) => y.value = !1)
      }), it({ _: 2 }, [
        Pe(g(P), (ge, ht) => ({
          name: ge,
          fn: ve((Ht) => [
            X(te.$slots, ge, Ue(rt(Ht)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      He($s, Ue(rt(re.value)), {
        default: ve(() => [
          He(dr, {
            name: g(w)(g(f)),
            css: g(D) && !g(ie).enabled
          }, {
            default: ve(() => [
              n.value ? (c(), k("div", Ee({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: p
              }, Me.value, {
                class: { "dp--menu-wrapper": !g(ie).enabled },
                style: g(ie).enabled ? void 0 : g(_)
              }), [
                He(D1, Ee({
                  ref_key: "dpMenuRef",
                  ref: h
                }, te.$props, {
                  "internal-model-value": g(B),
                  "onUpdate:internalModelValue": Ce[2] || (Ce[2] = (ge) => e1(B) ? B.value = ge : null),
                  class: { [ye.value]: !0, "dp--menu-wrapper": te.teleport },
                  "open-on-top": g(f),
                  "arr-map-values": N.value,
                  "no-overlay-focus": de.value,
                  onClosePicker: pt,
                  onSelectDate: _t,
                  onAutoApply: Qr,
                  onTimeUpdate: Gr,
                  onFlowStep: Ce[3] || (Ce[3] = (ge) => te.$emit("flow-step", ge)),
                  onUpdateMonthYear: Ce[4] || (Ce[4] = (ge) => te.$emit("update-month-year", ge)),
                  onInvalidSelect: Ce[5] || (Ce[5] = (ge) => te.$emit("invalid-select", g(B))),
                  onAutoApplyInvalid: Ce[6] || (Ce[6] = (ge) => te.$emit("invalid-select", ge)),
                  onInvalidFixedRange: Ce[7] || (Ce[7] = (ge) => te.$emit("invalid-fixed-range", ge)),
                  onRecalculatePosition: g(Y),
                  onTooltipOpen: Ce[8] || (Ce[8] = (ge) => te.$emit("tooltip-open", ge)),
                  onTooltipClose: Ce[9] || (Ce[9] = (ge) => te.$emit("tooltip-close", ge)),
                  onTimePickerOpen: Ce[10] || (Ce[10] = (ge) => te.$emit("time-picker-open", ge)),
                  onTimePickerClose: Ce[11] || (Ce[11] = (ge) => te.$emit("time-picker-close", ge)),
                  onAmPmChange: Ce[12] || (Ce[12] = (ge) => te.$emit("am-pm-change", ge)),
                  onRangeStart: Ce[13] || (Ce[13] = (ge) => te.$emit("range-start", ge)),
                  onRangeEnd: Ce[14] || (Ce[14] = (ge) => te.$emit("range-end", ge)),
                  onDateUpdate: Ce[15] || (Ce[15] = (ge) => te.$emit("date-update", ge)),
                  onInvalidDate: Ce[16] || (Ce[16] = (ge) => te.$emit("invalid-date", ge))
                }), it({ _: 2 }, [
                  Pe(g(G), (ge, ht) => ({
                    name: ge,
                    fn: ve((Ht) => [
                      X(te.$slots, ge, Ue(rt({ ...Ht })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "arr-map-values", "no-overlay-focus", "onRecalculatePosition"])
              ], 16)) : S("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), ja = /* @__PURE__ */ (() => {
  const e = V5;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), x5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ja
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(x5).forEach(([e, t]) => {
  e !== "default" && (ja[e] = t);
});
const D5 = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', Ms = (e, t, a) => {
  const s = Array.from(
    document.querySelectorAll(D5)
  ).filter((n) => n.tabIndex >= 0 && n.getClientRects().length > 0), r = s.findIndex((n) => n === t || n.contains(t));
  return r === -1 ? null : (a ? s.slice(0, r).reverse() : s.slice(r + 1)).find((n) => !e.contains(n)) ?? null;
}, fa = [
  "day",
  "month",
  "year",
  "hour",
  "minute",
  "second"
], H5 = ke({
  name: "KDateTimePicker",
  components: {
    Datepicker: ja,
    KIcon: St
  },
  emits: ["blur", "close", "focus", "open", "update:modelValue"],
  props: {
    modelValue: {
      type: Date,
      required: !1,
      default: null
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    clearable: {
      type: Boolean,
      required: !1,
      default: !1
    },
    minDate: {
      type: Date,
      required: !1,
      default: null
    },
    minDateTime: {
      type: Date,
      required: !1,
      default: null
    },
    maxDate: {
      type: Date,
      required: !1,
      default: null
    },
    maxDateTime: {
      type: Date,
      required: !1,
      default: null
    },
    minTime: {
      type: Date,
      required: !1,
      default: null
    },
    maxTime: {
      type: Date,
      required: !1,
      default: null
    },
    timezone: {
      type: String,
      required: !1,
      default: "utc"
    }
  },
  data() {
    return {
      isOpen: !1,
      isInputFocused: !1,
      position: "below",
      draftValue: null,
      panelHeight: null,
      calendarResizeObserver: null,
      activeSegment: "day",
      suppressEscapeKeyup: !1,
      segmentInputBuffer: "",
      segmentInputBufferPart: "day",
      segmentInputBufferAt: 0,
      dateInputs: {
        day: "",
        month: "",
        year: ""
      },
      timeInputs: {
        hour: "",
        minute: "",
        second: ""
      }
    };
  },
  computed: {
    hasValue() {
      return this.normalizedModelValue !== null;
    },
    normalizedModelValue() {
      return this.normalizeDate(this.modelValue);
    },
    normalizedMinDate() {
      return this.normalizeDate(this.minDate);
    },
    normalizedMinDateTime() {
      return this.normalizeDate(this.minDateTime);
    },
    normalizedMaxDate() {
      return this.normalizeDate(this.maxDate);
    },
    normalizedMaxDateTime() {
      return this.normalizeDate(this.maxDateTime);
    },
    normalizedMinTime() {
      return this.normalizeDate(this.minTime);
    },
    normalizedMaxTime() {
      return this.normalizeDate(this.maxTime);
    },
    rootClasses() {
      return [
        "kcl-date-time-picker",
        {
          "is-open": this.isOpen,
          "is-disabled": this.disabled,
          "is-focused": this.isInputFocused,
          "is-empty": !this.hasVisibleValue(),
          "opens-above": this.isOpen && this.position === "above",
          "opens-below": this.isOpen && this.position === "below"
        }
      ];
    },
    popoverBodyStyles() {
      return this.panelHeight === null ? {} : {
        height: `${this.panelHeight}px`
      };
    },
    pickerValue() {
      return this.toPickerDate(this.draftValue ?? this.createDefaultDate()) ?? this.createDefaultDate();
    },
    pickerMinDate() {
      return this.toPickerDate(
        this.normalizedMinDateTime ?? (this.normalizedMinDate ? this.getStartOfDay(this.normalizedMinDate) : null)
      );
    },
    pickerMaxDate() {
      return this.toPickerDate(
        this.normalizedMaxDateTime ?? (this.normalizedMaxDate ? this.getEndOfDay(this.normalizedMaxDate) : null)
      );
    },
    hourOptions() {
      return this.createTimeOptions(24);
    },
    minuteOptions() {
      return this.createTimeOptions(60);
    },
    secondOptions() {
      return this.createTimeOptions(60);
    }
  },
  watch: {
    modelValue() {
      this.syncWithinBounds();
    },
    minDate() {
      this.syncWithinBounds();
    },
    minDateTime() {
      this.syncWithinBounds();
    },
    maxDate() {
      this.syncWithinBounds();
    },
    maxDateTime() {
      this.syncWithinBounds();
    },
    minTime() {
      this.syncWithinBounds();
    },
    maxTime() {
      this.syncWithinBounds();
    },
    disabled(e) {
      e && this.closePicker();
    }
  },
  created() {
    this.syncWithinBounds();
  },
  mounted() {
    document.addEventListener("pointerdown", this.handleDocumentPointerDown), window.addEventListener("resize", this.updatePopoverPosition);
  },
  beforeUnmount() {
    this.disconnectCalendarResizeObserver(), document.removeEventListener("pointerdown", this.handleDocumentPointerDown), window.removeEventListener("resize", this.updatePopoverPosition);
  },
  methods: {
    normalizeDate(e) {
      return !(e instanceof Date) || Number.isNaN(e.getTime()) ? null : new Date(e.getTime());
    },
    getDateParts(e) {
      return this.timezone === "utc" ? {
        year: e.getUTCFullYear(),
        month: e.getUTCMonth() + 1,
        day: e.getUTCDate(),
        hour: e.getUTCHours(),
        minute: e.getUTCMinutes(),
        second: e.getUTCSeconds()
      } : {
        year: e.getFullYear(),
        month: e.getMonth() + 1,
        day: e.getDate(),
        hour: e.getHours(),
        minute: e.getMinutes(),
        second: e.getSeconds()
      };
    },
    getLocalDateParts(e) {
      return {
        year: e.getFullYear(),
        month: e.getMonth() + 1,
        day: e.getDate(),
        hour: e.getHours(),
        minute: e.getMinutes(),
        second: e.getSeconds()
      };
    },
    buildDateFromParts(e) {
      return this.timezone === "utc" ? new Date(
        Date.UTC(
          e.year,
          e.month - 1,
          e.day,
          e.hour,
          e.minute,
          e.second,
          0
        )
      ) : new Date(
        e.year,
        e.month - 1,
        e.day,
        e.hour,
        e.minute,
        e.second,
        0
      );
    },
    buildDateWithTime(e, t) {
      const a = this.getDateParts(e), s = this.getDateParts(t);
      return this.buildDateFromParts({
        ...a,
        hour: s.hour,
        minute: s.minute,
        second: s.second
      });
    },
    getStartOfDay(e) {
      const t = this.getDateParts(e);
      return this.buildDateFromParts({
        ...t,
        hour: 0,
        minute: 0,
        second: 0
      });
    },
    getEndOfDay(e) {
      const t = this.buildDateFromParts({
        ...this.getDateParts(e),
        hour: 23,
        minute: 59,
        second: 59
      });
      return t.setMilliseconds(999), t;
    },
    toPickerDate(e) {
      if (!e)
        return null;
      const t = this.getDateParts(e);
      return new Date(
        t.year,
        t.month - 1,
        t.day,
        t.hour,
        t.minute,
        t.second,
        0
      );
    },
    getLatestDate(...e) {
      return e.reduce((t, a) => a && (!t || a.getTime() > t.getTime()) ? a : t, null);
    },
    getEarliestDate(...e) {
      return e.reduce((t, a) => a && (!t || a.getTime() < t.getTime()) ? a : t, null);
    },
    getMinimumDateTime(e) {
      const t = this.normalizedMinDateTime;
      if (t)
        return t;
      const a = this.normalizedMinTime ? this.buildDateWithTime(e, this.normalizedMinTime) : null;
      return this.getLatestDate(
        this.normalizedMinDate ? this.getStartOfDay(this.normalizedMinDate) : null,
        a
      );
    },
    getMaximumDateTime(e) {
      const t = this.normalizedMaxDateTime;
      if (t)
        return t;
      const a = this.normalizedMaxTime ? this.buildDateWithTime(e, this.normalizedMaxTime) : null;
      return this.getEarliestDate(
        this.normalizedMaxDate ? this.getEndOfDay(this.normalizedMaxDate) : null,
        a
      );
    },
    isWithinBounds(e) {
      const t = this.getMinimumDateTime(e), a = this.getMaximumDateTime(e);
      return !(t && e.getTime() < t.getTime() || a && e.getTime() > a.getTime());
    },
    clampDate(e) {
      let t = new Date(e.getTime());
      const a = this.getMinimumDateTime(t), s = this.getMaximumDateTime(t);
      return a && s && a.getTime() > s.getTime() ? new Date(a.getTime()) : (a && t.getTime() < a.getTime() && (t = new Date(a.getTime())), s && t.getTime() > s.getTime() && (t = new Date(s.getTime())), t);
    },
    createDefaultDate() {
      return this.clampDate(this.normalizedModelValue ?? /* @__PURE__ */ new Date());
    },
    createTimeOptions(e) {
      return Array.from({ length: e }, (t, a) => a);
    },
    padValue(e, t) {
      return String(e).padStart(t, "0");
    },
    segmentMaxLength(e) {
      return e === "year" ? 4 : 2;
    },
    getSegmentValue(e) {
      return e === "day" || e === "month" || e === "year" ? this.dateInputs[e] : this.timeInputs[e];
    },
    setSegmentValue(e, t) {
      if (e === "day" || e === "month" || e === "year") {
        this.dateInputs = {
          ...this.dateInputs,
          [e]: t
        };
        return;
      }
      this.timeInputs = {
        ...this.timeInputs,
        [e]: t
      };
    },
    segmentDisplayValue(e, t) {
      return this.getSegmentValue(e) || t;
    },
    isTimeOptionDisabled(e, t) {
      const a = this.composeDateFromSegments() ?? this.draftValue ?? this.createDefaultDate(), s = this.getDateParts(a);
      return !this.isWithinBounds(
        this.buildDateFromParts({
          ...s,
          [e]: t
        })
      );
    },
    segmentClasses(e) {
      return {
        "is-active": this.isInputFocused && this.activeSegment === e,
        "is-placeholder": this.getSegmentValue(e).length === 0
      };
    },
    resetSegmentInputBuffer() {
      this.segmentInputBuffer = "", this.segmentInputBufferAt = 0;
    },
    moveActiveSegment(e) {
      const t = fa.indexOf(this.activeSegment), a = Math.min(
        Math.max(t + e, 0),
        fa.length - 1
      );
      this.activeSegment = fa[a], this.resetSegmentInputBuffer();
    },
    hasVisibleValue() {
      return this.dateInputs.day.length > 0 || this.dateInputs.month.length > 0 || this.dateInputs.year.length > 0 || this.timeInputs.hour.length > 0 || this.timeInputs.minute.length > 0 || this.timeInputs.second.length > 0;
    },
    syncSegmentsFromDate(e) {
      if (!e) {
        this.dateInputs = {
          day: "",
          month: "",
          year: ""
        }, this.timeInputs = {
          hour: "",
          minute: "",
          second: ""
        };
        return;
      }
      const t = this.getDateParts(e);
      this.dateInputs = {
        day: this.padValue(t.day, 2),
        month: this.padValue(t.month, 2),
        year: this.padValue(t.year, 4)
      }, this.timeInputs = {
        hour: this.padValue(t.hour, 2),
        minute: this.padValue(t.minute, 2),
        second: this.padValue(t.second, 2)
      };
    },
    syncFromModelValue() {
      const e = this.normalizedModelValue;
      this.draftValue = e ? new Date(e.getTime()) : this.createDefaultDate(), this.syncSegmentsFromDate(e);
    },
    syncWithinBounds() {
      const e = this.normalizedModelValue;
      if (!e) {
        this.syncFromModelValue();
        return;
      }
      const t = this.clampDate(e);
      if (t.getTime() !== e.getTime()) {
        this.$emit("update:modelValue", t);
        return;
      }
      this.syncFromModelValue();
    },
    getCalendarMeasuredElement() {
      const e = this.$refs.calendarWrapper;
      if (!e)
        return null;
      const t = e.querySelector(
        ".dp__menu, .dp__main, .dp__instance_calendar"
      );
      return t instanceof HTMLElement ? t : e;
    },
    measureCalendarHeight() {
      const e = this.getCalendarMeasuredElement();
      if (!e) {
        this.panelHeight = null;
        return;
      }
      const t = Math.ceil(
        Math.max(
          e.getBoundingClientRect().height,
          e.scrollHeight,
          e.offsetHeight
        )
      );
      t > 0 && (this.panelHeight = t, this.$nextTick(() => {
        this.updatePopoverPosition();
      }));
    },
    updatePopoverPosition() {
      if (!this.isOpen) {
        this.position = "below";
        return;
      }
      const e = this.$refs.root, t = e == null ? void 0 : e.querySelector(".kcl-date-time-picker--popover");
      if (!(e instanceof HTMLElement) || !(t instanceof HTMLElement))
        return;
      const a = e.getBoundingClientRect(), s = t.getBoundingClientRect(), r = window.innerHeight - a.bottom, l = a.top;
      this.position = s.height > r && l > r ? "above" : "below";
    },
    connectCalendarResizeObserver() {
      const e = this.getCalendarMeasuredElement();
      if (e) {
        if (this.disconnectCalendarResizeObserver(), typeof ResizeObserver > "u") {
          this.measureCalendarHeight();
          return;
        }
        this.calendarResizeObserver = new ResizeObserver(() => {
          this.measureCalendarHeight();
        }), this.calendarResizeObserver.observe(e), this.measureCalendarHeight();
      }
    },
    disconnectCalendarResizeObserver() {
      var e;
      (e = this.calendarResizeObserver) == null || e.disconnect(), this.calendarResizeObserver = null, this.panelHeight = null;
    },
    setDraftValue(e) {
      const t = new Date(e.getTime());
      this.draftValue = t, this.syncSegmentsFromDate(t);
    },
    emitDateValue(e) {
      const t = this.clampDate(e);
      this.setDraftValue(t), this.$emit("update:modelValue", t), this.isOpen && this.$nextTick(() => {
        this.scrollTimeColumnsToSelection();
      });
    },
    composeDateFromSegments() {
      if ([
        this.dateInputs.day,
        this.dateInputs.month,
        this.dateInputs.year,
        this.timeInputs.hour,
        this.timeInputs.minute,
        this.timeInputs.second
      ].some((r) => r.length === 0))
        return null;
      const t = {
        day: Number(this.dateInputs.day),
        month: Number(this.dateInputs.month),
        year: Number(this.dateInputs.year),
        hour: Number(this.timeInputs.hour),
        minute: Number(this.timeInputs.minute),
        second: Number(this.timeInputs.second)
      }, a = this.buildDateFromParts(t), s = this.getDateParts(a);
      return s.day !== t.day || s.month !== t.month || s.year !== t.year || s.hour !== t.hour || s.minute !== t.minute || s.second !== t.second ? null : a;
    },
    commitSegments() {
      if (!this.hasVisibleValue()) {
        this.clearable ? (this.$emit("update:modelValue", null), this.syncSegmentsFromDate(null)) : this.syncSegmentsFromDate(this.normalizedModelValue);
        return;
      }
      const e = this.composeDateFromSegments();
      if (!e) {
        this.syncSegmentsFromDate(this.normalizedModelValue);
        return;
      }
      this.emitDateValue(e);
    },
    openPicker() {
      this.disabled || this.isOpen || (this.hasValue || this.setDraftValue(this.createDefaultDate()), this.isOpen = !0, this.$emit("open"), this.$nextTick(() => {
        this.connectCalendarResizeObserver(), this.scrollTimeColumnsToSelection(), this.updatePopoverPosition();
      }));
    },
    closePicker() {
      if (!this.isOpen) {
        this.hasValue || this.syncSegmentsFromDate(null);
        return;
      }
      this.isOpen = !1, this.position = "below", this.disconnectCalendarResizeObserver(), this.hasValue || this.syncSegmentsFromDate(null), this.$emit("close");
    },
    togglePicker() {
      if (this.isOpen) {
        this.commitSegments(), this.closePicker();
        return;
      }
      this.openPicker(), this.focusFirstSegment();
    },
    clearValue() {
      this.$emit("update:modelValue", null), this.draftValue = this.createDefaultDate(), this.syncSegmentsFromDate(null), this.closePicker();
    },
    focusFirstSegment() {
      this.disabled || (this.openPicker(), this.$nextTick(() => {
        this.activeSegment = "day";
        const e = this.$refs.editor;
        e == null || e.focus();
      }));
    },
    focusSegment(e) {
      this.disabled || (this.activeSegment = e, this.openPicker(), this.$nextTick(() => {
        const t = this.$refs.editor;
        t == null || t.focus();
      }));
    },
    handleEditorFocus() {
      this.disabled || (this.isInputFocused = !0, this.openPicker(), this.$emit("focus"));
    },
    handleEditorBlur() {
      window.setTimeout(() => {
        const e = this.$refs.root, t = document.activeElement;
        e && t instanceof Node && e.contains(t) || (this.isInputFocused = !1, this.commitSegments(), this.closePicker(), this.$emit("blur"));
      }, 0);
    },
    handleRootKeydown(e) {
      if (e.key === "Tab") {
        this.handleTabNavigation(e);
        return;
      }
      e.key !== "Escape" || !this.isOpen || (e.preventDefault(), e.stopPropagation(), this.suppressEscapeKeyup = !0, this.resetSegmentInputBuffer(), this.syncSegmentsFromDate(this.normalizedModelValue), this.closePicker());
    },
    handleRootKeyup(e) {
      e.key !== "Escape" || !this.suppressEscapeKeyup || (e.preventDefault(), e.stopPropagation(), this.suppressEscapeKeyup = !1);
    },
    handleTabNavigation(e) {
      const t = this.$refs.root, a = document.activeElement;
      if (!t || !(a instanceof HTMLElement) || !t.contains(a))
        return;
      const s = Ms(
        t,
        a,
        e.shiftKey
      );
      this.isInputFocused = !1, this.commitSegments(), this.closePicker(), e.preventDefault(), e.stopPropagation(), s ? s.focus() : a.blur();
    },
    handleEditorKeydown(e) {
      if (e.key === "ArrowLeft") {
        e.preventDefault(), this.moveActiveSegment(-1);
        return;
      }
      if (e.key === "ArrowRight") {
        e.preventDefault(), this.moveActiveSegment(1);
        return;
      }
      if (e.key === "Enter") {
        e.preventDefault(), this.commitSegments();
        return;
      }
      if (e.key === "ArrowUp") {
        e.preventDefault(), this.stepSegment(this.activeSegment, 1);
        return;
      }
      if (e.key === "ArrowDown") {
        e.preventDefault(), this.stepSegment(this.activeSegment, -1);
        return;
      }
      if (e.key === "Backspace" || e.key === "Delete") {
        e.preventDefault(), this.setSegmentValue(this.activeSegment, ""), this.resetSegmentInputBuffer();
        return;
      }
      e.key !== "Escape" && /^\d$/.test(e.key) && (e.preventDefault(), this.handleSegmentDigitInput(this.activeSegment, e.key));
    },
    handleSegmentDigitInput(e, t) {
      const a = Date.now(), r = `${this.segmentInputBufferPart === e && a - this.segmentInputBufferAt < 1200 ? this.segmentInputBuffer : ""}${t}`.slice(
        -this.segmentMaxLength(e)
      );
      this.segmentInputBuffer = r, this.segmentInputBufferPart = e, this.segmentInputBufferAt = a, this.setSegmentValue(e, r), r.length >= this.segmentMaxLength(e) && (this.commitSegments(), this.moveActiveSegment(1));
    },
    stepSegment(e, t) {
      const a = this.composeDateFromSegments() ?? this.draftValue ?? this.createDefaultDate(), s = new Date(a.getTime());
      if (this.timezone === "utc")
        switch (e) {
          case "day":
            s.setUTCDate(s.getUTCDate() + t);
            break;
          case "month":
            s.setUTCMonth(s.getUTCMonth() + t);
            break;
          case "year":
            s.setUTCFullYear(s.getUTCFullYear() + t);
            break;
          case "hour":
            s.setUTCHours(s.getUTCHours() + t);
            break;
          case "minute":
            s.setUTCMinutes(s.getUTCMinutes() + t);
            break;
          case "second":
            s.setUTCSeconds(s.getUTCSeconds() + t);
            break;
        }
      else
        switch (e) {
          case "day":
            s.setDate(s.getDate() + t);
            break;
          case "month":
            s.setMonth(s.getMonth() + t);
            break;
          case "year":
            s.setFullYear(s.getFullYear() + t);
            break;
          case "hour":
            s.setHours(s.getHours() + t);
            break;
          case "minute":
            s.setMinutes(s.getMinutes() + t);
            break;
          case "second":
            s.setSeconds(s.getSeconds() + t);
            break;
        }
      this.emitDateValue(s);
    },
    selectTimeOption(e, t) {
      if (this.isTimeOptionDisabled(e, t))
        return;
      const a = this.composeDateFromSegments() ?? this.draftValue ?? this.createDefaultDate(), s = this.getDateParts(a);
      this.emitDateValue(
        this.buildDateFromParts({
          ...s,
          [e]: t
        })
      );
    },
    scrollTimeColumnsToSelection() {
      const e = this.$refs.content;
      e && ["hour", "minute", "second"].forEach(
        (t) => {
          const a = e.querySelector(
            `.kcl-date-time-picker--time-options[data-time-part="${t}"]`
          ), s = a == null ? void 0 : a.querySelector(".is-selected");
          !(a instanceof HTMLElement) || !(s instanceof HTMLElement) || (a.scrollTop = Math.max(
            s.offsetTop - a.clientHeight / 2 + s.clientHeight / 2,
            0
          ));
        }
      );
    },
    handleCalendarChange(e) {
      if (!(e instanceof Date) || Number.isNaN(e.getTime()))
        return;
      const t = this.getLocalDateParts(e), a = this.composeDateFromSegments() ?? this.draftValue ?? this.createDefaultDate(), s = this.getDateParts(a);
      this.emitDateValue(
        this.buildDateFromParts({
          year: t.year,
          month: t.month,
          day: t.day,
          hour: s.hour,
          minute: s.minute,
          second: s.second
        })
      );
    },
    handleDocumentPointerDown(e) {
      const t = this.$refs.root, a = e.target;
      !t || !(a instanceof Node) || t.contains(a) || (this.isInputFocused = !1, this.commitSegments(), this.closePicker());
    }
  }
}), T5 = { class: "kcl-date-time-picker--control" }, $5 = { class: "kcl-date-time-picker--value" }, S5 = ["tabindex"], _5 = { class: "kcl-date-time-picker--field-group" }, O5 = { class: "kcl-date-time-picker--field-group is-time" }, P5 = {
  key: 0,
  class: "kcl-date-time-picker--popover"
}, B5 = {
  class: "kcl-date-time-picker--calendar-wrapper",
  ref: "calendarWrapper"
}, Z5 = { class: "kcl-date-time-picker--side-panel" }, A5 = { class: "kcl-date-time-picker--time-columns" }, R5 = { class: "kcl-date-time-picker--time-column" }, I5 = { class: "kcl-date-time-picker--time-options-shell" }, Y5 = {
  class: "kcl-date-time-picker--time-options",
  "data-time-part": "hour"
}, N5 = ["disabled", "onClick"], F5 = { class: "kcl-date-time-picker--time-column" }, E5 = { class: "kcl-date-time-picker--time-options-shell" }, z5 = {
  class: "kcl-date-time-picker--time-options",
  "data-time-part": "minute"
}, q5 = ["disabled", "onClick"], U5 = { class: "kcl-date-time-picker--time-column" }, K5 = { class: "kcl-date-time-picker--time-options-shell" }, W5 = {
  class: "kcl-date-time-picker--time-options",
  "data-time-part": "second"
}, j5 = ["disabled", "onClick"];
function Q5(e, t, a, s, r, l) {
  const n = Ae("KIcon"), i = Ae("Datepicker");
  return c(), k("div", {
    class: ue(e.rootClasses),
    ref: "root",
    onKeydown: t[10] || (t[10] = (...u) => e.handleRootKeydown && e.handleRootKeydown(...u)),
    onKeyup: t[11] || (t[11] = (...u) => e.handleRootKeyup && e.handleRootKeyup(...u))
  }, [
    O("div", T5, [
      He(n, {
        class: "kcl-date-time-picker--leading-icon",
        name: e.disabled ? "lock" : "calendar",
        onClick: e.focusFirstSegment
      }, null, 8, ["name", "onClick"]),
      O("div", $5, [
        O("div", {
          class: "kcl-date-time-picker--editor",
          ref: "editor",
          tabindex: e.disabled ? -1 : 0,
          role: "group",
          "aria-label": "Date and time input",
          onFocus: t[6] || (t[6] = (...u) => e.handleEditorFocus && e.handleEditorFocus(...u)),
          onBlur: t[7] || (t[7] = (...u) => e.handleEditorBlur && e.handleEditorBlur(...u)),
          onKeydown: t[8] || (t[8] = (...u) => e.handleEditorKeydown && e.handleEditorKeydown(...u))
        }, [
          O("div", _5, [
            O("span", {
              class: ue(["kcl-date-time-picker--segment", e.segmentClasses("day")]),
              onClick: t[0] || (t[0] = (u) => e.focusSegment("day"))
            }, me(e.segmentDisplayValue("day", "DD")), 3),
            t[12] || (t[12] = O("span", { class: "kcl-date-time-picker--separator" }, "/", -1)),
            O("span", {
              class: ue(["kcl-date-time-picker--segment", e.segmentClasses("month")]),
              onClick: t[1] || (t[1] = (u) => e.focusSegment("month"))
            }, me(e.segmentDisplayValue("month", "MM")), 3),
            t[13] || (t[13] = O("span", { class: "kcl-date-time-picker--separator" }, "/", -1)),
            O("span", {
              class: ue(["kcl-date-time-picker--segment is-year", e.segmentClasses("year")]),
              onClick: t[2] || (t[2] = (u) => e.focusSegment("year"))
            }, me(e.segmentDisplayValue("year", "YYYY")), 3)
          ]),
          O("div", O5, [
            O("span", {
              class: ue(["kcl-date-time-picker--segment", e.segmentClasses("hour")]),
              onClick: t[3] || (t[3] = (u) => e.focusSegment("hour"))
            }, me(e.segmentDisplayValue("hour", "HH")), 3),
            t[14] || (t[14] = O("span", { class: "kcl-date-time-picker--separator" }, ":", -1)),
            O("span", {
              class: ue(["kcl-date-time-picker--segment", e.segmentClasses("minute")]),
              onClick: t[4] || (t[4] = (u) => e.focusSegment("minute"))
            }, me(e.segmentDisplayValue("minute", "MM")), 3),
            t[15] || (t[15] = O("span", { class: "kcl-date-time-picker--separator" }, ":", -1)),
            O("span", {
              class: ue(["kcl-date-time-picker--segment", e.segmentClasses("second")]),
              onClick: t[5] || (t[5] = (u) => e.focusSegment("second"))
            }, me(e.segmentDisplayValue("second", "SS")), 3)
          ])
        ], 40, S5)
      ]),
      e.clearable && e.hasValue && !e.disabled ? (c(), k("button", {
        key: 0,
        class: "kcl-date-time-picker--clear",
        type: "button",
        "aria-label": "Clear date and time",
        onClick: t[9] || (t[9] = xe((...u) => e.clearValue && e.clearValue(...u), ["stop", "prevent"]))
      }, [
        He(n, { name: "16/cross" })
      ])) : S("", !0)
    ]),
    e.isOpen ? (c(), k("section", P5, [
      O("div", {
        class: "kcl-date-time-picker--popover-body",
        style: dt(e.popoverBodyStyles)
      }, [
        O("div", B5, [
          He(i, {
            class: "kcl-date-time-picker--calendar",
            modelValue: e.pickerValue,
            minDate: e.pickerMinDate,
            maxDate: e.pickerMaxDate,
            inline: !0,
            autoApply: !0,
            enableTimePicker: !1,
            dark: !0,
            monthChangeOnScroll: !1,
            "onUpdate:modelValue": e.handleCalendarChange
          }, null, 8, ["modelValue", "minDate", "maxDate", "onUpdate:modelValue"])
        ], 512),
        O("aside", Z5, [
          O("div", A5, [
            O("div", R5, [
              t[16] || (t[16] = O("span", { class: "kcl-date-time-picker--time-column-label" }, "HH", -1)),
              O("div", I5, [
                O("div", Y5, [
                  (c(!0), k(he, null, Pe(e.hourOptions, (u) => (c(), k("button", {
                    class: ue(["kcl-date-time-picker--time-option", { "is-selected": e.timeInputs.hour === e.padValue(u, 2) }]),
                    key: `hour-${u}`,
                    type: "button",
                    disabled: e.disabled || e.isTimeOptionDisabled("hour", u),
                    onClick: xe((p) => e.selectTimeOption("hour", u), ["prevent"])
                  }, me(e.padValue(u, 2)), 11, N5))), 128))
                ])
              ])
            ]),
            O("div", F5, [
              t[17] || (t[17] = O("span", { class: "kcl-date-time-picker--time-column-label" }, "MM", -1)),
              O("div", E5, [
                O("div", z5, [
                  (c(!0), k(he, null, Pe(e.minuteOptions, (u) => (c(), k("button", {
                    class: ue(["kcl-date-time-picker--time-option", { "is-selected": e.timeInputs.minute === e.padValue(u, 2) }]),
                    key: `minute-${u}`,
                    type: "button",
                    disabled: e.disabled || e.isTimeOptionDisabled("minute", u),
                    onClick: xe((p) => e.selectTimeOption("minute", u), ["prevent"])
                  }, me(e.padValue(u, 2)), 11, q5))), 128))
                ])
              ])
            ]),
            O("div", U5, [
              t[18] || (t[18] = O("span", { class: "kcl-date-time-picker--time-column-label" }, "SS", -1)),
              O("div", K5, [
                O("div", W5, [
                  (c(!0), k(he, null, Pe(e.secondOptions, (u) => (c(), k("button", {
                    class: ue(["kcl-date-time-picker--time-option", { "is-selected": e.timeInputs.second === e.padValue(u, 2) }]),
                    key: `second-${u}`,
                    type: "button",
                    disabled: e.disabled || e.isTimeOptionDisabled("second", u),
                    onClick: xe((p) => e.selectTimeOption("second", u), ["prevent"])
                  }, me(e.padValue(u, 2)), 11, j5))), 128))
                ])
              ])
            ])
          ])
        ])
      ], 4)
    ])) : S("", !0)
  ], 34);
}
const X5 = /* @__PURE__ */ Ie(H5, [["render", Q5]]), G5 = ke({
  name: "KButton",
  components: {
    KIcon: St
  },
  emits: ["click"],
  data() {
    return {
      rootClass: "kcl-button"
    };
  },
  props: {
    onClick: {
      type: Function,
      required: !1,
      default: (e) => e.preventDefault()
    },
    text: {
      type: String,
      required: !1,
      default: null
    },
    icon: {
      type: String,
      required: !1
    },
    type: {
      type: String,
      required: !1,
      default: "button"
    },
    href: {
      type: String,
      required: !1,
      default: null
    },
    target: {
      type: String,
      required: !1,
      default: "_self"
    },
    variant: {
      type: String,
      required: !1
    },
    block: {
      type: Boolean,
      default: !1
    },
    outline: {
      type: Boolean,
      default: !1
    },
    small: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  computed: {
    tag() {
      return this.href ? "a" : "button";
    },
    props() {
      return {
        class: this.classnames,
        ...this.buttonProps,
        ...this.linkProps
      };
    },
    buttonProps() {
      return this.isButton ? {
        type: this.type ?? "button"
      } : {};
    },
    linkProps() {
      return this.isLink ? {
        href: this.href ?? "#",
        target: this.target === "_self" ? null : this.target
      } : {};
    },
    hasAddon() {
      return this.hasAddonLeft || this.hasAddonRight;
    },
    hasAddonLeft() {
      return this.hasIcon || !!this.$slots.addonLeft;
    },
    hasAddonRight() {
      return !!this.$slots.addonRight;
    },
    hasContent() {
      return this.hasText || this.hasSlot ? !0 : !this.hasAddon;
    },
    hasIcon() {
      return this.icon ? this.icon.length > 0 : !1;
    },
    eventListeners() {
      return this.isLink ? {} : {
        click: this.onClick
      };
    },
    classnames() {
      return [this.rootClass, this.variantClass, this.modifierClasses];
    },
    resolvedVariant() {
      return !this.variant || this.variant.length === 0 ? "default" : this.variant;
    },
    variantClass() {
      return `${this.rootClass}-${this.resolvedVariant}`;
    },
    modifierClasses() {
      return {
        "is-block": this.block,
        "is-outline": this.outline,
        "is-small": this.small,
        "is-loading": this.loading,
        "is-disabled": this.disabled
      };
    },
    isButton() {
      return this.tag === "button";
    },
    isLink() {
      return this.tag === "a";
    },
    hasSlot() {
      return typeof this.$slots.default == "function";
    },
    hasText() {
      return this.text !== null && this.text.length > 0;
    },
    activityIndicatorIcon() {
      return "activityIndicator";
    }
  }
}), J5 = { class: "kcl-button--inner" }, eu = {
  key: 0,
  class: "kcl-button--addon"
}, tu = {
  key: 1,
  class: "kcl-button--content"
}, ru = {
  key: 2,
  class: "kcl-button--addon"
}, au = {
  key: 0,
  class: "kcl-button--activity-indicator"
};
function su(e, t, a, s, r, l) {
  const n = Ae("KIcon");
  return c(), ce(Xt(e.tag), Ee(e.props, Bs(e.eventListeners), { disabled: e.disabled }), {
    default: ve(() => [
      O("div", J5, [
        e.hasAddonLeft ? (c(), k("div", eu, [
          e.hasIcon ? (c(), ce(n, {
            key: 0,
            name: e.icon
          }, null, 8, ["name"])) : X(e.$slots, "addonLeft", {}, void 0, void 0, 1)
        ])) : S("", !0),
        e.hasContent ? (c(), k("div", tu, [
          e.hasSlot ? X(e.$slots, "default", {}, void 0, void 0, 0) : e.hasText ? (c(), k(he, { key: 1 }, [
            Je(me(e.text), 1)
          ], 64)) : (c(), k(he, { key: 2 }, [
            Je("Button")
          ], 64))
        ])) : S("", !0),
        e.hasAddonRight ? (c(), k("div", ru, [
          X(e.$slots, "addonRight")
        ])) : S("", !0)
      ]),
      e.loading ? (c(), k("div", au, [
        He(n, { name: e.activityIndicatorIcon }, null, 8, ["name"])
      ])) : S("", !0)
    ]),
    _: 3
  }, 16, ["disabled"]);
}
const nu = /* @__PURE__ */ Ie(G5, [["render", su]]), lu = ke({
  name: "KButtonGroup",
  data() {
    return { rootClass: "kcl-button-group" };
  }
});
function iu(e, t, a, s, r, l) {
  return c(), k("div", {
    class: ue(e.rootClass)
  }, [
    X(e.$slots, "default")
  ], 2);
}
const k3 = /* @__PURE__ */ Ie(lu, [["render", iu]]), ou = ke({
  name: "KPill",
  components: {
    KIcon: St
  },
  data() {
    return {
      rootClass: "kcl-pill",
      addonClass: "kcl-pill--addon"
    };
  },
  props: {
    variant: {
      type: String,
      required: !1,
      default: null
    },
    text: {
      type: String,
      required: !1,
      default: null
    },
    icon: {
      type: String,
      required: !1
    },
    outline: {
      type: Boolean,
      required: !1,
      default: null
    },
    filled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    big: {
      type: Boolean,
      required: !1,
      default: !1
    },
    href: {
      type: String,
      required: !1,
      default: null
    }
  },
  computed: {
    rootClasses() {
      return [
        this.rootClass,
        this.variantClass,
        {
          "is-filled": this.isFilled,
          "is-big": this.isBig,
          "is-clickable": this.isClickable,
          "is-outline": this.outline
        }
      ];
    },
    tag() {
      return this.href ? "a" : "div";
    },
    props() {
      return {
        class: this.rootClasses,
        ...this.linkProps
      };
    },
    linkProps() {
      return this.isLink ? { href: this.href ?? "#" } : {};
    },
    variantClass() {
      return this.hasVariant ? `${this.rootClass}-${this.variant}` : null;
    },
    isLink() {
      return this.tag === "a";
    },
    isFilled() {
      return this.outline === !1 || this.outline === null && this.filled;
    },
    isBig() {
      return this.big;
    },
    hasVariant() {
      var e;
      return ((e = this.variant) == null ? void 0 : e.length) > 0 && this.variant !== "default";
    },
    hasSlot() {
      return typeof this.$slots.default == "function";
    },
    hasText() {
      return this.text !== null && this.text.length > 0;
    },
    hasIcon() {
      return this.icon ? this.icon.length > 0 : !1;
    },
    hasAddonLeft() {
      return this.hasIcon || !!this.$slots.addonLeft;
    },
    hasAddonRight() {
      return !!this.$slots.addonRight;
    },
    addonLeftClasses() {
      return [`${this.addonClass}-left`];
    },
    addonRightClasses() {
      return [`${this.addonClass}-right`];
    },
    hasClickEventListener() {
      var e, t;
      return !!((t = (e = T1()) == null ? void 0 : e.vnode.props) != null && t.onClick);
    },
    isClickable() {
      return !!this.href || this.hasClickEventListener;
    }
  }
}), uu = { class: "kcl-pill--inner" }, du = { class: "kcl-pill--content" };
function cu(e, t, a, s, r, l) {
  const n = Ae("KIcon");
  return c(), ce(Xt(e.tag), Ee(e.props, { to: e.href }), {
    default: ve(() => [
      O("div", uu, [
        e.hasAddonLeft ? (c(), k("div", {
          key: 0,
          class: ue(["kcl-pill--addon", e.addonLeftClasses])
        }, [
          e.hasIcon ? (c(), ce(n, {
            key: 0,
            name: e.icon
          }, null, 8, ["name"])) : X(e.$slots, "addonLeft", {}, void 0, void 0, 1)
        ], 2)) : S("", !0),
        O("div", du, [
          e.hasSlot ? X(e.$slots, "default", {}, void 0, void 0, 0) : e.hasText ? (c(), k(he, { key: 1 }, [
            Je(me(e.text), 1)
          ], 64)) : (c(), k(he, { key: 2 }, [
            Je("Pill")
          ], 64))
        ]),
        e.hasAddonRight ? (c(), k("div", {
          key: 1,
          class: ue(["kcl-pill--addon", e.addonRightClasses])
        }, [
          X(e.$slots, "addonRight")
        ], 2)) : S("", !0)
      ])
    ]),
    _: 3
  }, 16, ["to"]);
}
const pu = /* @__PURE__ */ Ie(ou, [["render", cu]]), hu = ke({
  name: "KTextBox",
  components: {
    KButton: nu
  },
  data() {
    return {
      rootClass: "kcl-textbox",
      isOverflown: !1,
      truncateTitle: !1,
      canCopy: !1
    };
  },
  props: {
    modelValue: {
      type: [String, Object],
      required: !1,
      default: null
    },
    title: {
      type: String,
      required: !1,
      default: null
    },
    variant: {
      type: String,
      required: !1,
      default: null
    },
    canEdit: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isDisabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    placeholder: {
      type: String,
      required: !1,
      default: "Enter text here..."
    },
    maxHeight: {
      type: String,
      required: !1,
      default: null
    },
    minHeight: {
      type: String,
      required: !1,
      default: null
    },
    fontMono: {
      type: Boolean,
      required: !1,
      default: !1
    },
    fontWeight: {
      type: String,
      required: !1,
      default: null
    },
    fontSize: {
      type: String,
      required: !1,
      default: null
    },
    padding: {
      type: String,
      required: !1,
      default: null
    },
    lineHeight: {
      type: String,
      required: !1,
      default: null
    }
  },
  watch: {
    modelValue() {
      this.resizeTextarea();
    }
  },
  emits: ["copy", "update:modelValue"],
  mounted() {
    var e, t, a;
    (a = (t = (e = T1()) == null ? void 0 : e.vnode) == null ? void 0 : t.props) != null && a.onCopy && (this.canCopy = !0), this.resizeTextarea();
  },
  computed: {
    formattedData() {
      return typeof this.modelValue > "u" || this.modelValue === null ? "" : typeof this.modelValue == "object" ? JSON.stringify(this.modelValue, null, 2) : this.modelValue;
    },
    hasTitle() {
      return typeof this.title == "string" && this.title.length > 0;
    },
    hasCustomFontSize() {
      return !!this.fontSize && !["small", "tiny"].includes(this.fontSize);
    },
    variantClass() {
      return this.variant ? `${this.rootClass}-${this.variant}` : null;
    },
    minRows() {
      return this.canCopy || this.hasTitle ? 3 : 1;
    },
    modifierClasses() {
      return {
        "font-size-small": !this.hasCustomFontSize && this.fontSize === "small" ? this.fontSize : null,
        "font-size-tiny": !this.hasCustomFontSize && this.fontSize === "tiny" ? this.fontSize : null,
        "font-family-mono": this.fontMono,
        "is-overflown": this.isOverflown,
        "minimized-title": this.truncateTitle
      };
    },
    rootClasses() {
      return [
        this.rootClass,
        this.variantClass,
        this.modifierClasses
      ];
    },
    rootStyles() {
      return {
        "--kcl-textbox-padding": this.padding,
        "--kcl-textbox-font-weight": this.fontWeight,
        "--kcl-textbox-font-size": this.hasCustomFontSize ? this.fontSize : null,
        "--kcl-textbox-line-height": this.lineHeight
      };
    },
    props() {
      return {
        class: this.rootClasses,
        style: this.rootStyles
      };
    }
  },
  methods: {
    didClickCopy() {
      let e = this.formattedData;
      this.hasTitle && (e = `${this.title}:
${e}`), this.copyToClipboard(e), this.$emit("copy", e);
    },
    copyToClipboard(e) {
      if (window.isSecureContext) {
        navigator.clipboard.writeText(e);
        return;
      }
      const t = document.createElement("textarea");
      t.value = e, document.body.appendChild(t), t.select(), document.execCommand("copy"), document.body.removeChild(t);
    },
    handleInput() {
      this.resizeTextarea(), this.$emit("update:modelValue", this.$refs.textInput.value);
    },
    resizeTextarea() {
      this.$nextTick(() => {
        const e = this.$refs.textInput;
        if (e) {
          e.style.height = "auto";
          let t = e.scrollHeight + 1;
          this.maxHeight && e.scrollHeight > parseInt(this.maxHeight) - 10 && (t = parseInt(this.maxHeight) - 10), this.minHeight && e.scrollHeight < parseInt(this.minHeight) && (t = parseInt(this.minHeight)), e.style.height = `${t}px`, this.isOverflown = e.scrollHeight > e.clientHeight;
        }
      });
    },
    toggleTitle() {
      this.truncateTitle = !this.truncateTitle;
    }
  }
}), mu = {
  key: 0,
  class: "kcl-textbox--header"
}, vu = { class: "kcl-textbox--actions" }, fu = ["readonly", "disabled", "placeholder", "rows", "value"];
function wu(e, t, a, s, r, l) {
  const n = Ae("KButton");
  return c(), ce(Xt("div"), Ue(rt(e.props)), {
    default: ve(() => [
      e.canCopy || e.hasTitle ? (c(), k("div", mu, [
        e.hasTitle ? (c(), k("div", {
          key: 0,
          class: "kcl-textbox--title",
          onClick: t[0] || (t[0] = (...i) => e.toggleTitle && e.toggleTitle(...i))
        }, me(e.title), 1)) : S("", !0),
        O("div", vu, [
          e.canCopy ? (c(), ce(n, {
            key: 0,
            onClick: e.didClickCopy,
            small: ""
          }, {
            default: ve(() => [...t[2] || (t[2] = [
              Je("Copy", -1)
            ])]),
            _: 1
          }, 8, ["onClick"])) : S("", !0)
        ])
      ])) : S("", !0),
      O("textarea", {
        class: "kcl-textbox--content",
        ref: "textInput",
        spellcheck: "false",
        readonly: !e.canEdit,
        disabled: e.isDisabled,
        placeholder: e.placeholder,
        rows: e.minRows,
        value: e.formattedData,
        onInput: t[1] || (t[1] = (...i) => e.handleInput && e.handleInput(...i))
      }, null, 40, fu)
    ]),
    _: 1
  }, 16);
}
const C3 = /* @__PURE__ */ Ie(hu, [["render", wu]]), gu = ke({
  name: "KTooltip",
  inject: {
    injectPosition: {
      from: "tooltipPlacement",
      default: null
    }
  },
  props: {
    text: {
      type: String,
      required: !1,
      default: null
    },
    position: {
      type: String,
      required: !1,
      default: "top"
    }
  },
  computed: {
    hasText() {
      return typeof this.text == "string" && this.text.length > 0;
    },
    hasContent() {
      return typeof this.$slots.content == "function";
    },
    isTooltip() {
      return this.hasText || this.hasContent;
    },
    placement() {
      return this.injectPosition === "top" || this.injectPosition === "right" || this.injectPosition === "bottom" || this.injectPosition === "left" ? this.injectPosition : this.position;
    },
    rootClasses() {
      return [
        "kcl-tooltip",
        `kcl-tooltip--${this.placement}`
      ];
    }
  }
}), yu = { class: "kcl-tooltip--trigger" }, ku = {
  class: "kcl-tooltip--content",
  role: "tooltip"
};
function Cu(e, t, a, s, r, l) {
  return e.isTooltip ? (c(), k("span", {
    key: 0,
    class: ue(e.rootClasses)
  }, [
    O("span", yu, [
      X(e.$slots, "default")
    ]),
    O("span", ku, [
      e.hasContent ? X(e.$slots, "content", {}, void 0, void 0, 0) : (c(), k(he, { key: 1 }, [
        Je(me(e.text), 1)
      ], 64))
    ]),
    t[0] || (t[0] = O("span", { class: "kcl-tooltip--arrow" }, null, -1))
  ], 2)) : X(e.$slots, "default", {}, void 0, void 0, 1);
}
const bu = /* @__PURE__ */ Ie(gu, [["render", Cu]]), Lu = ke({
  name: "KSearchBox",
  components: {
    KIcon: St,
    KTooltip: bu
  },
  emits: ["blur", "focus", "itemClicked", "submit", "update:modelValue"],
  props: {
    autocompleteSource: {
      type: Array,
      required: !1,
      default: null
    },
    modelValue: {
      type: String,
      required: !1,
      default: ""
    },
    placeholder: {
      type: String,
      required: !1,
      default: "Search"
    },
    focusOnLoad: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    debounce: {
      type: Number,
      required: !1,
      default: 300
    },
    noMatchesText: {
      type: String,
      required: !1,
      default: "No matches"
    },
    icon: {
      type: String,
      required: !1,
      default: "magnifyingGlass"
    }
  },
  data() {
    return {
      searchValue: this.modelValue,
      isFocused: !1,
      activeResultIndex: 0,
      delayTimer: 0,
      areResultsHidden: !1
    };
  },
  computed: {
    hasInput() {
      return this.searchValue.length > 0;
    },
    hasAutocompleteSource() {
      return Array.isArray(this.autocompleteSource);
    },
    results() {
      return this.hasAutocompleteSource ? this.autocompleteSource ?? [] : [];
    },
    showResults() {
      return this.hasAutocompleteSource && this.isFocused && !this.areResultsHidden;
    },
    activeResult() {
      return this.results[this.activeResultIndex];
    },
    controlClasses() {
      return {
        "is-focused": this.isFocused,
        "has-results": this.showResults,
        "has-input": this.hasInput,
        "is-disabled": this.disabled
      };
    }
  },
  watch: {
    modelValue(e) {
      e !== this.searchValue && (this.searchValue = e);
    },
    autocompleteSource() {
      this.activeResultIndex = 0, this.areResultsHidden = !1;
    },
    showResults(e) {
      e && this.$nextTick(() => {
        this.scrollActiveResultIntoView();
      });
    }
  },
  mounted() {
    this.focusOnLoad && this.focusInput();
  },
  beforeUnmount() {
    this.delayTimer && clearTimeout(this.delayTimer);
  },
  methods: {
    handleInput(e) {
      const t = e.target;
      t instanceof HTMLInputElement && (this.searchValue = t.value, this.activeResultIndex = 0, this.areResultsHidden = !1, this.delayTimer && clearTimeout(this.delayTimer), this.delayTimer = setTimeout(() => {
        this.$emit("update:modelValue", this.searchValue);
      }, this.debounce));
    },
    handleFocus() {
      this.disabled || (this.isFocused = !0, this.areResultsHidden = !1, this.$emit("focus"));
    },
    handleBlur() {
      window.setTimeout(() => {
        const e = this.$refs.root, t = document.activeElement;
        e && t instanceof Node && e.contains(t) || (this.isFocused = !1, this.areResultsHidden = !0, this.$emit("blur"));
      }, 0);
    },
    handleKeydown(e) {
      if (e.key === "ArrowDown") {
        if (e.preventDefault(), !this.results.length)
          return;
        this.activeResultIndex = Math.min(
          this.activeResultIndex + 1,
          this.results.length - 1
        ), this.scrollActiveResultIntoView();
        return;
      }
      if (e.key === "ArrowUp") {
        if (e.preventDefault(), !this.results.length)
          return;
        this.activeResultIndex = Math.max(this.activeResultIndex - 1, 0), this.scrollActiveResultIntoView();
        return;
      }
      if (e.key === "Enter") {
        if (e.preventDefault(), this.activeResult && this.showResults) {
          this.handleItemClick(this.activeResult);
          return;
        }
        this.$emit("submit", this.searchValue);
      }
    },
    handleItemClick(e) {
      e.disabled !== !0 && (this.areResultsHidden = !0, this.isFocused = !1, this.$emit("itemClicked", e));
    },
    isActiveResult(e) {
      return e === this.activeResultIndex;
    },
    scrollActiveResultIntoView() {
      this.$nextTick(() => {
        const e = this.$refs[`result-${this.activeResultIndex}`], t = Array.isArray(e) ? e[0] : e;
        t == null || t.scrollIntoView({
          block: "nearest"
        });
      });
    },
    focusInput() {
      this.$nextTick(() => {
        const e = this.$refs.input;
        e == null || e.focus();
      });
    }
  }
}), Mu = {
  class: "kcl-search-box",
  ref: "root"
}, Vu = ["value", "disabled", "placeholder"], xu = {
  key: 0,
  class: "kcl-search-box--results"
}, Du = ["disabled", "onClick"], Hu = { class: "kcl-search-box--result-main" }, Tu = ["title"], $u = {
  key: 1,
  class: "kcl-search-box--result-trailing"
}, Su = {
  key: 0,
  class: "kcl-search-box--empty"
};
function _u(e, t, a, s, r, l) {
  const n = Ae("KIcon"), i = Ae("KTooltip");
  return c(), k("div", Mu, [
    O("div", {
      class: ue(["kcl-search-box--control", e.controlClasses])
    }, [
      He(n, {
        class: "kcl-search-box--icon",
        name: e.icon
      }, null, 8, ["name"]),
      O("input", {
        class: "kcl-search-box--input",
        ref: "input",
        type: "search",
        value: e.searchValue,
        disabled: e.disabled,
        placeholder: e.placeholder,
        onInput: t[0] || (t[0] = (...u) => e.handleInput && e.handleInput(...u)),
        onFocus: t[1] || (t[1] = (...u) => e.handleFocus && e.handleFocus(...u)),
        onBlur: t[2] || (t[2] = (...u) => e.handleBlur && e.handleBlur(...u)),
        onKeydown: t[3] || (t[3] = (...u) => e.handleKeydown && e.handleKeydown(...u))
      }, null, 40, Vu)
    ], 2),
    e.showResults ? (c(), k("ul", xu, [
      (c(!0), k(he, null, Pe(e.results, (u, p) => (c(), k("li", {
        key: String(u.id)
      }, [
        O("button", {
          class: ue(["kcl-search-box--result", { "is-selected": e.isActiveResult(p), "is-disabled": u.disabled === !0 }]),
          ref_for: !0,
          ref: `result-${p}`,
          type: "button",
          disabled: u.disabled === !0,
          onMousedown: t[4] || (t[4] = xe(() => {
          }, ["prevent"])),
          onClick: (h) => e.handleItemClick(u)
        }, [
          O("span", Hu, [
            u.icon ? (c(), ce(n, {
              key: 0,
              class: "kcl-search-box--result-icon",
              name: u.icon
            }, null, 8, ["name"])) : S("", !0),
            O("span", {
              class: "kcl-search-box--result-label",
              title: u.name
            }, me(u.name), 9, Tu)
          ]),
          u.trailingIcon && u.trailingIconTooltip ? (c(), ce(i, {
            key: 0,
            class: "kcl-search-box--result-trailing",
            text: u.trailingIconTooltip,
            position: "left"
          }, {
            default: ve(() => [
              He(n, {
                class: "kcl-search-box--result-trailing-icon",
                name: u.trailingIcon
              }, null, 8, ["name"])
            ]),
            _: 2
          }, 1032, ["text"])) : u.trailingIcon ? (c(), k("span", $u, [
            He(n, {
              class: "kcl-search-box--result-trailing-icon",
              name: u.trailingIcon
            }, null, 8, ["name"])
          ])) : S("", !0)
        ], 42, Du)
      ]))), 128)),
      e.results.length ? S("", !0) : (c(), k("li", Su, me(e.noMatchesText), 1))
    ])) : S("", !0)
  ], 512);
}
const b3 = /* @__PURE__ */ Ie(Lu, [["render", _u]]), Ou = ke({
  name: "KAccordion",
  components: {
    KIcon: St
  },
  props: {
    title: {
      type: String,
      required: !1
    },
    secondaryTitle: {
      type: String,
      required: !1
    },
    icon: {
      type: String,
      required: !1
    },
    rightIcon: {
      type: String,
      required: !1
    },
    variant: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      rootClass: "kcl-accordion",
      open: !1
    };
  },
  computed: {
    hasLeftIcon() {
      var e;
      return ((e = this.$slots) == null ? void 0 : e.icon) || this.icon;
    },
    hasRightIcon() {
      var e;
      return ((e = this.$slots) == null ? void 0 : e.rightIcon) || this.rightIcon;
    },
    variantClass() {
      return this.variant ? `${this.rootClass}-${this.variant}` : null;
    },
    modifierClasses() {
      return {
        "is-open": this.open
      };
    },
    rootClasses() {
      return [
        this.rootClass,
        this.variantClass,
        this.modifierClasses
      ];
    },
    props() {
      return {
        class: this.rootClasses
      };
    }
  },
  methods: {
    toggle() {
      this.open = !this.open;
    }
  }
}), Pu = {
  key: 0,
  class: "kcl-accordion--header--left-icon"
}, Bu = { class: "kcl-accordion--header--left-title" }, Zu = { class: "kcl-accordion--header--left-title--main" }, Au = {
  key: 0,
  class: "kcl-accordion--header--left-title--secondary"
}, Ru = {
  key: 1,
  class: "kcl-accordion--header--right-title"
}, Iu = {
  key: 2,
  class: "kcl-accordion--header--right-icon"
}, Yu = {
  key: 0,
  class: "kcl-accordion--content"
}, Nu = { key: 0 };
function Fu(e, t, a, s, r, l) {
  const n = Ae("KIcon");
  return c(), ce(Xt("div"), Ue(rt(e.props)), {
    default: ve(() => {
      var i, u, p, h, d;
      return [
        O("div", {
          class: "kcl-accordion--header",
          onClick: t[0] || (t[0] = (...y) => e.toggle && e.toggle(...y))
        }, [
          e.hasLeftIcon ? (c(), k("div", Pu, [
            (i = e.$slots) != null && i.icon ? X(e.$slots, "icon", {}, void 0, void 0, 0) : e.icon ? (c(), ce(n, {
              key: 1,
              name: e.icon
            }, null, 8, ["name"])) : S("", !0)
          ])) : S("", !0),
          O("div", Bu, [
            (u = e.$slots) != null && u.title ? X(e.$slots, "title", {}, void 0, void 0, 0) : (c(), k(he, { key: 1 }, [
              O("div", Zu, me(e.title), 1),
              e.secondaryTitle ? (c(), k("div", Au, me(e.secondaryTitle), 1)) : S("", !0)
            ], 64))
          ]),
          (p = e.$slots) != null && p.rightTitle ? (c(), k("div", Ru, [
            X(e.$slots, "rightTitle")
          ])) : S("", !0),
          e.hasRightIcon ? (c(), k("div", Iu, [
            (h = e.$slots) != null && h.rightIcon ? X(e.$slots, "rightIcon", {}, void 0, void 0, 0) : e.rightIcon ? (c(), ce(n, {
              key: 1,
              name: e.rightIcon
            }, null, 8, ["name"])) : S("", !0)
          ])) : S("", !0),
          He(n, {
            class: "accordion--header--collapse-icon",
            name: e.open ? "arrow.simple.down" : "arrow.simple.right"
          }, null, 8, ["name"])
        ]),
        e.open ? (c(), k("div", Yu, [
          X(e.$slots, "default"),
          (d = e.$slots) != null && d.footer ? (c(), k("footer", Nu, [
            X(e.$slots, "footer")
          ])) : S("", !0)
        ])) : S("", !0)
      ];
    }),
    _: 3
  }, 16);
}
const L3 = /* @__PURE__ */ Ie(Ou, [["render", Fu]]), Eu = ke({
  name: "KDropdownShell",
  components: {
    KIcon: St
  },
  emits: ["clear", "toggle"],
  props: {
    rootClasses: {
      type: [String, Array, Object],
      required: !1,
      default: null
    },
    displayLabel: {
      type: String,
      required: !0
    },
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isOpen: {
      type: Boolean,
      required: !0
    },
    contentId: {
      type: String,
      required: !0
    },
    isPlaceholder: {
      type: Boolean,
      required: !1,
      default: !1
    },
    canClear: {
      type: Boolean,
      required: !1,
      default: !1
    },
    clearLabel: {
      type: String,
      required: !1,
      default: "Clear selection"
    },
    openOnFocus: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  computed: {
    resolvedRootClasses() {
      return ["kcl-dropdown", this.rootClasses];
    }
  },
  methods: {
    handleFocus(e) {
      !this.openOnFocus || this.isOpen || this.disabled || !e.target.matches(":focus-visible") || this.$emit("toggle");
    }
  }
}), zu = ["disabled", "aria-expanded", "aria-controls"], qu = { class: "kcl-dropdown--label-main" }, Uu = ["title"], Ku = { class: "kcl-dropdown--label-actions" }, Wu = ["aria-label"], ju = ["id"];
function Qu(e, t, a, s, r, l) {
  const n = Ae("KIcon");
  return c(), k("div", {
    class: ue(e.resolvedRootClasses)
  }, [
    O("button", {
      class: ue(["kcl-dropdown--label", { "has-clear": e.canClear && !e.disabled }]),
      type: "button",
      disabled: e.disabled,
      "aria-expanded": e.isOpen,
      "aria-controls": e.contentId,
      onClick: t[0] || (t[0] = (i) => e.$emit("toggle")),
      onFocus: t[1] || (t[1] = (...i) => e.handleFocus && e.handleFocus(...i))
    }, [
      O("span", qu, [
        e.icon ? (c(), ce(n, {
          key: 0,
          class: "kcl-dropdown--label-icon",
          name: e.icon
        }, null, 8, ["name"])) : S("", !0),
        O("span", {
          class: ue(["kcl-dropdown--label-text", { "is-placeholder": e.isPlaceholder }]),
          title: e.displayLabel
        }, me(e.displayLabel), 11, Uu)
      ]),
      O("span", Ku, [
        !e.canClear && !e.disabled ? (c(), ce(n, {
          key: 0,
          class: "kcl-dropdown--label-arrow",
          name: "arrow.simple.down"
        })) : e.disabled ? (c(), ce(n, {
          key: 1,
          class: "kcl-dropdown--label-lock",
          name: "lock"
        })) : S("", !0)
      ])
    ], 42, zu),
    e.canClear && !e.disabled ? (c(), k("button", {
      key: 0,
      class: "kcl-dropdown--label-clear",
      type: "button",
      "aria-label": e.clearLabel,
      onClick: t[2] || (t[2] = xe((i) => e.$emit("clear"), ["stop", "prevent"]))
    }, [
      He(n, { name: "16/cross" })
    ], 8, Wu)) : S("", !0),
    e.isOpen ? (c(), k("section", {
      key: 1,
      class: "kcl-dropdown--content",
      id: e.contentId
    }, [
      X(e.$slots, "default")
    ], 8, ju)) : S("", !0)
  ], 2);
}
const Vs = /* @__PURE__ */ Ie(Eu, [["render", Qu]]), H1 = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], Xu = ke({
  name: "KDropdownDateTimeRange",
  components: {
    KDateTimePicker: X5,
    KDropdownShell: Vs,
    KPill: pu
  },
  emits: ["close", "open", "update:modelValue"],
  props: {
    modelValue: {
      type: Object,
      required: !1,
      default: null
    },
    placeholder: {
      type: String,
      required: !1,
      default: "From -> To"
    },
    icon: {
      type: String,
      required: !1,
      default: "calendar"
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    openOnFocus: {
      type: Boolean,
      required: !1,
      default: !0
    },
    clearable: {
      type: Boolean,
      required: !1,
      default: !1
    },
    fromLabel: {
      type: String,
      required: !1,
      default: "Start time"
    },
    toLabel: {
      type: String,
      required: !1,
      default: "End time"
    },
    showOffsetButtons: {
      type: Boolean,
      required: !1,
      default: !1
    },
    showActiveState: {
      type: Boolean,
      required: !1,
      default: !1
    },
    offsetHours: {
      type: Number,
      required: !1,
      default: 24
    },
    suggestions: {
      type: Array,
      required: !1,
      default: () => []
    },
    suggestionsLabel: {
      type: String,
      required: !1,
      default: "Suggestions"
    },
    minDate: {
      type: Date,
      required: !1,
      default: null
    },
    maxDate: {
      type: Date,
      required: !1,
      default: null
    },
    minDateTime: {
      type: Date,
      required: !1,
      default: null
    },
    maxDateTime: {
      type: Date,
      required: !1,
      default: null
    },
    minTime: {
      type: Date,
      required: !1,
      default: null
    },
    maxTime: {
      type: Date,
      required: !1,
      default: null
    },
    timezone: {
      type: String,
      required: !1,
      default: "utc"
    }
  },
  data() {
    return {
      isOpen: !1,
      position: "below",
      contentId: Er(),
      suppressEscapeKeyup: !1,
      pointerDownInsideRoot: !1
    };
  },
  computed: {
    normalizedValue() {
      return this.normalizeRangeValue(this.modelValue);
    },
    hasValue() {
      return !!(this.normalizedValue.from || this.normalizedValue.to);
    },
    canClear() {
      return this.clearable && this.hasValue && !this.disabled;
    },
    displayLabel() {
      return this.formatDisplayLabel();
    },
    hasSuggestions() {
      return this.suggestions.length > 0 || typeof this.$slots.suggestions == "function";
    },
    minimumToDateTime() {
      const e = this.normalizeDate(this.minDateTime), t = this.normalizedValue.from;
      return t && (!e || t.getTime() > e.getTime()) ? new Date(t.getTime()) : e;
    },
    rootClasses() {
      return {
        "is-open": this.isOpen,
        "is-selected": this.showActiveState && this.hasValue,
        "is-disabled": this.disabled,
        "opens-above": this.isOpen && this.position === "above",
        "opens-below": this.isOpen && this.position === "below"
      };
    }
  },
  watch: {
    disabled(e) {
      e && this.closeDropdown();
    },
    isOpen(e) {
      if (!e) {
        this.position = "below", this.$emit("close");
        return;
      }
      this.$emit("open"), this.$nextTick(() => {
        this.updatePosition();
      });
    }
  },
  mounted() {
    document.addEventListener("pointerdown", this.handleDocumentPointerDown), window.addEventListener("resize", this.updatePosition);
  },
  beforeUnmount() {
    document.removeEventListener("pointerdown", this.handleDocumentPointerDown), window.removeEventListener("resize", this.updatePosition);
  },
  methods: {
    normalizeDate(e) {
      return !(e instanceof Date) || Number.isNaN(e.getTime()) ? null : new Date(e.getTime());
    },
    normalizeRangeValue(e) {
      return !e || typeof e != "object" ? {
        from: null,
        to: null
      } : {
        from: this.normalizeDate(e.from),
        to: this.normalizeDate(e.to)
      };
    },
    serializeRangeValue(e) {
      return !e.from && !e.to ? null : {
        from: e.from ? new Date(e.from.getTime()) : null,
        to: e.to ? new Date(e.to.getTime()) : null
      };
    },
    clampRangeValue(e) {
      const t = e.from ? new Date(e.from.getTime()) : null;
      let a = e.to ? new Date(e.to.getTime()) : null;
      return t && a && a.getTime() < t.getTime() && (a = new Date(t.getTime())), {
        from: t,
        to: a
      };
    },
    emitRangeValue(e) {
      this.$emit(
        "update:modelValue",
        this.serializeRangeValue(this.clampRangeValue(e))
      );
    },
    openDropdown() {
      this.disabled || this.isOpen || (this.isOpen = !0);
    },
    closeDropdown() {
      this.isOpen && (this.isOpen = !1);
    },
    toggleDropdown() {
      if (this.isOpen) {
        this.closeDropdown();
        return;
      }
      this.openDropdown();
    },
    clearRange() {
      this.$emit("update:modelValue", null), this.closeDropdown();
    },
    setFromValue(e) {
      this.emitRangeValue({
        from: this.normalizeDate(e),
        to: this.normalizedValue.to
      });
    },
    setToValue(e) {
      this.emitRangeValue({
        from: this.normalizedValue.from,
        to: this.normalizeDate(e)
      });
    },
    applySuggestion(e) {
      e.disabled !== !0 && this.emitRangeValue({
        from: this.normalizeDate(e.from),
        to: this.normalizeDate(e.to)
      });
    },
    shiftValue(e, t) {
      const a = t * 60 * 60 * 1e3;
      let s = this.normalizedValue.from ? new Date(this.normalizedValue.from.getTime()) : null, r = this.normalizedValue.to ? new Date(this.normalizedValue.to.getTime()) : null;
      if (e === "from") {
        const l = s ?? r ?? /* @__PURE__ */ new Date();
        s = new Date(l.getTime() + a), r && s.getTime() >= r.getTime() && (r = new Date(r.getTime() + a));
      } else {
        const l = r ?? s ?? /* @__PURE__ */ new Date();
        r = new Date(l.getTime() + a), s && r.getTime() <= s.getTime() && (s = new Date(s.getTime() + a));
      }
      this.emitRangeValue({
        from: s,
        to: r
      });
    },
    handleDocumentPointerDown(e) {
      const t = this.$refs.root, a = e.target, s = !!t && a instanceof Node && t.contains(a);
      this.pointerDownInsideRoot = s, window.setTimeout(() => {
        this.pointerDownInsideRoot = !1;
      }, 0), !(!this.isOpen || s) && this.closeDropdown();
    },
    updatePosition() {
      if (!this.isOpen)
        return;
      const e = this.$refs.root, t = e == null ? void 0 : e.querySelector(
        ".kcl-dropdown--content"
      );
      if (!e || !t)
        return;
      const a = e.getBoundingClientRect(), s = t.getBoundingClientRect(), r = window.innerHeight - a.bottom, l = a.top;
      this.position = s.height > r && l > r ? "above" : "below";
    },
    handleRootKeydown(e) {
      e.key !== "Escape" || !this.isOpen || (e.preventDefault(), e.stopPropagation(), this.suppressEscapeKeyup = !0, this.closeDropdown());
    },
    handleRootFocusOut(e) {
      const t = this.$refs.root, a = e.relatedTarget, s = this.pointerDownInsideRoot;
      this.pointerDownInsideRoot = !1, !(!this.isOpen || !t) && (a instanceof Node && t.contains(a) || s || this.closeDropdown());
    },
    handleRootKeyup(e) {
      e.key !== "Escape" || !this.suppressEscapeKeyup || (e.preventDefault(), e.stopPropagation(), this.suppressEscapeKeyup = !1);
    },
    getDateParts(e) {
      return this.timezone === "utc" ? {
        year: e.getUTCFullYear(),
        monthIndex: e.getUTCMonth(),
        day: e.getUTCDate(),
        hour: e.getUTCHours(),
        minute: e.getUTCMinutes(),
        second: e.getUTCSeconds()
      } : {
        year: e.getFullYear(),
        monthIndex: e.getMonth(),
        day: e.getDate(),
        hour: e.getHours(),
        minute: e.getMinutes(),
        second: e.getSeconds()
      };
    },
    padValue(e) {
      return String(e).padStart(2, "0");
    },
    formatDate(e) {
      const { year: t, monthIndex: a, day: s } = this.getDateParts(e);
      return `${H1[a]} ${this.padValue(s)}, ${t}`;
    },
    formatMonthDay(e) {
      const { monthIndex: t, day: a } = this.getDateParts(e);
      return `${H1[t]} ${this.padValue(a)}`;
    },
    formatTime(e) {
      const { hour: t, minute: a, second: s } = this.getDateParts(e);
      return `${this.padValue(t)}:${this.padValue(a)}:${this.padValue(s)}`;
    },
    hasSameDay(e, t) {
      const a = this.getDateParts(e), s = this.getDateParts(t);
      return a.year === s.year && a.monthIndex === s.monthIndex && a.day === s.day;
    },
    formatDisplayLabel() {
      const { from: e, to: t } = this.normalizedValue;
      return !e && !t ? this.placeholder : e && t ? this.hasSameDay(e, t) ? `${this.formatDate(e)} - ${this.formatTime(e)} -> ${this.formatTime(t)}` : `${this.formatMonthDay(e)} - ${this.formatTime(e)} -> ${this.formatMonthDay(t)} - ${this.formatTime(t)}` : e ? `${this.formatDate(e)} - ${this.formatTime(e)} -> To` : `From -> ${this.formatDate(t)} - ${this.formatTime(t)}`;
    }
  }
}), Gu = { class: "kcl-date-time-range-dropdown--pickers" }, Ju = { class: "kcl-date-time-range-dropdown--picker" }, ed = { class: "kcl-date-time-range-dropdown--picker-header" }, td = { class: "kcl-date-time-range-dropdown--picker-label" }, rd = { class: "kcl-date-time-range-dropdown--picker" }, ad = { class: "kcl-date-time-range-dropdown--picker-header" }, sd = { class: "kcl-date-time-range-dropdown--picker-label" }, nd = {
  key: 0,
  class: "kcl-date-time-range-dropdown--suggestions"
}, ld = { class: "kcl-date-time-range-dropdown--suggestions-label" }, id = { class: "kcl-date-time-range-dropdown--suggestions-list" };
function od(e, t, a, s, r, l) {
  const n = Ae("KDateTimePicker"), i = Ae("KPill"), u = Ae("KDropdownShell");
  return c(), k("div", {
    class: "kcl-date-time-range-dropdown",
    ref: "root",
    onKeydown: t[4] || (t[4] = (...p) => e.handleRootKeydown && e.handleRootKeydown(...p)),
    onKeyup: t[5] || (t[5] = (...p) => e.handleRootKeyup && e.handleRootKeyup(...p)),
    onFocusout: t[6] || (t[6] = (...p) => e.handleRootFocusOut && e.handleRootFocusOut(...p))
  }, [
    He(u, {
      rootClasses: e.rootClasses,
      displayLabel: e.displayLabel,
      icon: e.icon,
      disabled: e.disabled,
      isOpen: e.isOpen,
      contentId: e.contentId,
      isPlaceholder: !e.hasValue,
      canClear: e.canClear,
      clearLabel: "Clear date range",
      openOnFocus: e.openOnFocus,
      onToggle: e.toggleDropdown,
      onClear: e.clearRange
    }, {
      default: ve(() => [
        O("div", Gu, [
          O("div", Ju, [
            O("div", ed, [
              e.showOffsetButtons ? (c(), k("button", {
                key: 0,
                class: "kcl-date-time-range-dropdown--step-button",
                type: "button",
                onClick: t[0] || (t[0] = xe((p) => e.shiftValue("from", -e.offsetHours), ["stop", "prevent"]))
              }, [...t[7] || (t[7] = [
                O("span", { class: "kcl-date-time-range-dropdown--step-button-label kcl-date-time-range-dropdown--step-button-label-minus" }, "-", -1)
              ])])) : S("", !0),
              O("span", td, me(e.fromLabel), 1),
              e.showOffsetButtons ? (c(), k("button", {
                key: 1,
                class: "kcl-date-time-range-dropdown--step-button",
                type: "button",
                onClick: t[1] || (t[1] = xe((p) => e.shiftValue("from", e.offsetHours), ["stop", "prevent"]))
              }, [...t[8] || (t[8] = [
                O("span", { class: "kcl-date-time-range-dropdown--step-button-label" }, "+", -1)
              ])])) : S("", !0)
            ]),
            He(n, {
              modelValue: e.normalizedValue.from,
              clearable: e.clearable,
              disabled: e.disabled,
              minDate: e.minDate,
              maxDate: e.maxDate,
              minDateTime: e.minDateTime,
              maxDateTime: e.maxDateTime,
              minTime: e.minTime,
              maxTime: e.maxTime,
              timezone: e.timezone,
              "onUpdate:modelValue": e.setFromValue
            }, null, 8, ["modelValue", "clearable", "disabled", "minDate", "maxDate", "minDateTime", "maxDateTime", "minTime", "maxTime", "timezone", "onUpdate:modelValue"])
          ]),
          O("div", rd, [
            O("div", ad, [
              e.showOffsetButtons ? (c(), k("button", {
                key: 0,
                class: "kcl-date-time-range-dropdown--step-button",
                type: "button",
                onClick: t[2] || (t[2] = xe((p) => e.shiftValue("to", -e.offsetHours), ["stop", "prevent"]))
              }, [...t[9] || (t[9] = [
                O("span", { class: "kcl-date-time-range-dropdown--step-button-label kcl-date-time-range-dropdown--step-button-label-minus" }, "-", -1)
              ])])) : S("", !0),
              O("span", sd, me(e.toLabel), 1),
              e.showOffsetButtons ? (c(), k("button", {
                key: 1,
                class: "kcl-date-time-range-dropdown--step-button",
                type: "button",
                onClick: t[3] || (t[3] = xe((p) => e.shiftValue("to", e.offsetHours), ["stop", "prevent"]))
              }, [...t[10] || (t[10] = [
                O("span", { class: "kcl-date-time-range-dropdown--step-button-label" }, "+", -1)
              ])])) : S("", !0)
            ]),
            He(n, {
              modelValue: e.normalizedValue.to,
              clearable: e.clearable,
              disabled: e.disabled,
              minDate: e.minDate,
              maxDate: e.maxDate,
              minDateTime: e.minimumToDateTime,
              maxDateTime: e.maxDateTime,
              minTime: e.minTime,
              maxTime: e.maxTime,
              timezone: e.timezone,
              "onUpdate:modelValue": e.setToValue
            }, null, 8, ["modelValue", "clearable", "disabled", "minDate", "maxDate", "minDateTime", "maxDateTime", "minTime", "maxTime", "timezone", "onUpdate:modelValue"])
          ])
        ]),
        e.hasSuggestions ? (c(), k("div", nd, [
          O("span", ld, me(e.suggestionsLabel), 1),
          X(e.$slots, "suggestions", {
            suggestions: e.suggestions,
            value: e.normalizedValue,
            applySuggestion: e.applySuggestion
          }, () => [
            O("div", id, [
              (c(!0), k(he, null, Pe(e.suggestions, (p) => (c(), ce(i, {
                class: ue(["kcl-date-time-range-dropdown--suggestion", { "is-disabled": p.disabled === !0 }]),
                key: p.label,
                outline: "",
                onClick: (h) => e.applySuggestion(p)
              }, {
                default: ve(() => [
                  Je(me(p.label), 1)
                ]),
                _: 2
              }, 1032, ["class", "onClick"]))), 128))
            ])
          ])
        ])) : S("", !0)
      ]),
      _: 3
    }, 8, ["rootClasses", "displayLabel", "icon", "disabled", "isOpen", "contentId", "isPlaceholder", "canClear", "openOnFocus", "onToggle", "onClear"])
  ], 544);
}
const M3 = /* @__PURE__ */ Ie(Xu, [["render", od]]), Dr = {
  options: {
    type: Array,
    required: !0
  },
  modelValue: {
    type: [Array, String, Number, Boolean],
    required: !1,
    default: void 0
  },
  placeholder: {
    type: String,
    required: !1,
    default: "Select"
  },
  icon: {
    type: String,
    required: !1,
    default: void 0
  },
  disabled: {
    type: Boolean,
    required: !1,
    default: !1
  },
  noOptionsText: {
    type: String,
    required: !1,
    default: "No options"
  },
  allLabel: {
    type: String,
    required: !1,
    default: ""
  },
  selectionLabelSingular: {
    type: String,
    required: !1,
    default: ""
  },
  selectionLabelPlural: {
    type: String,
    required: !1,
    default: ""
  },
  showActiveState: {
    type: Boolean,
    required: !1,
    default: !0
  },
  openOnFocus: {
    type: Boolean,
    required: !1,
    default: !0
  }
}, Qa = {
  searchPlaceholder: {
    type: String,
    required: !1,
    default: "Search"
  },
  noMatchesText: {
    type: String,
    required: !1,
    default: "No matches"
  }
}, Xa = {
  showSelectAllVisible: {
    type: Boolean,
    required: !1,
    default: !1
  },
  selectAllVisibleLabel: {
    type: String,
    required: !1,
    default: "Select all visible"
  }
}, ud = ke({
  name: "KDropdownBase",
  components: {
    KCheckbox: P1,
    KDropdownShell: Vs,
    KIcon: St,
    KRadio: B1
  },
  emits: ["update:modelValue", "open", "close"],
  props: {
    ...Dr,
    ...Qa,
    ...Xa,
    mode: {
      type: String,
      required: !0
    },
    searchEnabled: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  data() {
    return {
      isOpen: !1,
      position: "below",
      contentId: Er(),
      searchValue: "",
      activeOptionId: ""
    };
  },
  computed: {
    isMultiple() {
      return this.mode === "multiple";
    },
    normalizedOptions() {
      return this.normalizeOptions(this.options);
    },
    allSelectableOptions() {
      return this.flattenSelectableOptions(this.normalizedOptions);
    },
    selectedValues() {
      return this.isMultiple ? Array.isArray(this.modelValue) ? this.modelValue.filter((e) => this.isDropdownValue(e)) : [] : this.isDropdownValue(this.modelValue) ? [this.modelValue] : [];
    },
    selectedValueSet() {
      return new Set(this.selectedValues);
    },
    selectedOptions() {
      return this.allSelectableOptions.filter((e) => this.isOptionSelected(e.value));
    },
    selectedRadioValue() {
      return this.selectedValues[0];
    },
    hasSelection() {
      return this.selectedOptions.length > 0;
    },
    canClearSelection() {
      return this.isMultiple && this.hasSelection && !this.disabled;
    },
    hasOptions() {
      return this.normalizedOptions.length > 0;
    },
    visibleRows() {
      return this.buildVisibleRows(
        this.normalizedOptions,
        this.normalizedSearchQuery
      );
    },
    visibleSelectableOptionRows() {
      return this.visibleRows.filter((e) => e.kind === "option" && e.selectable);
    },
    visibleEnabledOptionRows() {
      return this.visibleSelectableOptionRows.filter((e) => !this.isOptionDisabled(e.option));
    },
    activeOption() {
      var e;
      return (e = this.visibleSelectableOptionRows.find((t) => t.id === this.activeOptionId)) == null ? void 0 : e.option;
    },
    normalizedSearchQuery() {
      return this.searchEnabled ? this.searchValue.trim().toLowerCase() : "";
    },
    hasVisibleRows() {
      return this.visibleRows.length > 0;
    },
    hasUnselectedVisibleOptions() {
      return this.visibleEnabledOptionRows.some((e) => !this.isOptionSelected(e.option.value));
    },
    showSelectAllAction() {
      return this.isMultiple && this.showSelectAllVisible && this.visibleEnabledOptionRows.length > 0;
    },
    emptyStateText() {
      return this.hasOptions ? this.noMatchesText : this.noOptionsText;
    },
    displayLabel() {
      var e, t;
      if (!this.hasSelection)
        return this.placeholder;
      if (!this.isMultiple)
        return ((e = this.selectedOptions[0]) == null ? void 0 : e.label) ?? this.placeholder;
      if (this.selectedOptions.length === 1)
        return ((t = this.selectedOptions[0]) == null ? void 0 : t.label) ?? this.placeholder;
      if (this.allLabel.length > 0 && this.selectedOptions.length === this.allSelectableOptions.length)
        return this.allLabel;
      if (this.selectionLabelSingular.length > 0 && this.selectionLabelPlural.length > 0) {
        const a = this.selectedOptions.length === 1 ? this.selectionLabelSingular : this.selectionLabelPlural;
        return `${this.selectedOptions.length} ${a}`;
      }
      return `${this.selectedOptions.length} selected`;
    },
    rootClasses() {
      return {
        "is-open": this.isOpen,
        "is-multiple": this.isMultiple,
        "is-selected": this.hasSelection,
        "is-disabled": this.disabled,
        "is-search-enabled": this.searchEnabled,
        "opens-above": this.isOpen && this.position === "above",
        "opens-below": this.isOpen && this.position === "below"
      };
    }
  },
  watch: {
    disabled(e) {
      e && this.closeDropdown();
    },
    visibleSelectableOptionRows(e, t) {
      var r;
      const a = t.find((l) => l.id === this.activeOptionId), s = a ? e.find((l) => l.id === a.id && !this.isOptionDisabled(l.option)) : void 0;
      this.activeOptionId = (s == null ? void 0 : s.id) ?? ((r = this.firstEnabledOptionRow(e)) == null ? void 0 : r.id) ?? "", this.isOpen && this.$nextTick(() => {
        this.scrollActiveOptionIntoView(), this.updatePosition();
      });
    },
    isOpen(e) {
      var t;
      if (!e) {
        this.position = "below", this.resetSearchState(), this.$emit("close");
        return;
      }
      this.activeOptionId = ((t = this.firstEnabledOptionRow()) == null ? void 0 : t.id) ?? "", this.$emit("open"), this.$nextTick(() => {
        this.searchEnabled && this.focusSearchInput(), this.updatePosition(), this.scrollActiveOptionIntoView();
      });
    }
  },
  mounted() {
    document.addEventListener("pointerdown", this.handleDocumentPointerDown), window.addEventListener("keydown", this.handleWindowKeydown), window.addEventListener("resize", this.updatePosition);
  },
  beforeUnmount() {
    document.removeEventListener("pointerdown", this.handleDocumentPointerDown), window.removeEventListener("keydown", this.handleWindowKeydown), window.removeEventListener("resize", this.updatePosition);
  },
  methods: {
    isDropdownValue(e) {
      return typeof e == "string" || typeof e == "number" || typeof e == "boolean";
    },
    isOptionObject(e) {
      return typeof e == "object" && e !== null && "label" in e;
    },
    normalizeOptions(e, t = "option") {
      return e.map((a, s) => {
        const r = `${t}-${s}`;
        return this.isOptionObject(a) ? {
          id: r,
          value: this.isDropdownValue(a.value) ? a.value : void 0,
          label: a.label,
          secondaryLabel: a.secondaryLabel,
          icon: a.icon,
          disabled: a.disabled === !0,
          children: this.normalizeOptions(a.children ?? [], r),
          childrenLabel: a.childrenLabel,
          childrenVisibility: a.childrenVisibility ?? "always"
        } : {
          id: r,
          value: a,
          label: String(a),
          disabled: !1,
          children: [],
          childrenVisibility: "always"
        };
      });
    },
    flattenSelectableOptions(e) {
      return e.reduce((t, a) => (this.isOptionSelectable(a) && t.push(a), a.children.length > 0 && t.push(...this.flattenSelectableOptions(a.children)), t), []);
    },
    isOptionSelectable(e) {
      return this.isDropdownValue(e.value);
    },
    isOptionSelected(e) {
      return this.isDropdownValue(e) && this.selectedValueSet.has(e);
    },
    isOptionDisabled(e) {
      return this.disabled || e.disabled;
    },
    shouldShowChildren(e) {
      return e.children.length ? e.childrenVisibility === "when-selected" ? this.isOptionSelected(e.value) : !0 : !1;
    },
    optionMatchesQuery(e, t) {
      return [e.label, e.secondaryLabel].filter((a) => typeof a == "string").some((a) => a.toLowerCase().includes(t));
    },
    buildVisibleRows(e, t, a = 0) {
      return e.reduce((s, r) => {
        const l = r.children.length > 0 ? this.buildVisibleRows(r.children, t, a + 1) : [], n = !t.length || this.optionMatchesQuery(r, t), i = t.length > 0 && l.length > 0, u = t.length === 0 && this.shouldShowChildren(r), p = i || u;
        return (t.length === 0 || n || l.length > 0) && (s.push({
          kind: "option",
          id: r.id,
          refKey: `dropdown-row-${r.id}`,
          depth: a,
          selectable: this.isOptionSelectable(r),
          option: r
        }), p && l.length > 0 && (r.childrenLabel && s.push({
          kind: "group-label",
          id: `${r.id}-group-label`,
          label: r.childrenLabel,
          depth: a + 1
        }), s.push(...l))), s;
      }, []);
    },
    firstEnabledOptionRow(e) {
      return (e ?? this.visibleSelectableOptionRows).find((a) => !this.isOptionDisabled(a.option));
    },
    findNextEnabledOptionId(e) {
      if (!this.visibleSelectableOptionRows.length)
        return "";
      const t = this.visibleSelectableOptionRows.findIndex((s) => s.id === this.activeOptionId);
      let a = t >= 0 ? t + e : 0;
      for (; a >= 0 && a < this.visibleSelectableOptionRows.length; ) {
        const s = this.visibleSelectableOptionRows[a];
        if (!this.isOptionDisabled(s.option))
          return s.id;
        a += e;
      }
      return this.activeOptionId;
    },
    rowItemClasses(e) {
      return e.kind === "group-label" ? {
        "is-group-label": !0
      } : {
        "is-active": this.showActiveState && e.id === this.activeOptionId,
        "is-disabled": this.isOptionDisabled(e.option),
        "is-group-option": !e.selectable
      };
    },
    rowIndentStyle(e) {
      return {
        "--kcl-dropdown-row-indent": `${e * 16}px`
      };
    },
    optionTitle(e) {
      return e.secondaryLabel ? `${e.label} - ${e.secondaryLabel}` : e.label;
    },
    toggleDropdown() {
      this.disabled || (this.isOpen = !this.isOpen);
    },
    closeDropdown() {
      this.isOpen && (this.isOpen = !1);
    },
    clearSelection() {
      this.canClearSelection && this.$emit("update:modelValue", []);
    },
    resetSearchState() {
      this.searchValue = "", this.activeOptionId = "";
    },
    focusSearchInput() {
      const e = this.$refs.searchInput;
      e == null || e.focus();
    },
    handleDocumentPointerDown(e) {
      if (!this.isOpen)
        return;
      const t = this.$refs.root, a = e.target;
      !t || !(a instanceof Node) || t.contains(a) || this.closeDropdown();
    },
    handleRootKeydown(e) {
      if (e.key !== "Tab" || !this.isOpen)
        return;
      const t = this.$refs.root, a = document.activeElement;
      if (!t || !(a instanceof HTMLElement) || !t.contains(a))
        return;
      const s = Ms(
        t,
        a,
        e.shiftKey
      );
      this.closeDropdown(), e.preventDefault(), e.stopPropagation(), s ? s.focus() : a.blur();
    },
    handleWindowKeydown(e) {
      e.key === "Escape" && this.closeDropdown();
    },
    handleSearchInput(e) {
      const t = e.target;
      t instanceof HTMLInputElement && (this.searchValue = t.value);
    },
    handleSearchKeydown(e) {
      var t;
      if (e.key === "ArrowDown") {
        e.preventDefault(), this.activeOptionId = this.findNextEnabledOptionId(1), this.scrollActiveOptionIntoView();
        return;
      }
      if (e.key === "ArrowUp") {
        e.preventDefault(), this.activeOptionId = this.findNextEnabledOptionId(-1), this.scrollActiveOptionIntoView();
        return;
      }
      if (e.key === "Enter") {
        e.preventDefault();
        const a = this.activeOption && !this.isOptionDisabled(this.activeOption) ? this.activeOption : (t = this.firstEnabledOptionRow()) == null ? void 0 : t.option;
        if (!a || !this.isOptionSelectable(a))
          return;
        if (this.isMultiple) {
          this.handleCheckboxSelect(a, !this.isOptionSelected(a.value));
          return;
        }
        if (this.isOptionSelected(a.value)) {
          this.closeDropdown();
          return;
        }
        this.handleRadioSelect(a.value);
      }
    },
    scrollActiveOptionIntoView() {
      this.$nextTick(() => {
        const e = this.visibleSelectableOptionRows.find((s) => s.id === this.activeOptionId);
        if (!e)
          return;
        const t = this.$refs[e.refKey], a = Array.isArray(t) ? t[0] : t;
        a == null || a.scrollIntoView({
          block: "nearest"
        });
      });
    },
    handleSelectAllVisible() {
      if (!this.hasUnselectedVisibleOptions)
        return;
      const e = new Set(this.selectedValues);
      this.visibleEnabledOptionRows.forEach((a) => {
        this.isDropdownValue(a.option.value) && e.add(a.option.value);
      });
      const t = this.allSelectableOptions.reduce(
        (a, s) => ((this.isOptionSelected(s.value) || e.has(s.value)) && a.push(s.value), a),
        []
      );
      this.$emit("update:modelValue", t);
    },
    updatePosition() {
      if (!this.isOpen)
        return;
      const e = this.$refs.root, t = e == null ? void 0 : e.querySelector(
        ".kcl-dropdown--content"
      );
      if (!e || !t)
        return;
      const a = e.getBoundingClientRect(), s = t.getBoundingClientRect(), r = window.innerHeight - a.bottom, l = a.top;
      this.position = s.height > r && l > r ? "above" : "below";
    },
    handleCheckboxSelect(e, t) {
      if (this.isOptionDisabled(e) || !this.isOptionSelectable(e))
        return;
      this.activeOptionId = e.id;
      const a = this.allSelectableOptions.reduce(
        (s, r) => this.isDropdownValue(r.value) ? r.value === e.value ? (t && s.push(r.value), s) : (this.selectedValueSet.has(r.value) && s.push(r.value), s) : s,
        []
      );
      this.$emit("update:modelValue", a);
    },
    handleRadioSelect(e) {
      this.isDropdownValue(e) && (this.$emit("update:modelValue", e), this.closeDropdown());
    }
  }
}), dd = {
  key: 0,
  class: "kcl-dropdown--search"
}, cd = { class: "kcl-dropdown--search-control" }, pd = ["value", "placeholder"], hd = ["disabled"], md = { class: "kcl-dropdown--list" }, vd = {
  key: 0,
  class: "kcl-dropdown--empty"
}, fd = {
  key: 0,
  class: "kcl-dropdown--group-label"
}, wd = ["aria-disabled"], gd = { class: "kcl-dropdown--option-copy" }, yd = ["title"], kd = { class: "kcl-dropdown--option-label" }, Cd = {
  key: 0,
  class: "kcl-dropdown--option-secondary-label"
}, bd = ["aria-disabled"], Ld = { class: "kcl-dropdown--option-copy" }, Md = ["title"], Vd = { class: "kcl-dropdown--option-label" }, xd = {
  key: 0,
  class: "kcl-dropdown--option-secondary-label"
}, Dd = {
  key: 3,
  class: "kcl-dropdown--option-group"
}, Hd = { class: "kcl-dropdown--option-copy" }, Td = ["title"], $d = { class: "kcl-dropdown--option-label" }, Sd = {
  key: 0,
  class: "kcl-dropdown--option-secondary-label"
};
function _d(e, t, a, s, r, l) {
  const n = Ae("KIcon"), i = Ae("KCheckbox"), u = Ae("KRadio"), p = Ae("KDropdownShell");
  return c(), k("div", {
    ref: "root",
    onKeydown: t[3] || (t[3] = (...h) => e.handleRootKeydown && e.handleRootKeydown(...h))
  }, [
    He(p, {
      rootClasses: e.rootClasses,
      displayLabel: e.displayLabel,
      icon: e.icon,
      disabled: e.disabled,
      isOpen: e.isOpen,
      contentId: e.contentId,
      isPlaceholder: !e.hasSelection,
      canClear: e.canClearSelection,
      clearLabel: "Clear selection",
      openOnFocus: e.openOnFocus,
      onToggle: e.toggleDropdown,
      onClear: e.clearSelection
    }, {
      default: ve(() => [
        e.searchEnabled ? (c(), k("div", dd, [
          O("div", cd, [
            He(n, {
              class: "kcl-dropdown--search-icon",
              name: "magnifyingGlass"
            }),
            O("input", {
              class: "kcl-dropdown--search-input",
              ref: "searchInput",
              type: "search",
              value: e.searchValue,
              placeholder: e.searchPlaceholder,
              onInput: t[0] || (t[0] = (...h) => e.handleSearchInput && e.handleSearchInput(...h)),
              onKeydown: t[1] || (t[1] = (...h) => e.handleSearchKeydown && e.handleSearchKeydown(...h))
            }, null, 40, pd)
          ])
        ])) : S("", !0),
        e.showSelectAllAction ? (c(), k("button", {
          key: 1,
          class: "kcl-dropdown--select-all",
          type: "button",
          disabled: !e.hasUnselectedVisibleOptions,
          onClick: t[2] || (t[2] = (...h) => e.handleSelectAllVisible && e.handleSelectAllVisible(...h))
        }, me(e.selectAllVisibleLabel), 9, hd)) : S("", !0),
        O("ul", md, [
          e.hasVisibleRows ? (c(!0), k(he, { key: 1 }, Pe(e.visibleRows, (h) => (c(), k("li", {
            key: h.id,
            class: ue(e.rowItemClasses(h)),
            style: dt(e.rowIndentStyle(h.depth))
          }, [
            h.kind === "group-label" ? (c(), k("div", fd, me(h.label), 1)) : h.selectable && e.isMultiple ? (c(), k("label", {
              key: 1,
              class: "kcl-dropdown--option-checkbox",
              ref_for: !0,
              ref: h.refKey,
              "aria-disabled": e.isOptionDisabled(h.option)
            }, [
              O("span", gd, [
                h.option.icon ? (c(), ce(n, {
                  key: 0,
                  class: "kcl-dropdown--option-icon",
                  name: h.option.icon
                }, null, 8, ["name"])) : S("", !0),
                O("span", {
                  class: "kcl-dropdown--option-text",
                  title: e.optionTitle(h.option)
                }, [
                  O("span", kd, me(h.option.label), 1),
                  h.option.secondaryLabel ? (c(), k("span", Cd, me(h.option.secondaryLabel), 1)) : S("", !0)
                ], 8, yd)
              ]),
              He(i, {
                "model-value": e.isOptionSelected(h.option.value),
                disabled: e.isOptionDisabled(h.option),
                "onUpdate:modelValue": (d) => e.handleCheckboxSelect(h.option, d)
              }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"])
            ], 8, wd)) : h.selectable ? (c(), k("label", {
              key: 2,
              class: "kcl-dropdown--option-radio",
              ref_for: !0,
              ref: h.refKey,
              "aria-disabled": e.isOptionDisabled(h.option)
            }, [
              O("span", Ld, [
                h.option.icon ? (c(), ce(n, {
                  key: 0,
                  class: "kcl-dropdown--option-icon",
                  name: h.option.icon
                }, null, 8, ["name"])) : S("", !0),
                O("span", {
                  class: "kcl-dropdown--option-text",
                  title: e.optionTitle(h.option)
                }, [
                  O("span", Vd, me(h.option.label), 1),
                  h.option.secondaryLabel ? (c(), k("span", xd, me(h.option.secondaryLabel), 1)) : S("", !0)
                ], 8, Md)
              ]),
              He(u, {
                "model-value": e.selectedRadioValue,
                value: h.option.value,
                name: e.contentId,
                disabled: e.isOptionDisabled(h.option),
                "onUpdate:modelValue": e.handleRadioSelect
              }, null, 8, ["model-value", "value", "name", "disabled", "onUpdate:modelValue"])
            ], 8, bd)) : (c(), k("div", Dd, [
              O("span", Hd, [
                h.option.icon ? (c(), ce(n, {
                  key: 0,
                  class: "kcl-dropdown--option-icon",
                  name: h.option.icon
                }, null, 8, ["name"])) : S("", !0),
                O("span", {
                  class: "kcl-dropdown--option-text",
                  title: e.optionTitle(h.option)
                }, [
                  O("span", $d, me(h.option.label), 1),
                  h.option.secondaryLabel ? (c(), k("span", Sd, me(h.option.secondaryLabel), 1)) : S("", !0)
                ], 8, Td)
              ])
            ]))
          ], 6))), 128)) : (c(), k("li", vd, me(e.emptyStateText), 1))
        ])
      ]),
      _: 1
    }, 8, ["rootClasses", "displayLabel", "icon", "disabled", "isOpen", "contentId", "isPlaceholder", "canClear", "openOnFocus", "onToggle", "onClear"])
  ], 544);
}
const jr = /* @__PURE__ */ Ie(ud, [["render", _d]]), Od = ke({
  name: "KDropdownSingle",
  components: {
    KDropdownBase: jr
  },
  emits: ["update:modelValue", "open", "close"],
  props: {
    ...Dr
  }
});
function Pd(e, t, a, s, r, l) {
  const n = Ae("KDropdownBase");
  return c(), ce(n, Ee(e.$props, {
    mode: "single",
    "search-enabled": !1,
    "onUpdate:modelValue": t[0] || (t[0] = (i) => e.$emit("update:modelValue", i)),
    onOpen: t[1] || (t[1] = (i) => e.$emit("open")),
    onClose: t[2] || (t[2] = (i) => e.$emit("close"))
  }), null, 16);
}
const V3 = /* @__PURE__ */ Ie(Od, [["render", Pd]]), Bd = ke({
  name: "KDropdownSingleSearch",
  components: {
    KDropdownBase: jr
  },
  emits: ["update:modelValue", "open", "close"],
  props: {
    ...Dr,
    ...Qa
  }
});
function Zd(e, t, a, s, r, l) {
  const n = Ae("KDropdownBase");
  return c(), ce(n, Ee(e.$props, {
    mode: "single",
    "search-enabled": !0,
    "onUpdate:modelValue": t[0] || (t[0] = (i) => e.$emit("update:modelValue", i)),
    onOpen: t[1] || (t[1] = (i) => e.$emit("open")),
    onClose: t[2] || (t[2] = (i) => e.$emit("close"))
  }), null, 16);
}
const x3 = /* @__PURE__ */ Ie(Bd, [["render", Zd]]), Ad = ke({
  name: "KDropdownMulti",
  components: {
    KDropdownBase: jr
  },
  emits: ["update:modelValue", "open", "close"],
  props: {
    ...Dr,
    ...Xa
  }
});
function Rd(e, t, a, s, r, l) {
  const n = Ae("KDropdownBase");
  return c(), ce(n, Ee(e.$props, {
    mode: "multiple",
    "search-enabled": !1,
    "onUpdate:modelValue": t[0] || (t[0] = (i) => e.$emit("update:modelValue", i)),
    onOpen: t[1] || (t[1] = (i) => e.$emit("open")),
    onClose: t[2] || (t[2] = (i) => e.$emit("close"))
  }), null, 16);
}
const D3 = /* @__PURE__ */ Ie(Ad, [["render", Rd]]), Id = ke({
  name: "KDropdownMultiSearch",
  components: {
    KDropdownBase: jr
  },
  emits: ["update:modelValue", "open", "close"],
  props: {
    ...Dr,
    ...Qa,
    ...Xa,
    showSelectAllVisible: {
      type: Boolean,
      required: !1,
      default: !0
    }
  }
});
function Yd(e, t, a, s, r, l) {
  const n = Ae("KDropdownBase");
  return c(), ce(n, Ee(e.$props, {
    mode: "multiple",
    "search-enabled": !0,
    "onUpdate:modelValue": t[0] || (t[0] = (i) => e.$emit("update:modelValue", i)),
    onOpen: t[1] || (t[1] = (i) => e.$emit("open")),
    onClose: t[2] || (t[2] = (i) => e.$emit("close"))
  }), null, 16);
}
const H3 = /* @__PURE__ */ Ie(Id, [["render", Yd]]), Nd = ke({
  name: "KForm",
  emits: ["submit"],
  data() {
    return {
      rootClass: "kcl-form"
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault(), this.$emit("submit");
    }
  }
});
function Fd(e, t, a, s, r, l) {
  return c(), k("form", {
    class: ue(e.rootClass),
    onSubmit: t[0] || (t[0] = (...n) => e.onSubmit && e.onSubmit(...n))
  }, [
    X(e.$slots, "default")
  ], 34);
}
const T3 = /* @__PURE__ */ Ie(Nd, [["render", Fd]]), Ed = ke({
  name: "KFormActions",
  data() {
    return { rootClass: "kcl-form-actions" };
  }
});
function zd(e, t, a, s, r, l) {
  return c(), k("div", {
    class: ue(e.rootClass)
  }, [
    X(e.$slots, "default")
  ], 2);
}
const $3 = /* @__PURE__ */ Ie(Ed, [["render", zd]]), qd = ke({
  name: "KFormControl",
  props: {
    controlClass: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      rootClass: "kcl-form-control"
    };
  },
  computed: {
    controlClasses() {
      return !this.controlClass || this.controlClass.length === 0 ? null : `${this.rootClass}-${this.controlClass}`;
    },
    classNames() {
      return [this.rootClass, this.controlClasses];
    }
  }
});
function Ud(e, t, a, s, r, l) {
  return c(), k("div", {
    class: ue(e.classNames)
  }, [
    X(e.$slots, "default")
  ], 2);
}
const Ga = /* @__PURE__ */ Ie(qd, [["render", Ud]]), Kd = ke({
  name: "KFormLabel",
  data() {
    return {
      rootClass: "kcl-form-label",
      controlId: Gt()
    };
  }
}), Wd = ["for"];
function jd(e, t, a, s, r, l) {
  return c(), k("label", {
    class: ue(e.rootClass),
    for: e.controlId
  }, [
    X(e.$slots, "default")
  ], 10, Wd);
}
const xs = /* @__PURE__ */ Ie(Kd, [["render", jd]]), Qd = ke({
  name: "KFormRow",
  data() {
    return Ha(), {
      rootClass: "kcl-form-row"
    };
  }
});
function Xd(e, t, a, s, r, l) {
  return c(), k("div", {
    class: ue(e.rootClass)
  }, [
    X(e.$slots, "default")
  ], 2);
}
const S3 = /* @__PURE__ */ Ie(Qd, [["render", Xd]]), Gd = ke({
  name: "KFormCheckbox",
  components: { KCheckbox: P1, KFormLabel: xs },
  emits: ["update:modelValue"],
  props: {
    label: {
      type: String,
      required: !0
    },
    modelValue: {
      type: Boolean,
      required: !1
    }
  },
  data() {
    return Ha(), {
      rootClass: "kcl-form-control-checkbox"
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
});
function Jd(e, t, a, s, r, l) {
  const n = Ae("KCheckbox"), i = Ae("KFormLabel");
  return c(), k("div", {
    class: ue(e.rootClass)
  }, [
    He(n, {
      modelValue: e.value,
      "onUpdate:modelValue": t[0] || (t[0] = (u) => e.value = u)
    }, null, 8, ["modelValue"]),
    He(i, null, {
      default: ve(() => [
        Je(me(e.label), 1)
      ]),
      _: 1
    })
  ], 2);
}
const _3 = /* @__PURE__ */ Ie(Gd, [["render", Jd]]), Ja = (e) => typeof e == "object" ? e : {
  value: e,
  text: String(e)
}, e3 = ke({
  name: "KFormRadioOption",
  components: {
    KRadio: B1,
    KFormLabel: xs
  },
  emits: ["update:modelValue"],
  props: {
    option: {
      type: Object,
      required: !0
    },
    modelValue: {
      type: [String, Number],
      required: !0
    }
  },
  data() {
    return Ha(), {
      rootClass: "kcl-form-control-radio-option",
      controlName: Gt()
    };
  },
  computed: {
    showText() {
      return typeof this.option == "object";
    },
    selectable() {
      return Ja(this.option);
    }
  },
  methods: {
    handleUpdate(e) {
      this.$emit("update:modelValue", e);
    }
  }
});
function t3(e, t, a, s, r, l) {
  const n = Ae("KRadio"), i = Ae("KFormLabel");
  return c(), k("li", {
    class: ue(e.rootClass)
  }, [
    He(n, {
      "model-value": e.modelValue,
      value: e.selectable.value,
      name: e.controlName,
      "onUpdate:modelValue": e.handleUpdate
    }, null, 8, ["model-value", "value", "name", "onUpdate:modelValue"]),
    He(i, null, {
      default: ve(() => [
        e.showText ? (c(), k(he, { key: 0 }, [
          Je(me(e.selectable.text), 1)
        ], 64)) : X(e.$slots, "default", {}, void 0, void 0, 1)
      ]),
      _: 3
    })
  ], 2);
}
const r3 = /* @__PURE__ */ Ie(e3, [["render", t3]]), a3 = ke({
  name: "KFormRadio",
  components: { RadioOption: r3 },
  emits: ["update:modelValue"],
  props: {
    options: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [String, Number],
      required: !0
    }
  },
  data() {
    return {
      selectables: this.getSelectables(),
      hasSelectables: this.getSelectables() !== null,
      rootClass: "kcl-form-control-radio"
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  methods: {
    getSelectables() {
      return Array.isArray(this.options) ? this.options.map((e) => Ja(e)) : null;
    }
  }
}), s3 = { class: "kcl-form-control-radio--options" };
function n3(e, t, a, s, r, l) {
  const n = Ae("RadioOption");
  return c(), k("div", {
    class: ue(e.rootClass)
  }, [
    O("div", s3, [
      e.hasSelectables ? (c(!0), k(he, { key: 0 }, Pe(e.selectables, (i) => (c(), ce(n, {
        modelValue: e.value,
        "onUpdate:modelValue": t[0] || (t[0] = (u) => e.value = u),
        key: i.value,
        option: i
      }, null, 8, ["modelValue", "option"]))), 128)) : X(e.$slots, "default", {}, void 0, void 0, 1)
    ])
  ], 2);
}
const O3 = /* @__PURE__ */ Ie(a3, [["render", n3]]), l3 = ke({
  name: "KSelect",
  components: { KFormControl: Ga },
  emits: ["update:modelValue"],
  props: {
    options: {
      type: Array,
      required: !0
    },
    placeholder: {
      type: String,
      default: ""
    },
    blank: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: String,
      required: !1
    }
  },
  setup() {
    return {
      controlId: Gt()
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    hasValue() {
      return typeof this.value < "u" && this.value !== null;
    },
    placeholderSelected() {
      return !this.hasValue && !this.allowBlank;
    },
    hasPlaceholder() {
      return !!this.placeholder && this.placeholder.length > 0;
    },
    allowBlank() {
      return this.blank === !0;
    },
    selectables() {
      return (this.options ?? []).map((e) => Ja(e));
    }
  }
}), i3 = ["id"], o3 = ["selected"], u3 = {
  key: 1,
  value: void 0
}, d3 = ["value"];
function c3(e, t, a, s, r, l) {
  const n = Ae("KFormControl");
  return c(), ce(n, { "control-class": "select" }, {
    default: ve(() => [
      At(O("select", {
        id: e.controlId,
        "onUpdate:modelValue": t[0] || (t[0] = (i) => e.value = i)
      }, [
        e.hasPlaceholder ? (c(), k(he, { key: 0 }, [
          O("option", {
            selected: e.placeholderSelected,
            disabled: ""
          }, me(e.placeholder), 9, o3),
          t[1] || (t[1] = O("hr", null, null, -1))
        ], 64)) : S("", !0),
        e.allowBlank ? (c(), k("option", u3)) : S("", !0),
        (c(!0), k(he, null, Pe(e.selectables, (i) => (c(), k("option", {
          key: i.value,
          value: i.value
        }, me(i.text), 9, d3))), 128))
      ], 8, i3), [
        [Zs, e.value]
      ])
    ]),
    _: 1
  });
}
const P3 = /* @__PURE__ */ Ie(l3, [["render", c3]]), p3 = {
  name: "KTextArea",
  components: {
    KFormControl: Ga
  },
  emits: ["update:modelValue"],
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    lines: {
      type: Number,
      default: null
    },
    resizable: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      defaultRows: 3
    };
  },
  setup() {
    return {
      controlId: Gt()
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    rows() {
      return typeof this.lines > "u" ? this.defaultRows : this.lines === null ? void 0 : Math.max(1, this.lines);
    },
    modifierClasses() {
      return {
        "is-resizable": this.resizable
      };
    }
  }
}, h3 = ["id", "placeholder", "rows"];
function m3(e, t, a, s, r, l) {
  const n = Ae("KFormControl");
  return c(), ce(n, {
    "control-class": "text-area",
    class: ue(l.modifierClasses)
  }, {
    default: ve(() => [
      At(O("textarea", {
        id: s.controlId,
        placeholder: a.placeholder,
        rows: l.rows,
        "onUpdate:modelValue": t[0] || (t[0] = (i) => l.value = i)
      }, null, 8, h3), [
        [$1, l.value]
      ])
    ]),
    _: 1
  }, 8, ["class"]);
}
const B3 = /* @__PURE__ */ Ie(p3, [["render", m3]]), v3 = ke({
  name: "KTextField",
  components: {
    KFormControl: Ga
  },
  emits: ["update:modelValue"],
  props: {
    placeholder: {
      type: String,
      required: !1
    },
    modelValue: {
      type: String,
      required: !1
    }
  },
  setup() {
    return {
      controlId: Gt()
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}), f3 = ["id", "placeholder"];
function w3(e, t, a, s, r, l) {
  const n = Ae("KFormControl");
  return c(), ce(n, { "control-class": "text-field" }, {
    default: ve(() => [
      At(O("input", {
        type: "text",
        id: e.controlId,
        placeholder: e.placeholder,
        "onUpdate:modelValue": t[0] || (t[0] = (i) => e.value = i)
      }, null, 8, f3), [
        [$1, e.value]
      ])
    ]),
    _: 1
  });
}
const Z3 = /* @__PURE__ */ Ie(v3, [["render", w3]]);
export {
  L3 as KAccordion,
  nu as KButton,
  k3 as KButtonGroup,
  P1 as KCheckbox,
  X5 as KDateTimePicker,
  M3 as KDateTimeRangeDropdown,
  M3 as KDropdownDateTimeRange,
  D3 as KDropdownMulti,
  H3 as KDropdownMultiSearch,
  V3 as KDropdownSingle,
  x3 as KDropdownSingleSearch,
  T3 as KForm,
  $3 as KFormActions,
  _3 as KFormCheckbox,
  Ga as KFormControl,
  xs as KFormLabel,
  O3 as KFormRadio,
  r3 as KFormRadioOption,
  S3 as KFormRow,
  St as KIcon,
  y3 as KIconNames,
  ea as KIcons,
  pu as KPill,
  B1 as KRadio,
  b3 as KSearchBox,
  P3 as KSelect,
  B3 as KTextArea,
  C3 as KTextBox,
  Z3 as KTextField,
  bu as KTooltip
};
//# sourceMappingURL=kcl.js.map
